/**
 * @license lucide v0.545.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

(function (a, n) {
  typeof exports == "object" && typeof module < "u"
    ? n(exports)
    : typeof define == "function" && define.amd
    ? define(["exports"], n)
    : ((a = typeof globalThis < "u" ? globalThis : a || self),
      n((a.lucide = {})));
})(this, function (a) {
  "use strict";
  const n = {
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": 2,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
    },
    la = ([t, h, d]) => {
      const c = document.createElementNS("http://www.w3.org/2000/svg", t);
      return (
        Object.keys(h).forEach((M) => {
          c.setAttribute(M, String(h[M]));
        }),
        d?.length &&
          d.forEach((M) => {
            const i = la(M);
            c.appendChild(i);
          }),
        c
      );
    },
    ea = (t, h = {}) => {
      const d = { ...n, ...h };
      return la(["svg", d, t]);
    },
    Ru = (t) =>
      Array.from(t.attributes).reduce((h, d) => ((h[d.name] = d.value), h), {}),
    Tu = (t) =>
      typeof t == "string"
        ? t
        : !t || !t.class
        ? ""
        : t.class && typeof t.class == "string"
        ? t.class.split(" ")
        : t.class && Array.isArray(t.class)
        ? t.class
        : "",
    qu = (t) =>
      t
        .flatMap(Tu)
        .map((h) => h.trim())
        .filter(Boolean)
        .filter((h, d, c) => c.indexOf(h) === d)
        .join(" "),
    Uu = (t) =>
      t.replace(
        /(\w)(\w*)(_|-|\s*)/g,
        (h, d, c) => d.toUpperCase() + c.toLowerCase()
      ),
    ra = (t, { nameAttr: h, icons: d, attrs: c }) => {
      const M = t.getAttribute(h);
      if (M == null) return;
      const i = Uu(M),
        na = d[i];
      if (!na)
        return console.warn(
          `${t.outerHTML} icon name was not found in the provided icons object.`
        );
      const Fu = Ru(t),
        zu = { ...n, "data-lucide": M, ...c, ...Fu },
        bu = qu(["lucide", `lucide-${M}`, Fu, c]);
      bu && Object.assign(zu, { class: bu });
      const Zu = ea(na, zu);
      return t.parentNode?.replaceChild(Zu, t);
    },
    oa = [
      ["path", { d: "m14 12 4 4 4-4" }],
      ["path", { d: "M18 16V7" }],
      ["path", { d: "m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16" }],
      ["path", { d: "M3.304 13h6.392" }],
    ],
    va = [
      ["path", { d: "m14 11 4-4 4 4" }],
      ["path", { d: "M18 16V7" }],
      ["path", { d: "m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16" }],
      ["path", { d: "M3.304 13h6.392" }],
    ],
    $a = [
      ["path", { d: "m15 16 2.536-7.328a1.02 1.02 1 0 1 1.928 0L22 16" }],
      ["path", { d: "M15.697 14h5.606" }],
      ["path", { d: "m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16" }],
      ["path", { d: "M3.304 13h6.392" }],
    ],
    ma = [
      ["circle", { cx: "16", cy: "4", r: "1" }],
      ["path", { d: "m18 19 1-7-6 1" }],
      ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5" }],
      ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6" }],
      ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6" }],
    ],
    ya = [
      [
        "path",
        {
          d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
        },
      ],
    ],
    sa = [
      ["path", { d: "M18 17.5a2.5 2.5 0 1 1-4 2.03V12" }],
      [
        "path",
        {
          d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
        },
      ],
      ["path", { d: "M6 8h12" }],
      ["path", { d: "M6.6 15.572A2 2 0 1 0 10 17v-5" }],
    ],
    ga = [
      [
        "path",
        {
          d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
        },
      ],
      ["path", { d: "m12 15 5 6H7Z" }],
    ],
    y = [
      ["circle", { cx: "12", cy: "13", r: "8" }],
      ["path", { d: "M5 3 2 6" }],
      ["path", { d: "m22 6-3-3" }],
      ["path", { d: "M6.38 18.7 4 21" }],
      ["path", { d: "M17.64 18.67 20 21" }],
      ["path", { d: "m9 13 2 2 4-4" }],
    ],
    s = [
      ["circle", { cx: "12", cy: "13", r: "8" }],
      ["path", { d: "M5 3 2 6" }],
      ["path", { d: "m22 6-3-3" }],
      ["path", { d: "M6.38 18.7 4 21" }],
      ["path", { d: "M17.64 18.67 20 21" }],
      ["path", { d: "M9 13h6" }],
    ],
    ua = [
      ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26" }],
      ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15" }],
      ["path", { d: "m22 6-3-3" }],
      ["path", { d: "M6.26 18.67 4 21" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M4 4 2 6" }],
    ],
    g = [
      ["circle", { cx: "12", cy: "13", r: "8" }],
      ["path", { d: "M5 3 2 6" }],
      ["path", { d: "m22 6-3-3" }],
      ["path", { d: "M6.38 18.7 4 21" }],
      ["path", { d: "M17.64 18.67 20 21" }],
      ["path", { d: "M12 10v6" }],
      ["path", { d: "M9 13h6" }],
    ],
    Ca = [
      ["circle", { cx: "12", cy: "13", r: "8" }],
      ["path", { d: "M12 9v4l2 2" }],
      ["path", { d: "M5 3 2 6" }],
      ["path", { d: "m22 6-3-3" }],
      ["path", { d: "M6.38 18.7 4 21" }],
      ["path", { d: "M17.64 18.67 20 21" }],
    ],
    Ha = [
      ["path", { d: "M11 21c0-2.5 2-2.5 2-5" }],
      ["path", { d: "M16 21c0-2.5 2-2.5 2-5" }],
      [
        "path",
        { d: "m19 8-.8 3a1.25 1.25 0 0 1-1.2 1H7a1.25 1.25 0 0 1-1.2-1L5 8" },
      ],
      [
        "path",
        {
          d: "M21 3a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z",
        },
      ],
      ["path", { d: "M6 21c0-2.5 2-2.5 2-5" }],
    ],
    Aa = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["polyline", { points: "11 3 11 11 14 8 17 11 17 3" }],
    ],
    wa = [
      ["path", { d: "M2 12h20" }],
      ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4" }],
      ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1" }],
      ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1" }],
    ],
    Va = [
      ["path", { d: "M12 2v20" }],
      ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4" }],
      ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4" }],
      ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1" }],
      ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1" }],
    ],
    Sa = [
      ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2" }],
      ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2" }],
      ["path", { d: "M22 22H2" }],
    ],
    La = [
      ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2" }],
      ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2" }],
      ["path", { d: "M22 22V2" }],
    ],
    fa = [
      ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2" }],
      ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2" }],
      ["path", { d: "M17 22v-5" }],
      ["path", { d: "M17 7V2" }],
      ["path", { d: "M7 22v-3" }],
      ["path", { d: "M7 5V2" }],
    ],
    ka = [
      ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2" }],
      ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2" }],
      ["path", { d: "M10 2v20" }],
      ["path", { d: "M20 2v20" }],
    ],
    Pa = [
      ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2" }],
      ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2" }],
      ["path", { d: "M4 2v20" }],
      ["path", { d: "M14 2v20" }],
    ],
    Ba = [
      ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2" }],
      ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2" }],
      ["path", { d: "M12 2v20" }],
    ],
    Da = [
      ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2" }],
      ["rect", { width: "6", height: "10", x: "12", y: "7", rx: "2" }],
      ["path", { d: "M22 2v20" }],
    ],
    Fa = [
      ["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2" }],
      ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2" }],
      ["path", { d: "M2 2v20" }],
    ],
    za = [
      ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2" }],
      ["path", { d: "M4 22V2" }],
      ["path", { d: "M20 22V2" }],
    ],
    ba = [
      ["rect", { width: "6", height: "14", x: "3", y: "5", rx: "2" }],
      ["rect", { width: "6", height: "10", x: "15", y: "7", rx: "2" }],
      ["path", { d: "M3 2v20" }],
      ["path", { d: "M21 2v20" }],
    ],
    Ra = [
      ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2" }],
      ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2" }],
      ["path", { d: "M22 2H2" }],
    ],
    Ta = [
      ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2" }],
      ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2" }],
      ["path", { d: "M2 2v20" }],
    ],
    qa = [
      ["path", { d: "M22 17h-3" }],
      ["path", { d: "M22 7h-5" }],
      ["path", { d: "M5 17H2" }],
      ["path", { d: "M7 7H2" }],
      ["rect", { x: "5", y: "14", width: "14", height: "6", rx: "2" }],
      ["rect", { x: "7", y: "4", width: "10", height: "6", rx: "2" }],
    ],
    Ua = [
      ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2" }],
      ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2" }],
      ["path", { d: "M2 20h20" }],
      ["path", { d: "M2 10h20" }],
    ],
    Oa = [
      ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2" }],
      ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2" }],
      ["path", { d: "M2 14h20" }],
      ["path", { d: "M2 4h20" }],
    ],
    Za = [
      ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2" }],
      ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2" }],
      ["path", { d: "M2 12h20" }],
    ],
    Ga = [
      ["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2" }],
      ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2" }],
      ["path", { d: "M2 22h20" }],
    ],
    Ia = [
      ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2" }],
      ["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2" }],
      ["path", { d: "M2 2h20" }],
    ],
    Wa = [
      ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2" }],
      ["path", { d: "M22 20H2" }],
      ["path", { d: "M22 4H2" }],
    ],
    Ea = [
      ["rect", { width: "14", height: "6", x: "5", y: "15", rx: "2" }],
      ["rect", { width: "10", height: "6", x: "7", y: "3", rx: "2" }],
      ["path", { d: "M2 21h20" }],
      ["path", { d: "M2 3h20" }],
    ],
    Xa = [
      [
        "path",
        {
          d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
        },
      ],
      ["path", { d: "M16 12h3" }],
    ],
    ja = [
      ["path", { d: "M10 10H6" }],
      [
        "path",
        { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" },
      ],
      [
        "path",
        {
          d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
        },
      ],
      ["path", { d: "M8 8v4" }],
      ["path", { d: "M9 18h6" }],
      ["circle", { cx: "17", cy: "18", r: "2" }],
      ["circle", { cx: "7", cy: "18", r: "2" }],
    ],
    Na = [
      [
        "path",
        {
          d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
        },
      ],
      [
        "path",
        {
          d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
        },
      ],
    ],
    Ka = [
      [
        "path",
        {
          d: "M10 2v5.632c0 .424-.272.795-.653.982A6 6 0 0 0 6 14c.006 4 3 7 5 8",
        },
      ],
      ["path", { d: "M10 5H8a2 2 0 0 0 0 4h.68" }],
      [
        "path",
        { d: "M14 2v5.632c0 .424.272.795.652.982A6 6 0 0 1 18 14c0 4-3 7-5 8" },
      ],
      ["path", { d: "M14 5h2a2 2 0 0 1 0 4h-.68" }],
      ["path", { d: "M18 22H6" }],
      ["path", { d: "M9 2h6" }],
    ],
    Qa = [
      ["path", { d: "M12 22V8" }],
      ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3" }],
      ["circle", { cx: "12", cy: "5", r: "3" }],
    ],
    Ja = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2" }],
      ["path", { d: "M7.5 8 10 9" }],
      ["path", { d: "m14 9 2.5-1" }],
      ["path", { d: "M9 10h.01" }],
      ["path", { d: "M15 10h.01" }],
    ],
    Ya = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M8 15h8" }],
      ["path", { d: "M8 9h2" }],
      ["path", { d: "M14 9h2" }],
    ],
    _a = [
      ["path", { d: "M2 12 7 2" }],
      ["path", { d: "m7 12 5-10" }],
      ["path", { d: "m12 12 5-10" }],
      ["path", { d: "m17 12 5-10" }],
      ["path", { d: "M4.5 7h15" }],
      ["path", { d: "M12 16v6" }],
    ],
    xa = [
      ["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4" }],
      [
        "path",
        {
          d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z",
        },
      ],
      ["path", { d: "M9 12v5" }],
      ["path", { d: "M15 12v5" }],
      [
        "path",
        {
          d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1",
        },
      ],
    ],
    at = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m14.31 8 5.74 9.94" }],
      ["path", { d: "M9.69 8h11.48" }],
      ["path", { d: "m7.38 12 5.74-9.94" }],
      ["path", { d: "M9.69 16 3.95 6.06" }],
      ["path", { d: "M14.31 16H2.83" }],
      ["path", { d: "m16.62 12-5.74 9.94" }],
    ],
    tt = [
      ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
      ["path", { d: "M6 8h.01" }],
      ["path", { d: "M10 8h.01" }],
      ["path", { d: "M14 8h.01" }],
    ],
    ht = [
      ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }],
      ["path", { d: "M10 4v4" }],
      ["path", { d: "M2 8h20" }],
      ["path", { d: "M6 4v4" }],
    ],
    dt = [
      ["path", { d: "M12 6.528V3a1 1 0 0 1 1-1h0" }],
      [
        "path",
        {
          d: "M18.237 21A15 15 0 0 0 22 11a6 6 0 0 0-10-4.472A6 6 0 0 0 2 11a15.1 15.1 0 0 0 3.763 10 3 3 0 0 0 3.648.648 5.5 5.5 0 0 1 5.178 0A3 3 0 0 0 18.237 21",
        },
      ],
    ],
    ct = [
      ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1" }],
      ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2" }],
      ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "m9 15 3-3 3 3" }],
      ["path", { d: "M12 12v9" }],
    ],
    Mt = [
      ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1" }],
      ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" }],
      ["path", { d: "m9.5 17 5-5" }],
      ["path", { d: "m9.5 12 5 5" }],
    ],
    pt = [
      ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1" }],
      ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" }],
      ["path", { d: "M10 12h4" }],
    ],
    it = [
      ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3" }],
      [
        "path",
        {
          d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
        },
      ],
      ["path", { d: "M5 18v2" }],
      ["path", { d: "M19 18v2" }],
    ],
    nt = [
      [
        "path",
        {
          d: "M15 11a1 1 0 0 0 1 1h2.939a1 1 0 0 1 .75 1.811l-6.835 6.836a1.207 1.207 0 0 1-1.707 0L4.31 13.81a1 1 0 0 1 .75-1.811H8a1 1 0 0 0 1-1V9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "M9 4h6" }],
    ],
    lt = [
      [
        "path",
        {
          d: "M15 11a1 1 0 0 0 1 1h2.939a1 1 0 0 1 .75 1.811l-6.835 6.836a1.207 1.207 0 0 1-1.707 0L4.31 13.81a1 1 0 0 1 .75-1.811H8a1 1 0 0 0 1-1V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1z",
        },
      ],
    ],
    et = [
      [
        "path",
        {
          d: "M13 9a1 1 0 0 1-1-1V5.061a1 1 0 0 0-1.811-.75l-6.835 6.836a1.207 1.207 0 0 0 0 1.707l6.835 6.835a1 1 0 0 0 1.811-.75V16a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z",
        },
      ],
      ["path", { d: "M20 9v6" }],
    ],
    rt = [
      [
        "path",
        {
          d: "M13 9a1 1 0 0 1-1-1V5.061a1 1 0 0 0-1.811-.75l-6.835 6.836a1.207 1.207 0 0 0 0 1.707l6.835 6.835a1 1 0 0 0 1.811-.75V16a1 1 0 0 1 1-1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z",
        },
      ],
    ],
    ot = [
      [
        "path",
        {
          d: "M11 9a1 1 0 0 0 1-1V5.061a1 1 0 0 1 1.811-.75l6.836 6.836a1.207 1.207 0 0 1 0 1.707l-6.836 6.835a1 1 0 0 1-1.811-.75V16a1 1 0 0 0-1-1H9a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z",
        },
      ],
      ["path", { d: "M4 9v6" }],
    ],
    vt = [
      [
        "path",
        {
          d: "M11 9a1 1 0 0 0 1-1V5.061a1 1 0 0 1 1.811-.75l6.836 6.836a1.207 1.207 0 0 1 0 1.707l-6.836 6.835a1 1 0 0 1-1.811-.75V16a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z",
        },
      ],
    ],
    $t = [
      [
        "path",
        {
          d: "M9 13a1 1 0 0 0-1-1H5.061a1 1 0 0 1-.75-1.811l6.836-6.835a1.207 1.207 0 0 1 1.707 0l6.835 6.835a1 1 0 0 1-.75 1.811H16a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z",
        },
      ],
      ["path", { d: "M9 20h6" }],
    ],
    mt = [
      ["path", { d: "m3 16 4 4 4-4" }],
      ["path", { d: "M7 20V4" }],
      ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2" }],
      ["path", { d: "M17 20v-6h-2" }],
      ["path", { d: "M15 20h4" }],
    ],
    yt = [
      ["path", { d: "m3 16 4 4 4-4" }],
      ["path", { d: "M7 20V4" }],
      ["path", { d: "M17 10V4h-2" }],
      ["path", { d: "M15 10h4" }],
      ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2" }],
    ],
    st = [
      [
        "path",
        {
          d: "M9 13a1 1 0 0 0-1-1H5.061a1 1 0 0 1-.75-1.811l6.836-6.835a1.207 1.207 0 0 1 1.707 0l6.835 6.835a1 1 0 0 1-.75 1.811H16a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z",
        },
      ],
    ],
    u = [
      ["path", { d: "m3 16 4 4 4-4" }],
      ["path", { d: "M7 20V4" }],
      ["path", { d: "M20 8h-5" }],
      ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10" }],
      ["path", { d: "M15 14h5l-5 6h5" }],
    ],
    gt = [
      ["path", { d: "M19 3H5" }],
      ["path", { d: "M12 21V7" }],
      ["path", { d: "m6 15 6 6 6-6" }],
    ],
    ut = [
      ["path", { d: "m3 16 4 4 4-4" }],
      ["path", { d: "M7 20V4" }],
      ["path", { d: "M11 4h4" }],
      ["path", { d: "M11 8h7" }],
      ["path", { d: "M11 12h10" }],
    ],
    Ct = [
      ["path", { d: "M17 7 7 17" }],
      ["path", { d: "M17 17H7V7" }],
    ],
    Ht = [
      ["path", { d: "M12 2v14" }],
      ["path", { d: "m19 9-7 7-7-7" }],
      ["circle", { cx: "12", cy: "21", r: "1" }],
    ],
    At = [
      ["path", { d: "m7 7 10 10" }],
      ["path", { d: "M17 7v10H7" }],
    ],
    wt = [
      ["path", { d: "M12 17V3" }],
      ["path", { d: "m6 11 6 6 6-6" }],
      ["path", { d: "M19 21H5" }],
    ],
    Vt = [
      ["path", { d: "m3 16 4 4 4-4" }],
      ["path", { d: "M7 20V4" }],
      ["path", { d: "m21 8-4-4-4 4" }],
      ["path", { d: "M17 4v16" }],
    ],
    C = [
      ["path", { d: "m3 16 4 4 4-4" }],
      ["path", { d: "M7 20V4" }],
      ["path", { d: "M11 4h10" }],
      ["path", { d: "M11 8h7" }],
      ["path", { d: "M11 12h4" }],
    ],
    H = [
      ["path", { d: "m3 16 4 4 4-4" }],
      ["path", { d: "M7 4v16" }],
      ["path", { d: "M15 4h5l-5 6h5" }],
      ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20" }],
      ["path", { d: "M20 18h-5" }],
    ],
    St = [
      ["path", { d: "M12 5v14" }],
      ["path", { d: "m19 12-7 7-7-7" }],
    ],
    Lt = [
      ["path", { d: "m9 6-6 6 6 6" }],
      ["path", { d: "M3 12h14" }],
      ["path", { d: "M21 19V5" }],
    ],
    ft = [
      ["path", { d: "M8 3 4 7l4 4" }],
      ["path", { d: "M4 7h16" }],
      ["path", { d: "m16 21 4-4-4-4" }],
      ["path", { d: "M20 17H4" }],
    ],
    kt = [
      ["path", { d: "M3 19V5" }],
      ["path", { d: "m13 6-6 6 6 6" }],
      ["path", { d: "M7 12h14" }],
    ],
    Pt = [
      ["path", { d: "m12 19-7-7 7-7" }],
      ["path", { d: "M19 12H5" }],
    ],
    Bt = [
      ["path", { d: "M3 5v14" }],
      ["path", { d: "M21 12H7" }],
      ["path", { d: "m15 18 6-6-6-6" }],
    ],
    Dt = [
      ["path", { d: "M17 12H3" }],
      ["path", { d: "m11 18 6-6-6-6" }],
      ["path", { d: "M21 5v14" }],
    ],
    Ft = [
      ["path", { d: "m16 3 4 4-4 4" }],
      ["path", { d: "M20 7H4" }],
      ["path", { d: "m8 21-4-4 4-4" }],
      ["path", { d: "M4 17h16" }],
    ],
    zt = [
      ["path", { d: "M5 12h14" }],
      ["path", { d: "m12 5 7 7-7 7" }],
    ],
    bt = [
      ["path", { d: "m3 8 4-4 4 4" }],
      ["path", { d: "M7 4v16" }],
      ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2" }],
      ["path", { d: "M17 20v-6h-2" }],
      ["path", { d: "M15 20h4" }],
    ],
    Rt = [
      ["path", { d: "m3 8 4-4 4 4" }],
      ["path", { d: "M7 4v16" }],
      ["path", { d: "M17 10V4h-2" }],
      ["path", { d: "M15 10h4" }],
      ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2" }],
    ],
    A = [
      ["path", { d: "m3 8 4-4 4 4" }],
      ["path", { d: "M7 4v16" }],
      ["path", { d: "M20 8h-5" }],
      ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10" }],
      ["path", { d: "M15 14h5l-5 6h5" }],
    ],
    Tt = [
      ["path", { d: "m21 16-4 4-4-4" }],
      ["path", { d: "M17 20V4" }],
      ["path", { d: "m3 8 4-4 4 4" }],
      ["path", { d: "M7 4v16" }],
    ],
    qt = [
      ["path", { d: "m18 9-6-6-6 6" }],
      ["path", { d: "M12 3v14" }],
      ["path", { d: "M5 21h14" }],
    ],
    Ut = [
      ["path", { d: "m5 9 7-7 7 7" }],
      ["path", { d: "M12 16V2" }],
      ["circle", { cx: "12", cy: "21", r: "1" }],
    ],
    Ot = [
      ["path", { d: "M7 17V7h10" }],
      ["path", { d: "M17 17 7 7" }],
    ],
    w = [
      ["path", { d: "m3 8 4-4 4 4" }],
      ["path", { d: "M7 4v16" }],
      ["path", { d: "M11 12h4" }],
      ["path", { d: "M11 16h7" }],
      ["path", { d: "M11 20h10" }],
    ],
    Zt = [
      ["path", { d: "M7 7h10v10" }],
      ["path", { d: "M7 17 17 7" }],
    ],
    Gt = [
      ["path", { d: "m3 8 4-4 4 4" }],
      ["path", { d: "M7 4v16" }],
      ["path", { d: "M11 12h10" }],
      ["path", { d: "M11 16h7" }],
      ["path", { d: "M11 20h4" }],
    ],
    V = [
      ["path", { d: "m3 8 4-4 4 4" }],
      ["path", { d: "M7 4v16" }],
      ["path", { d: "M15 4h5l-5 6h5" }],
      ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20" }],
      ["path", { d: "M20 18h-5" }],
    ],
    It = [
      ["path", { d: "M5 3h14" }],
      ["path", { d: "m18 13-6-6-6 6" }],
      ["path", { d: "M12 7v14" }],
    ],
    Wt = [
      ["path", { d: "m5 12 7-7 7 7" }],
      ["path", { d: "M12 19V5" }],
    ],
    Et = [
      ["path", { d: "m4 6 3-3 3 3" }],
      ["path", { d: "M7 17V3" }],
      ["path", { d: "m14 6 3-3 3 3" }],
      ["path", { d: "M17 17V3" }],
      ["path", { d: "M4 21h16" }],
    ],
    Xt = [
      ["path", { d: "M12 6v12" }],
      ["path", { d: "M17.196 9 6.804 15" }],
      ["path", { d: "m6.804 9 10.392 6" }],
    ],
    jt = [
      ["circle", { cx: "12", cy: "12", r: "4" }],
      ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" }],
    ],
    Nt = [
      ["path", { d: "M2 10v3" }],
      ["path", { d: "M6 6v11" }],
      ["path", { d: "M10 3v18" }],
      ["path", { d: "M14 8v7" }],
      ["path", { d: "M18 5v13" }],
      ["path", { d: "M22 10v3" }],
    ],
    Kt = [
      [
        "path",
        {
          d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
        },
      ],
    ],
    Qt = [
      ["circle", { cx: "12", cy: "12", r: "1" }],
      [
        "path",
        {
          d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
        },
      ],
      [
        "path",
        {
          d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
        },
      ],
    ],
    Jt = [
      [
        "path",
        {
          d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
        },
      ],
      ["circle", { cx: "12", cy: "8", r: "6" }],
    ],
    Yt = [
      ["path", { d: "m14 12-8.381 8.38a1 1 0 0 1-3.001-3L11 9" }],
      [
        "path",
        {
          d: "M15 15.5a.5.5 0 0 0 .5.5A6.5 6.5 0 0 0 22 9.5a.5.5 0 0 0-.5-.5h-1.672a2 2 0 0 1-1.414-.586l-5.062-5.062a1.205 1.205 0 0 0-1.704 0L9.352 5.648a1.205 1.205 0 0 0 0 1.704l5.062 5.062A2 2 0 0 1 15 13.828z",
        },
      ],
    ],
    S = [
      ["path", { d: "M13.5 10.5 15 9" }],
      ["path", { d: "M4 4v15a1 1 0 0 0 1 1h15" }],
      ["path", { d: "M4.293 19.707 6 18" }],
      ["path", { d: "m9 15 1.5-1.5" }],
    ],
    _t = [
      ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5" }],
      ["path", { d: "M15 12h.01" }],
      [
        "path",
        {
          d: "M19.38 6.813A9 9 0 0 1 20.8 10.2a2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
        },
      ],
      ["path", { d: "M9 12h.01" }],
    ],
    xt = [
      [
        "path",
        {
          d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z",
        },
      ],
      ["path", { d: "M8 10h8" }],
      ["path", { d: "M8 18h8" }],
      ["path", { d: "M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6" }],
      ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" }],
    ],
    ah = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["line", { x1: "12", x2: "12", y1: "8", y2: "12" }],
      ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16" }],
    ],
    th = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "M12 7v10" }],
      ["path", { d: "M15.4 10a4 4 0 1 0 0 4" }],
    ],
    L = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "m9 12 2 2 4-4" }],
    ],
    hh = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" }],
      ["path", { d: "M12 18V6" }],
    ],
    dh = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "M7 12h5" }],
      ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2" }],
    ],
    ch = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "M8 8h8" }],
      ["path", { d: "M8 12h8" }],
      ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8" }],
    ],
    Mh = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["line", { x1: "12", x2: "12", y1: "16", y2: "12" }],
      ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8" }],
    ],
    ph = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "m9 8 3 3v7" }],
      ["path", { d: "m12 11 3-3" }],
      ["path", { d: "M9 12h6" }],
      ["path", { d: "M9 16h6" }],
    ],
    ih = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["line", { x1: "8", x2: "16", y1: "12", y2: "12" }],
    ],
    nh = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "m15 9-6 6" }],
      ["path", { d: "M9 9h.01" }],
      ["path", { d: "M15 15h.01" }],
    ],
    lh = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["line", { x1: "12", x2: "12", y1: "8", y2: "16" }],
      ["line", { x1: "8", x2: "16", y1: "12", y2: "12" }],
    ],
    eh = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "M8 12h4" }],
      ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0" }],
      ["path", { d: "M8 16h7" }],
    ],
    f = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }],
      ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17" }],
    ],
    rh = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "M9 16h5" }],
      ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9" }],
    ],
    oh = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["path", { d: "M11 17V8h4" }],
      ["path", { d: "M11 12h3" }],
      ["path", { d: "M9 16h4" }],
    ],
    vh = [
      ["path", { d: "M11 7v10a5 5 0 0 0 5-5" }],
      ["path", { d: "m15 8-6 3" }],
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76",
        },
      ],
    ],
    $h = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
      ["line", { x1: "15", x2: "9", y1: "9", y2: "15" }],
      ["line", { x1: "9", x2: "15", y1: "9", y2: "15" }],
    ],
    mh = [
      [
        "path",
        {
          d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        },
      ],
    ],
    yh = [
      ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2" }],
      ["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10" }],
      ["rect", { width: "13", height: "8", x: "8", y: "6", rx: "1" }],
      ["circle", { cx: "18", cy: "20", r: "2" }],
      ["circle", { cx: "9", cy: "20", r: "2" }],
    ],
    sh = [
      ["path", { d: "M4.929 4.929 19.07 19.071" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    gh = [
      ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5" }],
      [
        "path",
        {
          d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
        },
      ],
    ],
    uh = [
      ["path", { d: "M10 10.01h.01" }],
      ["path", { d: "M10 14.01h.01" }],
      ["path", { d: "M14 10.01h.01" }],
      ["path", { d: "M14 14.01h.01" }],
      ["path", { d: "M18 6v11.5" }],
      ["path", { d: "M6 6v12" }],
      ["rect", { x: "2", y: "6", width: "20", height: "12", rx: "2" }],
    ],
    Ch = [
      [
        "path",
        { d: "M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" },
      ],
      ["path", { d: "m16 19 3 3 3-3" }],
      ["path", { d: "M18 12h.01" }],
      ["path", { d: "M19 16v6" }],
      ["path", { d: "M6 12h.01" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
    ],
    Hh = [
      [
        "path",
        { d: "M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" },
      ],
      ["path", { d: "M18 12h.01" }],
      ["path", { d: "M19 22v-6" }],
      ["path", { d: "m22 19-3-3-3 3" }],
      ["path", { d: "M6 12h.01" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
    ],
    Ah = [
      [
        "path",
        { d: "M13 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" },
      ],
      ["path", { d: "m17 17 5 5" }],
      ["path", { d: "M18 12h.01" }],
      ["path", { d: "m22 17-5 5" }],
      ["path", { d: "M6 12h.01" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
    ],
    wh = [
      ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
      ["path", { d: "M6 12h.01M18 12h.01" }],
    ],
    Vh = [
      ["path", { d: "M3 5v14" }],
      ["path", { d: "M8 5v14" }],
      ["path", { d: "M12 5v14" }],
      ["path", { d: "M17 5v14" }],
      ["path", { d: "M21 5v14" }],
    ],
    Sh = [
      ["path", { d: "M10 3a41 41 0 0 0 0 18" }],
      ["path", { d: "M14 3a41 41 0 0 1 0 18" }],
      [
        "path",
        {
          d: "M17 3a2 2 0 0 1 1.68.92 15.25 15.25 0 0 1 0 16.16A2 2 0 0 1 17 21H7a2 2 0 0 1-1.68-.92 15.25 15.25 0 0 1 0-16.16A2 2 0 0 1 7 3z",
        },
      ],
      ["path", { d: "M3.84 17h16.32" }],
      ["path", { d: "M3.84 7h16.32" }],
    ],
    Lh = [
      ["path", { d: "M4 20h16" }],
      ["path", { d: "m6 16 6-12 6 12" }],
      ["path", { d: "M8 12h8" }],
    ],
    fh = [
      ["path", { d: "M10 4 8 6" }],
      ["path", { d: "M17 19v2" }],
      ["path", { d: "M2 12h20" }],
      ["path", { d: "M7 19v2" }],
      [
        "path",
        {
          d: "M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
        },
      ],
    ],
    kh = [
      ["path", { d: "m11 7-3 5h4l-3 5" }],
      ["path", { d: "M14.856 6H16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.935" }],
      ["path", { d: "M22 14v-4" }],
      ["path", { d: "M5.14 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2.936" }],
    ],
    Ph = [
      ["path", { d: "M10 10v4" }],
      ["path", { d: "M14 10v4" }],
      ["path", { d: "M22 14v-4" }],
      ["path", { d: "M6 10v4" }],
      ["rect", { x: "2", y: "6", width: "16", height: "12", rx: "2" }],
    ],
    Bh = [
      ["path", { d: "M22 14v-4" }],
      ["path", { d: "M6 14v-4" }],
      ["rect", { x: "2", y: "6", width: "16", height: "12", rx: "2" }],
    ],
    Dh = [
      ["path", { d: "M10 14v-4" }],
      ["path", { d: "M22 14v-4" }],
      ["path", { d: "M6 14v-4" }],
      ["rect", { x: "2", y: "6", width: "16", height: "12", rx: "2" }],
    ],
    Fh = [
      ["path", { d: "M10 9v6" }],
      ["path", { d: "M12.543 6H16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.605" }],
      ["path", { d: "M22 14v-4" }],
      ["path", { d: "M7 12h6" }],
      ["path", { d: "M7.606 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.606" }],
    ],
    zh = [
      ["path", { d: "M10 17h.01" }],
      ["path", { d: "M10 7v6" }],
      ["path", { d: "M14 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M22 14v-4" }],
      ["path", { d: "M6 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2" }],
    ],
    bh = [
      ["path", { d: "M 22 14 L 22 10" }],
      ["rect", { x: "2", y: "6", width: "16", height: "12", rx: "2" }],
    ],
    Rh = [
      ["path", { d: "M4.5 3h15" }],
      ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3" }],
      ["path", { d: "M6 14h12" }],
    ],
    Th = [
      [
        "path",
        {
          d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
        },
      ],
      [
        "path",
        { d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66" },
      ],
      [
        "path",
        {
          d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
        },
      ],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    qh = [
      [
        "path",
        {
          d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
        },
      ],
      ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28" }],
    ],
    Uh = [
      ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8" }],
      ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" }],
      ["path", { d: "M12 4v6" }],
      ["path", { d: "M2 18h20" }],
    ],
    Oh = [
      ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8" }],
      ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4" }],
      ["path", { d: "M3 18h18" }],
    ],
    Zh = [
      ["path", { d: "M2 4v16" }],
      ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10" }],
      ["path", { d: "M2 17h20" }],
      ["path", { d: "M6 8v9" }],
    ],
    Gh = [
      [
        "path",
        {
          d: "M16.4 13.7A6.5 6.5 0 1 0 6.28 6.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3",
        },
      ],
      [
        "path",
        {
          d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1-2.29 7.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
        },
      ],
      ["circle", { cx: "12.5", cy: "8.5", r: "2.5" }],
    ],
    Ih = [
      ["path", { d: "M13 13v5" }],
      ["path", { d: "M17 11.47V8" }],
      ["path", { d: "M17 11h1a3 3 0 0 1 2.745 4.211" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3" }],
      [
        "path",
        {
          d: "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268",
        },
      ],
      [
        "path",
        {
          d: "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
        },
      ],
      ["path", { d: "M9 14.6V18" }],
    ],
    Wh = [
      ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1" }],
      ["path", { d: "M9 12v6" }],
      ["path", { d: "M13 12v6" }],
      [
        "path",
        {
          d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
        },
      ],
      ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8" }],
    ],
    Eh = [
      ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
      [
        "path",
        {
          d: "M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665",
        },
      ],
      ["circle", { cx: "18", cy: "8", r: "3" }],
    ],
    Xh = [
      ["path", { d: "M18.518 17.347A7 7 0 0 1 14 19" }],
      ["path", { d: "M18.8 4A11 11 0 0 1 20 9" }],
      ["path", { d: "M9 9h.01" }],
      ["circle", { cx: "20", cy: "16", r: "2" }],
      ["circle", { cx: "9", cy: "9", r: "7" }],
      ["rect", { x: "4", y: "16", width: "10", height: "6", rx: "2" }],
    ],
    jh = [
      ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
      ["path", { d: "M15 8h6" }],
      [
        "path",
        {
          d: "M16.243 3.757A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673A9.4 9.4 0 0 1 18.667 12",
        },
      ],
    ],
    Nh = [
      ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
      [
        "path",
        {
          d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05" }],
    ],
    Kh = [
      ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
      ["path", { d: "M15 8h6" }],
      ["path", { d: "M18 5v6" }],
      [
        "path",
        {
          d: "M20.002 14.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332",
        },
      ],
    ],
    Qh = [
      ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
      ["path", { d: "M22 8c0-2.3-.8-4.3-2-6" }],
      [
        "path",
        {
          d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
        },
      ],
      ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8" }],
    ],
    Jh = [
      ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
      [
        "path",
        {
          d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
        },
      ],
    ],
    k = [
      ["rect", { width: "13", height: "7", x: "3", y: "3", rx: "1" }],
      ["path", { d: "m22 15-3-3 3-3" }],
      ["rect", { width: "13", height: "7", x: "3", y: "14", rx: "1" }],
    ],
    P = [
      ["rect", { width: "13", height: "7", x: "8", y: "3", rx: "1" }],
      ["path", { d: "m2 9 3 3-3 3" }],
      ["rect", { width: "13", height: "7", x: "8", y: "14", rx: "1" }],
    ],
    Yh = [
      ["rect", { width: "7", height: "13", x: "3", y: "3", rx: "1" }],
      ["path", { d: "m9 22 3-3 3 3" }],
      ["rect", { width: "7", height: "13", x: "14", y: "3", rx: "1" }],
    ],
    _h = [
      ["rect", { width: "7", height: "13", x: "3", y: "8", rx: "1" }],
      ["path", { d: "m15 2-3 3-3-3" }],
      ["rect", { width: "7", height: "13", x: "14", y: "8", rx: "1" }],
    ],
    xh = [
      [
        "path",
        {
          d: "M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1",
        },
      ],
      ["path", { d: "M15 14a5 5 0 0 0-7.584 2" }],
      ["path", { d: "M9.964 6.825C8.019 7.977 9.5 13 8 15" }],
    ],
    a4 = [
      ["circle", { cx: "18.5", cy: "17.5", r: "3.5" }],
      ["circle", { cx: "5.5", cy: "17.5", r: "3.5" }],
      ["circle", { cx: "15", cy: "5", r: "1" }],
      ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2" }],
    ],
    t4 = [
      ["rect", { x: "14", y: "14", width: "4", height: "6", rx: "2" }],
      ["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2" }],
      ["path", { d: "M6 20h4" }],
      ["path", { d: "M14 10h4" }],
      ["path", { d: "M6 14h2v6" }],
      ["path", { d: "M14 4h2v6" }],
    ],
    h4 = [
      ["path", { d: "M10 10h4" }],
      ["path", { d: "M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3" }],
      [
        "path",
        {
          d: "M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z",
        },
      ],
      ["path", { d: "M 22 16 L 2 16" }],
      [
        "path",
        {
          d: "M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z",
        },
      ],
      ["path", { d: "M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3" }],
    ],
    d4 = [
      ["circle", { cx: "12", cy: "11.9", r: "2" }],
      ["path", { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6" }],
      ["path", { d: "m8.9 10.1 1.4.8" }],
      ["path", { d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5" }],
      ["path", { d: "m15.1 10.1-1.4.8" }],
      [
        "path",
        { d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2" },
      ],
      ["path", { d: "M12 13.9v1.6" }],
      ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0" }],
      ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5" }],
      ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5" }],
    ],
    c4 = [
      ["path", { d: "M16 7h.01" }],
      ["path", { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20" }],
      ["path", { d: "m20 7 2 .5-2 .5" }],
      ["path", { d: "M10 18v3" }],
      ["path", { d: "M14 17.75V21" }],
      ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61" }],
    ],
    M4 = [
      ["circle", { cx: "9", cy: "9", r: "7" }],
      ["circle", { cx: "15", cy: "15", r: "7" }],
    ],
    p4 = [
      [
        "path",
        {
          d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
        },
      ],
    ],
    i4 = [
      [
        "path",
        {
          d: "M10 22V7a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1H2",
        },
      ],
      ["rect", { x: "14", y: "2", width: "8", height: "8", rx: "1" }],
    ],
    n4 = [
      ["path", { d: "M3 3h18" }],
      ["path", { d: "M20 7H8" }],
      ["path", { d: "M20 11H8" }],
      ["path", { d: "M10 19h10" }],
      ["path", { d: "M8 15h12" }],
      ["path", { d: "M4 3v14" }],
      ["circle", { cx: "4", cy: "19", r: "2" }],
    ],
    l4 = [
      ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17" }],
      ["line", { x1: "18", x2: "21", y1: "12", y2: "12" }],
      ["line", { x1: "3", x2: "6", y1: "12", y2: "12" }],
    ],
    e4 = [
      ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17" }],
      ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66" }],
      ["path", { d: "M18 12h.01" }],
    ],
    r4 = [["path", { d: "m7 7 10 10-5 5V2l5 5L7 17" }]],
    o4 = [
      ["path", { d: "m17 17-5 5V12l-5 5" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M14.5 9.5 17 7l-5-5v4.5" }],
    ],
    v4 = [
      [
        "path",
        {
          d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8",
        },
      ],
    ],
    $4 = [
      [
        "path",
        {
          d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
        },
      ],
      ["circle", { cx: "12", cy: "12", r: "4" }],
    ],
    m4 = [
      ["circle", { cx: "11", cy: "13", r: "9" }],
      [
        "path",
        {
          d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95",
        },
      ],
      ["path", { d: "m22 2-1.5 1.5" }],
    ],
    y4 = [
      [
        "path",
        {
          d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
        },
      ],
    ],
    s4 = [
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["path", { d: "m8 13 4-7 4 7" }],
      ["path", { d: "M9.1 11h5.7" }],
    ],
    g4 = [
      ["path", { d: "M12 13h.01" }],
      ["path", { d: "M12 6v3" }],
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
    ],
    u4 = [
      ["path", { d: "M12 6v7" }],
      ["path", { d: "M16 8v3" }],
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["path", { d: "M8 8v3" }],
    ],
    C4 = [
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["path", { d: "m9 9.5 2 2 4-4" }],
    ],
    H4 = [
      ["path", { d: "M5 7a2 2 0 0 0-2 2v11" }],
      ["path", { d: "M5.803 18H5a2 2 0 0 0 0 4h9.5a.5.5 0 0 0 .5-.5V21" }],
      [
        "path",
        {
          d: "M9 15V4a2 2 0 0 1 2-2h9.5a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H11a2 2 0 0 1 0-4h10",
        },
      ],
    ],
    B = [
      ["path", { d: "M12 17h1.5" }],
      ["path", { d: "M12 22h1.5" }],
      ["path", { d: "M12 2h1.5" }],
      ["path", { d: "M17.5 22H19a1 1 0 0 0 1-1" }],
      ["path", { d: "M17.5 2H19a1 1 0 0 1 1 1v1.5" }],
      ["path", { d: "M20 14v3h-2.5" }],
      ["path", { d: "M20 8.5V10" }],
      ["path", { d: "M4 10V8.5" }],
      ["path", { d: "M4 19.5V14" }],
      ["path", { d: "M4 4.5A2.5 2.5 0 0 1 6.5 2H8" }],
      ["path", { d: "M8 22H6.5a1 1 0 0 1 0-5H8" }],
    ],
    A4 = [
      ["path", { d: "M12 13V7" }],
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["path", { d: "m9 10 3 3 3-3" }],
    ],
    w4 = [
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2" }],
      ["circle", { cx: "15", cy: "12", r: "1" }],
      ["circle", { cx: "9", cy: "12", r: "1" }],
    ],
    V4 = [
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      [
        "path",
        {
          d: "M8.62 9.8A2.25 2.25 0 1 1 12 6.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z",
        },
      ],
    ],
    S4 = [
      ["path", { d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17" }],
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["circle", { cx: "10", cy: "8", r: "2" }],
    ],
    L4 = [
      ["path", { d: "m19 3 1 1" }],
      ["path", { d: "m20 2-4.5 4.5" }],
      ["path", { d: "M20 7.898V21a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" }],
      ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2h7.844" }],
      ["circle", { cx: "14", cy: "8", r: "2" }],
    ],
    f4 = [
      ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2" }],
      ["path", { d: "M20 15v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" }],
      ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10" }],
      ["rect", { x: "12", y: "6", width: "8", height: "5", rx: "1" }],
    ],
    k4 = [
      ["path", { d: "M10 2v8l3-3 3 3V2" }],
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
    ],
    P4 = [
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["path", { d: "M9 10h6" }],
    ],
    B4 = [
      ["path", { d: "M12 21V7" }],
      ["path", { d: "m16 12 2 2 4-4" }],
      [
        "path",
        {
          d: "M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1v-1.3",
        },
      ],
    ],
    D4 = [
      ["path", { d: "M12 7v14" }],
      ["path", { d: "M16 12h2" }],
      ["path", { d: "M16 8h2" }],
      [
        "path",
        {
          d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
        },
      ],
      ["path", { d: "M6 12h2" }],
      ["path", { d: "M6 8h2" }],
    ],
    F4 = [
      ["path", { d: "M12 7v14" }],
      [
        "path",
        {
          d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
        },
      ],
    ],
    z4 = [
      ["path", { d: "M12 7v6" }],
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["path", { d: "M9 10h6" }],
    ],
    b4 = [
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["path", { d: "M8 11h8" }],
      ["path", { d: "M8 7h6" }],
    ],
    R4 = [
      ["path", { d: "M12 13V7" }],
      [
        "path",
        { d: "M18 2h1a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
      ],
      ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2" }],
      ["path", { d: "m9 10 3-3 3 3" }],
      ["path", { d: "m9 5 3-3 3 3" }],
    ],
    T4 = [
      ["path", { d: "M10 13h4" }],
      ["path", { d: "M12 6v7" }],
      ["path", { d: "M16 8V6H8v2" }],
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
    ],
    q4 = [
      ["path", { d: "M12 13V7" }],
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["path", { d: "m9 10 3-3 3 3" }],
    ],
    U4 = [
      ["path", { d: "M15 13a3 3 0 1 0-6 0" }],
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["circle", { cx: "12", cy: "8", r: "2" }],
    ],
    O4 = [
      ["path", { d: "m14.5 7-5 5" }],
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
      ["path", { d: "m9.5 7 5 5" }],
    ],
    Z4 = [
      [
        "path",
        {
          d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
        },
      ],
    ],
    G4 = [
      ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z" }],
      ["path", { d: "m9 10 2 2 4-4" }],
    ],
    I4 = [
      ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" }],
      ["line", { x1: "15", x2: "9", y1: "10", y2: "10" }],
    ],
    W4 = [
      ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" }],
      ["line", { x1: "12", x2: "12", y1: "7", y2: "13" }],
      ["line", { x1: "15", x2: "9", y1: "10", y2: "10" }],
    ],
    E4 = [
      ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z" }],
      ["path", { d: "m14.5 7.5-5 5" }],
      ["path", { d: "m9.5 7.5 5 5" }],
    ],
    X4 = [
      ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" }],
    ],
    j4 = [
      ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" }],
      ["path", { d: "M8 8v1" }],
      ["path", { d: "M12 8v1" }],
      ["path", { d: "M16 8v1" }],
      ["rect", { width: "20", height: "12", x: "2", y: "9", rx: "2" }],
      ["circle", { cx: "8", cy: "15", r: "2" }],
      ["circle", { cx: "16", cy: "15", r: "2" }],
    ],
    N4 = [
      ["path", { d: "M13.67 8H18a2 2 0 0 1 2 2v4.33" }],
      ["path", { d: "M2 14h2" }],
      ["path", { d: "M20 14h2" }],
      ["path", { d: "M22 22 2 2" }],
      [
        "path",
        { d: "M8 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 1.414-.586" },
      ],
      ["path", { d: "M9 13v2" }],
      ["path", { d: "M9.67 4H12v2.33" }],
    ],
    K4 = [
      ["path", { d: "M12 6V2H8" }],
      ["path", { d: "M15 11v2" }],
      ["path", { d: "M2 12h2" }],
      ["path", { d: "M20 12h2" }],
      [
        "path",
        {
          d: "M20 16a2 2 0 0 1-2 2H8.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 4 20.286V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z",
        },
      ],
      ["path", { d: "M9 11v2" }],
    ],
    Q4 = [
      ["path", { d: "M12 8V4H8" }],
      ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2" }],
      ["path", { d: "M2 14h2" }],
      ["path", { d: "M20 14h2" }],
      ["path", { d: "M15 13v2" }],
      ["path", { d: "M9 13v2" }],
    ],
    J4 = [
      [
        "path",
        {
          d: "M10 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a6 6 0 0 0 1.2 3.6l.6.8A6 6 0 0 1 17 13v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-8a6 6 0 0 1 1.2-3.6l.6-.8A6 6 0 0 0 10 5z",
        },
      ],
      ["path", { d: "M17 13h-4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4" }],
    ],
    Y4 = [
      ["path", { d: "M17 3h4v4" }],
      [
        "path",
        {
          d: "M18.575 11.082a13 13 0 0 1 1.048 9.027 1.17 1.17 0 0 1-1.914.597L14 17",
        },
      ],
      [
        "path",
        { d: "M7 10 3.29 6.29a1.17 1.17 0 0 1 .6-1.91 13 13 0 0 1 9.03 1.05" },
      ],
      [
        "path",
        {
          d: "M7 14a1.7 1.7 0 0 0-1.207.5l-2.646 2.646A.5.5 0 0 0 3.5 18H5a1 1 0 0 1 1 1v1.5a.5.5 0 0 0 .854.354L9.5 18.207A1.7 1.7 0 0 0 10 17v-2a1 1 0 0 0-1-1z",
        },
      ],
      ["path", { d: "M9.707 14.293 21 3" }],
    ],
    _4 = [
      [
        "path",
        {
          d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
        },
      ],
      ["path", { d: "m3.3 7 8.7 5 8.7-5" }],
      ["path", { d: "M12 22V12" }],
    ],
    x4 = [
      [
        "path",
        {
          d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
        },
      ],
      ["path", { d: "m7 16.5-4.74-2.85" }],
      ["path", { d: "m7 16.5 5-3" }],
      ["path", { d: "M7 16.5v5.17" }],
      [
        "path",
        {
          d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
        },
      ],
      ["path", { d: "m17 16.5-5-3" }],
      ["path", { d: "m17 16.5 4.74-2.85" }],
      ["path", { d: "M17 16.5v5.17" }],
      [
        "path",
        {
          d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
        },
      ],
      ["path", { d: "M12 8 7.26 5.15" }],
      ["path", { d: "m12 8 4.74-2.85" }],
      ["path", { d: "M12 13.5V8" }],
    ],
    D = [
      [
        "path",
        {
          d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1",
        },
      ],
      [
        "path",
        {
          d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
        },
      ],
    ],
    a5 = [
      ["path", { d: "M16 3h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-3" }],
      ["path", { d: "M8 21H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3" }],
    ],
    t5 = [
      [
        "path",
        {
          d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
        },
      ],
      ["path", { d: "M9 13a4.5 4.5 0 0 0 3-4" }],
      ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5" }],
      ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396" }],
      ["path", { d: "M6 18a4 4 0 0 1-1.967-.516" }],
      ["path", { d: "M12 13h4" }],
      ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1" }],
      ["path", { d: "M12 8h8" }],
      ["path", { d: "M16 8V5a2 2 0 0 1 2-2" }],
      ["circle", { cx: "16", cy: "13", r: ".5" }],
      ["circle", { cx: "18", cy: "3", r: ".5" }],
      ["circle", { cx: "20", cy: "21", r: ".5" }],
      ["circle", { cx: "20", cy: "8", r: ".5" }],
    ],
    h5 = [
      ["path", { d: "m10.852 14.772-.383.923" }],
      ["path", { d: "m10.852 9.228-.383-.923" }],
      ["path", { d: "m13.148 14.772.382.924" }],
      ["path", { d: "m13.531 8.305-.383.923" }],
      ["path", { d: "m14.772 10.852.923-.383" }],
      ["path", { d: "m14.772 13.148.923.383" }],
      [
        "path",
        {
          d: "M17.598 6.5A3 3 0 1 0 12 5a3 3 0 0 0-5.63-1.446 3 3 0 0 0-.368 1.571 4 4 0 0 0-2.525 5.771",
        },
      ],
      ["path", { d: "M17.998 5.125a4 4 0 0 1 2.525 5.771" }],
      ["path", { d: "M19.505 10.294a4 4 0 0 1-1.5 7.706" }],
      [
        "path",
        {
          d: "M4.032 17.483A4 4 0 0 0 11.464 20c.18-.311.892-.311 1.072 0a4 4 0 0 0 7.432-2.516",
        },
      ],
      ["path", { d: "M4.5 10.291A4 4 0 0 0 6 18" }],
      ["path", { d: "M6.002 5.125a3 3 0 0 0 .4 1.375" }],
      ["path", { d: "m9.228 10.852-.923-.383" }],
      ["path", { d: "m9.228 13.148-.923.383" }],
      ["circle", { cx: "12", cy: "12", r: "3" }],
    ],
    d5 = [
      ["path", { d: "M12 18V5" }],
      ["path", { d: "M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4" }],
      ["path", { d: "M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5" }],
      ["path", { d: "M17.997 5.125a4 4 0 0 1 2.526 5.77" }],
      ["path", { d: "M18 18a4 4 0 0 0 2-7.464" }],
      ["path", { d: "M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517" }],
      ["path", { d: "M6 18a4 4 0 0 1-2-7.464" }],
      ["path", { d: "M6.003 5.125a4 4 0 0 0-2.526 5.77" }],
    ],
    c5 = [
      ["path", { d: "M16 3v2.107" }],
      [
        "path",
        {
          d: "M17 9c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 22 17a5 5 0 0 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C13 11.5 16 9 17 9",
        },
      ],
      [
        "path",
        {
          d: "M21 8.274V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.938",
        },
      ],
      ["path", { d: "M3 15h5.253" }],
      ["path", { d: "M3 9h8.228" }],
      ["path", { d: "M8 15v6" }],
      ["path", { d: "M8 3v6" }],
    ],
    M5 = [
      ["path", { d: "M12 9v1.258" }],
      ["path", { d: "M16 3v5.46" }],
      [
        "path",
        {
          d: "M21 9.118V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5.75",
        },
      ],
      [
        "path",
        {
          d: "M22 17.5c0 2.499-1.75 3.749-3.83 4.474a.5.5 0 0 1-.335-.005c-2.085-.72-3.835-1.97-3.835-4.47V14a.5.5 0 0 1 .5-.499c1 0 2.25-.6 3.12-1.36a.6.6 0 0 1 .76-.001c.875.765 2.12 1.36 3.12 1.36a.5.5 0 0 1 .5.5z",
        },
      ],
      ["path", { d: "M3 15h7" }],
      ["path", { d: "M3 9h12.142" }],
      ["path", { d: "M8 15v6" }],
      ["path", { d: "M8 3v6" }],
    ],
    p5 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M12 9v6" }],
      ["path", { d: "M16 15v6" }],
      ["path", { d: "M16 3v6" }],
      ["path", { d: "M3 15h18" }],
      ["path", { d: "M3 9h18" }],
      ["path", { d: "M8 15v6" }],
      ["path", { d: "M8 3v6" }],
    ],
    i5 = [
      ["path", { d: "M12 12h.01" }],
      ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }],
      ["path", { d: "M22 13a18.15 18.15 0 0 1-20 0" }],
      ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2" }],
    ],
    n5 = [
      ["path", { d: "M10 20v2" }],
      ["path", { d: "M14 20v2" }],
      ["path", { d: "M18 20v2" }],
      ["path", { d: "M21 20H3" }],
      ["path", { d: "M6 20v2" }],
      ["path", { d: "M8 16V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12" }],
      ["rect", { x: "4", y: "6", width: "16", height: "10", rx: "2" }],
    ],
    l5 = [
      ["path", { d: "M12 11v4" }],
      ["path", { d: "M14 13h-4" }],
      ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }],
      ["path", { d: "M18 6v14" }],
      ["path", { d: "M6 6v14" }],
      ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2" }],
    ],
    e5 = [
      ["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" }],
      ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2" }],
    ],
    r5 = [
      ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2" }],
      ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2" }],
      ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2" }],
    ],
    o5 = [
      ["path", { d: "m16 22-1-4" }],
      [
        "path",
        {
          d: "M19 13.99a1 1 0 0 0 1-1V12a2 2 0 0 0-2-2h-3a1 1 0 0 1-1-1V4a2 2 0 0 0-4 0v5a1 1 0 0 1-1 1H6a2 2 0 0 0-2 2v.99a1 1 0 0 0 1 1",
        },
      ],
      [
        "path",
        { d: "M5 14h14l1.973 6.767A1 1 0 0 1 20 22H4a1 1 0 0 1-.973-1.233z" },
      ],
      ["path", { d: "m8 22 1-4" }],
    ],
    v5 = [
      ["path", { d: "m11 10 3 3" }],
      [
        "path",
        {
          d: "M6.5 21A3.5 3.5 0 1 0 3 17.5a2.62 2.62 0 0 1-.708 1.792A1 1 0 0 0 3 21z",
        },
      ],
      [
        "path",
        { d: "M9.969 17.031 21.378 5.624a1 1 0 0 0-3.002-3.002L6.967 14.031" },
      ],
    ],
    $5 = [
      ["path", { d: "M7.2 14.8a2 2 0 0 1 2 2" }],
      ["circle", { cx: "18.5", cy: "8.5", r: "3.5" }],
      ["circle", { cx: "7.5", cy: "16.5", r: "5.5" }],
      ["circle", { cx: "7.5", cy: "4.5", r: "2.5" }],
    ],
    m5 = [
      ["path", { d: "M12 20v-8" }],
      ["path", { d: "M14.12 3.88 16 2" }],
      ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2" }],
      ["path", { d: "M18 12.34V11a4 4 0 0 0-4-4h-1.3" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M21 5a4 4 0 0 1-3.55 3.97" }],
      ["path", { d: "M22 13h-3.34" }],
      ["path", { d: "M3 21a4 4 0 0 1 3.81-4" }],
      ["path", { d: "M6 13H2" }],
      ["path", { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13" }],
    ],
    y5 = [
      [
        "path",
        { d: "M10 19.655A6 6 0 0 1 6 14v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 3.97" },
      ],
      [
        "path",
        {
          d: "M14 15.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997a1 1 0 0 1-1.517-.86z",
        },
      ],
      ["path", { d: "M14.12 3.88 16 2" }],
      ["path", { d: "M21 5a4 4 0 0 1-3.55 3.97" }],
      ["path", { d: "M3 21a4 4 0 0 1 3.81-4" }],
      ["path", { d: "M3 5a4 4 0 0 0 3.55 3.97" }],
      ["path", { d: "M6 13H2" }],
      ["path", { d: "m8 2 1.88 1.88" }],
      ["path", { d: "M9 7.13V6a3 3 0 1 1 6 0v1.13" }],
    ],
    s5 = [
      ["path", { d: "M12 20v-9" }],
      ["path", { d: "M14 7a4 4 0 0 1 4 4v3a6 6 0 0 1-12 0v-3a4 4 0 0 1 4-4z" }],
      ["path", { d: "M14.12 3.88 16 2" }],
      ["path", { d: "M21 21a4 4 0 0 0-3.81-4" }],
      ["path", { d: "M21 5a4 4 0 0 1-3.55 3.97" }],
      ["path", { d: "M22 13h-4" }],
      ["path", { d: "M3 21a4 4 0 0 1 3.81-4" }],
      ["path", { d: "M3 5a4 4 0 0 0 3.55 3.97" }],
      ["path", { d: "M6 13H2" }],
      ["path", { d: "m8 2 1.88 1.88" }],
      ["path", { d: "M9 7.13V6a3 3 0 1 1 6 0v1.13" }],
    ],
    g5 = [
      ["path", { d: "M10 12h4" }],
      ["path", { d: "M10 8h4" }],
      ["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
      [
        "path",
        {
          d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2",
        },
      ],
      ["path", { d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" }],
    ],
    u5 = [
      ["path", { d: "M12 10h.01" }],
      ["path", { d: "M12 14h.01" }],
      ["path", { d: "M12 6h.01" }],
      ["path", { d: "M16 10h.01" }],
      ["path", { d: "M16 14h.01" }],
      ["path", { d: "M16 6h.01" }],
      ["path", { d: "M8 10h.01" }],
      ["path", { d: "M8 14h.01" }],
      ["path", { d: "M8 6h.01" }],
      ["path", { d: "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3" }],
      ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2" }],
    ],
    C5 = [
      ["path", { d: "M4 6 2 7" }],
      ["path", { d: "M10 6h4" }],
      ["path", { d: "m22 7-2-1" }],
      ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2" }],
      ["path", { d: "M4 11h16" }],
      ["path", { d: "M8 15h.01" }],
      ["path", { d: "M16 15h.01" }],
      ["path", { d: "M6 19v2" }],
      ["path", { d: "M18 21v-2" }],
    ],
    H5 = [
      ["path", { d: "M8 6v6" }],
      ["path", { d: "M15 6v6" }],
      ["path", { d: "M2 12h19.6" }],
      [
        "path",
        {
          d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
        },
      ],
      ["circle", { cx: "7", cy: "18", r: "2" }],
      ["path", { d: "M9 18h5" }],
      ["circle", { cx: "16", cy: "18", r: "2" }],
    ],
    A5 = [
      ["path", { d: "M10 3h.01" }],
      ["path", { d: "M14 2h.01" }],
      ["path", { d: "m2 9 20-5" }],
      ["path", { d: "M12 12V6.5" }],
      ["rect", { width: "16", height: "10", x: "4", y: "12", rx: "3" }],
      ["path", { d: "M9 12v5" }],
      ["path", { d: "M15 12v5" }],
      ["path", { d: "M4 17h16" }],
    ],
    w5 = [
      [
        "path",
        {
          d: "M17 19a1 1 0 0 1-1-1v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a1 1 0 0 1-1 1z",
        },
      ],
      ["path", { d: "M17 21v-2" }],
      ["path", { d: "M19 14V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V10" }],
      ["path", { d: "M21 21v-2" }],
      ["path", { d: "M3 5V3" }],
      [
        "path",
        {
          d: "M4 10a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2z",
        },
      ],
      ["path", { d: "M7 5V3" }],
    ],
    V5 = [
      ["path", { d: "M16 13H3" }],
      ["path", { d: "M16 17H3" }],
      [
        "path",
        {
          d: "m7.2 7.9-3.388 2.5A2 2 0 0 0 3 12.01V20a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-8.654c0-2-2.44-6.026-6.44-8.026a1 1 0 0 0-1.082.057L10.4 5.6",
        },
      ],
      ["circle", { cx: "9", cy: "7", r: "2" }],
    ],
    S5 = [
      ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" }],
      ["path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1" }],
      ["path", { d: "M2 21h20" }],
      ["path", { d: "M7 8v3" }],
      ["path", { d: "M12 8v3" }],
      ["path", { d: "M17 8v3" }],
      ["path", { d: "M7 4h.01" }],
      ["path", { d: "M12 4h.01" }],
      ["path", { d: "M17 4h.01" }],
    ],
    L5 = [
      ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2" }],
      ["line", { x1: "8", x2: "16", y1: "6", y2: "6" }],
      ["line", { x1: "16", x2: "16", y1: "14", y2: "18" }],
      ["path", { d: "M16 10h.01" }],
      ["path", { d: "M12 10h.01" }],
      ["path", { d: "M8 10h.01" }],
      ["path", { d: "M12 14h.01" }],
      ["path", { d: "M8 14h.01" }],
      ["path", { d: "M12 18h.01" }],
      ["path", { d: "M8 18h.01" }],
    ],
    f5 = [
      ["path", { d: "M11 14h1v4" }],
      ["path", { d: "M16 2v4" }],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M8 2v4" }],
      ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2" }],
    ],
    k5 = [
      ["path", { d: "m14 18 4 4 4-4" }],
      ["path", { d: "M16 2v4" }],
      ["path", { d: "M18 14v8" }],
      [
        "path",
        {
          d: "M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343",
        },
      ],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M8 2v4" }],
    ],
    P5 = [
      ["path", { d: "m14 18 4-4 4 4" }],
      ["path", { d: "M16 2v4" }],
      ["path", { d: "M18 22v-8" }],
      [
        "path",
        { d: "M21 11.343V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9" },
      ],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M8 2v4" }],
    ],
    B5 = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M16 2v4" }],
      [
        "path",
        { d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8" },
      ],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "m16 20 2 2 4-4" }],
    ],
    D5 = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M16 2v4" }],
      ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2" }],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "m9 16 2 2 4-4" }],
    ],
    F5 = [
      ["path", { d: "M16 14v2.2l1.6 1" }],
      ["path", { d: "M16 2v4" }],
      [
        "path",
        { d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" },
      ],
      ["path", { d: "M3 10h5" }],
      ["path", { d: "M8 2v4" }],
      ["circle", { cx: "16", cy: "16", r: "6" }],
    ],
    z5 = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M16 2v4" }],
      ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2" }],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M8 14h.01" }],
      ["path", { d: "M12 14h.01" }],
      ["path", { d: "M16 14h.01" }],
      ["path", { d: "M8 18h.01" }],
      ["path", { d: "M12 18h.01" }],
      ["path", { d: "M16 18h.01" }],
    ],
    b5 = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M16 2v4" }],
      [
        "path",
        { d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z" },
      ],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M15 22v-4a2 2 0 0 1 2-2h4" }],
    ],
    R5 = [
      ["path", { d: "m15.228 16.852-.923-.383" }],
      ["path", { d: "m15.228 19.148-.923.383" }],
      ["path", { d: "M16 2v4" }],
      ["path", { d: "m16.47 14.305.382.923" }],
      ["path", { d: "m16.852 20.772-.383.924" }],
      ["path", { d: "m19.148 15.228.383-.923" }],
      ["path", { d: "m19.53 21.696-.382-.924" }],
      ["path", { d: "m20.772 16.852.924-.383" }],
      ["path", { d: "m20.772 19.148.924.383" }],
      [
        "path",
        { d: "M21 10.592V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" },
      ],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M8 2v4" }],
      ["circle", { cx: "18", cy: "18", r: "3" }],
    ],
    T5 = [
      [
        "path",
        {
          d: "M12.127 22H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5.125",
        },
      ],
      [
        "path",
        {
          d: "M14.62 18.8A2.25 2.25 0 1 1 18 15.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z",
        },
      ],
      ["path", { d: "M16 2v4" }],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M8 2v4" }],
    ],
    q5 = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M16 2v4" }],
      ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2" }],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M10 16h4" }],
    ],
    U5 = [
      ["path", { d: "M16 19h6" }],
      ["path", { d: "M16 2v4" }],
      [
        "path",
        { d: "M21 15V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5" },
      ],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M8 2v4" }],
    ],
    O5 = [
      [
        "path",
        { d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18" },
      ],
      ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5" }],
      ["path", { d: "M16 2v4" }],
      ["path", { d: "M3 10h7" }],
      ["path", { d: "M21 10h-5.5" }],
      ["path", { d: "m2 2 20 20" }],
    ],
    Z5 = [
      ["path", { d: "M16 19h6" }],
      ["path", { d: "M16 2v4" }],
      ["path", { d: "M19 16v6" }],
      [
        "path",
        {
          d: "M21 12.598V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5",
        },
      ],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M8 2v4" }],
    ],
    G5 = [
      ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2" }],
      ["path", { d: "M16 2v4" }],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M17 14h-6" }],
      ["path", { d: "M13 18H7" }],
      ["path", { d: "M7 14h.01" }],
      ["path", { d: "M17 18h.01" }],
    ],
    I5 = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M16 2v4" }],
      ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2" }],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M10 16h4" }],
      ["path", { d: "M12 14v4" }],
    ],
    W5 = [
      ["path", { d: "M11 10v4h4" }],
      ["path", { d: "m11 14 1.535-1.605a5 5 0 0 1 8 1.5" }],
      ["path", { d: "M16 2v4" }],
      ["path", { d: "m21 18-1.535 1.605a5 5 0 0 1-8-1.5" }],
      ["path", { d: "M21 22v-4h-4" }],
      [
        "path",
        { d: "M21 8.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3" },
      ],
      ["path", { d: "M3 10h4" }],
      ["path", { d: "M8 2v4" }],
    ],
    E5 = [
      ["path", { d: "M16 2v4" }],
      [
        "path",
        {
          d: "M21 11.75V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.25",
        },
      ],
      ["path", { d: "m22 22-1.875-1.875" }],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "M8 2v4" }],
      ["circle", { cx: "18", cy: "18", r: "3" }],
    ],
    X5 = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M16 2v4" }],
      [
        "path",
        { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8" },
      ],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "m17 22 5-5" }],
      ["path", { d: "m17 17 5 5" }],
    ],
    j5 = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M16 2v4" }],
      ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2" }],
      ["path", { d: "M3 10h18" }],
      ["path", { d: "m14 14-4 4" }],
      ["path", { d: "m10 14 4 4" }],
    ],
    N5 = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M16 2v4" }],
      ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2" }],
      ["path", { d: "M3 10h18" }],
    ],
    K5 = [
      ["path", { d: "M14.564 14.558a3 3 0 1 1-4.122-4.121" }],
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        {
          d: "M20 20H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 .819-.175",
        },
      ],
      [
        "path",
        {
          d: "M9.695 4.024A2 2 0 0 1 10.004 4h3.993a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v7.344",
        },
      ],
    ],
    Q5 = [
      [
        "path",
        {
          d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
        },
      ],
      ["circle", { cx: "12", cy: "13", r: "3" }],
    ],
    J5 = [
      [
        "path",
        {
          d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
        },
      ],
      ["path", { d: "M17.75 7 15 2.1" }],
      ["path", { d: "M10.9 4.8 13 9" }],
      ["path", { d: "m7.9 9.7 2 4.4" }],
      ["path", { d: "M4.9 14.7 7 18.9" }],
    ],
    Y5 = [
      ["path", { d: "M10 10v7.9" }],
      ["path", { d: "M11.802 6.145a5 5 0 0 1 6.053 6.053" }],
      ["path", { d: "M14 6.1v2.243" }],
      [
        "path",
        {
          d: "m15.5 15.571-.964.964a5 5 0 0 1-7.071 0 5 5 0 0 1 0-7.07l.964-.965",
        },
      ],
      [
        "path",
        {
          d: "M16 7V3a1 1 0 0 1 1.707-.707 2.5 2.5 0 0 0 2.152.717 1 1 0 0 1 1.131 1.131 2.5 2.5 0 0 0 .717 2.152A1 1 0 0 1 21 8h-4",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        {
          d: "M8 17v4a1 1 0 0 1-1.707.707 2.5 2.5 0 0 0-2.152-.717 1 1 0 0 1-1.131-1.131 2.5 2.5 0 0 0-.717-2.152A1 1 0 0 1 3 16h4",
        },
      ],
    ],
    _5 = [
      ["path", { d: "M10 7v10.9" }],
      ["path", { d: "M14 6.1V17" }],
      [
        "path",
        {
          d: "M16 7V3a1 1 0 0 1 1.707-.707 2.5 2.5 0 0 0 2.152.717 1 1 0 0 1 1.131 1.131 2.5 2.5 0 0 0 .717 2.152A1 1 0 0 1 21 8h-4",
        },
      ],
      [
        "path",
        {
          d: "M16.536 7.465a5 5 0 0 0-7.072 0l-2 2a5 5 0 0 0 0 7.07 5 5 0 0 0 7.072 0l2-2a5 5 0 0 0 0-7.07",
        },
      ],
      [
        "path",
        {
          d: "M8 17v4a1 1 0 0 1-1.707.707 2.5 2.5 0 0 0-2.152-.717 1 1 0 0 1-1.131-1.131 2.5 2.5 0 0 0-.717-2.152A1 1 0 0 1 3 16h4",
        },
      ],
    ],
    x5 = [
      ["path", { d: "M12 22v-4" }],
      [
        "path",
        {
          d: "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6",
        },
      ],
    ],
    a3 = [
      ["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5" }],
      ["path", { d: "M17 11h-.5" }],
      ["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M7 11h4" }],
      ["path", { d: "M7 15h2.5" }],
    ],
    F = [
      ["rect", { width: "18", height: "14", x: "3", y: "5", rx: "2", ry: "2" }],
      ["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4" }],
    ],
    t3 = [
      [
        "path",
        {
          d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8",
        },
      ],
      ["path", { d: "M7 14h.01" }],
      ["path", { d: "M17 14h.01" }],
      ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2" }],
      ["path", { d: "M5 18v2" }],
      ["path", { d: "M19 18v2" }],
    ],
    h3 = [
      ["path", { d: "M10 2h4" }],
      [
        "path",
        {
          d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8",
        },
      ],
      ["path", { d: "M7 14h.01" }],
      ["path", { d: "M17 14h.01" }],
      ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2" }],
      ["path", { d: "M5 18v2" }],
      ["path", { d: "M19 18v2" }],
    ],
    d3 = [
      [
        "path",
        {
          d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
        },
      ],
      ["circle", { cx: "7", cy: "17", r: "2" }],
      ["path", { d: "M9 17h6" }],
      ["circle", { cx: "17", cy: "17", r: "2" }],
    ],
    c3 = [
      [
        "path",
        { d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2" },
      ],
      ["path", { d: "M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2" }],
      [
        "path",
        { d: "M22 17v1a1 1 0 0 1-1 1H10v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9" },
      ],
      ["circle", { cx: "8", cy: "19", r: "2" }],
    ],
    M3 = [
      ["path", { d: "M12 14v4" }],
      [
        "path",
        {
          d: "M14.172 2a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 20 7.828V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z",
        },
      ],
      ["path", { d: "M8 14h8" }],
      ["rect", { x: "8", y: "10", width: "8", height: "8", rx: "1" }],
    ],
    p3 = [
      [
        "path",
        {
          d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
        },
      ],
      [
        "path",
        { d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z" },
      ],
      [
        "path",
        { d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z" },
      ],
    ],
    i3 = [
      ["path", { d: "M10 9v7" }],
      ["path", { d: "M14 6v10" }],
      ["circle", { cx: "17.5", cy: "12.5", r: "3.5" }],
      ["circle", { cx: "6.5", cy: "12.5", r: "3.5" }],
    ],
    n3 = [
      ["path", { d: "m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16" }],
      ["path", { d: "M22 9v7" }],
      ["path", { d: "M3.304 13h6.392" }],
      ["circle", { cx: "18.5", cy: "12.5", r: "3.5" }],
    ],
    l3 = [
      [
        "path",
        {
          d: "M15 11h4.5a1 1 0 0 1 0 5h-4a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h3a1 1 0 0 1 0 5",
        },
      ],
      ["path", { d: "m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16" }],
      ["path", { d: "M3.304 13h6.392" }],
    ],
    e3 = [
      ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
      ["circle", { cx: "8", cy: "10", r: "2" }],
      ["path", { d: "M8 12h8" }],
      ["circle", { cx: "16", cy: "10", r: "2" }],
      [
        "path",
        { d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3" },
      ],
    ],
    r3 = [
      [
        "path",
        { d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6" },
      ],
      ["path", { d: "M2 12a9 9 0 0 1 8 8" }],
      ["path", { d: "M2 16a5 5 0 0 1 4 4" }],
      ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20" }],
    ],
    o3 = [
      ["path", { d: "M10 5V3" }],
      ["path", { d: "M14 5V3" }],
      ["path", { d: "M15 21v-3a3 3 0 0 0-6 0v3" }],
      ["path", { d: "M18 3v8" }],
      ["path", { d: "M18 5H6" }],
      ["path", { d: "M22 11H2" }],
      ["path", { d: "M22 9v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9" }],
      ["path", { d: "M6 3v8" }],
    ],
    v3 = [
      [
        "path",
        {
          d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
        },
      ],
      ["path", { d: "M8 14v.5" }],
      ["path", { d: "M16 14v.5" }],
      ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z" }],
    ],
    $3 = [
      [
        "path",
        {
          d: "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97",
        },
      ],
      [
        "path",
        {
          d: "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z",
        },
      ],
      ["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15" }],
      ["path", { d: "M2 21v-4" }],
      ["path", { d: "M7 9h.01" }],
    ],
    z = [
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      [
        "path",
        {
          d: "M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
        },
      ],
    ],
    b = [
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1" }],
      ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1" }],
    ],
    m3 = [
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["path", { d: "M7 11h8" }],
      ["path", { d: "M7 16h3" }],
      ["path", { d: "M7 6h12" }],
    ],
    y3 = [
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["path", { d: "M7 11h8" }],
      ["path", { d: "M7 16h12" }],
      ["path", { d: "M7 6h3" }],
    ],
    s3 = [
      ["path", { d: "M11 13v4" }],
      ["path", { d: "M15 5v4" }],
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1" }],
      ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1" }],
    ],
    R = [
      ["path", { d: "M9 5v4" }],
      ["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1" }],
      ["path", { d: "M9 15v2" }],
      ["path", { d: "M17 3v2" }],
      ["rect", { width: "4", height: "8", x: "15", y: "5", rx: "1" }],
      ["path", { d: "M17 13v3" }],
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
    ],
    T = [
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["path", { d: "M7 16h8" }],
      ["path", { d: "M7 11h12" }],
      ["path", { d: "M7 6h3" }],
    ],
    g3 = [
      ["path", { d: "M13 17V9" }],
      ["path", { d: "M18 17v-3" }],
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["path", { d: "M8 17V5" }],
    ],
    q = [
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1" }],
      ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1" }],
    ],
    U = [
      ["path", { d: "M13 17V9" }],
      ["path", { d: "M18 17V5" }],
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["path", { d: "M8 17v-3" }],
    ],
    u3 = [
      ["path", { d: "M11 13H7" }],
      ["path", { d: "M19 9h-4" }],
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1" }],
      ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1" }],
    ],
    O = [
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["path", { d: "M18 17V9" }],
      ["path", { d: "M13 17V5" }],
      ["path", { d: "M8 17v-3" }],
    ],
    C3 = [
      ["path", { d: "M10 6h8" }],
      ["path", { d: "M12 16h6" }],
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["path", { d: "M8 11h7" }],
    ],
    H3 = [
      ["path", { d: "m13.11 7.664 1.78 2.672" }],
      ["path", { d: "m14.162 12.788-3.324 1.424" }],
      ["path", { d: "m20 4-6.06 1.515" }],
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["circle", { cx: "12", cy: "6", r: "2" }],
      ["circle", { cx: "16", cy: "12", r: "2" }],
      ["circle", { cx: "9", cy: "15", r: "2" }],
    ],
    Z = [
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["path", { d: "m19 9-5 5-4-4-3 3" }],
    ],
    A3 = [
      ["path", { d: "M5 21V3" }],
      ["path", { d: "M12 21V9" }],
      ["path", { d: "M19 21v-6" }],
    ],
    G = [
      ["path", { d: "M5 21v-6" }],
      ["path", { d: "M12 21V9" }],
      ["path", { d: "M19 21V3" }],
    ],
    I = [
      ["path", { d: "M5 21v-6" }],
      ["path", { d: "M12 21V3" }],
      ["path", { d: "M19 21V9" }],
    ],
    w3 = [
      ["path", { d: "M12 16v5" }],
      ["path", { d: "M16 14v7" }],
      ["path", { d: "M20 10v11" }],
      [
        "path",
        {
          d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15",
        },
      ],
      ["path", { d: "M4 18v3" }],
      ["path", { d: "M8 14v7" }],
    ],
    W = [
      ["path", { d: "M6 5h12" }],
      ["path", { d: "M4 12h10" }],
      ["path", { d: "M12 19h8" }],
    ],
    E = [
      ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" }],
      ["circle", { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor" }],
      ["circle", { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor" }],
      ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor" }],
      ["circle", { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor" }],
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
    ],
    X = [
      [
        "path",
        {
          d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
        },
      ],
      ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83" }],
    ],
    V3 = [
      ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
      ["path", { d: "M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7" }],
    ],
    S3 = [
      ["path", { d: "M18 6 7 17l-5-5" }],
      ["path", { d: "m22 10-7.5 7.5L13 16" }],
    ],
    L3 = [
      ["path", { d: "M20 4L9 15" }],
      ["path", { d: "M21 19L3 19" }],
      ["path", { d: "M9 15L4 10" }],
    ],
    f3 = [["path", { d: "M20 6 9 17l-5-5" }]],
    k3 = [
      [
        "path",
        {
          d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
        },
      ],
      ["path", { d: "M6 17h12" }],
    ],
    P3 = [["path", { d: "m6 9 6 6 6-6" }]],
    B3 = [
      ["path", { d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z" }],
      [
        "path",
        { d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z" },
      ],
      ["path", { d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12" }],
      ["path", { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z" }],
    ],
    D3 = [
      ["path", { d: "m17 18-6-6 6-6" }],
      ["path", { d: "M7 6v12" }],
    ],
    F3 = [
      ["path", { d: "m7 18 6-6-6-6" }],
      ["path", { d: "M17 6v12" }],
    ],
    z3 = [["path", { d: "m15 18-6-6 6-6" }]],
    b3 = [["path", { d: "m9 18 6-6-6-6" }]],
    R3 = [["path", { d: "m18 15-6-6-6 6" }]],
    T3 = [
      ["path", { d: "m7 20 5-5 5 5" }],
      ["path", { d: "m7 4 5 5 5-5" }],
    ],
    q3 = [
      ["path", { d: "m7 6 5 5 5-5" }],
      ["path", { d: "m7 13 5 5 5-5" }],
    ],
    U3 = [
      ["path", { d: "M12 12h.01" }],
      ["path", { d: "M16 12h.01" }],
      ["path", { d: "m17 7 5 5-5 5" }],
      ["path", { d: "m7 7-5 5 5 5" }],
      ["path", { d: "M8 12h.01" }],
    ],
    O3 = [
      ["path", { d: "m9 7-5 5 5 5" }],
      ["path", { d: "m15 7 5 5-5 5" }],
    ],
    Z3 = [
      ["path", { d: "m11 17-5-5 5-5" }],
      ["path", { d: "m18 17-5-5 5-5" }],
    ],
    G3 = [
      ["path", { d: "m20 17-5-5 5-5" }],
      ["path", { d: "m4 17 5-5-5-5" }],
    ],
    I3 = [
      ["path", { d: "m6 17 5-5-5-5" }],
      ["path", { d: "m13 17 5-5-5-5" }],
    ],
    W3 = [
      ["path", { d: "m7 15 5 5 5-5" }],
      ["path", { d: "m7 9 5-5 5 5" }],
    ],
    E3 = [
      ["path", { d: "m17 11-5-5-5 5" }],
      ["path", { d: "m17 18-5-5-5 5" }],
    ],
    j = [
      ["path", { d: "M10.88 21.94 15.46 14" }],
      ["path", { d: "M21.17 8H12" }],
      ["path", { d: "M3.95 6.06 8.54 14" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["circle", { cx: "12", cy: "12", r: "4" }],
    ],
    X3 = [
      ["path", { d: "M10 9h4" }],
      ["path", { d: "M12 7v5" }],
      ["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
      [
        "path",
        {
          d: "m18 9 3.52 2.147a1 1 0 0 1 .48.854V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6.999a1 1 0 0 1 .48-.854L6 9",
        },
      ],
      [
        "path",
        {
          d: "M6 21V7a1 1 0 0 1 .376-.782l5-3.999a1 1 0 0 1 1.249.001l5 4A1 1 0 0 1 18 7v14",
        },
      ],
    ],
    j3 = [
      ["path", { d: "M12 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h13" }],
      ["path", { d: "M18 8c0-2.5-2-2.5-2-5" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M21 12a1 1 0 0 1 1 1v2a1 1 0 0 1-.5.866" }],
      ["path", { d: "M22 8c0-2.5-2-2.5-2-5" }],
      ["path", { d: "M7 12v4" }],
    ],
    N3 = [
      ["path", { d: "M17 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14" }],
      ["path", { d: "M18 8c0-2.5-2-2.5-2-5" }],
      ["path", { d: "M21 16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" }],
      ["path", { d: "M22 8c0-2.5-2-2.5-2-5" }],
      ["path", { d: "M7 12v4" }],
    ],
    N = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["line", { x1: "12", x2: "12", y1: "8", y2: "12" }],
      ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16" }],
    ],
    K = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M12 8v8" }],
      ["path", { d: "m8 12 4 4 4-4" }],
    ],
    Q = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m12 8-4 4 4 4" }],
      ["path", { d: "M16 12H8" }],
    ],
    J = [
      ["path", { d: "M2 12a10 10 0 1 1 10 10" }],
      ["path", { d: "m2 22 10-10" }],
      ["path", { d: "M8 22H2v-6" }],
    ],
    Y = [
      ["path", { d: "M2 8V2h6" }],
      ["path", { d: "m2 2 10 10" }],
      ["path", { d: "M12 2A10 10 0 1 1 2 12" }],
    ],
    _ = [
      ["path", { d: "M12 22a10 10 0 1 1 10-10" }],
      ["path", { d: "M22 22 12 12" }],
      ["path", { d: "M22 16v6h-6" }],
    ],
    x = [
      ["path", { d: "M22 12A10 10 0 1 1 12 2" }],
      ["path", { d: "M22 2 12 12" }],
      ["path", { d: "M16 2h6v6" }],
    ],
    a1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m12 16 4-4-4-4" }],
      ["path", { d: "M8 12h8" }],
    ],
    t1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m16 12-4-4-4 4" }],
      ["path", { d: "M12 16V8" }],
    ],
    h1 = [
      ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335" }],
      ["path", { d: "m9 11 3 3L22 4" }],
    ],
    d1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m9 12 2 2 4-4" }],
    ],
    c1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m16 10-4 4-4-4" }],
    ],
    M1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m14 16-4-4 4-4" }],
    ],
    p1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m10 8 4 4-4 4" }],
    ],
    i1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m8 14 4-4 4 4" }],
    ],
    K3 = [
      ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0" }],
      ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0" }],
      ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7" }],
      ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8" }],
      ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69" }],
      ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8" }],
      ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69" }],
      ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7" }],
    ],
    n1 = [
      ["line", { x1: "8", x2: "16", y1: "12", y2: "12" }],
      ["line", { x1: "12", x2: "12", y1: "16", y2: "16" }],
      ["line", { x1: "12", x2: "12", y1: "8", y2: "8" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Q3 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" }],
      ["path", { d: "M12 18V6" }],
    ],
    J3 = [
      ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0" }],
      ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7" }],
      ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8" }],
      ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69" }],
      ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0" }],
      ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7" }],
      ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8" }],
      ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69" }],
      ["circle", { cx: "12", cy: "12", r: "1" }],
    ],
    Y3 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["circle", { cx: "12", cy: "12", r: "1" }],
    ],
    _3 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M17 12h.01" }],
      ["path", { d: "M12 12h.01" }],
      ["path", { d: "M7 12h.01" }],
    ],
    x3 = [
      ["path", { d: "M7 10h10" }],
      ["path", { d: "M7 14h10" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    ad = [
      ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75" }],
      ["path", { d: "m16 12-4-4-4 4" }],
      ["path", { d: "M12 16V8" }],
      ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3" }],
      ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4" }],
      ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857" }],
      ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38" }],
    ],
    l1 = [
      ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
      ["path", { d: "M13.4 10.6 19 5" }],
    ],
    td = [
      ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75" }],
      ["path", { d: "M12 8v8" }],
      ["path", { d: "M16 12H8" }],
      ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3" }],
      ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4" }],
      ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857" }],
      ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38" }],
    ],
    e1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M8 12h8" }],
    ],
    hd = [
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65" }],
      ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92" }],
    ],
    r1 = [
      ["path", { d: "M12.656 7H13a3 3 0 0 1 2.984 3.307" }],
      ["path", { d: "M13 13H9" }],
      ["path", { d: "M19.071 19.071A1 1 0 0 1 4.93 4.93" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M8.357 2.687a10 10 0 0 1 12.956 12.956" }],
      ["path", { d: "M9 17V9" }],
    ],
    o1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9" }],
    ],
    v1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["line", { x1: "10", x2: "10", y1: "15", y2: "9" }],
      ["line", { x1: "14", x2: "14", y1: "15", y2: "9" }],
    ],
    $1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m15 9-6 6" }],
      ["path", { d: "M9 9h.01" }],
      ["path", { d: "M15 15h.01" }],
    ],
    m1 = [
      [
        "path",
        {
          d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
        },
      ],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    y1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M8 12h8" }],
      ["path", { d: "M12 8v8" }],
    ],
    dd = [
      ["path", { d: "M10 16V9.5a1 1 0 0 1 5 0" }],
      ["path", { d: "M8 12h4" }],
      ["path", { d: "M8 16h7" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    s1 = [
      ["path", { d: "M12 7v4" }],
      ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    l = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }],
      ["path", { d: "M12 17h.01" }],
    ],
    g1 = [
      ["path", { d: "M22 2 2 22" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    cd = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["line", { x1: "9", x2: "15", y1: "15", y2: "9" }],
    ],
    Md = [["circle", { cx: "12", cy: "12", r: "6" }]],
    pd = [
      [
        "path",
        {
          d: "M11.051 7.616a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.867l-1.156-1.152a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z",
        },
      ],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    u1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1" }],
    ],
    C1 = [
      ["path", { d: "M18 20a6 6 0 0 0-12 0" }],
      ["circle", { cx: "12", cy: "10", r: "4" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    H1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["circle", { cx: "12", cy: "10", r: "3" }],
      ["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662" }],
    ],
    A1 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m15 9-6 6" }],
      ["path", { d: "m9 9 6 6" }],
    ],
    id = [["circle", { cx: "12", cy: "12", r: "10" }]],
    nd = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3" }],
      ["circle", { cx: "9", cy: "9", r: "2" }],
      ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4" }],
      ["circle", { cx: "15", cy: "15", r: "2" }],
    ],
    ld = [
      [
        "path",
        {
          d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
        },
      ],
      ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34" }],
      ["path", { d: "m14 10-5.5 5.5" }],
      ["path", { d: "M14 17.85V10H6.15" }],
    ],
    ed = [
      [
        "path",
        {
          d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z",
        },
      ],
      ["path", { d: "m6.2 5.3 3.1 3.9" }],
      ["path", { d: "m12.4 3.4 3.1 4" }],
      ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" }],
    ],
    rd = [
      ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
      [
        "path",
        {
          d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        },
      ],
      ["path", { d: "m9 14 2 2 4-4" }],
    ],
    od = [
      ["path", { d: "M16 14v2.2l1.6 1" }],
      ["path", { d: "M16 4h2a2 2 0 0 1 2 2v.832" }],
      ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2" }],
      ["circle", { cx: "16", cy: "16", r: "6" }],
      ["rect", { x: "8", y: "2", width: "8", height: "4", rx: "1" }],
    ],
    vd = [
      ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
      [
        "path",
        { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" },
      ],
      ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4" }],
      ["path", { d: "M21 14H11" }],
      ["path", { d: "m15 10-4 4 4 4" }],
    ],
    $d = [
      ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
      [
        "path",
        {
          d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        },
      ],
      ["path", { d: "M12 11h4" }],
      ["path", { d: "M12 16h4" }],
      ["path", { d: "M8 11h.01" }],
      ["path", { d: "M8 16h.01" }],
    ],
    md = [
      ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
      [
        "path",
        {
          d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        },
      ],
      ["path", { d: "M9 14h6" }],
    ],
    yd = [
      ["path", { d: "M11 14h10" }],
      ["path", { d: "M16 4h2a2 2 0 0 1 2 2v1.344" }],
      ["path", { d: "m17 18 4-4-4-4" }],
      [
        "path",
        { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 1.793-1.113" },
      ],
      ["rect", { x: "8", y: "2", width: "8", height: "4", rx: "1" }],
    ],
    w1 = [
      ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1" }],
      [
        "path",
        { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5" },
      ],
      ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1" }],
      ["path", { d: "M8 18h1" }],
      [
        "path",
        {
          d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
        },
      ],
    ],
    V1 = [
      ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1" }],
      ["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5" }],
      ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2" }],
      [
        "path",
        {
          d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
        },
      ],
    ],
    sd = [
      ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
      [
        "path",
        {
          d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        },
      ],
      ["path", { d: "M9 14h6" }],
      ["path", { d: "M12 17v-6" }],
    ],
    gd = [
      ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
      [
        "path",
        {
          d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        },
      ],
      ["path", { d: "M9 12v-1h6v1" }],
      ["path", { d: "M11 17h2" }],
      ["path", { d: "M12 11v6" }],
    ],
    ud = [
      ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
      [
        "path",
        {
          d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        },
      ],
      ["path", { d: "m15 11-6 6" }],
      ["path", { d: "m9 11 6 6" }],
    ],
    Cd = [
      ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
      [
        "path",
        {
          d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        },
      ],
    ],
    Hd = [
      ["path", { d: "M12 6v6l2-4" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Ad = [
      ["path", { d: "M12 6v6l-4-2" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    wd = [
      ["path", { d: "M12 6v6l-2-4" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Vd = [
      ["path", { d: "M12 6v6" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Sd = [
      ["path", { d: "M12 6v6l4-2" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Ld = [
      ["path", { d: "M12 6v6h4" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    fd = [
      ["path", { d: "M12 6v6l4 2" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    kd = [
      ["path", { d: "M12 6v6l2 4" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Pd = [
      ["path", { d: "M12 6v10" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Bd = [
      ["path", { d: "M12 6v6l-2 4" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Dd = [
      ["path", { d: "M12 6v6l-4 2" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Fd = [
      ["path", { d: "M12 6v6H8" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    zd = [
      ["path", { d: "M12 6v6l4 2" }],
      ["path", { d: "M20 12v5" }],
      ["path", { d: "M20 21h.01" }],
      ["path", { d: "M21.25 8.2A10 10 0 1 0 16 21.16" }],
    ],
    bd = [
      ["path", { d: "M12 6v6l2 1" }],
      ["path", { d: "M12.337 21.994a10 10 0 1 1 9.588-8.767" }],
      ["path", { d: "m14 18 4 4 4-4" }],
      ["path", { d: "M18 14v8" }],
    ],
    Rd = [
      ["path", { d: "M12 6v6l1.56.78" }],
      ["path", { d: "M13.227 21.925a10 10 0 1 1 8.767-9.588" }],
      ["path", { d: "m14 18 4-4 4 4" }],
      ["path", { d: "M18 22v-8" }],
    ],
    Td = [
      ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75" }],
      ["path", { d: "M12 6v6l4 2" }],
      ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3" }],
      ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4" }],
      ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857" }],
      ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38" }],
    ],
    qd = [
      ["path", { d: "M12 6v6l3.644 1.822" }],
      ["path", { d: "M16 19h6" }],
      ["path", { d: "M19 16v6" }],
      ["path", { d: "M21.92 13.267a10 10 0 1 0-8.653 8.653" }],
    ],
    Ud = [
      ["path", { d: "M12 6v6l4 2" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Od = [
      ["path", { d: "M10 9.17a3 3 0 1 0 0 5.66" }],
      ["path", { d: "M17 9.17a3 3 0 1 0 0 5.66" }],
      ["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2" }],
    ],
    Zd = [
      ["path", { d: "M12 12v4" }],
      ["path", { d: "M12 20h.01" }],
      ["path", { d: "M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708" }],
    ],
    Gd = [
      ["path", { d: "m17 15-5.5 5.5L9 18" }],
      [
        "path",
        { d: "M5 17.743A7 7 0 1 1 15.71 10h1.79a4.5 4.5 0 0 1 1.5 8.742" },
      ],
    ],
    Id = [
      ["path", { d: "m10.852 19.772-.383.924" }],
      ["path", { d: "m13.148 14.228.383-.923" }],
      ["path", { d: "M13.148 19.772a3 3 0 1 0-2.296-5.544l-.383-.923" }],
      ["path", { d: "m13.53 20.696-.382-.924a3 3 0 1 1-2.296-5.544" }],
      ["path", { d: "m14.772 15.852.923-.383" }],
      ["path", { d: "m14.772 18.148.923.383" }],
      [
        "path",
        {
          d: "M4.2 15.1a7 7 0 1 1 9.93-9.858A7 7 0 0 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2",
        },
      ],
      ["path", { d: "m9.228 15.852-.923-.383" }],
      ["path", { d: "m9.228 18.148-.923.383" }],
    ],
    S1 = [
      ["path", { d: "M12 13v8l-4-4" }],
      ["path", { d: "m12 21 4-4" }],
      [
        "path",
        { d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284" },
      ],
    ],
    Wd = [
      [
        "path",
        { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" },
      ],
      ["path", { d: "M8 19v1" }],
      ["path", { d: "M8 14v1" }],
      ["path", { d: "M16 19v1" }],
      ["path", { d: "M16 14v1" }],
      ["path", { d: "M12 21v1" }],
      ["path", { d: "M12 16v1" }],
    ],
    Ed = [
      [
        "path",
        { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" },
      ],
      ["path", { d: "M16 17H7" }],
      ["path", { d: "M17 21H9" }],
    ],
    Xd = [
      [
        "path",
        { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" },
      ],
      ["path", { d: "M16 14v2" }],
      ["path", { d: "M8 14v2" }],
      ["path", { d: "M16 20h.01" }],
      ["path", { d: "M8 20h.01" }],
      ["path", { d: "M12 16v2" }],
      ["path", { d: "M12 22h.01" }],
    ],
    jd = [
      ["path", { d: "M11 20v2" }],
      [
        "path",
        {
          d: "M18.376 14.512a6 6 0 0 0 3.461-4.127c.148-.625-.659-.97-1.248-.714a4 4 0 0 1-5.259-5.26c.255-.589-.09-1.395-.716-1.248a6 6 0 0 0-4.594 5.36",
        },
      ],
      ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24" }],
      ["path", { d: "M7 19v2" }],
    ],
    Nd = [
      [
        "path",
        { d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973" },
      ],
      ["path", { d: "m13 12-3 5h4l-3 5" }],
    ],
    Kd = [
      ["path", { d: "M13 16a3 3 0 0 1 0 6H7a5 5 0 1 1 4.9-6z" }],
      [
        "path",
        {
          d: "M18.376 14.512a6 6 0 0 0 3.461-4.127c.148-.625-.659-.97-1.248-.714a4 4 0 0 1-5.259-5.26c.255-.589-.09-1.395-.716-1.248a6 6 0 0 0-4.594 5.36",
        },
      ],
    ],
    Qd = [
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        { d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193" },
      ],
      [
        "path",
        {
          d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07",
        },
      ],
    ],
    Jd = [
      [
        "path",
        { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" },
      ],
      ["path", { d: "m9.2 22 3-7" }],
      ["path", { d: "m9 13-3 7" }],
      ["path", { d: "m17 13-3 7" }],
    ],
    Yd = [
      [
        "path",
        { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" },
      ],
      ["path", { d: "M16 14v6" }],
      ["path", { d: "M8 14v6" }],
      ["path", { d: "M12 16v6" }],
    ],
    _d = [
      [
        "path",
        { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" },
      ],
      ["path", { d: "M8 15h.01" }],
      ["path", { d: "M8 19h.01" }],
      ["path", { d: "M12 17h.01" }],
      ["path", { d: "M12 21h.01" }],
      ["path", { d: "M16 15h.01" }],
      ["path", { d: "M16 19h.01" }],
    ],
    xd = [
      ["path", { d: "M12 2v2" }],
      ["path", { d: "m4.93 4.93 1.41 1.41" }],
      ["path", { d: "M20 12h2" }],
      ["path", { d: "m19.07 4.93-1.41 1.41" }],
      ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128" }],
      ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24" }],
      ["path", { d: "M11 20v2" }],
      ["path", { d: "M7 19v2" }],
    ],
    a6 = [
      ["path", { d: "M12 2v2" }],
      ["path", { d: "m4.93 4.93 1.41 1.41" }],
      ["path", { d: "M20 12h2" }],
      ["path", { d: "m19.07 4.93-1.41 1.41" }],
      ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128" }],
      ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z" }],
    ],
    L1 = [
      ["path", { d: "M12 13v8" }],
      [
        "path",
        { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" },
      ],
      ["path", { d: "m8 17 4-4 4 4" }],
    ],
    t6 = [
      ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" }],
    ],
    h6 = [
      ["path", { d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" }],
      ["path", { d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5" }],
    ],
    d6 = [
      ["path", { d: "M16.17 7.83 2 22" }],
      [
        "path",
        {
          d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
        },
      ],
      ["path", { d: "m7.83 7.83 8.34 8.34" }],
    ],
    c6 = [
      [
        "path",
        {
          d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
        },
      ],
      ["path", { d: "M12 17.66L12 22" }],
    ],
    f1 = [
      ["path", { d: "m18 16 4-4-4-4" }],
      ["path", { d: "m6 8-4 4 4 4" }],
      ["path", { d: "m14.5 4-5 16" }],
    ],
    M6 = [
      ["polygon", { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2" }],
      ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5" }],
      ["polyline", { points: "22 8.5 12 15.5 2 8.5" }],
      ["polyline", { points: "2 15.5 12 8.5 22 15.5" }],
      ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5" }],
    ],
    p6 = [
      ["path", { d: "m16 18 6-6-6-6" }],
      ["path", { d: "m8 6-6 6 6 6" }],
    ],
    i6 = [
      [
        "path",
        {
          d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
        },
      ],
      ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21" }],
      ["polyline", { points: "7.5 19.79 7.5 14.6 3 12" }],
      ["polyline", { points: "21 12 16.5 14.6 16.5 19.79" }],
      ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96" }],
      ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12" }],
    ],
    n6 = [
      ["path", { d: "M10 2v2" }],
      ["path", { d: "M14 2v2" }],
      [
        "path",
        {
          d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
        },
      ],
      ["path", { d: "M6 2v2" }],
    ],
    l6 = [
      ["path", { d: "M11 10.27 7 3.34" }],
      ["path", { d: "m11 13.73-4 6.93" }],
      ["path", { d: "M12 22v-2" }],
      ["path", { d: "M12 2v2" }],
      ["path", { d: "M14 12h8" }],
      ["path", { d: "m17 20.66-1-1.73" }],
      ["path", { d: "m17 3.34-1 1.73" }],
      ["path", { d: "M2 12h2" }],
      ["path", { d: "m20.66 17-1.73-1" }],
      ["path", { d: "m20.66 7-1.73 1" }],
      ["path", { d: "m3.34 17 1.73-1" }],
      ["path", { d: "m3.34 7 1.73 1" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
      ["circle", { cx: "12", cy: "12", r: "8" }],
    ],
    e6 = [
      ["circle", { cx: "8", cy: "8", r: "6" }],
      ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18" }],
      ["path", { d: "M7 6h1v4" }],
      ["path", { d: "m16.71 13.88.7.71-2.82 2.82" }],
    ],
    k1 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M12 3v18" }],
    ],
    e = [
      [
        "path",
        { d: "M10.5 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5.5" },
      ],
      ["path", { d: "m14.3 19.6 1-.4" }],
      ["path", { d: "M15 3v7.5" }],
      ["path", { d: "m15.2 16.9-.9-.3" }],
      ["path", { d: "m16.6 21.7.3-.9" }],
      ["path", { d: "m16.8 15.3-.4-1" }],
      ["path", { d: "m19.1 15.2.3-.9" }],
      ["path", { d: "m19.6 21.7-.4-1" }],
      ["path", { d: "m20.7 16.8 1-.4" }],
      ["path", { d: "m21.7 19.4-.9-.3" }],
      ["path", { d: "M9 3v18" }],
      ["circle", { cx: "18", cy: "18", r: "3" }],
    ],
    r6 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M7.5 3v18" }],
      ["path", { d: "M12 3v18" }],
      ["path", { d: "M16.5 3v18" }],
    ],
    P1 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M9 3v18" }],
      ["path", { d: "M15 3v18" }],
    ],
    o6 = [
      ["path", { d: "M14 3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1" }],
      ["path", { d: "M19 3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1" }],
      ["path", { d: "m7 15 3 3" }],
      ["path", { d: "m7 21 3-3H5a2 2 0 0 1-2-2v-2" }],
      ["rect", { x: "14", y: "14", width: "7", height: "7", rx: "1" }],
      ["rect", { x: "3", y: "3", width: "7", height: "7", rx: "1" }],
    ],
    v6 = [
      [
        "path",
        {
          d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3",
        },
      ],
    ],
    $6 = [
      [
        "path",
        {
          d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z",
        },
      ],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    m6 = [
      [
        "path",
        {
          d: "M15.536 11.293a1 1 0 0 0 0 1.414l2.376 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
        },
      ],
      [
        "path",
        {
          d: "M2.297 11.293a1 1 0 0 0 0 1.414l2.377 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414L6.088 8.916a1 1 0 0 0-1.414 0z",
        },
      ],
      [
        "path",
        {
          d: "M8.916 17.912a1 1 0 0 0 0 1.415l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.415l-2.377-2.376a1 1 0 0 0-1.414 0z",
        },
      ],
      [
        "path",
        {
          d: "M8.916 4.674a1 1 0 0 0 0 1.414l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
        },
      ],
    ],
    y6 = [
      ["rect", { width: "14", height: "8", x: "5", y: "2", rx: "2" }],
      ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2" }],
      ["path", { d: "M6 18h2" }],
      ["path", { d: "M12 18h6" }],
    ],
    s6 = [
      [
        "path",
        {
          d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z",
        },
      ],
      ["path", { d: "M20 16a8 8 0 1 0-16 0" }],
      ["path", { d: "M12 4v4" }],
      ["path", { d: "M10 4h4" }],
    ],
    g6 = [
      ["path", { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98" }],
      ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3" }],
    ],
    u6 = [
      ["rect", { x: "2", y: "6", width: "20", height: "8", rx: "1" }],
      ["path", { d: "M17 14v7" }],
      ["path", { d: "M7 14v7" }],
      ["path", { d: "M17 3v3" }],
      ["path", { d: "M7 3v3" }],
      ["path", { d: "M10 14 2.3 6.3" }],
      ["path", { d: "m14 6 7.7 7.7" }],
      ["path", { d: "m8 6 8 8" }],
    ],
    B1 = [
      ["path", { d: "M16 2v2" }],
      ["path", { d: "M17.915 22a6 6 0 0 0-12 0" }],
      ["path", { d: "M8 2v2" }],
      ["circle", { cx: "12", cy: "12", r: "4" }],
      ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2" }],
    ],
    C6 = [
      ["path", { d: "M16 2v2" }],
      ["path", { d: "M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M8 2v2" }],
      ["circle", { cx: "12", cy: "11", r: "3" }],
      ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2" }],
    ],
    H6 = [
      [
        "path",
        {
          d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
        },
      ],
      ["path", { d: "M10 21.9V14L2.1 9.1" }],
      ["path", { d: "m10 14 11.9-6.9" }],
      ["path", { d: "M14 19.8v-8.1" }],
      ["path", { d: "M18 17.5V9.4" }],
    ],
    A6 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M12 18a6 6 0 0 0 0-12v12z" }],
    ],
    w6 = [
      ["path", { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5" }],
      ["path", { d: "M8.5 8.5v.01" }],
      ["path", { d: "M16 15.5v.01" }],
      ["path", { d: "M12 12v.01" }],
      ["path", { d: "M11 17v.01" }],
      ["path", { d: "M7 14v.01" }],
    ],
    V6 = [
      ["path", { d: "M2 12h20" }],
      ["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8" }],
      ["path", { d: "m4 8 16-4" }],
      [
        "path",
        {
          d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8",
        },
      ],
    ],
    S6 = [
      ["path", { d: "m12 15 2 2 4-4" }],
      ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
      [
        "path",
        { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" },
      ],
    ],
    L6 = [
      ["line", { x1: "12", x2: "18", y1: "15", y2: "15" }],
      ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
      [
        "path",
        { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" },
      ],
    ],
    f6 = [
      ["line", { x1: "15", x2: "15", y1: "12", y2: "18" }],
      ["line", { x1: "12", x2: "18", y1: "15", y2: "15" }],
      ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
      [
        "path",
        { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" },
      ],
    ],
    k6 = [
      ["line", { x1: "12", x2: "18", y1: "18", y2: "12" }],
      ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
      [
        "path",
        { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" },
      ],
    ],
    P6 = [
      ["line", { x1: "12", x2: "18", y1: "12", y2: "18" }],
      ["line", { x1: "12", x2: "18", y1: "18", y2: "12" }],
      ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
      [
        "path",
        { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" },
      ],
    ],
    B6 = [
      ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
      [
        "path",
        { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" },
      ],
    ],
    D6 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66" }],
    ],
    F6 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66" }],
    ],
    z6 = [
      ["path", { d: "m15 10 5 5-5 5" }],
      ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12" }],
    ],
    b6 = [
      ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4" }],
      ["path", { d: "m9 10-5 5 5 5" }],
    ],
    R6 = [
      ["path", { d: "m14 15-5 5-5-5" }],
      ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12" }],
    ],
    T6 = [
      ["path", { d: "M14 9 9 4 4 9" }],
      ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4" }],
    ],
    q6 = [
      ["path", { d: "m10 15 5 5 5-5" }],
      ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12" }],
    ],
    U6 = [
      ["path", { d: "m10 9 5-5 5 5" }],
      ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4" }],
    ],
    O6 = [
      ["path", { d: "m15 14 5-5-5-5" }],
      ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12" }],
    ],
    Z6 = [
      ["path", { d: "M12 20v2" }],
      ["path", { d: "M12 2v2" }],
      ["path", { d: "M17 20v2" }],
      ["path", { d: "M17 2v2" }],
      ["path", { d: "M2 12h2" }],
      ["path", { d: "M2 17h2" }],
      ["path", { d: "M2 7h2" }],
      ["path", { d: "M20 12h2" }],
      ["path", { d: "M20 17h2" }],
      ["path", { d: "M20 7h2" }],
      ["path", { d: "M7 20v2" }],
      ["path", { d: "M7 2v2" }],
      ["rect", { x: "4", y: "4", width: "16", height: "16", rx: "2" }],
      ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1" }],
    ],
    G6 = [
      ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4" }],
      ["path", { d: "M9 14 4 9l5-5" }],
    ],
    I6 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      [
        "path",
        {
          d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1",
        },
      ],
      [
        "path",
        {
          d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1",
        },
      ],
    ],
    W6 = [
      ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2" }],
      ["line", { x1: "2", x2: "22", y1: "10", y2: "10" }],
    ],
    E6 = [
      [
        "path",
        { d: "M10.2 18H4.774a1.5 1.5 0 0 1-1.352-.97 11 11 0 0 1 .132-6.487" },
      ],
      [
        "path",
        { d: "M18 10.2V4.774a1.5 1.5 0 0 0-.97-1.352 11 11 0 0 0-6.486.132" },
      ],
      [
        "path",
        { d: "M18 5a4 3 0 0 1 4 3 2 2 0 0 1-2 2 10 10 0 0 0-5.139 1.42" },
      ],
      [
        "path",
        { d: "M5 18a3 4 0 0 0 3 4 2 2 0 0 0 2-2 10 10 0 0 1 1.42-5.14" },
      ],
      [
        "path",
        {
          d: "M8.709 2.554a10 10 0 0 0-6.155 6.155 1.5 1.5 0 0 0 .676 1.626l9.807 5.42a2 2 0 0 0 2.718-2.718l-5.42-9.807a1.5 1.5 0 0 0-1.626-.676",
        },
      ],
    ],
    X6 = [
      ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14" }],
      ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2" }],
    ],
    j6 = [
      [
        "path",
        {
          d: "M4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a1 1 0 0 1 1 1v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a1 1 0 0 1-1-1V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a1 1 0 0 1-1 1z",
        },
      ],
    ],
    N6 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["line", { x1: "22", x2: "18", y1: "12", y2: "12" }],
      ["line", { x1: "6", x2: "2", y1: "12", y2: "12" }],
      ["line", { x1: "12", x2: "12", y1: "6", y2: "2" }],
      ["line", { x1: "12", x2: "12", y1: "22", y2: "18" }],
    ],
    K6 = [
      [
        "path",
        {
          d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
        },
      ],
      ["path", { d: "M5 21h14" }],
    ],
    Q6 = [
      [
        "path",
        {
          d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
        },
      ],
      ["path", { d: "M10 22v-8L2.25 9.15" }],
      ["path", { d: "m10 14 11.77-6.87" }],
    ],
    J6 = [
      [
        "path",
        { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8" },
      ],
      ["path", { d: "M5 8h14" }],
      ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0" }],
      ["path", { d: "m12 8 1-6h2" }],
    ],
    Y6 = [
      ["circle", { cx: "12", cy: "12", r: "8" }],
      ["line", { x1: "3", x2: "6", y1: "3", y2: "6" }],
      ["line", { x1: "21", x2: "18", y1: "3", y2: "6" }],
      ["line", { x1: "3", x2: "6", y1: "21", y2: "18" }],
      ["line", { x1: "21", x2: "18", y1: "21", y2: "18" }],
    ],
    _6 = [
      ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
      ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5" }],
    ],
    x6 = [
      [
        "path",
        {
          d: "M11 11.31c1.17.56 1.54 1.69 3.5 1.69 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        },
      ],
      [
        "path",
        {
          d: "M11.75 18c.35.5 1.45 1 2.75 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        },
      ],
      ["path", { d: "M2 10h4" }],
      ["path", { d: "M2 14h4" }],
      ["path", { d: "M2 18h4" }],
      ["path", { d: "M2 6h4" }],
      [
        "path",
        {
          d: "M7 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1L10 4a1 1 0 0 0-1-1z",
        },
      ],
    ],
    a8 = [
      ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
      ["path", { d: "M3 12a9 3 0 0 0 5 2.69" }],
      ["path", { d: "M21 9.3V5" }],
      ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88" }],
      ["path", { d: "M12 12v4h4" }],
      [
        "path",
        {
          d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
        },
      ],
    ],
    t8 = [
      ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
      ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84" }],
      ["path", { d: "M21 5V8" }],
      ["path", { d: "M21 12L18 17H22L19 22" }],
      ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87" }],
    ],
    h8 = [
      ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
      ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5" }],
      ["path", { d: "M3 12A9 3 0 0 0 21 12" }],
    ],
    d8 = [
      ["path", { d: "m13 21-3-3 3-3" }],
      ["path", { d: "M20 18H10" }],
      ["path", { d: "M3 11h.01" }],
      ["rect", { x: "6", y: "3", width: "5", height: "8", rx: "2.5" }],
    ],
    c8 = [
      ["path", { d: "M10 18h10" }],
      ["path", { d: "m17 21 3-3-3-3" }],
      ["path", { d: "M3 11h.01" }],
      ["rect", { x: "15", y: "3", width: "5", height: "8", rx: "2.5" }],
      ["rect", { x: "6", y: "3", width: "5", height: "8", rx: "2.5" }],
    ],
    M8 = [
      [
        "path",
        {
          d: "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
        },
      ],
      ["path", { d: "m12 9 6 6" }],
      ["path", { d: "m18 9-6 6" }],
    ],
    p8 = [
      [
        "path",
        {
          d: "M10.162 3.167A10 10 0 0 0 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4-.006 10 10 0 0 0-8.161-9.826",
        },
      ],
      ["path", { d: "M20.804 14.869a9 9 0 0 1-17.608 0" }],
      ["circle", { cx: "12", cy: "4", r: "2" }],
    ],
    i8 = [
      ["circle", { cx: "19", cy: "19", r: "2" }],
      ["circle", { cx: "5", cy: "5", r: "2" }],
      ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86" }],
      ["path", { d: "m6.41 6.41 11.18 11.18" }],
      ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86" }],
    ],
    n8 = [
      [
        "path",
        {
          d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
        },
      ],
      ["path", { d: "M8 12h8" }],
    ],
    D1 = [
      [
        "path",
        {
          d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
        },
      ],
      ["path", { d: "M9.2 9.2h.01" }],
      ["path", { d: "m14.5 9.5-5 5" }],
      ["path", { d: "M14.7 14.8h.01" }],
    ],
    l8 = [
      ["path", { d: "M12 8v8" }],
      [
        "path",
        {
          d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
        },
      ],
      ["path", { d: "M8 12h8" }],
    ],
    e8 = [
      [
        "path",
        {
          d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
        },
      ],
    ],
    r8 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["path", { d: "M12 12h.01" }],
    ],
    o8 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["path", { d: "M15 9h.01" }],
      ["path", { d: "M9 15h.01" }],
    ],
    v8 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["path", { d: "M16 8h.01" }],
      ["path", { d: "M12 12h.01" }],
      ["path", { d: "M8 16h.01" }],
    ],
    $8 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["path", { d: "M16 8h.01" }],
      ["path", { d: "M8 8h.01" }],
      ["path", { d: "M8 16h.01" }],
      ["path", { d: "M16 16h.01" }],
    ],
    m8 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["path", { d: "M16 8h.01" }],
      ["path", { d: "M8 8h.01" }],
      ["path", { d: "M8 16h.01" }],
      ["path", { d: "M16 16h.01" }],
      ["path", { d: "M12 12h.01" }],
    ],
    y8 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["path", { d: "M16 8h.01" }],
      ["path", { d: "M16 12h.01" }],
      ["path", { d: "M16 16h.01" }],
      ["path", { d: "M8 8h.01" }],
      ["path", { d: "M8 12h.01" }],
      ["path", { d: "M8 16h.01" }],
    ],
    s8 = [
      [
        "rect",
        { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2" },
      ],
      [
        "path",
        {
          d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6",
        },
      ],
      ["path", { d: "M6 18h.01" }],
      ["path", { d: "M10 14h.01" }],
      ["path", { d: "M15 6h.01" }],
      ["path", { d: "M18 9h.01" }],
    ],
    g8 = [
      ["path", { d: "M12 3v14" }],
      ["path", { d: "M5 10h14" }],
      ["path", { d: "M5 21h14" }],
    ],
    u8 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["circle", { cx: "12", cy: "12", r: "4" }],
      ["path", { d: "M12 12h.01" }],
    ],
    C8 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
      ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2" }],
    ],
    H8 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["circle", { cx: "12", cy: "12", r: "5" }],
      ["path", { d: "M12 12h.01" }],
    ],
    A8 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
    ],
    w8 = [
      ["circle", { cx: "12", cy: "6", r: "1" }],
      ["line", { x1: "5", x2: "19", y1: "12", y2: "12" }],
      ["circle", { cx: "12", cy: "18", r: "1" }],
    ],
    V8 = [
      ["path", { d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8" }],
      ["path", { d: "m17 6-2.891-2.891" }],
      ["path", { d: "M2 15c3.333-3 6.667-3 10-3" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "m20 9 .891.891" }],
      ["path", { d: "M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1" }],
      ["path", { d: "M3.109 14.109 4 15" }],
      ["path", { d: "m6.5 12.5 1 1" }],
      ["path", { d: "m7 18 2.891 2.891" }],
      ["path", { d: "M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16" }],
    ],
    S8 = [
      ["path", { d: "m10 16 1.5 1.5" }],
      ["path", { d: "m14 8-1.5-1.5" }],
      ["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993" }],
      ["path", { d: "m16.5 10.5 1 1" }],
      ["path", { d: "m17 6-2.891-2.891" }],
      ["path", { d: "M2 15c6.667-6 13.333 0 20-6" }],
      ["path", { d: "m20 9 .891.891" }],
      ["path", { d: "M3.109 14.109 4 15" }],
      ["path", { d: "m6.5 12.5 1 1" }],
      ["path", { d: "m7 18 2.891 2.891" }],
      ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993" }],
    ],
    L8 = [
      ["path", { d: "M2 8h20" }],
      ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
      ["path", { d: "M6 16h12" }],
    ],
    f8 = [
      ["path", { d: "M11.25 16.25h1.5L12 17z" }],
      ["path", { d: "M16 14v.5" }],
      [
        "path",
        {
          d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309",
        },
      ],
      ["path", { d: "M8 14v.5" }],
      [
        "path",
        {
          d: "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
        },
      ],
    ],
    k8 = [
      ["line", { x1: "12", x2: "12", y1: "2", y2: "22" }],
      ["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" }],
    ],
    P8 = [
      [
        "path",
        {
          d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
        },
      ],
      ["circle", { cx: "12", cy: "12", r: "3" }],
    ],
    B8 = [
      ["path", { d: "M10 12h.01" }],
      ["path", { d: "M18 9V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14" }],
      ["path", { d: "M2 20h8" }],
      ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2" }],
      ["rect", { x: "14", y: "17", width: "8", height: "5", rx: "1" }],
    ],
    D8 = [
      ["path", { d: "M10 12h.01" }],
      ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14" }],
      ["path", { d: "M2 20h20" }],
    ],
    F8 = [
      ["path", { d: "M11 20H2" }],
      [
        "path",
        {
          d: "M11 4.562v16.157a1 1 0 0 0 1.242.97L19 20V5.562a2 2 0 0 0-1.515-1.94l-4-1A2 2 0 0 0 11 4.561z",
        },
      ],
      ["path", { d: "M11 4H8a2 2 0 0 0-2 2v14" }],
      ["path", { d: "M14 12h.01" }],
      ["path", { d: "M22 20h-3" }],
    ],
    z8 = [["circle", { cx: "12.1", cy: "12.1", r: "1" }]],
    b8 = [
      ["path", { d: "M12 15V3" }],
      ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }],
      ["path", { d: "m7 10 5 5 5-5" }],
    ],
    R8 = [
      ["path", { d: "m12.99 6.74 1.93 3.44" }],
      ["path", { d: "M19.136 12a10 10 0 0 1-14.271 0" }],
      ["path", { d: "m21 21-2.16-3.84" }],
      ["path", { d: "m3 21 8.02-14.26" }],
      ["circle", { cx: "12", cy: "5", r: "2" }],
    ],
    T8 = [
      ["path", { d: "M10 11h.01" }],
      ["path", { d: "M14 6h.01" }],
      ["path", { d: "M18 6h.01" }],
      ["path", { d: "M6.5 13.1h.01" }],
      ["path", { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3" }],
      ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0" }],
      [
        "path",
        {
          d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
        },
      ],
      ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4" }],
    ],
    q8 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94" }],
      ["path", { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32" }],
      ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72" }],
    ],
    U8 = [
      [
        "path",
        {
          d: "M10 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3 1 1 0 0 1 1-1z",
        },
      ],
      [
        "path",
        {
          d: "M13 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1l-.81 3.242a1 1 0 0 1-.97.758H8",
        },
      ],
      ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3" }],
      ["path", { d: "M18 6h4" }],
      ["path", { d: "m5 10-2 8" }],
      ["path", { d: "m7 18 2-8" }],
    ],
    O8 = [
      ["path", { d: "M10 10 7 7" }],
      ["path", { d: "m10 14-3 3" }],
      ["path", { d: "m14 10 3-3" }],
      ["path", { d: "m14 14 3 3" }],
      ["path", { d: "M14.205 4.139a4 4 0 1 1 5.439 5.863" }],
      ["path", { d: "M19.637 14a4 4 0 1 1-5.432 5.868" }],
      ["path", { d: "M4.367 10a4 4 0 1 1 5.438-5.862" }],
      ["path", { d: "M9.795 19.862a4 4 0 1 1-5.429-5.873" }],
      ["rect", { x: "10", y: "8", width: "4", height: "8", rx: "1" }],
    ],
    Z8 = [
      [
        "path",
        {
          d: "M18.715 13.186C18.29 11.858 17.384 10.607 16 9.5c-2-1.6-3.5-4-4-6.5a10.7 10.7 0 0 1-.884 2.586",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        {
          d: "M8.795 8.797A11 11 0 0 1 8 9.5C6 11.1 5 13 5 15a7 7 0 0 0 13.222 3.208",
        },
      ],
    ],
    G8 = [
      [
        "path",
        {
          d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
        },
      ],
    ],
    I8 = [
      [
        "path",
        {
          d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
        },
      ],
      [
        "path",
        {
          d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
        },
      ],
    ],
    W8 = [
      ["path", { d: "m2 2 8 8" }],
      ["path", { d: "m22 2-8 8" }],
      ["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5" }],
      ["path", { d: "M7 13.4v7.9" }],
      ["path", { d: "M12 14v8" }],
      ["path", { d: "M17 13.4v7.9" }],
      ["path", { d: "M2 9v8a10 5 0 0 0 20 0V9" }],
    ],
    E8 = [
      [
        "path",
        {
          d: "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23",
        },
      ],
      [
        "path",
        {
          d: "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59",
        },
      ],
    ],
    X8 = [
      [
        "path",
        {
          d: "M17.596 12.768a2 2 0 1 0 2.829-2.829l-1.768-1.767a2 2 0 0 0 2.828-2.829l-2.828-2.828a2 2 0 0 0-2.829 2.828l-1.767-1.768a2 2 0 1 0-2.829 2.829z",
        },
      ],
      ["path", { d: "m2.5 21.5 1.4-1.4" }],
      ["path", { d: "m20.1 3.9 1.4-1.4" }],
      [
        "path",
        {
          d: "M5.343 21.485a2 2 0 1 0 2.829-2.828l1.767 1.768a2 2 0 1 0 2.829-2.829l-6.364-6.364a2 2 0 1 0-2.829 2.829l1.768 1.767a2 2 0 0 0-2.828 2.829z",
        },
      ],
      ["path", { d: "m9.6 14.4 4.8-4.8" }],
    ],
    j8 = [
      [
        "path",
        { d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0" },
      ],
      ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4" }],
    ],
    N8 = [
      ["path", { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46" }],
      ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14" }],
      [
        "path",
        { d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76" },
      ],
      ["path", { d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18" }],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    K8 = [
      ["path", { d: "M7 3.34V5a3 3 0 0 0 3 3" }],
      [
        "path",
        { d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05" },
      ],
      ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54" }],
      ["path", { d: "M12 2a10 10 0 1 0 9.54 13" }],
      ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2" }],
      ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1" }],
    ],
    F1 = [
      ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54" }],
      [
        "path",
        {
          d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17",
        },
      ],
      [
        "path",
        { d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05" },
      ],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Q8 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M12 2a7 7 0 1 0 10 10" }],
    ],
    J8 = [
      ["circle", { cx: "11.5", cy: "12.5", r: "3.5" }],
      [
        "path",
        {
          d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
        },
      ],
    ],
    Y8 = [["path", { d: "M12 2C8 2 4 8 4 14a8 8 0 0 0 16 0c0-6-4-12-8-12" }]],
    _8 = [
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        { d: "M20 14.347V14c0-6-4-12-8-12-1.078 0-2.157.436-3.157 1.19" },
      ],
      [
        "path",
        { d: "M6.206 6.21C4.871 8.4 4 11.2 4 14a8 8 0 0 0 14.568 4.568" },
      ],
    ],
    z1 = [
      ["circle", { cx: "12", cy: "12", r: "1" }],
      ["circle", { cx: "12", cy: "5", r: "1" }],
      ["circle", { cx: "12", cy: "19", r: "1" }],
    ],
    b1 = [
      ["circle", { cx: "12", cy: "12", r: "1" }],
      ["circle", { cx: "19", cy: "12", r: "1" }],
      ["circle", { cx: "5", cy: "12", r: "1" }],
    ],
    x8 = [
      ["path", { d: "M5 15a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0" }],
      ["path", { d: "M5 9a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0" }],
    ],
    ac = [
      ["line", { x1: "5", x2: "19", y1: "9", y2: "9" }],
      ["line", { x1: "5", x2: "19", y1: "15", y2: "15" }],
      ["line", { x1: "19", x2: "5", y1: "5", y2: "19" }],
    ],
    tc = [
      ["line", { x1: "5", x2: "19", y1: "9", y2: "9" }],
      ["line", { x1: "5", x2: "19", y1: "15", y2: "15" }],
    ],
    hc = [
      [
        "path",
        {
          d: "m15 20 3-3h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h2l3 3z",
        },
      ],
      ["path", { d: "M6 8v1" }],
      ["path", { d: "M10 8v1" }],
      ["path", { d: "M14 8v1" }],
      ["path", { d: "M18 8v1" }],
    ],
    dc = [
      [
        "path",
        {
          d: "M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21",
        },
      ],
      ["path", { d: "m5.082 11.09 8.828 8.828" }],
    ],
    cc = [
      ["path", { d: "M4 10h12" }],
      ["path", { d: "M4 14h9" }],
      [
        "path",
        {
          d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
        },
      ],
    ],
    Mc = [
      [
        "path",
        {
          d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 4 0v-6.998a2 2 0 0 0-.59-1.42L18 5",
        },
      ],
      ["path", { d: "M14 21V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16" }],
      ["path", { d: "M2 21h13" }],
      ["path", { d: "M3 7h11" }],
      ["path", { d: "m9 11-2 3h3l-2 3" }],
    ],
    pc = [
      ["path", { d: "m15 15 6 6" }],
      ["path", { d: "m15 9 6-6" }],
      ["path", { d: "M21 16v5h-5" }],
      ["path", { d: "M21 8V3h-5" }],
      ["path", { d: "M3 16v5h5" }],
      ["path", { d: "m3 21 6-6" }],
      ["path", { d: "M3 8V3h5" }],
      ["path", { d: "M9 9 3 3" }],
    ],
    ic = [
      ["path", { d: "M15 3h6v6" }],
      ["path", { d: "M10 14 21 3" }],
      [
        "path",
        { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" },
      ],
    ],
    nc = [
      ["path", { d: "m15 18-.722-3.25" }],
      ["path", { d: "M2 8a10.645 10.645 0 0 0 20 0" }],
      ["path", { d: "m20 15-1.726-2.05" }],
      ["path", { d: "m4 15 1.726-2.05" }],
      ["path", { d: "m9 18 .722-3.25" }],
    ],
    lc = [
      [
        "path",
        {
          d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
        },
      ],
      ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242" }],
      [
        "path",
        {
          d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
    ],
    ec = [
      [
        "path",
        {
          d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
        },
      ],
      ["circle", { cx: "12", cy: "12", r: "3" }],
    ],
    rc = [
      [
        "path",
        {
          d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z",
        },
      ],
    ],
    oc = [
      ["path", { d: "M12 16h.01" }],
      ["path", { d: "M16 16h.01" }],
      [
        "path",
        {
          d: "M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z",
        },
      ],
      ["path", { d: "M8 16h.01" }],
    ],
    vc = [
      [
        "path",
        {
          d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
        },
      ],
      ["path", { d: "M12 12v.01" }],
    ],
    $c = [
      [
        "path",
        {
          d: "M12 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 12 18z",
        },
      ],
      [
        "path",
        {
          d: "M2 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 2 18z",
        },
      ],
    ],
    mc = [
      [
        "path",
        {
          d: "M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z",
        },
      ],
      ["path", { d: "M16 8 2 22" }],
      ["path", { d: "M17.5 15H9" }],
    ],
    yc = [
      ["path", { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z" }],
      ["path", { d: "M6 8h4" }],
      ["path", { d: "M6 18h4" }],
      ["path", { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z" }],
      ["path", { d: "M14 8h4" }],
      ["path", { d: "M14 18h4" }],
      ["path", { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z" }],
    ],
    sc = [
      ["circle", { cx: "12", cy: "12", r: "2" }],
      ["path", { d: "M12 2v4" }],
      ["path", { d: "m6.8 15-3.5 2" }],
      ["path", { d: "m20.7 7-3.5 2" }],
      ["path", { d: "M6.8 9 3.3 7" }],
      ["path", { d: "m20.7 17-3.5-2" }],
      ["path", { d: "m9 22 3-8 3 8" }],
      ["path", { d: "M8 22h8" }],
      ["path", { d: "M18 18.7a9 9 0 1 0-12 0" }],
    ],
    gc = [
      [
        "path",
        { d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z" },
      ],
      ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z" }],
      ["path", { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z" }],
      ["path", { d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z" }],
      [
        "path",
        { d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z" },
      ],
    ],
    uc = [
      ["path", { d: "M10 12v-1" }],
      ["path", { d: "M10 18v-2" }],
      ["path", { d: "M10 7V6" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01",
        },
      ],
      ["circle", { cx: "10", cy: "20", r: "2" }],
    ],
    Cc = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["circle", { cx: "3", cy: "17", r: "1" }],
      ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3" }],
      ["circle", { cx: "9", cy: "17", r: "1" }],
    ],
    R1 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "m8 18 4-4" }],
      ["path", { d: "M8 10v8h8" }],
    ],
    Hc = [
      ["path", { d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0",
        },
      ],
    ],
    Ac = [
      [
        "path",
        {
          d: "m13.69 12.479 1.29 4.88a.5.5 0 0 1-.697.591l-1.844-.849a1 1 0 0 0-.88.001l-1.846.85a.5.5 0 0 1-.693-.593l1.29-4.88",
        },
      ],
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z" },
      ],
      ["circle", { cx: "12", cy: "10", r: "3" }],
    ],
    wc = [
      ["path", { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.072" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "m6.69 16.479 1.29 4.88a.5.5 0 0 1-.698.591l-1.843-.849a1 1 0 0 0-.88.001l-1.846.85a.5.5 0 0 1-.693-.593l1.29-4.88",
        },
      ],
      ["circle", { cx: "5", cy: "14", r: "3" }],
    ],
    Vc = [
      ["path", { d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z",
        },
      ],
      ["path", { d: "M7 17v5" }],
      ["path", { d: "M11.7 14.2 7 17l-4.7-2.8" }],
    ],
    T1 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M8 18v-2" }],
      ["path", { d: "M12 18v-4" }],
      ["path", { d: "M16 18v-6" }],
    ],
    q1 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M8 18v-1" }],
      ["path", { d: "M12 18v-6" }],
      ["path", { d: "M16 18v-3" }],
    ],
    U1 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "m16 13-3.5 3.5-2-2L8 17" }],
    ],
    O1 = [
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5" }],
      ["path", { d: "M4.017 11.512a6 6 0 1 0 8.466 8.475" }],
      [
        "path",
        {
          d: "M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z",
        },
      ],
    ],
    Sc = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "m3 15 2 2 4-4" }],
    ],
    Lc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "m9 15 2 2 4-4" }],
    ],
    fc = [
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3" }],
      ["path", { d: "M8 14v2.2l1.6 1" }],
      ["circle", { cx: "8", cy: "16", r: "6" }],
    ],
    kc = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "m5 12-3 3 3 3" }],
      ["path", { d: "m9 18 3-3-3-3" }],
    ],
    Pc = [
      ["path", { d: "M10 12.5 8 15l2 2.5" }],
      ["path", { d: "m14 12.5 2 2.5-2 2.5" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z" },
      ],
    ],
    Z1 = [
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "m2.305 15.53.923-.382" }],
      ["path", { d: "m3.228 12.852-.924-.383" }],
      [
        "path",
        {
          d: "M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5",
        },
      ],
      ["path", { d: "m4.852 11.228-.383-.923" }],
      ["path", { d: "m4.852 16.772-.383.924" }],
      ["path", { d: "m7.148 11.228.383-.923" }],
      ["path", { d: "m7.53 17.696-.382-.924" }],
      ["path", { d: "m8.772 12.852.923-.383" }],
      ["path", { d: "m8.772 15.148.923.383" }],
      ["circle", { cx: "6", cy: "14", r: "3" }],
    ],
    Bc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M9 10h6" }],
      ["path", { d: "M12 13V7" }],
      ["path", { d: "M9 17h6" }],
    ],
    Dc = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["rect", { width: "4", height: "6", x: "2", y: "12", rx: "2" }],
      ["path", { d: "M10 12h2v6" }],
      ["path", { d: "M10 18h4" }],
    ],
    Fc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M12 18v-6" }],
      ["path", { d: "m9 15 3 3 3-3" }],
    ],
    zc = [
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "M2.62 13.8A2.25 2.25 0 1 1 6 10.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z",
        },
      ],
      [
        "path",
        {
          d: "M4 6.005V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-1.9-1.376",
        },
      ],
    ],
    bc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["circle", { cx: "10", cy: "12", r: "2" }],
      ["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22" }],
    ],
    Rc = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M2 15h10" }],
      ["path", { d: "m9 18 3-3-3-3" }],
    ],
    Tc = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1",
        },
      ],
      [
        "path",
        {
          d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1",
        },
      ],
    ],
    qc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1",
        },
      ],
      [
        "path",
        {
          d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1",
        },
      ],
    ],
    Uc = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["circle", { cx: "4", cy: "16", r: "2" }],
      ["path", { d: "m10 10-4.5 4.5" }],
      ["path", { d: "m9 11 1 1" }],
    ],
    Oc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["circle", { cx: "10", cy: "16", r: "2" }],
      ["path", { d: "m16 10-4.5 4.5" }],
      ["path", { d: "m15 11 1 1" }],
    ],
    Zc = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["rect", { width: "8", height: "5", x: "2", y: "13", rx: "1" }],
      ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2" }],
    ],
    Gc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["rect", { width: "8", height: "6", x: "8", y: "12", rx: "1" }],
      ["path", { d: "M10 12v-2a2 2 0 1 1 4 0v2" }],
    ],
    Ic = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M3 15h6" }],
    ],
    Wc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M9 15h6" }],
    ],
    Ec = [
      ["path", { d: "M10.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v8.4" }],
      ["path", { d: "M8 18v-7.7L16 9v7" }],
      ["circle", { cx: "14", cy: "16", r: "2" }],
      ["circle", { cx: "6", cy: "18", r: "2" }],
    ],
    Xc = [
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2" }],
      [
        "path",
        { d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6" },
      ],
      ["path", { d: "m5 11-3 3" }],
      ["path", { d: "m5 17-3-3h10" }],
    ],
    G1 = [
      [
        "path",
        {
          d: "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2",
        },
      ],
      [
        "path",
        {
          d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
        },
      ],
      ["path", { d: "M8 18h1" }],
    ],
    I1 = [
      ["path", { d: "M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
        },
      ],
    ],
    W1 = [
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z" },
      ],
      [
        "path",
        {
          d: "M15.033 13.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56v-4.704a.645.645 0 0 1 .967-.56z",
        },
      ],
    ],
    jc = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M3 15h6" }],
      ["path", { d: "M6 12v6" }],
    ],
    Nc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M9 15h6" }],
      ["path", { d: "M12 18v-6" }],
    ],
    E1 = [
      ["path", { d: "M12 17h.01" }],
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z" },
      ],
      ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3" }],
    ],
    Kc = [
      ["path", { d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M16 14a2 2 0 0 0-2 2" }],
      ["path", { d: "M20 14a2 2 0 0 1 2 2" }],
      ["path", { d: "M20 22a2 2 0 0 0 2-2" }],
      ["path", { d: "M16 22a2 2 0 0 1-2-2" }],
    ],
    Qc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["circle", { cx: "11.5", cy: "14.5", r: "2.5" }],
      ["path", { d: "M13.3 16.3 15 18" }],
    ],
    Jc = [
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3",
        },
      ],
      ["path", { d: "m9 18-1.5-1.5" }],
      ["circle", { cx: "5", cy: "14", r: "3" }],
    ],
    Yc = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M8 12h8" }],
      ["path", { d: "M10 11v2" }],
      ["path", { d: "M8 17h8" }],
      ["path", { d: "M14 16v2" }],
    ],
    _c = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M8 13h2" }],
      ["path", { d: "M14 13h2" }],
      ["path", { d: "M8 17h2" }],
      ["path", { d: "M14 17h2" }],
    ],
    xc = [
      ["path", { d: "M11 21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1" }],
      ["path", { d: "M16 16a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1" }],
      [
        "path",
        {
          d: "M21 6a2 2 0 0 0-.586-1.414l-2-2A2 2 0 0 0 17 2h-3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1z",
        },
      ],
    ],
    a7 = [
      ["path", { d: "m10 18 3-3-3-3" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
        },
      ],
    ],
    t7 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "m8 16 2-2-2-2" }],
      ["path", { d: "M12 18h4" }],
    ],
    h7 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M10 9H8" }],
      ["path", { d: "M16 13H8" }],
      ["path", { d: "M16 17H8" }],
    ],
    d7 = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M2 13v-1h6v1" }],
      ["path", { d: "M5 12v6" }],
      ["path", { d: "M4 18h2" }],
    ],
    c7 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M9 13v-1h6v1" }],
      ["path", { d: "M12 12v6" }],
      ["path", { d: "M11 18h2" }],
    ],
    M7 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M12 12v6" }],
      ["path", { d: "m15 15-3-3-3 3" }],
    ],
    p7 = [
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M15 18a3 3 0 1 0-6 0" }],
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z" },
      ],
      ["circle", { cx: "12", cy: "13", r: "2" }],
    ],
    X1 = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["rect", { width: "8", height: "6", x: "2", y: "12", rx: "1" }],
      [
        "path",
        {
          d: "m10 13.843 3.033-1.755a.645.645 0 0 1 .967.56v4.704a.645.645 0 0 1-.967.56L10 16.157",
        },
      ],
    ],
    i7 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M8 15h.01" }],
      ["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3" }],
      ["path", { d: "M15 12a5 5 0 0 1 0 6" }],
    ],
    n7 = [
      ["path", { d: "M11 11a5 5 0 0 1 0 6" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        {
          d: "M4 6.765V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-.93-.23",
        },
      ],
      [
        "path",
        {
          d: "M7 10.51a.5.5 0 0 0-.826-.38l-1.893 1.628A1 1 0 0 1 3.63 12H2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1.129a1 1 0 0 1 .652.242l1.893 1.63a.5.5 0 0 0 .826-.38z",
        },
      ],
    ],
    l7 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M12 9v4" }],
      ["path", { d: "M12 17h.01" }],
    ],
    e7 = [
      ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "m8 12.5-5 5" }],
      ["path", { d: "m3 12.5 5 5" }],
    ],
    r7 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "m14.5 12.5-5 5" }],
      ["path", { d: "m9.5 12.5 5 5" }],
    ],
    o7 = [
      [
        "path",
        { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" },
      ],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
    ],
    v7 = [
      [
        "path",
        {
          d: "M15 2a2 2 0 0 1 1.414.586l4 4A2 2 0 0 1 21 8v7a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z",
        },
      ],
      ["path", { d: "M15 2v4a2 2 0 0 0 2 2h4" }],
      [
        "path",
        { d: "M5 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 1.732-1" },
      ],
    ],
    $7 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M7 3v18" }],
      ["path", { d: "M3 7.5h4" }],
      ["path", { d: "M3 12h18" }],
      ["path", { d: "M3 16.5h4" }],
      ["path", { d: "M17 3v18" }],
      ["path", { d: "M17 7.5h4" }],
      ["path", { d: "M17 16.5h4" }],
    ],
    m7 = [
      ["path", { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5" }],
      ["path", { d: "M9 18h8" }],
      ["path", { d: "M18 3h-3" }],
      ["path", { d: "M11 3a6 6 0 0 0-6 6v11" }],
      ["path", { d: "M5 13h4" }],
      ["path", { d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z" }],
    ],
    y7 = [
      ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" }],
      ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88" }],
      ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02" }],
      ["path", { d: "M2 12a10 10 0 0 1 18-6" }],
      ["path", { d: "M2 16h.01" }],
      ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6" }],
      ["path", { d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" }],
      ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2" }],
      ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2v2" }],
    ],
    s7 = [
      [
        "path",
        {
          d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
        },
      ],
      [
        "path",
        {
          d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
        },
      ],
      [
        "path",
        {
          d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
        },
      ],
    ],
    g7 = [["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8" }]],
    u7 = [
      [
        "path",
        {
          d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
        },
      ],
      ["path", { d: "M18 12v.5" }],
      ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86" }],
      [
        "path",
        {
          d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
        },
      ],
      [
        "path",
        {
          d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4",
        },
      ],
      [
        "path",
        {
          d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98",
        },
      ],
    ],
    C7 = [
      ["path", { d: "M16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M4 22V4" }],
      [
        "path",
        { d: "M7.656 2H8c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10.347" },
      ],
    ],
    H7 = [
      [
        "path",
        {
          d: "M18 22V2.8a.8.8 0 0 0-1.17-.71L5.45 7.78a.8.8 0 0 0 0 1.44L18 15.5",
        },
      ],
    ],
    A7 = [
      [
        "path",
        {
          d: "M6 22V2.8a.8.8 0 0 1 1.17-.71l11.38 5.69a.8.8 0 0 1 0 1.44L6 15.5",
        },
      ],
    ],
    w7 = [
      [
        "path",
        {
          d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
        },
      ],
    ],
    V7 = [
      [
        "path",
        {
          d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
        },
      ],
      ["path", { d: "m5 22 14-4" }],
      ["path", { d: "m5 18 14 4" }],
    ],
    S7 = [
      [
        "path",
        {
          d: "M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4",
        },
      ],
    ],
    L7 = [
      ["path", { d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4" }],
      ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1" }],
      ["line", { x1: "11", x2: "18", y1: "6", y2: "6" }],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    f7 = [
      [
        "path",
        {
          d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
        },
      ],
      ["line", { x1: "6", x2: "18", y1: "6", y2: "6" }],
      ["line", { x1: "12", x2: "12", y1: "12", y2: "12" }],
    ],
    k7 = [
      ["path", { d: "M10 2v2.343" }],
      ["path", { d: "M14 2v6.343" }],
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        { d: "M20 20a2 2 0 0 1-2 2H6a2 2 0 0 1-1.755-2.96l5.227-9.563" },
      ],
      ["path", { d: "M6.453 15H15" }],
      ["path", { d: "M8.5 2h7" }],
    ],
    P7 = [
      [
        "path",
        {
          d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
        },
      ],
      ["path", { d: "M6.453 15h11.094" }],
      ["path", { d: "M8.5 2h7" }],
    ],
    B7 = [
      ["path", { d: "M10 2v6.292a7 7 0 1 0 4 0V2" }],
      ["path", { d: "M5 15h14" }],
      ["path", { d: "M8.5 2h7" }],
    ],
    D7 = [
      ["path", { d: "m3 7 5 5-5 5V7" }],
      ["path", { d: "m21 7-5 5 5 5V7" }],
      ["path", { d: "M12 20v2" }],
      ["path", { d: "M12 14v2" }],
      ["path", { d: "M12 8v2" }],
      ["path", { d: "M12 2v2" }],
    ],
    F7 = [
      ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3" }],
      ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3" }],
      ["path", { d: "M12 20v2" }],
      ["path", { d: "M12 14v2" }],
      ["path", { d: "M12 8v2" }],
      ["path", { d: "M12 2v2" }],
    ],
    z7 = [
      ["path", { d: "m17 3-5 5-5-5h10" }],
      ["path", { d: "m17 21-5-5-5 5h10" }],
      ["path", { d: "M4 12H2" }],
      ["path", { d: "M10 12H8" }],
      ["path", { d: "M16 12h-2" }],
      ["path", { d: "M22 12h-2" }],
    ],
    b7 = [
      ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3" }],
      ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3" }],
      ["path", { d: "M4 12H2" }],
      ["path", { d: "M10 12H8" }],
      ["path", { d: "M16 12h-2" }],
      ["path", { d: "M22 12h-2" }],
    ],
    R7 = [
      [
        "path",
        {
          d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
        },
      ],
      ["circle", { cx: "12", cy: "8", r: "2" }],
      ["path", { d: "M12 10v12" }],
      ["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z" }],
      ["path", { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z" }],
    ],
    T7 = [
      ["circle", { cx: "12", cy: "12", r: "3" }],
      [
        "path",
        {
          d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
        },
      ],
      ["path", { d: "M12 7.5V9" }],
      ["path", { d: "M7.5 12H9" }],
      ["path", { d: "M16.5 12H15" }],
      ["path", { d: "M12 16.5V15" }],
      ["path", { d: "m8 8 1.88 1.88" }],
      ["path", { d: "M14.12 9.88 16 8" }],
      ["path", { d: "m8 16 1.88-1.88" }],
      ["path", { d: "M14.12 14.12 16 16" }],
    ],
    q7 = [
      ["circle", { cx: "12", cy: "12", r: "3" }],
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
    ],
    U7 = [
      ["path", { d: "M2 12h6" }],
      ["path", { d: "M22 12h-6" }],
      ["path", { d: "M12 2v2" }],
      ["path", { d: "M12 8v2" }],
      ["path", { d: "M12 14v2" }],
      ["path", { d: "M12 20v2" }],
      ["path", { d: "m19 9-3 3 3 3" }],
      ["path", { d: "m5 15 3-3-3-3" }],
    ],
    O7 = [
      ["path", { d: "M12 22v-6" }],
      ["path", { d: "M12 8V2" }],
      ["path", { d: "M4 12H2" }],
      ["path", { d: "M10 12H8" }],
      ["path", { d: "M16 12h-2" }],
      ["path", { d: "M22 12h-2" }],
      ["path", { d: "m15 19-3-3-3 3" }],
      ["path", { d: "m15 5-3 3-3-3" }],
    ],
    Z7 = [
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        },
      ],
      ["path", { d: "m9 13 2 2 4-4" }],
    ],
    G7 = [
      ["circle", { cx: "15", cy: "19", r: "2" }],
      [
        "path",
        {
          d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
        },
      ],
      ["path", { d: "M15 11v-1" }],
      ["path", { d: "M15 17v-2" }],
    ],
    I7 = [
      ["path", { d: "M16 14v2.2l1.6 1" }],
      [
        "path",
        {
          d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
        },
      ],
      ["circle", { cx: "16", cy: "16", r: "6" }],
    ],
    W7 = [
      ["path", { d: "M10 10.5 8 13l2 2.5" }],
      ["path", { d: "m14 10.5 2 2.5-2 2.5" }],
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
        },
      ],
    ],
    E7 = [
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        },
      ],
      ["path", { d: "M2 10h20" }],
    ],
    j1 = [
      [
        "path",
        {
          d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.98a2 2 0 0 1 1.69.9l.66 1.2A2 2 0 0 0 12 6h8a2 2 0 0 1 2 2v3.3",
        },
      ],
      ["path", { d: "m14.305 19.53.923-.382" }],
      ["path", { d: "m15.228 16.852-.923-.383" }],
      ["path", { d: "m16.852 15.228-.383-.923" }],
      ["path", { d: "m16.852 20.772-.383.924" }],
      ["path", { d: "m19.148 15.228.383-.923" }],
      ["path", { d: "m19.53 21.696-.382-.924" }],
      ["path", { d: "m20.772 16.852.924-.383" }],
      ["path", { d: "m20.772 19.148.924.383" }],
      ["circle", { cx: "18", cy: "18", r: "3" }],
    ],
    X7 = [
      [
        "path",
        {
          d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
        },
      ],
      ["circle", { cx: "12", cy: "13", r: "1" }],
    ],
    j7 = [
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        },
      ],
      ["path", { d: "M12 10v6" }],
      ["path", { d: "m15 13-3 3-3-3" }],
    ],
    N7 = [
      [
        "path",
        {
          d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
        },
      ],
      ["circle", { cx: "13", cy: "12", r: "2" }],
      ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8" }],
      ["circle", { cx: "20", cy: "19", r: "2" }],
    ],
    K7 = [
      ["circle", { cx: "12", cy: "13", r: "2" }],
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        },
      ],
      ["path", { d: "M14 13h3" }],
      ["path", { d: "M7 13h3" }],
    ],
    Q7 = [
      [
        "path",
        {
          d: "M10.638 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.417",
        },
      ],
      [
        "path",
        {
          d: "M14.62 18.8A2.25 2.25 0 1 1 18 15.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z",
        },
      ],
    ],
    J7 = [
      [
        "path",
        {
          d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
        },
      ],
      ["path", { d: "M2 13h10" }],
      ["path", { d: "m9 16 3-3-3-3" }],
    ],
    Y7 = [
      ["circle", { cx: "16", cy: "20", r: "2" }],
      [
        "path",
        {
          d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2",
        },
      ],
      ["path", { d: "m22 14-4.5 4.5" }],
      ["path", { d: "m21 15 1 1" }],
    ],
    _7 = [
      [
        "path",
        {
          d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
        },
      ],
      ["path", { d: "M8 10v4" }],
      ["path", { d: "M12 10v2" }],
      ["path", { d: "M16 10v6" }],
    ],
    x7 = [
      ["path", { d: "M9 13h6" }],
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        },
      ],
    ],
    aM = [
      ["rect", { width: "8", height: "5", x: "14", y: "17", rx: "1" }],
      [
        "path",
        {
          d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
        },
      ],
      ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2" }],
    ],
    tM = [
      [
        "path",
        {
          d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
        },
      ],
      ["circle", { cx: "14", cy: "15", r: "1" }],
    ],
    hM = [
      [
        "path",
        {
          d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
        },
      ],
    ],
    dM = [
      [
        "path",
        {
          d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
        },
      ],
      ["path", { d: "M2 13h10" }],
      ["path", { d: "m5 10-3 3 3 3" }],
    ],
    N1 = [
      [
        "path",
        {
          d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
        },
      ],
      [
        "path",
        {
          d: "M11.378 13.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
        },
      ],
    ],
    cM = [
      ["path", { d: "M12 10v6" }],
      ["path", { d: "M9 13h6" }],
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        },
      ],
    ],
    MM = [
      [
        "path",
        {
          d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
        },
      ],
      ["circle", { cx: "12", cy: "13", r: "2" }],
      ["path", { d: "M12 15v5" }],
    ],
    pM = [
      ["circle", { cx: "11.5", cy: "12.5", r: "2.5" }],
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        },
      ],
      ["path", { d: "M13.3 14.3 15 16" }],
    ],
    iM = [
      [
        "path",
        {
          d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
        },
      ],
      ["path", { d: "m21 21-1.9-1.9" }],
      ["circle", { cx: "17", cy: "17", r: "3" }],
    ],
    nM = [
      [
        "path",
        {
          d: "M2 9.35V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
        },
      ],
      ["path", { d: "m8 16 3-3-3-3" }],
    ],
    lM = [
      [
        "path",
        {
          d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
        },
      ],
      ["path", { d: "M12 10v4h4" }],
      ["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5" }],
      ["path", { d: "M22 22v-4h-4" }],
      ["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5" }],
    ],
    eM = [
      [
        "path",
        {
          d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
        },
      ],
      [
        "path",
        {
          d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
        },
      ],
      ["path", { d: "M3 5a2 2 0 0 0 2 2h3" }],
      ["path", { d: "M3 3v13a2 2 0 0 0 2 2h3" }],
    ],
    rM = [
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        },
      ],
      ["path", { d: "M12 10v6" }],
      ["path", { d: "m9 13 3-3 3 3" }],
    ],
    oM = [
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        },
      ],
      ["path", { d: "m9.5 10.5 5 5" }],
      ["path", { d: "m14.5 10.5-5 5" }],
    ],
    vM = [
      [
        "path",
        {
          d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        },
      ],
    ],
    $M = [
      [
        "path",
        {
          d: "M20 5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2.5a1.5 1.5 0 0 1 1.2.6l.6.8a1.5 1.5 0 0 0 1.2.6z",
        },
      ],
      [
        "path",
        {
          d: "M3 8.268a2 2 0 0 0-1 1.738V19a2 2 0 0 0 2 2h11a2 2 0 0 0 1.732-1",
        },
      ],
    ],
    mM = [
      [
        "path",
        {
          d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
        },
      ],
      [
        "path",
        {
          d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
        },
      ],
      ["path", { d: "M16 17h4" }],
      ["path", { d: "M4 13h4" }],
    ],
    yM = [
      ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5" }],
      ["circle", { cx: "13", cy: "19", r: "2" }],
      ["circle", { cx: "5", cy: "19", r: "2" }],
      ["path", { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5" }],
    ],
    sM = [
      ["path", { d: "m15 17 5-5-5-5" }],
      ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12" }],
    ],
    gM = [
      ["line", { x1: "22", x2: "2", y1: "6", y2: "6" }],
      ["line", { x1: "22", x2: "2", y1: "18", y2: "18" }],
      ["line", { x1: "6", x2: "6", y1: "2", y2: "22" }],
      ["line", { x1: "18", x2: "18", y1: "2", y2: "22" }],
    ],
    uM = [["path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7" }]],
    CM = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2" }],
      ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9" }],
      ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9" }],
    ],
    HM = [
      [
        "path",
        {
          d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 4 0v-6.998a2 2 0 0 0-.59-1.42L18 5",
        },
      ],
      ["path", { d: "M14 21V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16" }],
      ["path", { d: "M2 21h13" }],
      ["path", { d: "M3 9h11" }],
    ],
    AM = [
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
      ["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1" }],
    ],
    wM = [
      [
        "path",
        {
          d: "M13.354 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l1.218-1.348",
        },
      ],
      ["path", { d: "M16 6h6" }],
      ["path", { d: "M19 3v6" }],
    ],
    K1 = [
      [
        "path",
        {
          d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
        },
      ],
    ],
    Q1 = [
      [
        "path",
        {
          d: "M12.531 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l.427-.473",
        },
      ],
      ["path", { d: "m16.5 3.5 5 5" }],
      ["path", { d: "m21.5 3.5-5 5" }],
    ],
    VM = [
      ["path", { d: "M2 7v10" }],
      ["path", { d: "M6 5v14" }],
      ["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2" }],
    ],
    SM = [
      ["path", { d: "M2 3v18" }],
      ["rect", { width: "12", height: "18", x: "6", y: "3", rx: "2" }],
      ["path", { d: "M22 3v18" }],
    ],
    LM = [
      ["rect", { width: "18", height: "14", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M4 21h1" }],
      ["path", { d: "M9 21h1" }],
      ["path", { d: "M14 21h1" }],
      ["path", { d: "M19 21h1" }],
    ],
    fM = [
      ["path", { d: "M7 2h10" }],
      ["path", { d: "M5 6h14" }],
      ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2" }],
    ],
    kM = [
      ["path", { d: "M3 2h18" }],
      ["rect", { width: "18", height: "12", x: "3", y: "6", rx: "2" }],
      ["path", { d: "M3 22h18" }],
    ],
    PM = [
      ["line", { x1: "6", x2: "10", y1: "11", y2: "11" }],
      ["line", { x1: "8", x2: "8", y1: "9", y2: "13" }],
      ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12" }],
      ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10" }],
      [
        "path",
        {
          d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
        },
      ],
    ],
    BM = [
      ["line", { x1: "6", x2: "10", y1: "12", y2: "12" }],
      ["line", { x1: "8", x2: "8", y1: "10", y2: "14" }],
      ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13" }],
      ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11" }],
      ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }],
    ],
    DM = [
      ["path", { d: "m12 14 4-4" }],
      ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0" }],
    ],
    FM = [
      ["path", { d: "m14 13-8.381 8.38a1 1 0 0 1-3.001-3l8.384-8.381" }],
      ["path", { d: "m16 16 6-6" }],
      ["path", { d: "m21.5 10.5-8-8" }],
      ["path", { d: "m8 8 6-6" }],
      ["path", { d: "m8.5 7.5 8 8" }],
    ],
    zM = [
      ["path", { d: "M10.5 3 8 9l4 13 4-13-2.5-6" }],
      [
        "path",
        {
          d: "M17 3a2 2 0 0 1 1.6.8l3 4a2 2 0 0 1 .013 2.382l-7.99 10.986a2 2 0 0 1-3.247 0l-7.99-10.986A2 2 0 0 1 2.4 7.8l2.998-3.997A2 2 0 0 1 7 3z",
        },
      ],
      ["path", { d: "M2 9h20" }],
    ],
    bM = [
      ["path", { d: "M11.5 21a7.5 7.5 0 1 1 7.35-9" }],
      ["path", { d: "M13 12V3" }],
      ["path", { d: "M4 21h16" }],
      ["path", { d: "M9 12V3" }],
    ],
    RM = [
      ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1" }],
      ["path", { d: "M12 8v13" }],
      ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" }],
      [
        "path",
        {
          d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
        },
      ],
    ],
    TM = [
      ["path", { d: "M6 3v12" }],
      ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" }],
      ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" }],
      ["path", { d: "M15 6a9 9 0 0 0-9 9" }],
      ["path", { d: "M18 15v6" }],
      ["path", { d: "M21 18h-6" }],
    ],
    qM = [
      ["path", { d: "M9 10h.01" }],
      ["path", { d: "M15 10h.01" }],
      [
        "path",
        {
          d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
        },
      ],
    ],
    UM = [
      ["line", { x1: "6", x2: "6", y1: "3", y2: "15" }],
      ["circle", { cx: "18", cy: "6", r: "3" }],
      ["circle", { cx: "6", cy: "18", r: "3" }],
      ["path", { d: "M18 9a9 9 0 0 1-9 9" }],
    ],
    J1 = [
      ["circle", { cx: "12", cy: "12", r: "3" }],
      ["line", { x1: "3", x2: "9", y1: "12", y2: "12" }],
      ["line", { x1: "15", x2: "21", y1: "12", y2: "12" }],
    ],
    OM = [
      ["path", { d: "M12 3v6" }],
      ["circle", { cx: "12", cy: "12", r: "3" }],
      ["path", { d: "M12 15v6" }],
    ],
    ZM = [
      ["circle", { cx: "5", cy: "6", r: "3" }],
      ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7" }],
      ["path", { d: "m15 9-3-3 3-3" }],
      ["circle", { cx: "19", cy: "18", r: "3" }],
      ["path", { d: "M12 18H7a2 2 0 0 1-2-2V9" }],
      ["path", { d: "m9 15 3 3-3 3" }],
    ],
    GM = [
      ["circle", { cx: "18", cy: "18", r: "3" }],
      ["circle", { cx: "6", cy: "6", r: "3" }],
      ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7" }],
      ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9" }],
    ],
    IM = [
      ["circle", { cx: "12", cy: "18", r: "3" }],
      ["circle", { cx: "6", cy: "6", r: "3" }],
      ["circle", { cx: "18", cy: "6", r: "3" }],
      ["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9" }],
      ["path", { d: "M12 12v3" }],
    ],
    WM = [
      ["circle", { cx: "5", cy: "6", r: "3" }],
      ["path", { d: "M5 9v6" }],
      ["circle", { cx: "5", cy: "18", r: "3" }],
      ["path", { d: "M12 3v18" }],
      ["circle", { cx: "19", cy: "6", r: "3" }],
      ["path", { d: "M16 15.7A9 9 0 0 0 19 9" }],
    ],
    EM = [
      ["circle", { cx: "18", cy: "18", r: "3" }],
      ["circle", { cx: "6", cy: "6", r: "3" }],
      ["path", { d: "M6 21V9a9 9 0 0 0 9 9" }],
    ],
    XM = [
      ["circle", { cx: "5", cy: "6", r: "3" }],
      ["path", { d: "M5 9v12" }],
      ["circle", { cx: "19", cy: "18", r: "3" }],
      ["path", { d: "m15 9-3-3 3-3" }],
      ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7" }],
    ],
    jM = [
      ["circle", { cx: "6", cy: "6", r: "3" }],
      ["path", { d: "M6 9v12" }],
      ["path", { d: "m21 3-6 6" }],
      ["path", { d: "m21 9-6-6" }],
      ["path", { d: "M18 11.5V15" }],
      ["circle", { cx: "18", cy: "18", r: "3" }],
    ],
    NM = [
      ["circle", { cx: "5", cy: "6", r: "3" }],
      ["path", { d: "M5 9v12" }],
      ["path", { d: "m15 9-3-3 3-3" }],
      ["path", { d: "M12 6h5a2 2 0 0 1 2 2v3" }],
      ["path", { d: "M19 15v6" }],
      ["path", { d: "M22 18h-6" }],
    ],
    KM = [
      ["circle", { cx: "6", cy: "6", r: "3" }],
      ["path", { d: "M6 9v12" }],
      ["path", { d: "M13 6h3a2 2 0 0 1 2 2v3" }],
      ["path", { d: "M18 15v6" }],
      ["path", { d: "M21 18h-6" }],
    ],
    QM = [
      ["circle", { cx: "18", cy: "18", r: "3" }],
      ["circle", { cx: "6", cy: "6", r: "3" }],
      ["path", { d: "M18 6V5" }],
      ["path", { d: "M18 11v-1" }],
      ["line", { x1: "6", x2: "6", y1: "9", y2: "21" }],
    ],
    JM = [
      ["circle", { cx: "18", cy: "18", r: "3" }],
      ["circle", { cx: "6", cy: "6", r: "3" }],
      ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7" }],
      ["line", { x1: "6", x2: "6", y1: "9", y2: "21" }],
    ],
    YM = [
      [
        "path",
        {
          d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
        },
      ],
      ["path", { d: "M9 18c-4.51 2-5-2-7-2" }],
    ],
    _M = [
      [
        "path",
        {
          d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
        },
      ],
    ],
    xM = [
      [
        "path",
        {
          d: "M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z",
        },
      ],
      ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0" }],
    ],
    a9 = [
      ["circle", { cx: "6", cy: "15", r: "4" }],
      ["circle", { cx: "18", cy: "15", r: "4" }],
      ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2" }],
      ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2" }],
      ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2" }],
    ],
    t9 = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" }],
      ["path", { d: "M2 12h20" }],
    ],
    h9 = [
      [
        "path",
        {
          d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13",
        },
      ],
      ["path", { d: "M2 12h8.5" }],
      ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2" }],
      ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1" }],
    ],
    d9 = [
      ["path", { d: "M12 13V2l8 4-8 4" }],
      ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29" }],
      ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02" }],
    ],
    c9 = [
      ["path", { d: "M2 21V3" }],
      ["path", { d: "M2 5h18a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2.26" }],
      ["path", { d: "M7 17v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3" }],
      ["circle", { cx: "16", cy: "11", r: "2" }],
      ["circle", { cx: "8", cy: "11", r: "2" }],
    ],
    M9 = [
      [
        "path",
        {
          d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
        },
      ],
      ["path", { d: "M22 10v6" }],
      ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5" }],
    ],
    p9 = [
      ["path", { d: "M22 5V2l-5.89 5.89" }],
      ["circle", { cx: "16.6", cy: "15.89", r: "3" }],
      ["circle", { cx: "8.11", cy: "7.4", r: "3" }],
      ["circle", { cx: "12.35", cy: "11.65", r: "3" }],
      ["circle", { cx: "13.91", cy: "5.85", r: "3" }],
      ["circle", { cx: "18.15", cy: "10.09", r: "3" }],
      ["circle", { cx: "6.56", cy: "13.2", r: "3" }],
      ["circle", { cx: "10.8", cy: "17.44", r: "3" }],
      ["circle", { cx: "5", cy: "19", r: "3" }],
    ],
    Y1 = [
      [
        "path",
        {
          d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
        },
      ],
      ["path", { d: "M16 19h6" }],
      ["path", { d: "M19 22v-6" }],
    ],
    _1 = [
      [
        "path",
        {
          d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
        },
      ],
      ["path", { d: "m16 19 2 2 4-4" }],
    ],
    x1 = [
      [
        "path",
        {
          d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
        },
      ],
      ["path", { d: "m16 16 5 5" }],
      ["path", { d: "m16 21 5-5" }],
    ],
    i9 = [
      ["path", { d: "M15 3v18" }],
      ["path", { d: "M3 12h18" }],
      ["path", { d: "M9 3v18" }],
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
    ],
    a2 = [
      ["path", { d: "M12 3v18" }],
      ["path", { d: "M3 12h18" }],
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
    ],
    r = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 9h18" }],
      ["path", { d: "M3 15h18" }],
      ["path", { d: "M9 3v18" }],
      ["path", { d: "M15 3v18" }],
    ],
    n9 = [
      ["circle", { cx: "12", cy: "9", r: "1" }],
      ["circle", { cx: "19", cy: "9", r: "1" }],
      ["circle", { cx: "5", cy: "9", r: "1" }],
      ["circle", { cx: "12", cy: "15", r: "1" }],
      ["circle", { cx: "19", cy: "15", r: "1" }],
      ["circle", { cx: "5", cy: "15", r: "1" }],
    ],
    l9 = [
      ["circle", { cx: "9", cy: "12", r: "1" }],
      ["circle", { cx: "9", cy: "5", r: "1" }],
      ["circle", { cx: "9", cy: "19", r: "1" }],
      ["circle", { cx: "15", cy: "12", r: "1" }],
      ["circle", { cx: "15", cy: "5", r: "1" }],
      ["circle", { cx: "15", cy: "19", r: "1" }],
    ],
    e9 = [
      ["circle", { cx: "12", cy: "5", r: "1" }],
      ["circle", { cx: "19", cy: "5", r: "1" }],
      ["circle", { cx: "5", cy: "5", r: "1" }],
      ["circle", { cx: "12", cy: "12", r: "1" }],
      ["circle", { cx: "19", cy: "12", r: "1" }],
      ["circle", { cx: "5", cy: "12", r: "1" }],
      ["circle", { cx: "12", cy: "19", r: "1" }],
      ["circle", { cx: "19", cy: "19", r: "1" }],
      ["circle", { cx: "5", cy: "19", r: "1" }],
    ],
    r9 = [
      ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2" }],
      ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2" }],
      ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2" }],
      ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2" }],
      ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1" }],
      ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1" }],
    ],
    o9 = [
      ["path", { d: "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856" }],
      [
        "path",
        {
          d: "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288",
        },
      ],
      [
        "path",
        {
          d: "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
        },
      ],
      ["path", { d: "m8.5 16.5-1-1" }],
    ],
    v9 = [
      ["path", { d: "m11.9 12.1 4.514-4.514" }],
      [
        "path",
        {
          d: "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z",
        },
      ],
      ["path", { d: "m6 16 2 2" }],
      [
        "path",
        {
          d: "M8.23 9.85A3 3 0 0 1 11 8a5 5 0 0 1 5 5 3 3 0 0 1-1.85 2.77l-.92.38A2 2 0 0 0 12 18a4 4 0 0 1-4 4 6 6 0 0 1-6-6 4 4 0 0 1 4-4 2 2 0 0 0 1.85-1.23z",
        },
      ],
    ],
    $9 = [
      ["path", { d: "M12 16H4a2 2 0 1 1 0-4h16a2 2 0 1 1 0 4h-4.25" }],
      ["path", { d: "M5 12a2 2 0 0 1-2-2 9 7 0 0 1 18 0 2 2 0 0 1-2 2" }],
      [
        "path",
        {
          d: "M5 16a2 2 0 0 0-2 2 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 2 2 0 0 0-2-2q0 0 0 0",
        },
      ],
      ["path", { d: "m6.67 12 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2" }],
    ],
    m9 = [
      ["path", { d: "m15 12-9.373 9.373a1 1 0 0 1-3.001-3L12 9" }],
      ["path", { d: "m18 15 4-4" }],
      [
        "path",
        {
          d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172v-.344a2 2 0 0 0-.586-1.414l-1.657-1.657A6 6 0 0 0 12.516 3H9l1.243 1.243A6 6 0 0 1 12 8.485V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
        },
      ],
    ],
    y9 = [
      ["path", { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17" }],
      [
        "path",
        {
          d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
        },
      ],
      ["path", { d: "m2 16 6 6" }],
      ["circle", { cx: "16", cy: "9", r: "2.9" }],
      ["circle", { cx: "6", cy: "5", r: "3" }],
    ],
    s9 = [
      [
        "path",
        {
          d: "M12.035 17.012a3 3 0 0 0-3-3l-.311-.002a.72.72 0 0 1-.505-1.229l1.195-1.195A2 2 0 0 1 10.828 11H12a2 2 0 0 0 0-4H9.243a3 3 0 0 0-2.122.879l-2.707 2.707A4.83 4.83 0 0 0 3 14a8 8 0 0 0 8 8h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0",
        },
      ],
      ["path", { d: "M13.888 9.662A2 2 0 0 0 17 8V5A2 2 0 1 0 13 5" }],
      ["path", { d: "M9 5A2 2 0 1 0 5 5V10" }],
      ["path", { d: "M9 7V4A2 2 0 1 1 13 4V7.268" }],
    ],
    t2 = [
      ["path", { d: "M18 11.5V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4" }],
      ["path", { d: "M14 10V8a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2" }],
      ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5" }],
      ["path", { d: "M6 14a2 2 0 0 0-2-2a2 2 0 0 0-2 2" }],
      [
        "path",
        {
          d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0",
        },
      ],
    ],
    h2 = [
      ["path", { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14" }],
      [
        "path",
        {
          d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
        },
      ],
      ["path", { d: "m2 13 6 6" }],
    ],
    g9 = [
      ["path", { d: "M11 14h2a2 2 0 0 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16" }],
      [
        "path",
        {
          d: "m14.45 13.39 5.05-4.694C20.196 8 21 6.85 21 5.75a2.75 2.75 0 0 0-4.797-1.837.276.276 0 0 1-.406 0A2.75 2.75 0 0 0 11 5.75c0 1.2.802 2.248 1.5 2.946L16 11.95",
        },
      ],
      ["path", { d: "m2 15 6 6" }],
      [
        "path",
        {
          d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a1 1 0 0 0-2.75-2.91",
        },
      ],
    ],
    u9 = [
      ["path", { d: "M18 12.5V10a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4" }],
      ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2" }],
      ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9" }],
      [
        "path",
        {
          d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
        },
      ],
    ],
    C9 = [
      ["path", { d: "M12 3V2" }],
      [
        "path",
        {
          d: "m15.4 17.4 3.2-2.8a2 2 0 1 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2l-1.302-1.464A1 1 0 0 0 6.151 19H5",
        },
      ],
      ["path", { d: "M2 14h12a2 2 0 0 1 0 4h-2" }],
      ["path", { d: "M4 10h16" }],
      ["path", { d: "M5 10a7 7 0 0 1 14 0" }],
      ["path", { d: "M5 14v6a1 1 0 0 1-1 1H2" }],
    ],
    H9 = [
      [
        "path",
        {
          d: "M2.048 18.566A2 2 0 0 0 4 21h16a2 2 0 0 0 1.952-2.434l-2-9A2 2 0 0 0 18 8H6a2 2 0 0 0-1.952 1.566z",
        },
      ],
      ["path", { d: "M8 11V6a4 4 0 0 1 8 0v5" }],
    ],
    A9 = [
      ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2" }],
      ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2" }],
      ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8" }],
      [
        "path",
        {
          d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
        },
      ],
    ],
    w9 = [
      ["path", { d: "m11 17 2 2a1 1 0 1 0 3-3" }],
      [
        "path",
        {
          d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
        },
      ],
      ["path", { d: "m21 3 1 11h-2" }],
      ["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" }],
      ["path", { d: "M3 4h8" }],
    ],
    V9 = [
      ["path", { d: "M12 2v8" }],
      ["path", { d: "m16 6-4 4-4-4" }],
      ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2" }],
      ["path", { d: "M6 18h.01" }],
      ["path", { d: "M10 18h.01" }],
    ],
    S9 = [
      ["path", { d: "m16 6-4-4-4 4" }],
      ["path", { d: "M12 2v8" }],
      ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2" }],
      ["path", { d: "M6 18h.01" }],
      ["path", { d: "M10 18h.01" }],
    ],
    L9 = [
      ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5" }],
      ["path", { d: "M14 6a6 6 0 0 1 6 6v3" }],
      ["path", { d: "M4 15v-3a6 6 0 0 1 6-6" }],
      ["rect", { x: "2", y: "15", width: "20", height: "4", rx: "1" }],
    ],
    f9 = [
      ["line", { x1: "22", x2: "2", y1: "12", y2: "12" }],
      [
        "path",
        {
          d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
        },
      ],
      ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16" }],
      ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16" }],
    ],
    k9 = [
      ["line", { x1: "4", x2: "20", y1: "9", y2: "9" }],
      ["line", { x1: "4", x2: "20", y1: "15", y2: "15" }],
      ["line", { x1: "10", x2: "8", y1: "3", y2: "21" }],
      ["line", { x1: "16", x2: "14", y1: "3", y2: "21" }],
    ],
    P9 = [
      ["path", { d: "M14 18a2 2 0 0 0-4 0" }],
      [
        "path",
        {
          d: "m19 11-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11",
        },
      ],
      ["path", { d: "M2 11h20" }],
      ["circle", { cx: "17", cy: "18", r: "3" }],
      ["circle", { cx: "7", cy: "18", r: "3" }],
    ],
    B9 = [
      [
        "path",
        {
          d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
        },
      ],
      ["path", { d: "M7.5 12h9" }],
    ],
    D9 = [
      ["path", { d: "m5.2 6.2 1.4 1.4" }],
      ["path", { d: "M2 13h2" }],
      ["path", { d: "M20 13h2" }],
      ["path", { d: "m17.4 7.6 1.4-1.4" }],
      ["path", { d: "M22 17H2" }],
      ["path", { d: "M22 21H2" }],
      ["path", { d: "M16 13a4 4 0 0 0-8 0" }],
      ["path", { d: "M12 5V2.5" }],
    ],
    F9 = [
      ["path", { d: "M4 12h8" }],
      ["path", { d: "M4 18V6" }],
      ["path", { d: "M12 18V6" }],
      ["path", { d: "m17 12 3-2v8" }],
    ],
    z9 = [
      ["path", { d: "M4 12h8" }],
      ["path", { d: "M4 18V6" }],
      ["path", { d: "M12 18V6" }],
      ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1" }],
    ],
    b9 = [
      ["path", { d: "M12 18V6" }],
      ["path", { d: "M17 10v3a1 1 0 0 0 1 1h3" }],
      ["path", { d: "M21 10v8" }],
      ["path", { d: "M4 12h8" }],
      ["path", { d: "M4 18V6" }],
    ],
    R9 = [
      ["path", { d: "M4 12h8" }],
      ["path", { d: "M4 18V6" }],
      ["path", { d: "M12 18V6" }],
      ["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2" }],
      ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2" }],
    ],
    T9 = [
      ["path", { d: "M4 12h8" }],
      ["path", { d: "M4 18V6" }],
      ["path", { d: "M12 18V6" }],
      ["path", { d: "M17 13v-3h4" }],
      [
        "path",
        {
          d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17",
        },
      ],
    ],
    q9 = [
      ["path", { d: "M4 12h8" }],
      ["path", { d: "M4 18V6" }],
      ["path", { d: "M12 18V6" }],
      ["circle", { cx: "19", cy: "16", r: "2" }],
      ["path", { d: "M20 10c-2 2-3 3.5-3 6" }],
    ],
    U9 = [
      ["path", { d: "M6 12h12" }],
      ["path", { d: "M6 20V4" }],
      ["path", { d: "M18 20V4" }],
    ],
    O9 = [
      ["path", { d: "M21 14h-1.343" }],
      ["path", { d: "M9.128 3.47A9 9 0 0 1 21 12v3.343" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M20.414 20.414A2 2 0 0 1 19 21h-1a2 2 0 0 1-2-2v-3" }],
      [
        "path",
        {
          d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 2.636-6.364",
        },
      ],
    ],
    Z9 = [
      [
        "path",
        {
          d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
        },
      ],
    ],
    G9 = [
      [
        "path",
        {
          d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
        },
      ],
      ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5" }],
    ],
    I9 = [
      [
        "path",
        {
          d: "M12.409 5.824c-.702.792-1.15 1.496-1.415 2.166l2.153 2.156a.5.5 0 0 1 0 .707l-2.293 2.293a.5.5 0 0 0 0 .707L12 15",
        },
      ],
      [
        "path",
        {
          d: "M13.508 20.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.677.6.6 0 0 0 .818.001A5.5 5.5 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5z",
        },
      ],
    ],
    W9 = [
      [
        "path",
        {
          d: "M19.414 14.414C21 12.828 22 11.5 22 9.5a5.5 5.5 0 0 0-9.591-3.676.6.6 0 0 1-.818.001A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.535 5.362a2 2 0 0 0 2.879.052 2.12 2.12 0 0 0-.004-3 2.124 2.124 0 1 0 3-3 2.124 2.124 0 0 0 3.004 0 2 2 0 0 0 0-2.828l-1.881-1.882a2.41 2.41 0 0 0-3.409 0l-1.71 1.71a2 2 0 0 1-2.828 0 2 2 0 0 1 0-2.828l2.823-2.762",
        },
      ],
    ],
    E9 = [
      [
        "path",
        {
          d: "m14.876 18.99-1.368 1.323a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5a5.2 5.2 0 0 1-.244 1.572",
        },
      ],
      ["path", { d: "M15 15h6" }],
    ],
    X9 = [
      [
        "path",
        {
          d: "M10.5 4.893a5.5 5.5 0 0 1 1.091.931.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 1.872-1.002 3.356-2.187 4.655",
        },
      ],
      [
        "path",
        {
          d: "m16.967 16.967-3.459 3.346a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 2.747-4.761",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
    ],
    j9 = [
      [
        "path",
        {
          d: "m14.479 19.374-.971.939a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5a5.2 5.2 0 0 1-.219 1.49",
        },
      ],
      ["path", { d: "M15 15h6" }],
      ["path", { d: "M18 12v6" }],
    ],
    N9 = [
      [
        "path",
        {
          d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
        },
      ],
      ["path", { d: "M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27" }],
    ],
    K9 = [
      [
        "path",
        {
          d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
        },
      ],
    ],
    Q9 = [
      ["path", { d: "M11 8c2-3-2-3 0-6" }],
      ["path", { d: "M15.5 8c2-3-2-3 0-6" }],
      ["path", { d: "M6 10h.01" }],
      ["path", { d: "M6 14h.01" }],
      ["path", { d: "M10 16v-4" }],
      ["path", { d: "M14 16v-4" }],
      ["path", { d: "M18 16v-4" }],
      [
        "path",
        {
          d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3",
        },
      ],
      ["path", { d: "M5 20v2" }],
      ["path", { d: "M19 20v2" }],
    ],
    J9 = [
      [
        "path",
        {
          d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
        },
      ],
    ],
    Y9 = [
      ["path", { d: "m9 11-6 6v3h9l3-3" }],
      [
        "path",
        { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4" },
      ],
    ],
    _9 = [
      ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }],
      ["path", { d: "M3 3v5h5" }],
      ["path", { d: "M12 7v5l4 2" }],
    ],
    x9 = [
      ["path", { d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27" }],
      [
        "path",
        {
          d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28",
        },
      ],
      ["path", { d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26" }],
      [
        "path",
        {
          d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25",
        },
      ],
      [
        "path",
        { d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75" },
      ],
      [
        "path",
        {
          d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
        },
      ],
      [
        "path",
        {
          d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28",
        },
      ],
      [
        "path",
        {
          d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
    ],
    ap = [
      [
        "path",
        {
          d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
        },
      ],
      [
        "path",
        {
          d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
        },
      ],
      [
        "path",
        {
          d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
        },
      ],
      [
        "path",
        {
          d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
        },
      ],
      [
        "path",
        {
          d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
        },
      ],
      [
        "path",
        {
          d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
        },
      ],
      ["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1" }],
      [
        "path",
        {
          d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
        },
      ],
    ],
    tp = [
      ["path", { d: "M12 7v4" }],
      ["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
      ["path", { d: "M14 9h-4" }],
      [
        "path",
        {
          d: "M18 11h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2",
        },
      ],
      ["path", { d: "M18 21V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16" }],
    ],
    hp = [
      ["path", { d: "M10 22v-6.57" }],
      ["path", { d: "M12 11h.01" }],
      ["path", { d: "M12 7h.01" }],
      ["path", { d: "M14 15.43V22" }],
      ["path", { d: "M15 16a5 5 0 0 0-6 0" }],
      ["path", { d: "M16 11h.01" }],
      ["path", { d: "M16 7h.01" }],
      ["path", { d: "M8 11h.01" }],
      ["path", { d: "M8 7h.01" }],
      ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2" }],
    ],
    dp = [
      ["path", { d: "M5 22h14" }],
      ["path", { d: "M5 2h14" }],
      [
        "path",
        {
          d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
        },
      ],
      [
        "path",
        {
          d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2",
        },
      ],
    ],
    cp = [
      [
        "path",
        {
          d: "M8.62 13.8A2.25 2.25 0 1 1 12 10.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z",
        },
      ],
      [
        "path",
        {
          d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
        },
      ],
    ],
    Mp = [
      ["path", { d: "M10 12V8.964" }],
      ["path", { d: "M14 12V8.964" }],
      [
        "path",
        {
          d: "M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z",
        },
      ],
      [
        "path",
        {
          d: "M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2",
        },
      ],
    ],
    pp = [
      [
        "path",
        {
          d: "M12.35 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .71-1.53l7-6a2 2 0 0 1 2.58 0l7 6A2 2 0 0 1 21 10v2.35",
        },
      ],
      ["path", { d: "M14.8 12.4A1 1 0 0 0 14 12h-4a1 1 0 0 0-1 1v8" }],
      ["path", { d: "M15 18h6" }],
      ["path", { d: "M18 15v6" }],
    ],
    ip = [
      ["path", { d: "M9.5 13.866a4 4 0 0 1 5 .01" }],
      ["path", { d: "M12 17h.01" }],
      [
        "path",
        {
          d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
        },
      ],
      ["path", { d: "M7 10.754a8 8 0 0 1 10 0" }],
    ],
    d2 = [
      ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" }],
      [
        "path",
        {
          d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
        },
      ],
    ],
    c2 = [
      ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11" }],
      ["path", { d: "M17 7A5 5 0 0 0 7 7" }],
      ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4" }],
    ],
    M2 = [
      [
        "path",
        {
          d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
        },
      ],
      ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0" }],
      ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0" }],
    ],
    np = [
      ["path", { d: "M13.5 8h-3" }],
      [
        "path",
        {
          d: "m15 2-1 2h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3",
        },
      ],
      ["path", { d: "M16.899 22A5 5 0 0 0 7.1 22" }],
      ["path", { d: "m9 2 3 6" }],
      ["circle", { cx: "12", cy: "15", r: "3" }],
    ],
    lp = [
      ["path", { d: "M16 10h2" }],
      ["path", { d: "M16 14h2" }],
      ["path", { d: "M6.17 15a3 3 0 0 1 5.66 0" }],
      ["circle", { cx: "9", cy: "11", r: "2" }],
      ["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2" }],
    ],
    ep = [
      [
        "path",
        {
          d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
        },
      ],
      ["path", { d: "m14 19 3 3v-5.5" }],
      ["path", { d: "m17 22 3-3" }],
      ["circle", { cx: "9", cy: "9", r: "2" }],
    ],
    rp = [
      [
        "path",
        { d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" },
      ],
      ["line", { x1: "16", x2: "22", y1: "5", y2: "5" }],
      ["circle", { cx: "9", cy: "9", r: "2" }],
      ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" }],
    ],
    op = [
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
      ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83" }],
      ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21" }],
      ["line", { x1: "18", x2: "21", y1: "12", y2: "15" }],
      [
        "path",
        {
          d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
        },
      ],
      ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9" }],
    ],
    vp = [
      [
        "path",
        {
          d: "M15 15.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997a1 1 0 0 1-1.517-.86z",
        },
      ],
      [
        "path",
        { d: "M21 12.17V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" },
      ],
      ["path", { d: "m6 21 5-5" }],
      ["circle", { cx: "9", cy: "9", r: "2" }],
    ],
    $p = [
      ["path", { d: "M16 5h6" }],
      ["path", { d: "M19 2v6" }],
      [
        "path",
        { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5" },
      ],
      ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" }],
      ["circle", { cx: "9", cy: "9", r: "2" }],
    ],
    mp = [
      [
        "path",
        {
          d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
        },
      ],
      ["path", { d: "m14 19.5 3-3 3 3" }],
      ["path", { d: "M17 22v-5.5" }],
      ["circle", { cx: "9", cy: "9", r: "2" }],
    ],
    yp = [
      ["path", { d: "M16 3h5v5" }],
      ["path", { d: "M17 21h2a2 2 0 0 0 2-2" }],
      ["path", { d: "M21 12v3" }],
      ["path", { d: "m21 3-5 5" }],
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2" }],
      ["path", { d: "m5 21 4.144-4.144a1.21 1.21 0 0 1 1.712 0L13 19" }],
      ["path", { d: "M9 3h3" }],
      ["rect", { x: "3", y: "11", width: "10", height: "10", rx: "1" }],
    ],
    sp = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["circle", { cx: "9", cy: "9", r: "2" }],
      ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" }],
    ],
    gp = [
      ["path", { d: "m22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16" }],
      ["path", { d: "M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2" }],
      ["circle", { cx: "13", cy: "7", r: "1", fill: "currentColor" }],
      ["rect", { x: "8", y: "2", width: "14", height: "14", rx: "2" }],
    ],
    up = [
      ["path", { d: "M12 3v12" }],
      ["path", { d: "m8 11 4 4 4-4" }],
      [
        "path",
        {
          d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
        },
      ],
    ],
    Cp = [
      ["path", { d: "M6 3h12" }],
      ["path", { d: "M6 8h12" }],
      ["path", { d: "m6 13 8.5 8" }],
      ["path", { d: "M6 13h3" }],
      ["path", { d: "M9 13c6.667 0 6.667-10 0-10" }],
    ],
    Hp = [
      ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12" }],
      [
        "path",
        {
          d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
        },
      ],
    ],
    Ap = [
      [
        "path",
        { d: "M6 16c5 0 7-8 12-8a4 4 0 0 1 0 8c-5 0-7-8-12-8a4 4 0 1 0 0 8" },
      ],
    ],
    wp = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M12 16v-4" }],
      ["path", { d: "M12 8h.01" }],
    ],
    Vp = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M7 7h.01" }],
      ["path", { d: "M17 7h.01" }],
      ["path", { d: "M7 17h.01" }],
      ["path", { d: "M17 17h.01" }],
    ],
    Sp = [
      ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "5", ry: "5" }],
      ["path", { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" }],
      ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5" }],
    ],
    Lp = [
      ["line", { x1: "19", x2: "10", y1: "4", y2: "4" }],
      ["line", { x1: "14", x2: "5", y1: "20", y2: "20" }],
      ["line", { x1: "15", x2: "9", y1: "4", y2: "20" }],
    ],
    fp = [
      ["path", { d: "m16 14 4 4-4 4" }],
      ["path", { d: "M20 10a8 8 0 1 0-8 8h8" }],
    ],
    kp = [
      ["path", { d: "M4 10a8 8 0 1 1 8 8H4" }],
      ["path", { d: "m8 22-4-4 4-4" }],
    ],
    Pp = [
      ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3" }],
      ["path", { d: "M6 15h12" }],
      ["path", { d: "M6 11h12" }],
    ],
    Bp = [
      [
        "path",
        {
          d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
        },
      ],
      ["path", { d: "M6 15v-2" }],
      ["path", { d: "M12 15V9" }],
      ["circle", { cx: "12", cy: "6", r: "3" }],
    ],
    Dp = [
      ["path", { d: "M5 3v14" }],
      ["path", { d: "M12 3v8" }],
      ["path", { d: "M19 3v18" }],
    ],
    Fp = [
      [
        "path",
        {
          d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
        },
      ],
      ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor" }],
    ],
    zp = [
      ["path", { d: "M18 17a1 1 0 0 0-1 1v1a2 2 0 1 0 2-2z" }],
      [
        "path",
        {
          d: "M20.97 3.61a.45.45 0 0 0-.58-.58C10.2 6.6 6.6 10.2 3.03 20.39a.45.45 0 0 0 .58.58C13.8 17.4 17.4 13.8 20.97 3.61",
        },
      ],
      ["path", { d: "m6.707 6.707 10.586 10.586" }],
      ["path", { d: "M7 5a2 2 0 1 0-2 2h1a1 1 0 0 0 1-1z" }],
    ],
    bp = [
      [
        "path",
        {
          d: "M12.4 2.7a2.5 2.5 0 0 1 3.4 0l5.5 5.5a2.5 2.5 0 0 1 0 3.4l-3.7 3.7a2.5 2.5 0 0 1-3.4 0L8.7 9.8a2.5 2.5 0 0 1 0-3.4z",
        },
      ],
      ["path", { d: "m14 7 3 3" }],
      [
        "path",
        {
          d: "m9.4 10.6-6.814 6.814A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814",
        },
      ],
    ],
    Rp = [
      [
        "path",
        { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4" },
      ],
      ["path", { d: "m21 2-9.6 9.6" }],
      ["circle", { cx: "7.5", cy: "15.5", r: "5.5" }],
    ],
    Tp = [
      ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
      ["path", { d: "M6 8h4" }],
      ["path", { d: "M14 8h.01" }],
      ["path", { d: "M18 8h.01" }],
      ["path", { d: "M2 12h20" }],
      ["path", { d: "M6 12v4" }],
      ["path", { d: "M10 12v4" }],
      ["path", { d: "M14 12v4" }],
      ["path", { d: "M18 12v4" }],
    ],
    qp = [
      ["path", { d: "M 20 4 A2 2 0 0 1 22 6" }],
      ["path", { d: "M 22 6 L 22 16.41" }],
      ["path", { d: "M 7 16 L 16 16" }],
      ["path", { d: "M 9.69 4 L 20 4" }],
      ["path", { d: "M14 8h.01" }],
      ["path", { d: "M18 8h.01" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2" }],
      ["path", { d: "M6 8h.01" }],
      ["path", { d: "M8 12h.01" }],
    ],
    Up = [
      ["path", { d: "M10 8h.01" }],
      ["path", { d: "M12 12h.01" }],
      ["path", { d: "M14 8h.01" }],
      ["path", { d: "M16 12h.01" }],
      ["path", { d: "M18 8h.01" }],
      ["path", { d: "M6 8h.01" }],
      ["path", { d: "M7 16h10" }],
      ["path", { d: "M8 12h.01" }],
      ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
    ],
    Op = [
      ["path", { d: "M12 2v5" }],
      ["path", { d: "M14.829 15.998a3 3 0 1 1-5.658 0" }],
      [
        "path",
        {
          d: "M20.92 14.606A1 1 0 0 1 20 16H4a1 1 0 0 1-.92-1.394l3-7A1 1 0 0 1 7 7h10a1 1 0 0 1 .92.606z",
        },
      ],
    ],
    Zp = [
      [
        "path",
        {
          d: "M10.293 2.293a1 1 0 0 1 1.414 0l2.5 2.5 5.994 1.227a1 1 0 0 1 .506 1.687l-7 7a1 1 0 0 1-1.687-.506l-1.227-5.994-2.5-2.5a1 1 0 0 1 0-1.414z",
        },
      ],
      ["path", { d: "m14.207 4.793-3.414 3.414" }],
      [
        "path",
        {
          d: "M3 20a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z",
        },
      ],
      ["path", { d: "m9.086 6.5-4.793 4.793a1 1 0 0 0-.18 1.17L7 18" }],
    ],
    Gp = [
      ["path", { d: "M12 10v12" }],
      [
        "path",
        {
          d: "M17.929 7.629A1 1 0 0 1 17 9H7a1 1 0 0 1-.928-1.371l2-5A1 1 0 0 1 9 2h6a1 1 0 0 1 .928.629z",
        },
      ],
      ["path", { d: "M9 22h6" }],
    ],
    Ip = [
      [
        "path",
        {
          d: "M19.929 18.629A1 1 0 0 1 19 20H9a1 1 0 0 1-.928-1.371l2-5A1 1 0 0 1 11 13h6a1 1 0 0 1 .928.629z",
        },
      ],
      [
        "path",
        {
          d: "M6 3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z",
        },
      ],
      ["path", { d: "M8 6h4a2 2 0 0 1 2 2v5" }],
    ],
    Wp = [
      [
        "path",
        {
          d: "M19.929 9.629A1 1 0 0 1 19 11H9a1 1 0 0 1-.928-1.371l2-5A1 1 0 0 1 11 4h6a1 1 0 0 1 .928.629z",
        },
      ],
      [
        "path",
        {
          d: "M6 15a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z",
        },
      ],
      ["path", { d: "M8 18h4a2 2 0 0 0 2-2v-5" }],
    ],
    Ep = [
      ["path", { d: "M12 12v6" }],
      [
        "path",
        {
          d: "M4.077 10.615A1 1 0 0 0 5 12h14a1 1 0 0 0 .923-1.385l-3.077-7.384A2 2 0 0 0 15 2H9a2 2 0 0 0-1.846 1.23Z",
        },
      ],
      [
        "path",
        {
          d: "M8 20a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1z",
        },
      ],
    ],
    Xp = [
      ["path", { d: "m12 8 6-3-6-3v10" }],
      [
        "path",
        {
          d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
        },
      ],
      ["path", { d: "m6.49 12.85 11.02 6.3" }],
      ["path", { d: "M17.51 12.85 6.5 19.15" }],
    ],
    jp = [
      ["path", { d: "M10 18v-7" }],
      [
        "path",
        {
          d: "M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z",
        },
      ],
      ["path", { d: "M14 18v-7" }],
      ["path", { d: "M18 18v-7" }],
      ["path", { d: "M3 22h18" }],
      ["path", { d: "M6 18v-7" }],
    ],
    Np = [
      ["path", { d: "m5 8 6 6" }],
      ["path", { d: "m4 14 6-6 2-3" }],
      ["path", { d: "M2 5h12" }],
      ["path", { d: "M7 2h1" }],
      ["path", { d: "m22 22-5-10-5 10" }],
      ["path", { d: "M14 18h6" }],
    ],
    Kp = [
      ["path", { d: "M2 20h20" }],
      ["path", { d: "m9 10 2 2 4-4" }],
      ["rect", { x: "3", y: "4", width: "18", height: "12", rx: "2" }],
    ],
    p2 = [
      ["rect", { width: "18", height: "12", x: "3", y: "4", rx: "2", ry: "2" }],
      ["line", { x1: "2", x2: "22", y1: "20", y2: "20" }],
    ],
    Qp = [
      [
        "path",
        {
          d: "M18 5a2 2 0 0 1 2 2v8.526a2 2 0 0 0 .212.897l1.068 2.127a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45l1.068-2.127A2 2 0 0 0 4 15.526V7a2 2 0 0 1 2-2z",
        },
      ],
      ["path", { d: "M20.054 15.987H3.946" }],
    ],
    Jp = [
      ["path", { d: "M7 22a5 5 0 0 1-2-4" }],
      ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91" }],
      [
        "path",
        {
          d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
        },
      ],
      ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" }],
      [
        "path",
        {
          d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
        },
      ],
    ],
    Yp = [
      [
        "path",
        {
          d: "M3.704 14.467A10 8 0 0 1 2 10a10 8 0 0 1 20 0 10 8 0 0 1-10 8 10 8 0 0 1-5.181-1.158",
        },
      ],
      ["path", { d: "M7 22a5 5 0 0 1-2-3.994" }],
      ["circle", { cx: "5", cy: "16", r: "2" }],
    ],
    _p = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z" }],
      ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9" }],
      ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9" }],
    ],
    xp = [
      [
        "path",
        {
          d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74z",
        },
      ],
      [
        "path",
        {
          d: "m20 14.285 1.5.845a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74l1.5-.845",
        },
      ],
    ],
    ai = [
      ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1" }],
      ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1" }],
      ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1" }],
      ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1" }],
    ],
    ti = [
      ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1" }],
      ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1" }],
      ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1" }],
      ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1" }],
    ],
    i2 = [
      [
        "path",
        {
          d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
        },
      ],
      [
        "path",
        {
          d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
        },
      ],
      [
        "path",
        {
          d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
        },
      ],
    ],
    hi = [
      ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1" }],
      ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1" }],
      ["path", { d: "M14 4h7" }],
      ["path", { d: "M14 9h7" }],
      ["path", { d: "M14 15h7" }],
      ["path", { d: "M14 20h7" }],
    ],
    di = [
      ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1" }],
      ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1" }],
      ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1" }],
    ],
    ci = [
      ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1" }],
      ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1" }],
      ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1" }],
    ],
    Mi = [
      ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1" }],
      ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1" }],
      ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1" }],
    ],
    pi = [
      [
        "path",
        {
          d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
        },
      ],
      ["path", { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" }],
    ],
    ii = [
      [
        "path",
        {
          d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
        },
      ],
      ["path", { d: "M2 22 17 7" }],
    ],
    ni = [
      [
        "path",
        {
          d: "M16 12h3a2 2 0 0 0 1.902-1.38l1.056-3.333A1 1 0 0 0 21 6H3a1 1 0 0 0-.958 1.287l1.056 3.334A2 2 0 0 0 5 12h3",
        },
      ],
      ["path", { d: "M18 6V3a1 1 0 0 0-1-1h-3" }],
      ["rect", { width: "8", height: "12", x: "8", y: "10", rx: "1" }],
    ],
    li = [
      ["rect", { width: "8", height: "18", x: "3", y: "3", rx: "1" }],
      ["path", { d: "M7 3v18" }],
      [
        "path",
        {
          d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
        },
      ],
    ],
    ei = [
      ["path", { d: "m16 6 4 14" }],
      ["path", { d: "M12 6v14" }],
      ["path", { d: "M8 8v12" }],
      ["path", { d: "M4 4v16" }],
    ],
    ri = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "m4.93 4.93 4.24 4.24" }],
      ["path", { d: "m14.83 9.17 4.24-4.24" }],
      ["path", { d: "m14.83 14.83 4.24 4.24" }],
      ["path", { d: "m9.17 14.83-4.24 4.24" }],
      ["circle", { cx: "12", cy: "12", r: "4" }],
    ],
    oi = [
      ["path", { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5" }],
      ["path", { d: "M9 18h6" }],
      ["path", { d: "M10 22h4" }],
    ],
    vi = [
      ["path", { d: "M14 12h2v8" }],
      ["path", { d: "M14 20h4" }],
      ["path", { d: "M6 12h4" }],
      ["path", { d: "M6 20h4" }],
      ["path", { d: "M8 20V8a4 4 0 0 1 7.464-2" }],
    ],
    $i = [
      [
        "path",
        {
          d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
        },
      ],
      ["path", { d: "M9 18h6" }],
      ["path", { d: "M10 22h4" }],
    ],
    mi = [
      [
        "path",
        {
          d: "M7 3.5c5-2 7 2.5 3 4C1.5 10 2 15 5 16c5 2 9-10 14-7s.5 13.5-4 12c-5-2.5.5-11 6-2",
        },
      ],
    ],
    yi = [
      ["path", { d: "M9 17H7A5 5 0 0 1 7 7" }],
      ["path", { d: "M15 7h2a5 5 0 0 1 4 8" }],
      ["line", { x1: "8", x2: "12", y1: "12", y2: "12" }],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    si = [
      ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2" }],
      ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2" }],
      ["line", { x1: "8", x2: "16", y1: "12", y2: "12" }],
    ],
    gi = [
      [
        "path",
        { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" },
      ],
      [
        "path",
        { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" },
      ],
    ],
    ui = [
      [
        "path",
        {
          d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
        },
      ],
      ["rect", { width: "4", height: "12", x: "2", y: "9" }],
      ["circle", { cx: "4", cy: "4", r: "2" }],
    ],
    Ci = [
      ["path", { d: "M16 5H3" }],
      ["path", { d: "M16 12H3" }],
      ["path", { d: "M11 19H3" }],
      ["path", { d: "m15 18 2 2 4-4" }],
    ],
    Hi = [
      ["path", { d: "M13 5h8" }],
      ["path", { d: "M13 12h8" }],
      ["path", { d: "M13 19h8" }],
      ["path", { d: "m3 17 2 2 4-4" }],
      ["path", { d: "m3 7 2 2 4-4" }],
    ],
    Ai = [
      ["path", { d: "M3 5h8" }],
      ["path", { d: "M3 12h8" }],
      ["path", { d: "M3 19h8" }],
      ["path", { d: "m15 5 3 3 3-3" }],
      ["path", { d: "m15 19 3-3 3 3" }],
    ],
    wi = [
      ["path", { d: "M3 5h8" }],
      ["path", { d: "M3 12h8" }],
      ["path", { d: "M3 19h8" }],
      ["path", { d: "m15 8 3-3 3 3" }],
      ["path", { d: "m15 16 3 3 3-3" }],
    ],
    Vi = [
      ["path", { d: "M10 5h11" }],
      ["path", { d: "M10 12h11" }],
      ["path", { d: "M10 19h11" }],
      ["path", { d: "m3 10 3-3-3-3" }],
      ["path", { d: "m3 20 3-3-3-3" }],
    ],
    Si = [
      ["path", { d: "M16 5H3" }],
      ["path", { d: "M16 12H3" }],
      ["path", { d: "M9 19H3" }],
      ["path", { d: "m16 16-3 3 3 3" }],
      ["path", { d: "M21 5v12a2 2 0 0 1-2 2h-6" }],
    ],
    Li = [
      ["path", { d: "M12 5H2" }],
      ["path", { d: "M6 12h12" }],
      ["path", { d: "M9 19h6" }],
      ["path", { d: "M16 5h6" }],
      ["path", { d: "M19 8V2" }],
    ],
    fi = [
      ["path", { d: "M2 5h20" }],
      ["path", { d: "M6 12h12" }],
      ["path", { d: "M9 19h6" }],
    ],
    o = [
      ["path", { d: "M21 5H11" }],
      ["path", { d: "M21 12H11" }],
      ["path", { d: "M21 19H11" }],
      ["path", { d: "m7 8-4 4 4 4" }],
    ],
    v = [
      ["path", { d: "M21 5H11" }],
      ["path", { d: "M21 12H11" }],
      ["path", { d: "M21 19H11" }],
      ["path", { d: "m3 8 4 4-4 4" }],
    ],
    ki = [
      ["path", { d: "M16 5H3" }],
      ["path", { d: "M11 12H3" }],
      ["path", { d: "M16 19H3" }],
      ["path", { d: "M21 12h-6" }],
    ],
    Pi = [
      ["path", { d: "M16 5H3" }],
      ["path", { d: "M11 12H3" }],
      ["path", { d: "M11 19H3" }],
      ["path", { d: "M21 16V5" }],
      ["circle", { cx: "18", cy: "16", r: "3" }],
    ],
    Bi = [
      ["path", { d: "M11 5h10" }],
      ["path", { d: "M11 12h10" }],
      ["path", { d: "M11 19h10" }],
      ["path", { d: "M4 4h1v5" }],
      ["path", { d: "M4 9h2" }],
      [
        "path",
        { d: "M6.5 20H3.4c0-1 2.6-1.925 2.6-3.5a1.5 1.5 0 0 0-2.6-1.02" },
      ],
    ],
    Di = [
      ["path", { d: "M16 5H3" }],
      ["path", { d: "M11 12H3" }],
      ["path", { d: "M16 19H3" }],
      ["path", { d: "M18 9v6" }],
      ["path", { d: "M21 12h-6" }],
    ],
    Fi = [
      ["path", { d: "M21 5H3" }],
      ["path", { d: "M7 12H3" }],
      ["path", { d: "M7 19H3" }],
      [
        "path",
        {
          d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
        },
      ],
      ["path", { d: "M11 10v4h4" }],
    ],
    zi = [
      ["path", { d: "M3 5h6" }],
      ["path", { d: "M3 12h13" }],
      ["path", { d: "M3 19h13" }],
      ["path", { d: "m16 8-3-3 3-3" }],
      ["path", { d: "M21 19V7a2 2 0 0 0-2-2h-6" }],
    ],
    bi = [
      ["path", { d: "M13 5h8" }],
      ["path", { d: "M13 12h8" }],
      ["path", { d: "M13 19h8" }],
      ["path", { d: "m3 17 2 2 4-4" }],
      ["rect", { x: "3", y: "4", width: "6", height: "6", rx: "1" }],
    ],
    Ri = [
      ["path", { d: "M21 5H3" }],
      ["path", { d: "M10 12H3" }],
      ["path", { d: "M10 19H3" }],
      [
        "path",
        {
          d: "M15 12.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997a1 1 0 0 1-1.517-.86z",
        },
      ],
    ],
    Ti = [
      ["path", { d: "M8 5h13" }],
      ["path", { d: "M13 12h8" }],
      ["path", { d: "M13 19h8" }],
      ["path", { d: "M3 10a2 2 0 0 0 2 2h3" }],
      ["path", { d: "M3 5v12a2 2 0 0 0 2 2h3" }],
    ],
    qi = [
      ["path", { d: "M3 5h.01" }],
      ["path", { d: "M3 12h.01" }],
      ["path", { d: "M3 19h.01" }],
      ["path", { d: "M8 5h13" }],
      ["path", { d: "M8 12h13" }],
      ["path", { d: "M8 19h13" }],
    ],
    Ui = [
      ["path", { d: "M16 5H3" }],
      ["path", { d: "M11 12H3" }],
      ["path", { d: "M16 19H3" }],
      ["path", { d: "m15.5 9.5 5 5" }],
      ["path", { d: "m20.5 9.5-5 5" }],
    ],
    n2 = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56" }]],
    Oi = [
      ["path", { d: "M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0" }],
      ["path", { d: "M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6" }],
      ["path", { d: "M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Zi = [
      ["path", { d: "M12 2v4" }],
      ["path", { d: "m16.2 7.8 2.9-2.9" }],
      ["path", { d: "M18 12h4" }],
      ["path", { d: "m16.2 16.2 2.9 2.9" }],
      ["path", { d: "M12 18v4" }],
      ["path", { d: "m4.9 19.1 2.9-2.9" }],
      ["path", { d: "M2 12h4" }],
      ["path", { d: "m4.9 4.9 2.9 2.9" }],
    ],
    Gi = [
      ["path", { d: "M12 19v3" }],
      ["path", { d: "M12 2v3" }],
      ["path", { d: "M18.89 13.24a7 7 0 0 0-8.13-8.13" }],
      ["path", { d: "M19 12h3" }],
      ["path", { d: "M2 12h3" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M7.05 7.05a7 7 0 0 0 9.9 9.9" }],
    ],
    Ii = [
      ["line", { x1: "2", x2: "5", y1: "12", y2: "12" }],
      ["line", { x1: "19", x2: "22", y1: "12", y2: "12" }],
      ["line", { x1: "12", x2: "12", y1: "2", y2: "5" }],
      ["line", { x1: "12", x2: "12", y1: "19", y2: "22" }],
      ["circle", { cx: "12", cy: "12", r: "7" }],
      ["circle", { cx: "12", cy: "12", r: "3" }],
    ],
    Wi = [
      ["line", { x1: "2", x2: "5", y1: "12", y2: "12" }],
      ["line", { x1: "19", x2: "22", y1: "12", y2: "12" }],
      ["line", { x1: "12", x2: "12", y1: "2", y2: "5" }],
      ["line", { x1: "12", x2: "12", y1: "19", y2: "22" }],
      ["circle", { cx: "12", cy: "12", r: "7" }],
    ],
    l2 = [
      ["circle", { cx: "12", cy: "16", r: "1" }],
      ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2" }],
      ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5" }],
    ],
    Ei = [
      ["circle", { cx: "12", cy: "16", r: "1" }],
      ["rect", { x: "3", y: "10", width: "18", height: "12", rx: "2" }],
      ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3" }],
    ],
    e2 = [
      [
        "rect",
        { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2" },
      ],
      ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1" }],
    ],
    Xi = [
      [
        "rect",
        { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2" },
      ],
      ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }],
    ],
    ji = [
      ["path", { d: "m16 17 5-5-5-5" }],
      ["path", { d: "M21 12H9" }],
      ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }],
    ],
    Ni = [
      ["path", { d: "m10 17 5-5-5-5" }],
      ["path", { d: "M15 12H3" }],
      ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" }],
    ],
    Ki = [
      ["path", { d: "M3 5h1" }],
      ["path", { d: "M3 12h1" }],
      ["path", { d: "M3 19h1" }],
      ["path", { d: "M8 5h1" }],
      ["path", { d: "M8 12h1" }],
      ["path", { d: "M8 19h1" }],
      ["path", { d: "M13 5h8" }],
      ["path", { d: "M13 12h8" }],
      ["path", { d: "M13 19h8" }],
    ],
    Qi = [
      ["circle", { cx: "11", cy: "11", r: "8" }],
      ["path", { d: "m21 21-4.3-4.3" }],
      ["path", { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0" }],
    ],
    Ji = [
      [
        "path",
        {
          d: "M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2",
        },
      ],
      ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14" }],
      ["path", { d: "M10 20h4" }],
      ["circle", { cx: "16", cy: "20", r: "2" }],
      ["circle", { cx: "8", cy: "20", r: "2" }],
    ],
    Yi = [
      ["path", { d: "m12 15 4 4" }],
      [
        "path",
        {
          d: "M2.352 10.648a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l6.029-6.029a1 1 0 1 1 3 3l-6.029 6.029a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l6.365-6.367A1 1 0 0 0 8.716 4.282z",
        },
      ],
      ["path", { d: "m5 8 4 4" }],
    ],
    _i = [
      [
        "path",
        { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8" },
      ],
      ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
      ["path", { d: "m16 19 2 2 4-4" }],
    ],
    xi = [
      [
        "path",
        { d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8" },
      ],
      ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
      ["path", { d: "M16 19h6" }],
    ],
    an = [
      [
        "path",
        {
          d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
        },
      ],
      ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10" }],
    ],
    tn = [
      [
        "path",
        { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8" },
      ],
      ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
      ["path", { d: "M19 16v6" }],
      ["path", { d: "M16 19h6" }],
    ],
    r2 = [
      [
        "path",
        { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5" },
      ],
      ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
      [
        "path",
        {
          d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
        },
      ],
      ["path", { d: "M20 22v.01" }],
    ],
    hn = [
      [
        "path",
        { d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5" },
      ],
      ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
      ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }],
      ["circle", { cx: "18", cy: "18", r: "3" }],
      ["path", { d: "m22 22-1.5-1.5" }],
    ],
    dn = [
      [
        "path",
        { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5" },
      ],
      ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
      ["path", { d: "M20 14v4" }],
      ["path", { d: "M20 22v.01" }],
    ],
    cn = [
      [
        "path",
        { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9" },
      ],
      ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
      ["path", { d: "m17 17 4 4" }],
      ["path", { d: "m21 17-4 4" }],
    ],
    Mn = [
      ["path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" }],
      ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }],
    ],
    pn = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
        },
      ],
      ["polyline", { points: "15,9 18,9 18,11" }],
      ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2" }],
      ["line", { x1: "6", x2: "7", y1: "10", y2: "10" }],
    ],
    nn = [
      [
        "path",
        { d: "M17 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 1-1.732" },
      ],
      ["path", { d: "m22 5.5-6.419 4.179a2 2 0 0 1-2.162 0L7 5.5" }],
      ["rect", { x: "7", y: "3", width: "15", height: "12", rx: "2" }],
    ],
    ln = [
      [
        "path",
        {
          d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V14",
        },
      ],
      ["path", { d: "M15 5.764V14" }],
      ["path", { d: "M21 18h-6" }],
      ["path", { d: "M9 3.236v15" }],
    ],
    en = [
      [
        "path",
        {
          d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
        },
      ],
      ["path", { d: "m9 10 2 2 4-4" }],
    ],
    rn = [
      [
        "path",
        {
          d: "M19.43 12.935c.357-.967.57-1.955.57-2.935a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32.197 32.197 0 0 0 .813-.728",
        },
      ],
      ["circle", { cx: "12", cy: "10", r: "3" }],
      ["path", { d: "m16 18 2 2 4-4" }],
    ],
    on = [
      [
        "path",
        {
          d: "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z",
        },
      ],
      [
        "path",
        {
          d: "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2",
        },
      ],
      ["path", { d: "M18 22v-3" }],
      ["circle", { cx: "10", cy: "10", r: "3" }],
    ],
    vn = [
      [
        "path",
        {
          d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
        },
      ],
      ["path", { d: "M9 10h6" }],
    ],
    $n = [
      [
        "path",
        {
          d: "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
        },
      ],
      ["circle", { cx: "12", cy: "10", r: "3" }],
      ["path", { d: "M16 18h6" }],
    ],
    mn = [
      ["path", { d: "M12.75 7.09a3 3 0 0 1 2.16 2.16" }],
      [
        "path",
        {
          d: "M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        { d: "M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533" },
      ],
      ["path", { d: "M9.13 9.13a3 3 0 0 0 3.74 3.74" }],
    ],
    o2 = [
      [
        "path",
        { d: "M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468" },
      ],
      [
        "path",
        {
          d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
        },
      ],
      ["circle", { cx: "10", cy: "10", r: "3" }],
    ],
    yn = [
      [
        "path",
        {
          d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
        },
      ],
      ["path", { d: "M12 7v6" }],
      ["path", { d: "M9 10h6" }],
    ],
    sn = [
      [
        "path",
        {
          d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
        },
      ],
      ["path", { d: "m14.5 7.5-5 5" }],
      ["path", { d: "m9.5 7.5 5 5" }],
    ],
    gn = [
      [
        "path",
        {
          d: "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
        },
      ],
      ["circle", { cx: "12", cy: "10", r: "3" }],
      ["path", { d: "M16 18h6" }],
      ["path", { d: "M19 15v6" }],
    ],
    un = [
      [
        "path",
        {
          d: "M19.752 11.901A7.78 7.78 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 19 19 0 0 0 .09-.077",
        },
      ],
      ["circle", { cx: "12", cy: "10", r: "3" }],
      ["path", { d: "m21.5 15.5-5 5" }],
      ["path", { d: "m21.5 20.5-5-5" }],
    ],
    Cn = [
      [
        "path",
        {
          d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
        },
      ],
      ["circle", { cx: "12", cy: "10", r: "3" }],
    ],
    Hn = [
      [
        "path",
        {
          d: "M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0",
        },
      ],
      ["circle", { cx: "12", cy: "8", r: "2" }],
      [
        "path",
        {
          d: "M8.714 14h-3.71a1 1 0 0 0-.948.683l-2.004 6A1 1 0 0 0 3 22h18a1 1 0 0 0 .948-1.316l-2-6a1 1 0 0 0-.949-.684h-3.712",
        },
      ],
    ],
    An = [
      [
        "path",
        {
          d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12",
        },
      ],
      ["path", { d: "M15 5.764V12" }],
      ["path", { d: "M18 15v6" }],
      ["path", { d: "M21 18h-6" }],
      ["path", { d: "M9 3.236v15" }],
    ],
    wn = [
      [
        "path",
        {
          d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
        },
      ],
      ["path", { d: "M15 5.764v15" }],
      ["path", { d: "M9 3.236v15" }],
    ],
    Vn = [
      ["path", { d: "m14 6 4 4" }],
      ["path", { d: "M17 3h4v4" }],
      ["path", { d: "m21 3-7.75 7.75" }],
      ["circle", { cx: "9", cy: "15", r: "6" }],
    ],
    Sn = [
      ["path", { d: "M16 3h5v5" }],
      ["path", { d: "m21 3-6.75 6.75" }],
      ["circle", { cx: "10", cy: "14", r: "6" }],
    ],
    Ln = [
      ["path", { d: "M8 22h8" }],
      ["path", { d: "M12 11v11" }],
      ["path", { d: "m19 3-7 8-7-8Z" }],
    ],
    fn = [
      ["path", { d: "M15 3h6v6" }],
      ["path", { d: "m21 3-7 7" }],
      ["path", { d: "m3 21 7-7" }],
      ["path", { d: "M9 21H3v-6" }],
    ],
    kn = [
      ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3" }],
      ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3" }],
      ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3" }],
      ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3" }],
    ],
    Pn = [
      [
        "path",
        {
          d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
        },
      ],
      ["path", { d: "M11 12 5.12 2.2" }],
      ["path", { d: "m13 12 5.88-9.8" }],
      ["path", { d: "M8 7h8" }],
      ["circle", { cx: "12", cy: "17", r: "5" }],
      ["path", { d: "M12 18v-2h-.5" }],
    ],
    Bn = [
      ["path", { d: "M11.636 6A13 13 0 0 0 19.4 3.2 1 1 0 0 1 21 4v11.344" }],
      [
        "path",
        {
          d: "M14.378 14.357A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        { d: "M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" },
      ],
      ["path", { d: "M8 8v6" }],
    ],
    Dn = [
      [
        "path",
        {
          d: "M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z",
        },
      ],
      [
        "path",
        { d: "M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" },
      ],
      ["path", { d: "M8 6v8" }],
    ],
    Fn = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["line", { x1: "8", x2: "16", y1: "15", y2: "15" }],
      ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9" }],
      ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9" }],
    ],
    zn = [
      ["path", { d: "M6 19v-3" }],
      ["path", { d: "M10 19v-3" }],
      ["path", { d: "M14 19v-3" }],
      ["path", { d: "M18 19v-3" }],
      ["path", { d: "M8 11V9" }],
      ["path", { d: "M16 11V9" }],
      ["path", { d: "M12 11V9" }],
      ["path", { d: "M2 15h20" }],
      [
        "path",
        {
          d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
        },
      ],
    ],
    bn = [
      ["path", { d: "M4 5h16" }],
      ["path", { d: "M4 12h16" }],
      ["path", { d: "M4 19h16" }],
    ],
    Rn = [
      ["path", { d: "m8 6 4-4 4 4" }],
      ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22" }],
      ["path", { d: "m20 22-5-5" }],
    ],
    Tn = [
      ["path", { d: "m10 9-3 3 3 3" }],
      ["path", { d: "m14 15 3-3-3-3" }],
      [
        "path",
        {
          d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        },
      ],
    ],
    qn = [
      ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0" }],
      ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0" }],
      ["path", { d: "M17.609 3.72a10 10 0 0 1 2.69 2.7" }],
      ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8" }],
      ["path", { d: "M20.28 17.61a10 10 0 0 1-2.7 2.69" }],
      ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8" }],
      ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69" }],
      ["path", { d: "m6.163 21.117-2.906.85a1 1 0 0 1-1.236-1.169l.965-2.98" }],
    ],
    Un = [
      [
        "path",
        {
          d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        },
      ],
      [
        "path",
        {
          d: "M7.828 13.07A3 3 0 0 1 12 8.764a3 3 0 0 1 5.004 2.224 3 3 0 0 1-.832 2.083l-3.447 3.62a1 1 0 0 1-1.45-.001z",
        },
      ],
    ],
    On = [
      [
        "path",
        {
          d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        },
      ],
      ["path", { d: "M8 12h.01" }],
      ["path", { d: "M12 12h.01" }],
      ["path", { d: "M16 12h.01" }],
    ],
    Zn = [
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        {
          d: "M4.93 4.929a10 10 0 0 0-1.938 11.412 2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 0 0 11.302-1.989",
        },
      ],
      ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65" }],
    ],
    Gn = [
      [
        "path",
        {
          d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        },
      ],
      ["path", { d: "M8 12h8" }],
      ["path", { d: "M12 8v8" }],
    ],
    v2 = [
      [
        "path",
        {
          d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        },
      ],
      ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }],
      ["path", { d: "M12 17h.01" }],
    ],
    In = [
      [
        "path",
        {
          d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        },
      ],
      ["path", { d: "m10 15-3-3 3-3" }],
      ["path", { d: "M7 12h8a2 2 0 0 1 2 2v1" }],
    ],
    Wn = [
      [
        "path",
        {
          d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        },
      ],
      ["path", { d: "M12 8v4" }],
      ["path", { d: "M12 16h.01" }],
    ],
    En = [
      [
        "path",
        {
          d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        },
      ],
      ["path", { d: "m15 9-6 6" }],
      ["path", { d: "m9 9 6 6" }],
    ],
    Xn = [
      [
        "path",
        {
          d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        },
      ],
    ],
    jn = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
      ["path", { d: "m10 8-3 3 3 3" }],
      ["path", { d: "m14 14 3-3-3-3" }],
    ],
    Nn = [
      ["path", { d: "M12 19h.01" }],
      ["path", { d: "M12 3h.01" }],
      ["path", { d: "M16 19h.01" }],
      ["path", { d: "M16 3h.01" }],
      ["path", { d: "M2 13h.01" }],
      [
        "path",
        {
          d: "M2 17v4.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H8",
        },
      ],
      ["path", { d: "M2 5a2 2 0 0 1 2-2" }],
      ["path", { d: "M2 9h.01" }],
      ["path", { d: "M20 3a2 2 0 0 1 2 2" }],
      ["path", { d: "M22 13h.01" }],
      ["path", { d: "M22 17a2 2 0 0 1-2 2" }],
      ["path", { d: "M22 9h.01" }],
      ["path", { d: "M8 3h.01" }],
    ],
    Kn = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
      ["path", { d: "M10 15h4" }],
      ["path", { d: "M10 9h4" }],
      ["path", { d: "M12 7v4" }],
    ],
    Qn = [
      [
        "path",
        {
          d: "M12.7 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4.7",
        },
      ],
      ["circle", { cx: "19", cy: "6", r: "3" }],
    ],
    Jn = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
      [
        "path",
        {
          d: "M7.5 9.5c0 .687.265 1.383.697 1.844l3.009 3.264a1.14 1.14 0 0 0 .407.314 1 1 0 0 0 .783-.004 1.14 1.14 0 0 0 .398-.31l3.008-3.264A2.77 2.77 0 0 0 16.5 9.5 2.5 2.5 0 0 0 12 8a2.5 2.5 0 0 0-4.5 1.5",
        },
      ],
    ],
    Yn = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
      ["path", { d: "M12 11h.01" }],
      ["path", { d: "M16 11h.01" }],
      ["path", { d: "M8 11h.01" }],
    ],
    _n = [
      [
        "path",
        {
          d: "M22 8.5V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H10",
        },
      ],
      ["path", { d: "M20 15v-2a2 2 0 0 0-4 0v2" }],
      ["rect", { x: "14", y: "15", width: "8", height: "5", rx: "1" }],
    ],
    xn = [
      [
        "path",
        {
          d: "M19 19H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.7.7 0 0 1 2 21.286V5a2 2 0 0 1 1.184-1.826",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M8.656 3H20a2 2 0 0 1 2 2v11.344" }],
    ],
    al = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
      ["path", { d: "M12 8v6" }],
      ["path", { d: "M9 11h6" }],
    ],
    tl = [
      ["path", { d: "M14 14a2 2 0 0 0 2-2V8h-2" }],
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
      ["path", { d: "M8 14a2 2 0 0 0 2-2V8H8" }],
    ],
    hl = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
      ["path", { d: "m10 8-3 3 3 3" }],
      ["path", { d: "M17 14v-1a2 2 0 0 0-2-2H7" }],
    ],
    dl = [
      [
        "path",
        {
          d: "M12 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4",
        },
      ],
      ["path", { d: "M16 3h6v6" }],
      ["path", { d: "m16 9 6-6" }],
    ],
    cl = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
      ["path", { d: "M7 11h10" }],
      ["path", { d: "M7 15h6" }],
      ["path", { d: "M7 7h8" }],
    ],
    Ml = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
      ["path", { d: "M12 15h.01" }],
      ["path", { d: "M12 7v4" }],
    ],
    pl = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
      ["path", { d: "m14.5 8.5-5 5" }],
      ["path", { d: "m9.5 8.5 5 5" }],
    ],
    il = [
      [
        "path",
        {
          d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        },
      ],
    ],
    nl = [
      [
        "path",
        {
          d: "M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
        },
      ],
      [
        "path",
        {
          d: "M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1",
        },
      ],
    ],
    $2 = [
      [
        "path",
        {
          d: "m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12",
        },
      ],
      [
        "path",
        {
          d: "M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5",
        },
      ],
      ["circle", { cx: "16", cy: "7", r: "5" }],
    ],
    ll = [
      ["path", { d: "M12 19v3" }],
      ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33" }],
      ["path", { d: "M16.95 16.95A7 7 0 0 1 5 12v-2" }],
      ["path", { d: "M18.89 13.23A7 7 0 0 0 19 12v-2" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12" }],
    ],
    el = [
      ["path", { d: "M12 19v3" }],
      ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }],
      ["rect", { x: "9", y: "2", width: "6", height: "13", rx: "3" }],
    ],
    rl = [
      ["path", { d: "M18 12h2" }],
      ["path", { d: "M18 16h2" }],
      ["path", { d: "M18 20h2" }],
      ["path", { d: "M18 4h2" }],
      ["path", { d: "M18 8h2" }],
      ["path", { d: "M4 12h2" }],
      ["path", { d: "M4 16h2" }],
      ["path", { d: "M4 20h2" }],
      ["path", { d: "M4 4h2" }],
      ["path", { d: "M4 8h2" }],
      [
        "path",
        {
          d: "M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z",
        },
      ],
    ],
    ol = [
      ["path", { d: "M6 18h8" }],
      ["path", { d: "M3 22h18" }],
      ["path", { d: "M14 22a7 7 0 1 0 0-14h-1" }],
      ["path", { d: "M9 14h2" }],
      ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z" }],
      ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3" }],
    ],
    vl = [
      ["rect", { width: "20", height: "15", x: "2", y: "4", rx: "2" }],
      ["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1" }],
      ["path", { d: "M18 8v7" }],
      ["path", { d: "M6 19v2" }],
      ["path", { d: "M18 19v2" }],
    ],
    $l = [
      ["path", { d: "M12 13v8" }],
      ["path", { d: "M12 3v3" }],
      [
        "path",
        {
          d: "M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z",
        },
      ],
    ],
    ml = [
      ["path", { d: "M8 2h8" }],
      [
        "path",
        {
          d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
        },
      ],
      ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435" }],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    yl = [
      ["path", { d: "M8 2h8" }],
      [
        "path",
        {
          d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
        },
      ],
      ["path", { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0" }],
    ],
    sl = [
      ["path", { d: "m14 10 7-7" }],
      ["path", { d: "M20 10h-6V4" }],
      ["path", { d: "m3 21 7-7" }],
      ["path", { d: "M4 14h6v6" }],
    ],
    gl = [
      ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3" }],
      ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3" }],
      ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3" }],
      ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3" }],
    ],
    ul = [["path", { d: "M5 12h14" }]],
    Cl = [
      ["path", { d: "m9 10 2 2 4-4" }],
      ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
      ["path", { d: "M12 17v4" }],
      ["path", { d: "M8 21h8" }],
    ],
    Hl = [
      ["path", { d: "M12 17v4" }],
      ["path", { d: "m14.305 7.53.923-.382" }],
      ["path", { d: "m15.228 4.852-.923-.383" }],
      ["path", { d: "m16.852 3.228-.383-.924" }],
      ["path", { d: "m16.852 8.772-.383.923" }],
      ["path", { d: "m19.148 3.228.383-.924" }],
      ["path", { d: "m19.53 9.696-.382-.924" }],
      ["path", { d: "m20.772 4.852.924-.383" }],
      ["path", { d: "m20.772 7.148.924.383" }],
      [
        "path",
        { d: "M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" },
      ],
      ["path", { d: "M8 21h8" }],
      ["circle", { cx: "18", cy: "6", r: "3" }],
    ],
    Al = [
      ["path", { d: "M12 17v4" }],
      [
        "path",
        {
          d: "M22 12.307V15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8.693",
        },
      ],
      ["path", { d: "M8 21h8" }],
      ["circle", { cx: "19", cy: "6", r: "3" }],
    ],
    wl = [
      ["path", { d: "M12 13V7" }],
      ["path", { d: "m15 10-3 3-3-3" }],
      ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
      ["path", { d: "M12 17v4" }],
      ["path", { d: "M8 21h8" }],
    ],
    Vl = [
      ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2" }],
      ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9" }],
      ["path", { d: "M8 21h8" }],
      ["path", { d: "M12 17v4" }],
      ["path", { d: "m2 2 20 20" }],
    ],
    Sl = [
      ["path", { d: "M10 13V7" }],
      ["path", { d: "M14 13V7" }],
      ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
      ["path", { d: "M12 17v4" }],
      ["path", { d: "M8 21h8" }],
    ],
    Ll = [
      [
        "path",
        {
          d: "M15.033 9.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56V7.648a.645.645 0 0 1 .967-.56z",
        },
      ],
      ["path", { d: "M12 17v4" }],
      ["path", { d: "M8 21h8" }],
      ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2" }],
    ],
    fl = [
      [
        "path",
        { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8" },
      ],
      ["path", { d: "M10 19v-3.96 3.15" }],
      ["path", { d: "M7 19h5" }],
      ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2" }],
    ],
    kl = [
      ["path", { d: "M5.5 20H8" }],
      ["path", { d: "M17 9h.01" }],
      ["rect", { width: "10", height: "16", x: "12", y: "4", rx: "2" }],
      ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4" }],
      ["circle", { cx: "17", cy: "15", r: "1" }],
    ],
    Pl = [
      ["path", { d: "M12 17v4" }],
      ["path", { d: "M8 21h8" }],
      ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2" }],
      ["rect", { x: "9", y: "7", width: "6", height: "6", rx: "1" }],
    ],
    Bl = [
      ["path", { d: "m9 10 3-3 3 3" }],
      ["path", { d: "M12 13V7" }],
      ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
      ["path", { d: "M12 17v4" }],
      ["path", { d: "M8 21h8" }],
    ],
    Dl = [
      ["path", { d: "m14.5 12.5-5-5" }],
      ["path", { d: "m9.5 12.5 5-5" }],
      ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
      ["path", { d: "M12 17v4" }],
      ["path", { d: "M8 21h8" }],
    ],
    Fl = [
      ["path", { d: "M18 5h4" }],
      ["path", { d: "M20 3v4" }],
      [
        "path",
        {
          d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
        },
      ],
    ],
    zl = [
      ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
      ["line", { x1: "8", x2: "16", y1: "21", y2: "21" }],
      ["line", { x1: "12", x2: "12", y1: "17", y2: "21" }],
    ],
    bl = [
      [
        "path",
        {
          d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
        },
      ],
    ],
    Rl = [
      ["path", { d: "m18 14-1-3" }],
      ["path", { d: "m3 9 6 2a2 2 0 0 1 2-2h2a2 2 0 0 1 1.99 1.81" }],
      [
        "path",
        {
          d: "M8 17h3a1 1 0 0 0 1-1 6 6 0 0 1 6-6 1 1 0 0 0 1-1v-.75A5 5 0 0 0 17 5",
        },
      ],
      ["circle", { cx: "19", cy: "17", r: "3" }],
      ["circle", { cx: "5", cy: "17", r: "3" }],
    ],
    Tl = [
      ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z" }],
      [
        "path",
        {
          d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19",
        },
      ],
    ],
    ql = [["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z" }]],
    Ul = [
      ["path", { d: "M12 6v.343" }],
      ["path", { d: "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218" }],
      ["path", { d: "M19 13.343V9A7 7 0 0 0 8.56 2.902" }],
      ["path", { d: "M22 22 2 2" }],
    ],
    Ol = [
      [
        "path",
        {
          d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
        },
      ],
    ],
    Zl = [
      [
        "path",
        {
          d: "M2.034 2.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.944L8.204 7.545a1 1 0 0 0-.66.66l-1.066 3.443a.5.5 0 0 1-.944.033z",
        },
      ],
      ["circle", { cx: "16", cy: "16", r: "6" }],
      ["path", { d: "m11.8 11.8 8.4 8.4" }],
    ],
    Gl = [
      ["path", { d: "M14 4.1 12 6" }],
      ["path", { d: "m5.1 8-2.9-.8" }],
      ["path", { d: "m6 12-1.9 2" }],
      ["path", { d: "M7.2 2.2 8 5.1" }],
      [
        "path",
        {
          d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
        },
      ],
    ],
    Il = [
      ["path", { d: "M12.586 12.586 19 19" }],
      [
        "path",
        {
          d: "M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z",
        },
      ],
    ],
    Wl = [
      ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7" }],
      ["path", { d: "M12 6v4" }],
    ],
    m2 = [
      ["path", { d: "M5 3v16h16" }],
      ["path", { d: "m5 19 6-6" }],
      ["path", { d: "m2 6 3-3 3 3" }],
      ["path", { d: "m18 16 3 3-3 3" }],
    ],
    El = [
      ["path", { d: "M19 13v6h-6" }],
      ["path", { d: "M5 11V5h6" }],
      ["path", { d: "m5 5 14 14" }],
    ],
    Xl = [
      ["path", { d: "M11 19H5v-6" }],
      ["path", { d: "M13 5h6v6" }],
      ["path", { d: "M19 5 5 19" }],
    ],
    jl = [
      ["path", { d: "M11 19H5V13" }],
      ["path", { d: "M19 5L5 19" }],
    ],
    Nl = [
      ["path", { d: "M19 13V19H13" }],
      ["path", { d: "M5 5L19 19" }],
    ],
    Kl = [
      ["path", { d: "M8 18L12 22L16 18" }],
      ["path", { d: "M12 2V22" }],
    ],
    Ql = [
      ["path", { d: "m18 8 4 4-4 4" }],
      ["path", { d: "M2 12h20" }],
      ["path", { d: "m6 8-4 4 4 4" }],
    ],
    Jl = [
      ["path", { d: "M6 8L2 12L6 16" }],
      ["path", { d: "M2 12H22" }],
    ],
    Yl = [
      ["path", { d: "M18 8L22 12L18 16" }],
      ["path", { d: "M2 12H22" }],
    ],
    _l = [
      ["path", { d: "M13 5H19V11" }],
      ["path", { d: "M19 5L5 19" }],
    ],
    xl = [
      ["path", { d: "M5 11V5H11" }],
      ["path", { d: "M5 5L19 19" }],
    ],
    ae = [
      ["path", { d: "M8 6L12 2L16 6" }],
      ["path", { d: "M12 2V22" }],
    ],
    te = [
      ["path", { d: "M12 2v20" }],
      ["path", { d: "m8 18 4 4 4-4" }],
      ["path", { d: "m8 6 4-4 4 4" }],
    ],
    he = [
      ["path", { d: "M12 2v20" }],
      ["path", { d: "m15 19-3 3-3-3" }],
      ["path", { d: "m19 9 3 3-3 3" }],
      ["path", { d: "M2 12h20" }],
      ["path", { d: "m5 9-3 3 3 3" }],
      ["path", { d: "m9 5 3-3 3 3" }],
    ],
    de = [
      ["circle", { cx: "8", cy: "18", r: "4" }],
      ["path", { d: "M12 18V2l7 4" }],
    ],
    ce = [
      ["circle", { cx: "12", cy: "18", r: "4" }],
      ["path", { d: "M16 18V2" }],
    ],
    Me = [
      ["path", { d: "M9 18V5l12-2v13" }],
      ["path", { d: "m9 9 12-2" }],
      ["circle", { cx: "6", cy: "18", r: "3" }],
      ["circle", { cx: "18", cy: "16", r: "3" }],
    ],
    pe = [
      ["path", { d: "M9 18V5l12-2v13" }],
      ["circle", { cx: "6", cy: "18", r: "3" }],
      ["circle", { cx: "18", cy: "16", r: "3" }],
    ],
    ie = [
      ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17" }],
      ["path", { d: "M14.53 8.88 12 2l-1.17 3.17" }],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    ne = [["polygon", { points: "12 2 19 21 12 17 5 21 12 2" }]],
    le = [
      ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43" }],
      ["path", { d: "M17.39 11.73 22 2l-9.73 4.61" }],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    ee = [["polygon", { points: "3 11 22 2 13 21 11 13 3 11" }]],
    re = [
      ["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1" }],
      ["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1" }],
      ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1" }],
      ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3" }],
      ["path", { d: "M12 12V8" }],
    ],
    oe = [
      ["path", { d: "M15 18h-5" }],
      ["path", { d: "M18 14h-8" }],
      [
        "path",
        {
          d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2",
        },
      ],
      ["rect", { width: "8", height: "4", x: "10", y: "6", rx: "1" }],
    ],
    ve = [
      ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36" }],
      ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58" }],
      ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8" }],
      ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20" }],
    ],
    $e = [
      ["path", { d: "M12 2v10" }],
      ["path", { d: "m8.5 4 7 4" }],
      ["path", { d: "m8.5 8 7-4" }],
      ["circle", { cx: "12", cy: "17", r: "5" }],
    ],
    me = [
      [
        "path",
        { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4" },
      ],
      ["path", { d: "M2 6h4" }],
      ["path", { d: "M2 10h4" }],
      ["path", { d: "M2 14h4" }],
      ["path", { d: "M2 18h4" }],
      [
        "path",
        {
          d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
        },
      ],
    ],
    ye = [
      ["path", { d: "M2 6h4" }],
      ["path", { d: "M2 10h4" }],
      ["path", { d: "M2 14h4" }],
      ["path", { d: "M2 18h4" }],
      ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2" }],
      ["path", { d: "M15 2v20" }],
      ["path", { d: "M15 7h5" }],
      ["path", { d: "M15 12h5" }],
      ["path", { d: "M15 17h5" }],
    ],
    se = [
      ["path", { d: "M2 6h4" }],
      ["path", { d: "M2 10h4" }],
      ["path", { d: "M2 14h4" }],
      ["path", { d: "M2 18h4" }],
      ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2" }],
      ["path", { d: "M9.5 8h5" }],
      ["path", { d: "M9.5 12H16" }],
      ["path", { d: "M9.5 16H14" }],
    ],
    ge = [
      ["path", { d: "M2 6h4" }],
      ["path", { d: "M2 10h4" }],
      ["path", { d: "M2 14h4" }],
      ["path", { d: "M2 18h4" }],
      ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2" }],
      ["path", { d: "M16 2v20" }],
    ],
    ue = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M12 2v4" }],
      ["path", { d: "M16 2v4" }],
      ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M20 12v2" }],
      ["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1" }],
      ["path", { d: "M13 22h-2" }],
      ["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2" }],
      ["path", { d: "M4 14v-2" }],
      ["path", { d: "M4 8V6a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M8 10h6" }],
      ["path", { d: "M8 14h8" }],
      ["path", { d: "M8 18h5" }],
    ],
    Ce = [
      ["path", { d: "M8 2v4" }],
      ["path", { d: "M12 2v4" }],
      ["path", { d: "M16 2v4" }],
      ["rect", { width: "16", height: "18", x: "4", y: "4", rx: "2" }],
      ["path", { d: "M8 10h6" }],
      ["path", { d: "M8 14h8" }],
      ["path", { d: "M8 18h5" }],
    ],
    He = [
      ["path", { d: "M12 4V2" }],
      [
        "path",
        {
          d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
        },
      ],
      ["path", { d: "M19 10v3.343" }],
      [
        "path",
        {
          d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
        },
      ],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    Ae = [
      ["path", { d: "M12 4V2" }],
      [
        "path",
        {
          d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
        },
      ],
      [
        "path",
        {
          d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
        },
      ],
    ],
    y2 = [
      ["path", { d: "M12 16h.01" }],
      ["path", { d: "M12 8v4" }],
      [
        "path",
        {
          d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
        },
      ],
    ],
    we = [
      [
        "path",
        {
          d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
        },
      ],
      ["path", { d: "M8 12h8" }],
    ],
    s2 = [
      ["path", { d: "M10 15V9" }],
      ["path", { d: "M14 15V9" }],
      [
        "path",
        {
          d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
        },
      ],
    ],
    g2 = [
      ["path", { d: "m15 9-6 6" }],
      [
        "path",
        {
          d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
        },
      ],
      ["path", { d: "m9 9 6 6" }],
    ],
    Ve = [
      [
        "path",
        {
          d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
        },
      ],
    ],
    Se = [
      [
        "path",
        {
          d: "M3 20h4.5a.5.5 0 0 0 .5-.5v-.282a.52.52 0 0 0-.247-.437 8 8 0 1 1 8.494-.001.52.52 0 0 0-.247.438v.282a.5.5 0 0 0 .5.5H21",
        },
      ],
    ],
    Le = [
      ["path", { d: "M20.341 6.484A10 10 0 0 1 10.266 21.85" }],
      ["path", { d: "M3.659 17.516A10 10 0 0 1 13.74 2.152" }],
      ["circle", { cx: "12", cy: "12", r: "3" }],
      ["circle", { cx: "19", cy: "5", r: "2" }],
      ["circle", { cx: "5", cy: "19", r: "2" }],
    ],
    fe = [
      ["path", { d: "M3 3h6l6 18h6" }],
      ["path", { d: "M14 3h7" }],
    ],
    ke = [
      [
        "path",
        { d: "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025" },
      ],
      [
        "path",
        {
          d: "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009",
        },
      ],
      [
        "path",
        {
          d: "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027",
        },
      ],
    ],
    Pe = [
      ["path", { d: "M12 3v6" }],
      [
        "path",
        {
          d: "M16.76 3a2 2 0 0 1 1.8 1.1l2.23 4.479a2 2 0 0 1 .21.891V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9.472a2 2 0 0 1 .211-.894L5.45 4.1A2 2 0 0 1 7.24 3z",
        },
      ],
      ["path", { d: "M3.054 9.013h17.893" }],
    ],
    Be = [
      ["path", { d: "m16 16 2 2 4-4" }],
      [
        "path",
        {
          d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
        },
      ],
      ["path", { d: "m7.5 4.27 9 5.15" }],
      ["polyline", { points: "3.29 7 12 12 20.71 7" }],
      ["line", { x1: "12", x2: "12", y1: "22", y2: "12" }],
    ],
    De = [
      ["path", { d: "M16 16h6" }],
      [
        "path",
        {
          d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
        },
      ],
      ["path", { d: "m7.5 4.27 9 5.15" }],
      ["polyline", { points: "3.29 7 12 12 20.71 7" }],
      ["line", { x1: "12", x2: "12", y1: "22", y2: "12" }],
    ],
    Fe = [
      ["path", { d: "M16 16h6" }],
      ["path", { d: "M19 13v6" }],
      [
        "path",
        {
          d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
        },
      ],
      ["path", { d: "m7.5 4.27 9 5.15" }],
      ["polyline", { points: "3.29 7 12 12 20.71 7" }],
      ["line", { x1: "12", x2: "12", y1: "22", y2: "12" }],
    ],
    ze = [
      ["path", { d: "M12 22v-9" }],
      [
        "path",
        {
          d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
        },
      ],
      [
        "path",
        {
          d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
        },
      ],
      [
        "path",
        {
          d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
        },
      ],
    ],
    be = [
      [
        "path",
        {
          d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
        },
      ],
      ["path", { d: "m7.5 4.27 9 5.15" }],
      ["polyline", { points: "3.29 7 12 12 20.71 7" }],
      ["line", { x1: "12", x2: "12", y1: "22", y2: "12" }],
      ["circle", { cx: "18.5", cy: "15.5", r: "2.5" }],
      ["path", { d: "M20.27 17.27 22 19" }],
    ],
    Re = [
      [
        "path",
        {
          d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
        },
      ],
      ["path", { d: "m7.5 4.27 9 5.15" }],
      ["polyline", { points: "3.29 7 12 12 20.71 7" }],
      ["line", { x1: "12", x2: "12", y1: "22", y2: "12" }],
      ["path", { d: "m17 13 5 5m-5 0 5-5" }],
    ],
    Te = [
      [
        "path",
        {
          d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
        },
      ],
      ["path", { d: "M12 22V12" }],
      ["polyline", { points: "3.29 7 12 12 20.71 7" }],
      ["path", { d: "m7.5 4.27 9 5.15" }],
    ],
    qe = [
      [
        "path",
        {
          d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z",
        },
      ],
      ["path", { d: "m5 2 5 5" }],
      ["path", { d: "M2 13h15" }],
      [
        "path",
        { d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z" },
      ],
    ],
    Ue = [
      ["rect", { width: "16", height: "6", x: "2", y: "2", rx: "2" }],
      [
        "path",
        { d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" },
      ],
      ["rect", { width: "4", height: "6", x: "8", y: "16", rx: "1" }],
    ],
    u2 = [
      ["path", { d: "M10 2v2" }],
      ["path", { d: "M14 2v4" }],
      ["path", { d: "M17 2a1 1 0 0 1 1 1v9H6V3a1 1 0 0 1 1-1z" }],
      [
        "path",
        {
          d: "M6 12a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 1 1 1v2.9a2 2 0 1 0 4 0V17a1 1 0 0 1 1-1h2a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1",
        },
      ],
    ],
    Oe = [
      ["path", { d: "m14.622 17.897-10.68-2.913" }],
      [
        "path",
        {
          d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
        },
      ],
      [
        "path",
        {
          d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
        },
      ],
    ],
    Ze = [
      [
        "path",
        {
          d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
        },
      ],
      ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor" }],
      ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor" }],
      ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor" }],
      ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor" }],
    ],
    Ge = [
      ["path", { d: "M11.25 17.25h1.5L12 18z" }],
      ["path", { d: "m15 12 2 2" }],
      ["path", { d: "M18 6.5a.5.5 0 0 0-.5-.5" }],
      [
        "path",
        {
          d: "M20.69 9.67a4.5 4.5 0 1 0-7.04-5.5 8.35 8.35 0 0 0-3.3 0 4.5 4.5 0 1 0-7.04 5.5C2.49 11.2 2 12.88 2 14.5 2 19.47 6.48 22 12 22s10-2.53 10-7.5c0-1.62-.48-3.3-1.3-4.83",
        },
      ],
      ["path", { d: "M6 6.5a.495.495 0 0 1 .5-.5" }],
      ["path", { d: "m9 12-2 2" }],
    ],
    C2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M14 15h1" }],
      ["path", { d: "M19 15h2" }],
      ["path", { d: "M3 15h2" }],
      ["path", { d: "M9 15h1" }],
    ],
    Ie = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 15h18" }],
      ["path", { d: "m15 8-3 3-3-3" }],
    ],
    We = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 15h18" }],
      ["path", { d: "m9 10 3-3 3 3" }],
    ],
    Ee = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 15h18" }],
    ],
    H2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M9 3v18" }],
      ["path", { d: "m16 15-3-3 3-3" }],
    ],
    A2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M9 14v1" }],
      ["path", { d: "M9 19v2" }],
      ["path", { d: "M9 3v2" }],
      ["path", { d: "M9 9v1" }],
    ],
    w2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M9 3v18" }],
      ["path", { d: "m14 9 3 3-3 3" }],
    ],
    Xe = [
      ["path", { d: "M15 10V9" }],
      ["path", { d: "M15 15v-1" }],
      ["path", { d: "M15 21v-2" }],
      ["path", { d: "M15 5V3" }],
      ["path", { d: "M9 10V9" }],
      ["path", { d: "M9 15v-1" }],
      ["path", { d: "M9 21v-2" }],
      ["path", { d: "M9 5V3" }],
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
    ],
    V2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M9 3v18" }],
    ],
    je = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M15 3v18" }],
      ["path", { d: "m8 9 3 3-3 3" }],
    ],
    S2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M15 14v1" }],
      ["path", { d: "M15 19v2" }],
      ["path", { d: "M15 3v2" }],
      ["path", { d: "M15 9v1" }],
    ],
    Ne = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M15 3v18" }],
      ["path", { d: "m10 15-3-3 3-3" }],
    ],
    Ke = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M15 3v18" }],
    ],
    Qe = [
      ["path", { d: "M14 15h1" }],
      ["path", { d: "M14 9h1" }],
      ["path", { d: "M19 15h2" }],
      ["path", { d: "M19 9h2" }],
      ["path", { d: "M3 15h2" }],
      ["path", { d: "M3 9h2" }],
      ["path", { d: "M9 15h1" }],
      ["path", { d: "M9 9h1" }],
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
    ],
    Je = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 9h18" }],
      ["path", { d: "m9 16 3-3 3 3" }],
    ],
    L2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M14 9h1" }],
      ["path", { d: "M19 9h2" }],
      ["path", { d: "M3 9h2" }],
      ["path", { d: "M9 9h1" }],
    ],
    Ye = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 9h18" }],
      ["path", { d: "m15 14-3 3-3-3" }],
    ],
    _e = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 9h18" }],
    ],
    xe = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M9 3v18" }],
      ["path", { d: "M9 15h12" }],
    ],
    ar = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 15h12" }],
      ["path", { d: "M15 3v18" }],
    ],
    f2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 9h18" }],
      ["path", { d: "M9 21V9" }],
    ],
    tr = [
      ["path", { d: "M8 21s-4-3-4-9 4-9 4-9" }],
      ["path", { d: "M16 3s4 3 4 9-4 9-4 9" }],
    ],
    hr = [
      [
        "path",
        {
          d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
        },
      ],
    ],
    dr = [
      ["path", { d: "M11 15h2" }],
      ["path", { d: "M12 12v3" }],
      ["path", { d: "M12 19v3" }],
      [
        "path",
        {
          d: "M15.282 19a1 1 0 0 0 .948-.68l2.37-6.988a7 7 0 1 0-13.2 0l2.37 6.988a1 1 0 0 0 .948.68z",
        },
      ],
      ["path", { d: "M9 9a3 3 0 1 1 6 0" }],
    ],
    cr = [
      ["path", { d: "M5.8 11.3 2 22l10.7-3.79" }],
      ["path", { d: "M4 3h.01" }],
      ["path", { d: "M22 8h.01" }],
      ["path", { d: "M15 2h.01" }],
      ["path", { d: "M22 20h.01" }],
      [
        "path",
        {
          d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
        },
      ],
      [
        "path",
        {
          d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17",
        },
      ],
      [
        "path",
        { d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7" },
      ],
      [
        "path",
        {
          d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
        },
      ],
    ],
    Mr = [
      ["rect", { x: "14", y: "3", width: "5", height: "18", rx: "1" }],
      ["rect", { x: "5", y: "3", width: "5", height: "18", rx: "1" }],
    ],
    pr = [
      ["circle", { cx: "11", cy: "4", r: "2" }],
      ["circle", { cx: "18", cy: "8", r: "2" }],
      ["circle", { cx: "20", cy: "16", r: "2" }],
      [
        "path",
        {
          d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
        },
      ],
    ],
    k2 = [
      ["path", { d: "M13 21h8" }],
      [
        "path",
        {
          d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
        },
      ],
    ],
    ir = [
      [
        "path",
        {
          d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
        },
      ],
      [
        "path",
        { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353" },
      ],
      ["path", { d: "m2 2 20 20" }],
    ],
    nr = [
      ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2" }],
      ["path", { d: "M15 14h.01" }],
      ["path", { d: "M9 6h6" }],
      ["path", { d: "M9 10h6" }],
    ],
    lr = [
      [
        "path",
        {
          d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z",
        },
      ],
      [
        "path",
        {
          d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18",
        },
      ],
      ["path", { d: "m2.3 2.3 7.286 7.286" }],
      ["circle", { cx: "11", cy: "11", r: "2" }],
    ],
    er = [
      ["path", { d: "M13 21h8" }],
      ["path", { d: "m15 5 4 4" }],
      [
        "path",
        {
          d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
        },
      ],
    ],
    rr = [
      [
        "path",
        {
          d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
        },
      ],
      [
        "path",
        { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353" },
      ],
      ["path", { d: "m15 5 4 4" }],
      ["path", { d: "m2 2 20 20" }],
    ],
    P2 = [
      [
        "path",
        {
          d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
        },
      ],
    ],
    or = [
      [
        "path",
        {
          d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13",
        },
      ],
      ["path", { d: "m8 6 2-2" }],
      ["path", { d: "m18 16 2-2" }],
      [
        "path",
        {
          d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
        },
      ],
      [
        "path",
        {
          d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
        },
      ],
      ["path", { d: "m15 5 4 4" }],
    ],
    vr = [
      [
        "path",
        {
          d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
        },
      ],
      ["path", { d: "m15 5 4 4" }],
    ],
    $r = [
      [
        "path",
        {
          d: "M10.83 2.38a2 2 0 0 1 2.34 0l8 5.74a2 2 0 0 1 .73 2.25l-3.04 9.26a2 2 0 0 1-1.9 1.37H7.04a2 2 0 0 1-1.9-1.37L2.1 10.37a2 2 0 0 1 .73-2.25z",
        },
      ],
    ],
    mr = [
      ["line", { x1: "19", x2: "5", y1: "5", y2: "19" }],
      ["circle", { cx: "6.5", cy: "6.5", r: "2.5" }],
      ["circle", { cx: "17.5", cy: "17.5", r: "2.5" }],
    ],
    yr = [
      ["circle", { cx: "12", cy: "5", r: "1" }],
      ["path", { d: "m9 20 3-6 3 6" }],
      ["path", { d: "m6 8 6 2 6-2" }],
      ["path", { d: "M12 10v4" }],
    ],
    sr = [
      ["path", { d: "M20 11H4" }],
      ["path", { d: "M20 7H4" }],
      ["path", { d: "M7 21V4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 12H7" }],
    ],
    gr = [
      ["path", { d: "M13 2a9 9 0 0 1 9 9" }],
      ["path", { d: "M13 6a5 5 0 0 1 5 5" }],
      [
        "path",
        {
          d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
        },
      ],
    ],
    ur = [
      ["path", { d: "M14 6h8" }],
      ["path", { d: "m18 2 4 4-4 4" }],
      [
        "path",
        {
          d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
        },
      ],
    ],
    Cr = [
      ["path", { d: "M16 2v6h6" }],
      ["path", { d: "m22 2-6 6" }],
      [
        "path",
        {
          d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
        },
      ],
    ],
    Hr = [
      ["path", { d: "m16 2 6 6" }],
      ["path", { d: "m22 2-6 6" }],
      [
        "path",
        {
          d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
        },
      ],
    ],
    Ar = [
      [
        "path",
        {
          d: "M10.1 13.9a14 14 0 0 0 3.732 2.668 1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2 18 18 0 0 1-12.728-5.272",
        },
      ],
      ["path", { d: "M22 2 2 22" }],
      [
        "path",
        {
          d: "M4.76 13.582A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 .244.473",
        },
      ],
    ],
    wr = [
      ["path", { d: "m16 8 6-6" }],
      ["path", { d: "M22 8V2h-6" }],
      [
        "path",
        {
          d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
        },
      ],
    ],
    Vr = [
      [
        "path",
        {
          d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
        },
      ],
    ],
    Sr = [
      ["line", { x1: "9", x2: "9", y1: "4", y2: "20" }],
      ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13" }],
      ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4" }],
    ],
    Lr = [
      [
        "path",
        {
          d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
        },
      ],
      ["path", { d: "M2 14h20" }],
      ["path", { d: "M6 14v4" }],
      ["path", { d: "M10 14v4" }],
      ["path", { d: "M14 14v4" }],
      ["path", { d: "M18 14v4" }],
    ],
    fr = [
      ["path", { d: "m14 13-8.381 8.38a1 1 0 0 1-3.001-3L11 9.999" }],
      [
        "path",
        {
          d: "M15.973 4.027A13 13 0 0 0 5.902 2.373c-1.398.342-1.092 2.158.277 2.601a19.9 19.9 0 0 1 5.822 3.024",
        },
      ],
      [
        "path",
        {
          d: "M16.001 11.999a19.9 19.9 0 0 1 3.024 5.824c.444 1.369 2.26 1.676 2.603.278A13 13 0 0 0 20 8.069",
        },
      ],
      [
        "path",
        {
          d: "M18.352 3.352a1.205 1.205 0 0 0-1.704 0l-5.296 5.296a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l5.296-5.296a1.205 1.205 0 0 0 0-1.704z",
        },
      ],
    ],
    kr = [
      [
        "path",
        { d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4" },
      ],
      ["rect", { width: "10", height: "7", x: "12", y: "13", rx: "2" }],
    ],
    Pr = [
      ["path", { d: "M2 10h6V4" }],
      ["path", { d: "m2 4 6 6" }],
      ["path", { d: "M21 10V7a2 2 0 0 0-2-2h-7" }],
      ["path", { d: "M3 14v2a2 2 0 0 0 2 2h3" }],
      ["rect", { x: "12", y: "14", width: "10", height: "7", rx: "1" }],
    ],
    Br = [
      [
        "path",
        {
          d: "M11 17h3v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a3.16 3.16 0 0 0 2-2h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1a5 5 0 0 0-2-4V3a4 4 0 0 0-3.2 1.6l-.3.4H11a6 6 0 0 0-6 6v1a5 5 0 0 0 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1z",
        },
      ],
      ["path", { d: "M16 10h.01" }],
      ["path", { d: "M2 8v1a2 2 0 0 0 2 2h1" }],
    ],
    Dr = [
      ["path", { d: "M14 3v11" }],
      ["path", { d: "M14 9h-3a3 3 0 0 1 0-6h9" }],
      ["path", { d: "M18 3v11" }],
      ["path", { d: "M22 18H2l4-4" }],
      ["path", { d: "m6 22-4-4" }],
    ],
    Fr = [
      ["path", { d: "M10 3v11" }],
      ["path", { d: "M10 9H7a1 1 0 0 1 0-6h8" }],
      ["path", { d: "M14 3v11" }],
      ["path", { d: "m18 14 4 4H2" }],
      ["path", { d: "m22 18-4 4" }],
    ],
    zr = [
      ["path", { d: "M13 4v16" }],
      ["path", { d: "M17 4v16" }],
      ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13" }],
    ],
    br = [
      ["path", { d: "M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4" }],
      ["path", { d: "M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7" }],
      ["rect", { width: "16", height: "5", x: "4", y: "2", rx: "1" }],
    ],
    Rr = [
      [
        "path",
        {
          d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z",
        },
      ],
      ["path", { d: "m8.5 8.5 7 7" }],
    ],
    Tr = [
      ["path", { d: "M12 17v5" }],
      ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89" }],
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        {
          d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
        },
      ],
    ],
    qr = [
      ["path", { d: "M12 17v5" }],
      [
        "path",
        {
          d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
        },
      ],
    ],
    Ur = [
      [
        "path",
        {
          d: "m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12",
        },
      ],
      [
        "path",
        {
          d: "m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z",
        },
      ],
      ["path", { d: "m2 22 .414-.414" }],
    ],
    Or = [
      ["path", { d: "m12 14-1 1" }],
      ["path", { d: "m13.75 18.25-1.25 1.42" }],
      ["path", { d: "M17.775 5.654a15.68 15.68 0 0 0-12.121 12.12" }],
      ["path", { d: "M18.8 9.3a1 1 0 0 0 2.1 7.7" }],
      [
        "path",
        {
          d: "M21.964 20.732a1 1 0 0 1-1.232 1.232l-18-5a1 1 0 0 1-.695-1.232A19.68 19.68 0 0 1 15.732 2.037a1 1 0 0 1 1.232.695z",
        },
      ],
    ],
    Zr = [
      ["path", { d: "M2 22h20" }],
      [
        "path",
        {
          d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
        },
      ],
    ],
    Gr = [
      ["path", { d: "M2 22h20" }],
      [
        "path",
        {
          d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
        },
      ],
    ],
    Ir = [
      [
        "path",
        {
          d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
        },
      ],
    ],
    Wr = [
      [
        "path",
        {
          d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
        },
      ],
    ],
    B2 = [
      [
        "path",
        {
          d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z",
        },
      ],
      ["path", { d: "m2 22 3-3" }],
      ["path", { d: "M7.5 13.5 10 11" }],
      ["path", { d: "M10.5 16.5 13 14" }],
      ["path", { d: "m18 3-4 4h6l-4 4" }],
    ],
    Er = [
      ["path", { d: "M9 2v6" }],
      ["path", { d: "M15 2v6" }],
      ["path", { d: "M12 17v5" }],
      ["path", { d: "M5 8h14" }],
      ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0Z" }],
    ],
    Xr = [
      ["path", { d: "M12 22v-5" }],
      ["path", { d: "M9 8V2" }],
      ["path", { d: "M15 8V2" }],
      ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z" }],
    ],
    jr = [
      ["path", { d: "M5 12h14" }],
      ["path", { d: "M12 5v14" }],
    ],
    Nr = [
      ["path", { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2" }],
      ["path", { d: "M18 6h.01" }],
      ["path", { d: "M6 18h.01" }],
      [
        "path",
        { d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z" },
      ],
      ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6" }],
    ],
    Kr = [
      ["path", { d: "M20 3a2 2 0 0 1 2 2v6a1 1 0 0 1-20 0V5a2 2 0 0 1 2-2z" }],
      ["path", { d: "m8 10 4 4 4-4" }],
    ],
    Qr = [
      ["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957" }],
      ["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295" }],
      [
        "path",
        {
          d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158",
        },
      ],
      [
        "path",
        {
          d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343",
        },
      ],
      ["path", { d: "M6 6v8" }],
      ["path", { d: "m2 2 20 20" }],
    ],
    Jr = [
      ["path", { d: "M22 14a8 8 0 0 1-8 8" }],
      ["path", { d: "M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2" }],
      ["path", { d: "M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1" }],
      ["path", { d: "M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10" }],
      [
        "path",
        {
          d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
        },
      ],
    ],
    Yr = [
      [
        "path",
        {
          d: "M13 17a1 1 0 1 0-2 0l.5 4.5a0.5 0.5 0 0 0 1 0z",
          fill: "currentColor",
        },
      ],
      ["path", { d: "M16.85 18.58a9 9 0 1 0-9.7 0" }],
      ["path", { d: "M8 14a5 5 0 1 1 8 0" }],
      ["circle", { cx: "12", cy: "11", r: "1", fill: "currentColor" }],
    ],
    _r = [
      [
        "path",
        {
          d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
        },
      ],
      ["path", { d: "M10 22 9 8" }],
      ["path", { d: "m14 22 1-14" }],
      [
        "path",
        {
          d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
        },
      ],
    ],
    xr = [
      [
        "path",
        {
          d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
        },
      ],
      ["path", { d: "m22 22-5.5-5.5" }],
    ],
    ao = [
      ["path", { d: "M18 7c0-5.333-8-5.333-8 0" }],
      ["path", { d: "M10 7v14" }],
      ["path", { d: "M6 21h12" }],
      ["path", { d: "M6 13h10" }],
    ],
    to = [
      ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15" }],
      ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68" }],
      ["path", { d: "M12 2v4" }],
      ["path", { d: "m2 2 20 20" }],
    ],
    ho = [
      ["path", { d: "M12 2v10" }],
      ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04" }],
    ],
    co = [
      ["path", { d: "M2 3h20" }],
      ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3" }],
      ["path", { d: "m7 21 5-5 5 5" }],
    ],
    Mo = [
      [
        "path",
        { d: "M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5" },
      ],
      ["path", { d: "m16 19 2 2 4-4" }],
      [
        "path",
        { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2" },
      ],
      ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" }],
    ],
    po = [
      [
        "path",
        {
          d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
        },
      ],
      ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" }],
      ["rect", { x: "6", y: "14", width: "12", height: "8", rx: "1" }],
    ],
    io = [
      ["path", { d: "M5 7 3 5" }],
      ["path", { d: "M9 6V3" }],
      ["path", { d: "m13 7 2-2" }],
      ["circle", { cx: "9", cy: "13", r: "3" }],
      [
        "path",
        {
          d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
        },
      ],
      ["path", { d: "M16 16h2" }],
    ],
    no = [
      ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
      ["path", { d: "M12 9v11" }],
      ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9" }],
    ],
    lo = [
      [
        "path",
        {
          d: "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z",
        },
      ],
    ],
    eo = [
      [
        "path",
        {
          d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
        },
      ],
      ["path", { d: "M12 2v20" }],
    ],
    ro = [
      ["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1" }],
      ["rect", { width: "5", height: "5", x: "16", y: "3", rx: "1" }],
      ["rect", { width: "5", height: "5", x: "3", y: "16", rx: "1" }],
      ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3" }],
      ["path", { d: "M21 21v.01" }],
      ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7" }],
      ["path", { d: "M3 12h.01" }],
      ["path", { d: "M12 3h.01" }],
      ["path", { d: "M12 16v.01" }],
      ["path", { d: "M16 12h1" }],
      ["path", { d: "M21 12v.01" }],
      ["path", { d: "M12 21v-1" }],
    ],
    oo = [
      [
        "path",
        {
          d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
        },
      ],
      [
        "path",
        {
          d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
        },
      ],
    ],
    vo = [
      ["path", { d: "M13 16a3 3 0 0 1 2.24 5" }],
      ["path", { d: "M18 12h.01" }],
      [
        "path",
        {
          d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
        },
      ],
      ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3" }],
      ["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3" }],
    ],
    $o = [
      ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34" }],
      ["path", { d: "M4 6h.01" }],
      ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35" }],
      ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67" }],
      ["path", { d: "M12 18h.01" }],
      ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
      ["path", { d: "m13.41 10.59 5.66-5.66" }],
    ],
    mo = [
      ["path", { d: "M12 12h.01" }],
      [
        "path",
        {
          d: "M14 15.4641a4 4 0 0 1-4 0L7.52786 19.74597 A 1 1 0 0 0 7.99303 21.16211 10 10 0 0 0 16.00697 21.16211 1 1 0 0 0 16.47214 19.74597z",
        },
      ],
      [
        "path",
        {
          d: "M16 12a4 4 0 0 0-2-3.464l2.472-4.282a1 1 0 0 1 1.46-.305 10 10 0 0 1 4.006 6.94A1 1 0 0 1 21 12z",
        },
      ],
      [
        "path",
        {
          d: "M8 12a4 4 0 0 1 2-3.464L7.528 4.254a1 1 0 0 0-1.46-.305 10 10 0 0 0-4.006 6.94A1 1 0 0 0 3 12z",
        },
      ],
    ],
    yo = [
      [
        "path",
        {
          d: "M3 12h3.28a1 1 0 0 1 .948.684l2.298 7.934a.5.5 0 0 0 .96-.044L13.82 4.771A1 1 0 0 1 14.792 4H21",
        },
      ],
    ],
    so = [
      ["path", { d: "M5 16v2" }],
      ["path", { d: "M19 16v2" }],
      ["rect", { width: "20", height: "8", x: "2", y: "8", rx: "2" }],
      ["path", { d: "M18 12h.01" }],
    ],
    go = [
      ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9" }],
      ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5" }],
      ["circle", { cx: "12", cy: "9", r: "2" }],
      ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47" }],
      ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1" }],
      ["path", { d: "M9.5 18h5" }],
      ["path", { d: "m8 22 4-11 4 11" }],
    ],
    uo = [
      ["path", { d: "M16.247 7.761a6 6 0 0 1 0 8.478" }],
      ["path", { d: "M19.075 4.933a10 10 0 0 1 0 14.134" }],
      ["path", { d: "M4.925 19.067a10 10 0 0 1 0-14.134" }],
      ["path", { d: "M7.753 16.239a6 6 0 0 1 0-8.478" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
    ],
    Co = [
      ["path", { d: "M5 15h14" }],
      ["path", { d: "M5 9h14" }],
      ["path", { d: "m14 20-5-5 6-6-5-5" }],
    ],
    Ho = [
      ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82" }],
      ["circle", { cx: "19", cy: "19", r: "2" }],
      ["path", { d: "m13.41 13.41 4.18 4.18" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
    ],
    Ao = [
      ["path", { d: "M22 17a10 10 0 0 0-20 0" }],
      ["path", { d: "M6 17a6 6 0 0 1 12 0" }],
      ["path", { d: "M10 17a2 2 0 0 1 4 0" }],
    ],
    wo = [
      ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12" }],
      ["path", { d: "M13.236 18a3 3 0 0 0-2.2-5" }],
      ["path", { d: "M16 9h.01" }],
      [
        "path",
        {
          d: "M16.82 3.94a3 3 0 1 1 3.237 4.868l1.815 2.587a1.5 1.5 0 0 1-1.5 2.1l-2.872-.453a3 3 0 0 0-3.5 3",
        },
      ],
      [
        "path",
        {
          d: "M17 4.988a3 3 0 1 0-5.2 2.052A7 7 0 0 0 4 14.015 4 4 0 0 0 8 18",
        },
      ],
    ],
    Vo = [
      ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2" }],
      ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }],
    ],
    So = [
      [
        "path",
        {
          d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        },
      ],
      ["path", { d: "M12 6.5v11" }],
      ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2" }],
    ],
    Lo = [
      [
        "path",
        {
          d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        },
      ],
      ["path", { d: "M8 12h5" }],
      ["path", { d: "M16 9.5a4 4 0 1 0 0 5.2" }],
    ],
    fo = [
      [
        "path",
        {
          d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        },
      ],
      ["path", { d: "M8 7h8" }],
      ["path", { d: "M12 17.5 8 15h1a4 4 0 0 0 0-8" }],
      ["path", { d: "M8 11h8" }],
    ],
    ko = [
      [
        "path",
        {
          d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        },
      ],
      ["path", { d: "m12 10 3-3" }],
      ["path", { d: "m9 7 3 3v7.5" }],
      ["path", { d: "M9 11h6" }],
      ["path", { d: "M9 15h6" }],
    ],
    Po = [
      [
        "path",
        {
          d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        },
      ],
      ["path", { d: "M8 13h5" }],
      ["path", { d: "M10 17V9.5a2.5 2.5 0 0 1 5 0" }],
      ["path", { d: "M8 17h7" }],
    ],
    Bo = [
      [
        "path",
        {
          d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        },
      ],
      ["path", { d: "M8 15h5" }],
      ["path", { d: "M8 11h5a2 2 0 1 0 0-4h-3v10" }],
    ],
    Do = [
      [
        "path",
        {
          d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        },
      ],
      ["path", { d: "M10 17V7h5" }],
      ["path", { d: "M10 11h4" }],
      ["path", { d: "M8 15h5" }],
    ],
    Fo = [
      [
        "path",
        {
          d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        },
      ],
      ["path", { d: "M14 8H8" }],
      ["path", { d: "M16 12H8" }],
      ["path", { d: "M13 16H8" }],
    ],
    zo = [
      [
        "path",
        {
          d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        },
      ],
      ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" }],
      ["path", { d: "M12 17.5v-11" }],
    ],
    bo = [
      ["path", { d: "M10 6.5v11a5.5 5.5 0 0 0 5.5-5.5" }],
      ["path", { d: "m14 8-6 3" }],
      [
        "path",
        {
          d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1z",
        },
      ],
    ],
    Ro = [
      ["path", { d: "M14 4v16H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" }],
      ["circle", { cx: "14", cy: "12", r: "8" }],
    ],
    D2 = [
      ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }],
      ["path", { d: "M12 12h.01" }],
      ["path", { d: "M17 12h.01" }],
      ["path", { d: "M7 12h.01" }],
    ],
    To = [
      [
        "path",
        {
          d: "M20 6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-4a2 2 0 0 1-1.6-.8l-1.6-2.13a1 1 0 0 0-1.6 0L9.6 17.2A2 2 0 0 1 8 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z",
        },
      ],
    ],
    qo = [["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }]],
    Uo = [
      [
        "path",
        {
          d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
        },
      ],
      [
        "path",
        {
          d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
        },
      ],
      ["path", { d: "m14 16-3 3 3 3" }],
      ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598" }],
      [
        "path",
        {
          d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
        },
      ],
      ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096" }],
    ],
    Oo = [["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2" }]],
    Zo = [
      ["path", { d: "m15 14 5-5-5-5" }],
      ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13" }],
    ],
    Go = [
      ["circle", { cx: "12", cy: "17", r: "1" }],
      ["path", { d: "M21 7v6h-6" }],
      ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7" }],
    ],
    Io = [
      ["path", { d: "M21 7v6h-6" }],
      ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7" }],
    ],
    Wo = [
      ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }],
      ["path", { d: "M3 3v5h5" }],
      ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" }],
      ["path", { d: "M16 16h5v5" }],
    ],
    Eo = [
      ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }],
      ["path", { d: "M3 3v5h5" }],
      ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" }],
      ["path", { d: "M16 16h5v5" }],
      ["circle", { cx: "12", cy: "12", r: "1" }],
    ],
    Xo = [
      [
        "path",
        {
          d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47",
        },
      ],
      ["path", { d: "M8 16H3v5" }],
      ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64" }],
      [
        "path",
        { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64" },
      ],
      ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87" }],
      ["path", { d: "M21 3v5h-5" }],
      ["path", { d: "M22 22 2 2" }],
    ],
    jo = [
      ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" }],
      ["path", { d: "M21 3v5h-5" }],
      ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" }],
      ["path", { d: "M8 16H3v5" }],
    ],
    No = [
      [
        "path",
        {
          d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z",
        },
      ],
      ["path", { d: "M5 10h14" }],
      ["path", { d: "M15 7v6" }],
    ],
    Ko = [
      ["path", { d: "M17 3v10" }],
      ["path", { d: "m12.67 5.5 8.66 5" }],
      ["path", { d: "m12.67 10.5 8.66-5" }],
      [
        "path",
        {
          d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z",
        },
      ],
    ],
    Qo = [
      ["path", { d: "M4 7V4h16v3" }],
      ["path", { d: "M5 20h6" }],
      ["path", { d: "M13 4 8 20" }],
      ["path", { d: "m15 15 5 5" }],
      ["path", { d: "m20 15-5 5" }],
    ],
    Jo = [
      ["path", { d: "m2 9 3-3 3 3" }],
      ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6" }],
      ["path", { d: "m22 15-3 3-3-3" }],
      ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10" }],
    ],
    Yo = [
      ["path", { d: "m17 2 4 4-4 4" }],
      ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14" }],
      ["path", { d: "m7 22-4-4 4-4" }],
      ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3" }],
      ["path", { d: "M11 10h1v4" }],
    ],
    _o = [
      ["path", { d: "m17 2 4 4-4 4" }],
      ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14" }],
      ["path", { d: "m7 22-4-4 4-4" }],
      ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3" }],
    ],
    xo = [
      ["path", { d: "M14 14a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1" }],
      ["path", { d: "M14 4a1 1 0 0 1 1-1" }],
      ["path", { d: "M15 10a1 1 0 0 1-1-1" }],
      ["path", { d: "M19 14a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1" }],
      ["path", { d: "M21 4a1 1 0 0 0-1-1" }],
      ["path", { d: "M21 9a1 1 0 0 1-1 1" }],
      ["path", { d: "m3 7 3 3 3-3" }],
      ["path", { d: "M6 10V5a2 2 0 0 1 2-2h2" }],
      ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1" }],
    ],
    av = [
      ["path", { d: "M14 4a1 1 0 0 1 1-1" }],
      ["path", { d: "M15 10a1 1 0 0 1-1-1" }],
      ["path", { d: "M21 4a1 1 0 0 0-1-1" }],
      ["path", { d: "M21 9a1 1 0 0 1-1 1" }],
      ["path", { d: "m3 7 3 3 3-3" }],
      ["path", { d: "M6 10V5a2 2 0 0 1 2-2h2" }],
      ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1" }],
    ],
    tv = [
      ["path", { d: "m12 17-5-5 5-5" }],
      ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7" }],
      ["path", { d: "m7 17-5-5 5-5" }],
    ],
    hv = [
      ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4" }],
      ["path", { d: "m9 17-5-5 5-5" }],
    ],
    dv = [
      [
        "path",
        {
          d: "M12 6a2 2 0 0 0-3.414-1.414l-6 6a2 2 0 0 0 0 2.828l6 6A2 2 0 0 0 12 18z",
        },
      ],
      [
        "path",
        {
          d: "M22 6a2 2 0 0 0-3.414-1.414l-6 6a2 2 0 0 0 0 2.828l6 6A2 2 0 0 0 22 18z",
        },
      ],
    ],
    cv = [
      [
        "path",
        {
          d: "M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22",
        },
      ],
      ["path", { d: "m12 18 2.57-3.5" }],
      ["path", { d: "M6.243 9.016a7 7 0 0 1 11.507-.009" }],
      ["path", { d: "M9.35 14.53 12 11.22" }],
      [
        "path",
        {
          d: "M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z",
        },
      ],
    ],
    Mv = [
      [
        "path",
        {
          d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
        },
      ],
      [
        "path",
        {
          d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
        },
      ],
      ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" }],
      ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" }],
    ],
    pv = [
      ["polyline", { points: "3.5 2 6.5 12.5 18 12.5" }],
      ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20" }],
      ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20" }],
      ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0" }],
    ],
    iv = [
      ["path", { d: "M6 19V5" }],
      ["path", { d: "M10 19V6.8" }],
      ["path", { d: "M14 19v-7.8" }],
      ["path", { d: "M18 5v4" }],
      ["path", { d: "M18 19v-6" }],
      ["path", { d: "M22 19V9" }],
      [
        "path",
        { d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65" },
      ],
    ],
    nv = [
      ["path", { d: "M17 10h-1a4 4 0 1 1 4-4v.534" }],
      [
        "path",
        {
          d: "M17 6h1a4 4 0 0 1 1.42 7.74l-2.29.87a6 6 0 0 1-5.339-10.68l2.069-1.31",
        },
      ],
      [
        "path",
        {
          d: "M4.5 17c2.8-.5 4.4 0 5.5.8s1.8 2.2 2.3 3.7c-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2",
        },
      ],
      ["path", { d: "M9.77 12C4 15 2 22 2 22" }],
      ["circle", { cx: "17", cy: "8", r: "2" }],
    ],
    F2 = [
      [
        "path",
        {
          d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
        },
      ],
      ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814" }],
      [
        "path",
        {
          d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
        },
      ],
    ],
    lv = [
      ["path", { d: "m14.5 9.5 1 1" }],
      ["path", { d: "m15.5 8.5-4 4" }],
      ["path", { d: "M3 12a9 9 0 1 0 9-9 9.74 9.74 0 0 0-6.74 2.74L3 8" }],
      ["path", { d: "M3 3v5h5" }],
      ["circle", { cx: "10", cy: "14", r: "2" }],
    ],
    ev = [
      ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }],
      ["path", { d: "M3 3v5h5" }],
    ],
    rv = [
      ["path", { d: "M12 5H6a2 2 0 0 0-2 2v3" }],
      ["path", { d: "m9 8 3-3-3-3" }],
      [
        "path",
        { d: "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" },
      ],
    ],
    ov = [
      ["path", { d: "M20 9V7a2 2 0 0 0-2-2h-6" }],
      ["path", { d: "m15 2-3 3 3 3" }],
      [
        "path",
        { d: "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2" },
      ],
    ],
    vv = [
      ["circle", { cx: "6", cy: "19", r: "3" }],
      ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2" }],
      ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3" }],
      ["path", { d: "M15 5h-4.3" }],
      ["circle", { cx: "18", cy: "5", r: "3" }],
    ],
    $v = [
      ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" }],
      ["path", { d: "M21 3v5h-5" }],
    ],
    mv = [
      ["circle", { cx: "6", cy: "19", r: "3" }],
      ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15" }],
      ["circle", { cx: "18", cy: "5", r: "3" }],
    ],
    yv = [
      ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2" }],
      ["path", { d: "M6.01 18H6" }],
      ["path", { d: "M10.01 18H10" }],
      ["path", { d: "M15 10v4" }],
      ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0" }],
      ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0" }],
    ],
    z2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 12h18" }],
    ],
    b2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M21 9H3" }],
      ["path", { d: "M21 15H3" }],
    ],
    sv = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M21 7.5H3" }],
      ["path", { d: "M21 12H3" }],
      ["path", { d: "M21 16.5H3" }],
    ],
    gv = [
      ["path", { d: "M4 11a9 9 0 0 1 9 9" }],
      ["path", { d: "M4 4a16 16 0 0 1 16 16" }],
      ["circle", { cx: "5", cy: "19", r: "1" }],
    ],
    uv = [
      ["path", { d: "M12 15v-3.014" }],
      ["path", { d: "M16 15v-3.014" }],
      ["path", { d: "M20 6H4" }],
      ["path", { d: "M20 8V4" }],
      ["path", { d: "M4 8V4" }],
      ["path", { d: "M8 15v-3.014" }],
      ["rect", { x: "3", y: "12", width: "18", height: "7", rx: "1" }],
    ],
    Cv = [
      [
        "path",
        {
          d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
        },
      ],
      ["path", { d: "m14.5 12.5 2-2" }],
      ["path", { d: "m11.5 9.5 2-2" }],
      ["path", { d: "m8.5 6.5 2-2" }],
      ["path", { d: "m17.5 15.5 2-2" }],
    ],
    Hv = [
      ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18" }],
      ["path", { d: "M6 15h8" }],
    ],
    Av = [
      ["path", { d: "M10 2v15" }],
      [
        "path",
        {
          d: "M7 22a4 4 0 0 1-4-4 1 1 0 0 1 1-1h16a1 1 0 0 1 1 1 4 4 0 0 1-4 4z",
        },
      ],
      [
        "path",
        {
          d: "M9.159 2.46a1 1 0 0 1 1.521-.193l9.977 8.98A1 1 0 0 1 20 13H4a1 1 0 0 1-.824-1.567z",
        },
      ],
    ],
    wv = [
      ["path", { d: "M7 21h10" }],
      ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z" }],
      [
        "path",
        {
          d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
        },
      ],
      ["path", { d: "m13 12 4-4" }],
      ["path", { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2" }],
    ],
    Vv = [
      ["path", { d: "m2.37 11.223 8.372-6.777a2 2 0 0 1 2.516 0l8.371 6.777" }],
      ["path", { d: "M21 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.25" }],
      ["path", { d: "M3 15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9" }],
      ["path", { d: "m6.67 15 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2" }],
      ["rect", { width: "20", height: "4", x: "2", y: "11", rx: "1" }],
    ],
    Sv = [
      ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z" }],
      ["path", { d: "m9 15 3-3" }],
      ["path", { d: "M17 13a6 6 0 0 0-6-6" }],
      ["path", { d: "M21 13A10 10 0 0 0 11 3" }],
    ],
    Lv = [
      [
        "path",
        {
          d: "m13.5 6.5-3.148-3.148a1.205 1.205 0 0 0-1.704 0L6.352 5.648a1.205 1.205 0 0 0 0 1.704L9.5 10.5",
        },
      ],
      ["path", { d: "M16.5 7.5 19 5" }],
      [
        "path",
        {
          d: "m17.5 10.5 3.148 3.148a1.205 1.205 0 0 1 0 1.704l-2.296 2.296a1.205 1.205 0 0 1-1.704 0L13.5 14.5",
        },
      ],
      ["path", { d: "M9 21a6 6 0 0 0-6-6" }],
      [
        "path",
        {
          d: "M9.352 10.648a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l4.296-4.296a1.205 1.205 0 0 0 0-1.704l-2.296-2.296a1.205 1.205 0 0 0-1.704 0z",
        },
      ],
    ],
    fv = [
      ["path", { d: "m20 19.5-5.5 1.2" }],
      ["path", { d: "M14.5 4v11.22a1 1 0 0 0 1.242.97L20 15.2" }],
      ["path", { d: "m2.978 19.351 5.549-1.363A2 2 0 0 0 10 16V2" }],
      ["path", { d: "M20 10 4 13.5" }],
    ],
    kv = [
      ["path", { d: "M10 2v3a1 1 0 0 0 1 1h5" }],
      ["path", { d: "M18 18v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6" }],
      ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6" }],
      [
        "path",
        {
          d: "M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 22 6.828V16a2 2 0 0 1-2.01 2z",
        },
      ],
    ],
    Pv = [
      ["path", { d: "M13 13H8a1 1 0 0 0-1 1v7" }],
      ["path", { d: "M14 8h1" }],
      ["path", { d: "M17 21v-4" }],
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        {
          d: "M20.41 20.41A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .59-1.41",
        },
      ],
      ["path", { d: "M29.5 11.5s5 5 4 5" }],
      ["path", { d: "M9 3h6.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V15" }],
    ],
    Bv = [
      [
        "path",
        {
          d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
        },
      ],
      ["path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" }],
      ["path", { d: "M7 3v4a1 1 0 0 0 1 1h7" }],
    ],
    R2 = [
      ["path", { d: "M5 7v11a1 1 0 0 0 1 1h11" }],
      ["path", { d: "M5.293 18.707 11 13" }],
      ["circle", { cx: "19", cy: "19", r: "2" }],
      ["circle", { cx: "5", cy: "5", r: "2" }],
    ],
    Dv = [
      ["path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" }],
      ["path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" }],
      ["path", { d: "M7 21h10" }],
      ["path", { d: "M12 3v18" }],
      ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" }],
    ],
    Fv = [
      [
        "path",
        { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" },
      ],
      ["path", { d: "M14 15H9v-5" }],
      ["path", { d: "M16 3h5v5" }],
      ["path", { d: "M21 3 9 15" }],
    ],
    zv = [
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
      ["path", { d: "M8 7v10" }],
      ["path", { d: "M12 7v10" }],
      ["path", { d: "M17 7v10" }],
    ],
    bv = [
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
      ["circle", { cx: "12", cy: "12", r: "1" }],
      [
        "path",
        {
          d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
        },
      ],
    ],
    Rv = [
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
      ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2" }],
      ["path", { d: "M9 9h.01" }],
      ["path", { d: "M15 9h.01" }],
    ],
    Tv = [
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
      [
        "path",
        {
          d: "M7.828 13.07A3 3 0 0 1 12 8.764a3 3 0 0 1 4.172 4.306l-3.447 3.62a1 1 0 0 1-1.449 0z",
        },
      ],
    ],
    qv = [
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
      ["path", { d: "M7 12h10" }],
    ],
    Uv = [
      ["path", { d: "M17 12v4a1 1 0 0 1-1 1h-4" }],
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M17 8V7" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M7 17h.01" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
      ["rect", { x: "7", y: "7", width: "5", height: "5", rx: "1" }],
    ],
    Ov = [
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
      ["circle", { cx: "12", cy: "12", r: "3" }],
      ["path", { d: "m16 16-1.9-1.9" }],
    ],
    Zv = [
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
      ["path", { d: "M7 8h8" }],
      ["path", { d: "M7 12h10" }],
      ["path", { d: "M7 16h6" }],
    ],
    Gv = [
      ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
      ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
      ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
    ],
    Iv = [
      ["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
      ["path", { d: "M18 5v16" }],
      ["path", { d: "m4 6 7.106-3.79a2 2 0 0 1 1.788 0L20 6" }],
      [
        "path",
        {
          d: "m6 11-3.52 2.147a1 1 0 0 0-.48.854V19a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a1 1 0 0 0-.48-.853L18 11",
        },
      ],
      ["path", { d: "M6 5v16" }],
      ["circle", { cx: "12", cy: "9", r: "2" }],
    ],
    Wv = [
      ["path", { d: "M5.42 9.42 8 12" }],
      ["circle", { cx: "4", cy: "8", r: "2" }],
      ["path", { d: "m14 6-8.58 8.58" }],
      ["circle", { cx: "4", cy: "16", r: "2" }],
      ["path", { d: "M10.8 14.8 14 18" }],
      ["path", { d: "M16 12h-2" }],
      ["path", { d: "M22 12h-2" }],
    ],
    Ev = [
      ["circle", { cx: "6", cy: "6", r: "3" }],
      ["path", { d: "M8.12 8.12 12 12" }],
      ["path", { d: "M20 4 8.12 15.88" }],
      ["circle", { cx: "6", cy: "18", r: "3" }],
      ["path", { d: "M14.8 14.8 20 20" }],
    ],
    Xv = [
      [
        "path",
        { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3" },
      ],
      ["path", { d: "M8 21h8" }],
      ["path", { d: "M12 17v4" }],
      ["path", { d: "m22 3-5 5" }],
      ["path", { d: "m17 3 5 5" }],
    ],
    jv = [
      [
        "path",
        { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3" },
      ],
      ["path", { d: "M8 21h8" }],
      ["path", { d: "M12 17v4" }],
      ["path", { d: "m17 8 5-5" }],
      ["path", { d: "M17 3h5v5" }],
    ],
    Nv = [
      ["path", { d: "M15 12h-5" }],
      ["path", { d: "M15 8h-5" }],
      ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4" }],
      [
        "path",
        {
          d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
        },
      ],
    ],
    Kv = [
      ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4" }],
      [
        "path",
        {
          d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
        },
      ],
    ],
    Qv = [
      ["path", { d: "m8 11 2 2 4-4" }],
      ["circle", { cx: "11", cy: "11", r: "8" }],
      ["path", { d: "m21 21-4.3-4.3" }],
    ],
    Jv = [
      ["path", { d: "m13 13.5 2-2.5-2-2.5" }],
      ["path", { d: "m21 21-4.3-4.3" }],
      ["path", { d: "M9 8.5 7 11l2 2.5" }],
      ["circle", { cx: "11", cy: "11", r: "8" }],
    ],
    Yv = [
      ["path", { d: "m13.5 8.5-5 5" }],
      ["circle", { cx: "11", cy: "11", r: "8" }],
      ["path", { d: "m21 21-4.3-4.3" }],
    ],
    _v = [
      ["path", { d: "m13.5 8.5-5 5" }],
      ["path", { d: "m8.5 8.5 5 5" }],
      ["circle", { cx: "11", cy: "11", r: "8" }],
      ["path", { d: "m21 21-4.3-4.3" }],
    ],
    xv = [
      ["path", { d: "m21 21-4.34-4.34" }],
      ["circle", { cx: "11", cy: "11", r: "8" }],
    ],
    a$ = [
      ["path", { d: "M16 5a4 3 0 0 0-8 0c0 4 8 3 8 7a4 3 0 0 1-8 0" }],
      ["path", { d: "M8 19a4 3 0 0 0 8 0c0-4-8-3-8-7a4 3 0 0 1 8 0" }],
    ],
    T2 = [
      [
        "path",
        {
          d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z",
        },
      ],
      ["path", { d: "M6 12h16" }],
    ],
    t$ = [
      ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2" }],
      ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2" }],
      ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1" }],
      ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1" }],
    ],
    h$ = [
      [
        "path",
        {
          d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
        },
      ],
      ["path", { d: "m21.854 2.147-10.94 10.939" }],
    ],
    d$ = [
      ["path", { d: "m16 16-4 4-4-4" }],
      ["path", { d: "M3 12h18" }],
      ["path", { d: "m8 8 4-4 4 4" }],
    ],
    c$ = [
      ["path", { d: "M12 3v18" }],
      ["path", { d: "m16 16 4-4-4-4" }],
      ["path", { d: "m8 8-4 4 4 4" }],
    ],
    M$ = [
      ["path", { d: "m10.852 14.772-.383.923" }],
      ["path", { d: "M13.148 14.772a3 3 0 1 0-2.296-5.544l-.383-.923" }],
      ["path", { d: "m13.148 9.228.383-.923" }],
      ["path", { d: "m13.53 15.696-.382-.924a3 3 0 1 1-2.296-5.544" }],
      ["path", { d: "m14.772 10.852.923-.383" }],
      ["path", { d: "m14.772 13.148.923.383" }],
      [
        "path",
        {
          d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
        },
      ],
      [
        "path",
        {
          d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
        },
      ],
      ["path", { d: "M6 18h.01" }],
      ["path", { d: "M6 6h.01" }],
      ["path", { d: "m9.228 10.852-.923-.383" }],
      ["path", { d: "m9.228 13.148-.923.383" }],
    ],
    p$ = [
      [
        "path",
        {
          d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
        },
      ],
      [
        "path",
        {
          d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
        },
      ],
      ["path", { d: "M6 6h.01" }],
      ["path", { d: "M6 18h.01" }],
      ["path", { d: "m13 6-4 6h6l-4 6" }],
    ],
    i$ = [
      ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5" }],
      ["path", { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z" }],
      ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1" }],
      [
        "path",
        { d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z" },
      ],
      ["path", { d: "M6 18h.01" }],
      ["path", { d: "m2 2 20 20" }],
    ],
    n$ = [
      ["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2" }],
      ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2" }],
      ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6" }],
      ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18" }],
    ],
    l$ = [
      ["path", { d: "M14 17H5" }],
      ["path", { d: "M19 7h-9" }],
      ["circle", { cx: "17", cy: "17", r: "3" }],
      ["circle", { cx: "7", cy: "7", r: "3" }],
    ],
    e$ = [
      [
        "path",
        {
          d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
        },
      ],
      ["circle", { cx: "12", cy: "12", r: "3" }],
    ],
    r$ = [
      ["circle", { cx: "18", cy: "5", r: "3" }],
      ["circle", { cx: "6", cy: "12", r: "3" }],
      ["circle", { cx: "18", cy: "19", r: "3" }],
      ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49" }],
      ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49" }],
    ],
    o$ = [
      [
        "path",
        {
          d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
        },
      ],
      ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1" }],
      ["circle", { cx: "17.5", cy: "17.5", r: "3.5" }],
    ],
    v$ = [
      ["path", { d: "M12 2v13" }],
      ["path", { d: "m16 6-4-4-4 4" }],
      ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" }],
    ],
    $$ = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["line", { x1: "3", x2: "21", y1: "9", y2: "9" }],
      ["line", { x1: "3", x2: "21", y1: "15", y2: "15" }],
      ["line", { x1: "9", x2: "9", y1: "9", y2: "21" }],
      ["line", { x1: "15", x2: "15", y1: "9", y2: "21" }],
    ],
    m$ = [
      [
        "path",
        {
          d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
        },
      ],
    ],
    y$ = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "M12 8v4" }],
      ["path", { d: "M12 16h.01" }],
    ],
    s$ = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "m4.243 5.21 14.39 12.472" }],
    ],
    g$ = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "m9 12 2 2 4-4" }],
    ],
    u$ = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "M8 12h.01" }],
      ["path", { d: "M12 12h.01" }],
      ["path", { d: "M16 12h.01" }],
    ],
    C$ = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "M12 22V2" }],
    ],
    H$ = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "M9 12h6" }],
    ],
    A$ = [
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        {
          d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
        },
      ],
      [
        "path",
        {
          d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
        },
      ],
    ],
    w$ = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "M9 12h6" }],
      ["path", { d: "M12 9v6" }],
    ],
    q2 = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3" }],
      ["path", { d: "M12 17h.01" }],
    ],
    V$ = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "M6.376 18.91a6 6 0 0 1 11.249.003" }],
      ["circle", { cx: "12", cy: "11", r: "4" }],
    ],
    U2 = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
      ["path", { d: "m14.5 9.5-5 5" }],
      ["path", { d: "m9.5 9.5 5 5" }],
    ],
    S$ = [
      [
        "path",
        {
          d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        },
      ],
    ],
    L$ = [
      ["circle", { cx: "12", cy: "12", r: "8" }],
      ["path", { d: "M12 2v7.5" }],
      ["path", { d: "m19 5-5.23 5.23" }],
      ["path", { d: "M22 12h-7.5" }],
      ["path", { d: "m19 19-5.23-5.23" }],
      ["path", { d: "M12 14.5V22" }],
      ["path", { d: "M10.23 13.77 5 19" }],
      ["path", { d: "M9.5 12H2" }],
      ["path", { d: "M10.23 10.23 5 5" }],
      ["circle", { cx: "12", cy: "12", r: "2.5" }],
    ],
    f$ = [
      ["path", { d: "M12 10.189V14" }],
      ["path", { d: "M12 2v3" }],
      ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6" }],
      [
        "path",
        {
          d: "M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76",
        },
      ],
      [
        "path",
        {
          d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        },
      ],
    ],
    k$ = [
      [
        "path",
        {
          d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
        },
      ],
    ],
    P$ = [
      ["path", { d: "M16 10a4 4 0 0 1-8 0" }],
      ["path", { d: "M3.103 6.034h17.794" }],
      [
        "path",
        {
          d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
        },
      ],
    ],
    B$ = [
      ["path", { d: "m15 11-1 9" }],
      ["path", { d: "m19 11-4-7" }],
      ["path", { d: "M2 11h20" }],
      [
        "path",
        { d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4" },
      ],
      ["path", { d: "M4.5 15.5h15" }],
      ["path", { d: "m5 11 4-7" }],
      ["path", { d: "m9 11 1 9" }],
    ],
    D$ = [
      ["circle", { cx: "8", cy: "21", r: "1" }],
      ["circle", { cx: "19", cy: "21", r: "1" }],
      [
        "path",
        {
          d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
        },
      ],
    ],
    F$ = [
      [
        "path",
        {
          d: "M21.56 4.56a1.5 1.5 0 0 1 0 2.122l-.47.47a3 3 0 0 1-4.212-.03 3 3 0 0 1 0-4.243l.44-.44a1.5 1.5 0 0 1 2.121 0z",
        },
      ],
      [
        "path",
        {
          d: "M3 22a1 1 0 0 1-1-1v-3.586a1 1 0 0 1 .293-.707l3.355-3.355a1.205 1.205 0 0 1 1.704 0l3.296 3.296a1.205 1.205 0 0 1 0 1.704l-3.355 3.355a1 1 0 0 1-.707.293z",
        },
      ],
      ["path", { d: "m9 15 7.879-7.878" }],
    ],
    z$ = [
      ["path", { d: "m4 4 2.5 2.5" }],
      ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7" }],
      ["path", { d: "M15 5 5 15" }],
      ["path", { d: "M14 17v.01" }],
      ["path", { d: "M10 16v.01" }],
      ["path", { d: "M13 13v.01" }],
      ["path", { d: "M16 10v.01" }],
      ["path", { d: "M11 20v.01" }],
      ["path", { d: "M17 14v.01" }],
      ["path", { d: "M20 11v.01" }],
    ],
    b$ = [
      ["path", { d: "M10 22v-5" }],
      ["path", { d: "M14 19v-2" }],
      ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M18 20v-3" }],
      ["path", { d: "M2 13h20" }],
      ["path", { d: "M20 13V7l-5-5H6a2 2 0 0 0-2 2v9" }],
      ["path", { d: "M6 20v-3" }],
    ],
    R$ = [
      ["path", { d: "M11 12h.01" }],
      ["path", { d: "M13 22c.5-.5 1.12-1 2.5-1-1.38 0-2-.5-2.5-1" }],
      [
        "path",
        {
          d: "M14 2a3.28 3.28 0 0 1-3.227 1.798l-6.17-.561A2.387 2.387 0 1 0 4.387 8H15.5a1 1 0 0 1 0 13 1 1 0 0 0 0-5H12a7 7 0 0 1-7-7V8",
        },
      ],
      ["path", { d: "M14 8a8.5 8.5 0 0 1 0 8" }],
      ["path", { d: "M16 16c2 0 4.5-4 4-6" }],
    ],
    T$ = [
      ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8" }],
      ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6" }],
      ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6" }],
      ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3" }],
    ],
    q$ = [
      ["path", { d: "M12 22v-5.172a2 2 0 0 0-.586-1.414L9.5 13.5" }],
      ["path", { d: "M14.5 14.5 12 17" }],
      [
        "path",
        { d: "M17 8.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0z" },
      ],
    ],
    U$ = [
      ["path", { d: "m18 14 4 4-4 4" }],
      ["path", { d: "m18 2 4 4-4 4" }],
      [
        "path",
        { d: "M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22" },
      ],
      ["path", { d: "M2 6h1.972a4 4 0 0 1 3.6 2.2" }],
      ["path", { d: "M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45" }],
    ],
    O$ = [
      [
        "path",
        {
          d: "M18 7V5a1 1 0 0 0-1-1H6.5a.5.5 0 0 0-.4.8l4.5 6a2 2 0 0 1 0 2.4l-4.5 6a.5.5 0 0 0 .4.8H17a1 1 0 0 0 1-1v-2",
        },
      ],
    ],
    Z$ = [
      ["path", { d: "M2 20h.01" }],
      ["path", { d: "M7 20v-4" }],
      ["path", { d: "M12 20v-8" }],
      ["path", { d: "M17 20V8" }],
    ],
    G$ = [
      ["path", { d: "M2 20h.01" }],
      ["path", { d: "M7 20v-4" }],
    ],
    I$ = [
      ["path", { d: "M2 20h.01" }],
      ["path", { d: "M7 20v-4" }],
      ["path", { d: "M12 20v-8" }],
    ],
    W$ = [["path", { d: "M2 20h.01" }]],
    E$ = [
      ["path", { d: "M2 20h.01" }],
      ["path", { d: "M7 20v-4" }],
      ["path", { d: "M12 20v-8" }],
      ["path", { d: "M17 20V8" }],
      ["path", { d: "M22 4v16" }],
    ],
    X$ = [
      [
        "path",
        {
          d: "m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284",
        },
      ],
      ["path", { d: "M3 21h18" }],
    ],
    j$ = [
      ["path", { d: "M10 9H4L2 7l2-2h6" }],
      ["path", { d: "M14 5h6l2 2-2 2h-6" }],
      ["path", { d: "M10 22V4a2 2 0 1 1 4 0v18" }],
      ["path", { d: "M8 22h8" }],
    ],
    N$ = [
      ["path", { d: "M12 13v8" }],
      ["path", { d: "M12 3v3" }],
      [
        "path",
        {
          d: "M18 6a2 2 0 0 1 1.387.56l2.307 2.22a1 1 0 0 1 0 1.44l-2.307 2.22A2 2 0 0 1 18 13H6a2 2 0 0 1-1.387-.56l-2.306-2.22a1 1 0 0 1 0-1.44l2.306-2.22A2 2 0 0 1 6 6z",
        },
      ],
    ],
    K$ = [
      ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6" }],
      [
        "path",
        {
          d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z",
        },
      ],
      ["path", { d: "M21 12h1" }],
      ["path", { d: "M18.5 4.5 18 5" }],
      ["path", { d: "M2 12h1" }],
      ["path", { d: "M12 2v1" }],
      ["path", { d: "m4.929 4.929.707.707" }],
      ["path", { d: "M12 12v6" }],
    ],
    Q$ = [
      [
        "path",
        {
          d: "M17.971 4.285A2 2 0 0 1 21 6v12a2 2 0 0 1-3.029 1.715l-9.997-5.998a2 2 0 0 1-.003-3.432z",
        },
      ],
      ["path", { d: "M3 20V4" }],
    ],
    J$ = [
      ["path", { d: "M21 4v16" }],
      [
        "path",
        {
          d: "M6.029 4.285A2 2 0 0 0 3 6v12a2 2 0 0 0 3.029 1.715l9.997-5.998a2 2 0 0 0 .003-3.432z",
        },
      ],
    ],
    Y$ = [
      ["path", { d: "m12.5 17-.5-1-.5 1h1z" }],
      [
        "path",
        {
          d: "M15 22a1 1 0 0 0 1-1v-1a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20v1a1 1 0 0 0 1 1z",
        },
      ],
      ["circle", { cx: "15", cy: "12", r: "1" }],
      ["circle", { cx: "9", cy: "12", r: "1" }],
    ],
    _$ = [
      ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5" }],
      ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5" }],
      ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5" }],
      ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5" }],
      ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5" }],
      ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5" }],
      ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5" }],
      ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5" }],
    ],
    x$ = [["path", { d: "M22 2 2 22" }]],
    am = [
      [
        "path",
        {
          d: "M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a1 1 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-1.414 0L8 14",
        },
      ],
    ],
    tm = [
      ["path", { d: "M10 5H3" }],
      ["path", { d: "M12 19H3" }],
      ["path", { d: "M14 3v4" }],
      ["path", { d: "M16 17v4" }],
      ["path", { d: "M21 12h-9" }],
      ["path", { d: "M21 19h-5" }],
      ["path", { d: "M21 5h-7" }],
      ["path", { d: "M8 10v4" }],
      ["path", { d: "M8 12H3" }],
    ],
    O2 = [
      ["path", { d: "M10 8h4" }],
      ["path", { d: "M12 21v-9" }],
      ["path", { d: "M12 8V3" }],
      ["path", { d: "M17 16h4" }],
      ["path", { d: "M19 12V3" }],
      ["path", { d: "M19 21v-5" }],
      ["path", { d: "M3 14h4" }],
      ["path", { d: "M5 10V3" }],
      ["path", { d: "M5 21v-7" }],
    ],
    hm = [
      ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2" }],
      ["path", { d: "M12.667 8 10 12h4l-2.667 4" }],
    ],
    dm = [
      ["rect", { width: "7", height: "12", x: "2", y: "6", rx: "1" }],
      ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36" }],
      ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58" }],
      ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8" }],
    ],
    cm = [
      ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2" }],
      ["path", { d: "M12 18h.01" }],
    ],
    Mm = [
      ["path", { d: "M22 11v1a10 10 0 1 1-9-10" }],
      ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2" }],
      ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9" }],
      ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9" }],
      ["path", { d: "M16 5h6" }],
      ["path", { d: "M19 2v6" }],
    ],
    pm = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2" }],
      ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9" }],
      ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9" }],
    ],
    im = [
      ["path", { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0" }],
      ["circle", { cx: "10", cy: "13", r: "8" }],
      ["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6" }],
      ["path", { d: "M18 3 19.1 5.2" }],
      ["path", { d: "M22 3 20.9 5.2" }],
    ],
    nm = [
      ["path", { d: "m10 20-1.25-2.5L6 18" }],
      ["path", { d: "M10 4 8.75 6.5 6 6" }],
      ["path", { d: "m14 20 1.25-2.5L18 18" }],
      ["path", { d: "m14 4 1.25 2.5L18 6" }],
      ["path", { d: "m17 21-3-6h-4" }],
      ["path", { d: "m17 3-3 6 1.5 3" }],
      ["path", { d: "M2 12h6.5L10 9" }],
      ["path", { d: "m20 10-1.5 2 1.5 2" }],
      ["path", { d: "M22 12h-6.5L14 15" }],
      ["path", { d: "m4 10 1.5 2L4 14" }],
      ["path", { d: "m7 21 3-6-1.5-3" }],
      ["path", { d: "m7 3 3 6h4" }],
    ],
    lm = [
      ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3" }],
      [
        "path",
        {
          d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
        },
      ],
      ["path", { d: "M4 18v2" }],
      ["path", { d: "M20 18v2" }],
      ["path", { d: "M12 4v9" }],
    ],
    em = [
      ["path", { d: "M10.5 2v4" }],
      ["path", { d: "M14 2H7a2 2 0 0 0-2 2" }],
      [
        "path",
        {
          d: "M19.29 14.76A6.67 6.67 0 0 1 17 11a6.6 6.6 0 0 1-2.29 3.76c-1.15.92-1.71 2.04-1.71 3.19 0 2.22 1.8 4.05 4 4.05s4-1.83 4-4.05c0-1.16-.57-2.26-1.71-3.19",
        },
      ],
      [
        "path",
        {
          d: "M9.607 21H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h7V7a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3",
        },
      ],
    ],
    rm = [
      ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z" }],
      ["path", { d: "M7 21h10" }],
      ["path", { d: "M19.5 12 22 6" }],
      [
        "path",
        {
          d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
        },
      ],
      [
        "path",
        {
          d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
        },
      ],
      [
        "path",
        {
          d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62",
        },
      ],
    ],
    om = [["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1" }]],
    vm = [
      ["path", { d: "M12 18v4" }],
      [
        "path",
        {
          d: "M2 14.499a5.5 5.5 0 0 0 9.591 3.675.6.6 0 0 1 .818.001A5.5 5.5 0 0 0 22 14.5c0-2.29-1.5-4-3-5.5l-5.492-5.312a2 2 0 0 0-3-.02L5 8.999c-1.5 1.5-3 3.2-3 5.5",
        },
      ],
    ],
    $m = [
      [
        "path",
        {
          d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
        },
      ],
    ],
    Z2 = [
      [
        "path",
        {
          d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
        },
      ],
      ["path", { d: "M20 2v4" }],
      ["path", { d: "M22 4h-4" }],
      ["circle", { cx: "4", cy: "20", r: "2" }],
    ],
    mm = [
      ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2" }],
      ["path", { d: "M12 6h.01" }],
      ["circle", { cx: "12", cy: "14", r: "4" }],
      ["path", { d: "M12 14h.01" }],
    ],
    ym = [
      [
        "path",
        {
          d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
        },
      ],
      ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603" }],
      ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975" }],
    ],
    sm = [
      ["path", { d: "m6 16 6-12 6 12" }],
      ["path", { d: "M8 12h8" }],
      [
        "path",
        {
          d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
        },
      ],
    ],
    gm = [
      ["path", { d: "m6 16 6-12 6 12" }],
      ["path", { d: "M8 12h8" }],
      ["path", { d: "m16 20 2 2 4-4" }],
    ],
    um = [
      [
        "path",
        {
          d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
        },
      ],
      ["path", { d: "M5 17A12 12 0 0 1 17 5" }],
      ["circle", { cx: "19", cy: "5", r: "2" }],
      ["circle", { cx: "5", cy: "19", r: "2" }],
    ],
    Cm = [
      ["circle", { cx: "19", cy: "5", r: "2" }],
      ["circle", { cx: "5", cy: "19", r: "2" }],
      ["path", { d: "M5 17A12 12 0 0 1 17 5" }],
    ],
    Hm = [
      ["path", { d: "M16 3h5v5" }],
      ["path", { d: "M8 3H3v5" }],
      ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3" }],
      ["path", { d: "m15 9 6-6" }],
    ],
    Am = [
      [
        "path",
        {
          d: "M17 13.44 4.442 17.082A2 2 0 0 0 4.982 21H19a2 2 0 0 0 .558-3.921l-1.115-.32A2 2 0 0 1 17 14.837V7.66",
        },
      ],
      [
        "path",
        {
          d: "m7 10.56 12.558-3.642A2 2 0 0 0 19.018 3H5a2 2 0 0 0-.558 3.921l1.115.32A2 2 0 0 1 7 9.163v7.178",
        },
      ],
    ],
    wm = [
      ["path", { d: "M15.295 19.562 16 22" }],
      ["path", { d: "m17 16 3.758 2.098" }],
      ["path", { d: "m19 12.5 3.026-.598" }],
      [
        "path",
        {
          d: "M7.61 6.3a3 3 0 0 0-3.92 1.3l-1.38 2.79a3 3 0 0 0 1.3 3.91l6.89 3.597a1 1 0 0 0 1.342-.447l3.106-6.211a1 1 0 0 0-.447-1.341z",
        },
      ],
      ["path", { d: "M8 9V2" }],
    ],
    Vm = [
      ["path", { d: "M3 3h.01" }],
      ["path", { d: "M7 5h.01" }],
      ["path", { d: "M11 7h.01" }],
      ["path", { d: "M3 7h.01" }],
      ["path", { d: "M7 9h.01" }],
      ["path", { d: "M3 11h.01" }],
      ["rect", { width: "4", height: "4", x: "15", y: "5" }],
      ["path", { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2" }],
      ["path", { d: "m13 14 8-2" }],
      ["path", { d: "m13 19 8-2" }],
    ],
    Sm = [
      [
        "path",
        {
          d: "M14 9.536V7a4 4 0 0 1 4-4h1.5a.5.5 0 0 1 .5.5V5a4 4 0 0 1-4 4 4 4 0 0 0-4 4c0 2 1 3 1 5a5 5 0 0 1-1 3",
        },
      ],
      ["path", { d: "M4 9a5 5 0 0 1 8 4 5 5 0 0 1-8-4" }],
      ["path", { d: "M5 21h14" }],
    ],
    G2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7" }],
    ],
    I2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "m16 8-8 8" }],
      ["path", { d: "M16 16H8V8" }],
    ],
    W2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "m8 8 8 8" }],
      ["path", { d: "M16 8v8H8" }],
    ],
    E2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M12 8v8" }],
      ["path", { d: "m8 12 4 4 4-4" }],
    ],
    X2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "m12 8-4 4 4 4" }],
      ["path", { d: "M16 12H8" }],
    ],
    j2 = [
      [
        "path",
        { d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6" },
      ],
      ["path", { d: "m3 21 9-9" }],
      ["path", { d: "M9 21H3v-6" }],
    ],
    N2 = [
      [
        "path",
        { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" },
      ],
      ["path", { d: "m21 21-9-9" }],
      ["path", { d: "M21 15v6h-6" }],
    ],
    K2 = [
      [
        "path",
        { d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6" },
      ],
      ["path", { d: "m3 3 9 9" }],
      ["path", { d: "M3 9V3h6" }],
    ],
    Q2 = [
      [
        "path",
        { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" },
      ],
      ["path", { d: "m21 3-9 9" }],
      ["path", { d: "M15 3h6v6" }],
    ],
    J2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M8 12h8" }],
      ["path", { d: "m12 16 4-4-4-4" }],
    ],
    Y2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M8 16V8h8" }],
      ["path", { d: "M16 16 8 8" }],
    ],
    _2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M8 8h8v8" }],
      ["path", { d: "m8 16 8-8" }],
    ],
    x2 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "m16 12-4-4-4 4" }],
      ["path", { d: "M12 16V8" }],
    ],
    a0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M12 8v8" }],
      ["path", { d: "m8.5 14 7-4" }],
      ["path", { d: "m8.5 10 7 4" }],
    ],
    t0 = [
      [
        "path",
        {
          d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2",
        },
      ],
      ["path", { d: "M10 22H8" }],
      ["path", { d: "M16 22h-2" }],
      ["circle", { cx: "8", cy: "8", r: "2" }],
      ["path", { d: "M9.414 9.414 12 12" }],
      ["path", { d: "M14.8 14.8 18 18" }],
      ["circle", { cx: "8", cy: "16", r: "2" }],
      ["path", { d: "m18 6-8.586 8.586" }],
    ],
    $ = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M9 8h7" }],
      ["path", { d: "M8 12h6" }],
      ["path", { d: "M11 16h5" }],
    ],
    h0 = [
      [
        "path",
        {
          d: "M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344",
        },
      ],
      ["path", { d: "m9 11 3 3L22 4" }],
    ],
    d0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "m9 12 2 2 4-4" }],
    ],
    c0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "m16 10-4 4-4-4" }],
    ],
    M0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "m14 16-4-4 4-4" }],
    ],
    p0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "m10 8 4 4-4 4" }],
    ],
    i0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "m8 14 4-4 4 4" }],
    ],
    n0 = [
      ["path", { d: "m10 9-3 3 3 3" }],
      ["path", { d: "m14 15 3-3-3-3" }],
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
    ],
    Lm = [
      ["path", { d: "M10 9.5 8 12l2 2.5" }],
      ["path", { d: "M14 21h1" }],
      ["path", { d: "m14 9.5 2 2.5-2 2.5" }],
      [
        "path",
        {
          d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
        },
      ],
      ["path", { d: "M9 21h1" }],
    ],
    fm = [
      [
        "path",
        {
          d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
        },
      ],
      ["path", { d: "M9 21h1" }],
      ["path", { d: "M14 21h1" }],
    ],
    l0 = [
      ["path", { d: "M8 7v7" }],
      ["path", { d: "M12 7v4" }],
      ["path", { d: "M16 7v9" }],
      ["path", { d: "M5 3a2 2 0 0 0-2 2" }],
      ["path", { d: "M9 3h1" }],
      ["path", { d: "M14 3h1" }],
      ["path", { d: "M19 3a2 2 0 0 1 2 2" }],
      ["path", { d: "M21 9v1" }],
      ["path", { d: "M21 14v1" }],
      ["path", { d: "M21 19a2 2 0 0 1-2 2" }],
      ["path", { d: "M14 21h1" }],
      ["path", { d: "M9 21h1" }],
      ["path", { d: "M5 21a2 2 0 0 1-2-2" }],
      ["path", { d: "M3 14v1" }],
      ["path", { d: "M3 9v1" }],
    ],
    e0 = [
      [
        "path",
        {
          d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
        },
      ],
      ["path", { d: "M5 3a2 2 0 0 0-2 2" }],
      ["path", { d: "M19 3a2 2 0 0 1 2 2" }],
      ["path", { d: "M5 21a2 2 0 0 1-2-2" }],
      ["path", { d: "M9 3h1" }],
      ["path", { d: "M9 21h2" }],
      ["path", { d: "M14 3h1" }],
      ["path", { d: "M3 9v1" }],
      ["path", { d: "M21 9v2" }],
      ["path", { d: "M3 14v1" }],
    ],
    km = [
      ["path", { d: "M14 21h1" }],
      ["path", { d: "M21 14v1" }],
      ["path", { d: "M21 19a2 2 0 0 1-2 2" }],
      ["path", { d: "M21 9v1" }],
      ["path", { d: "M3 14v1" }],
      ["path", { d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2" }],
      ["path", { d: "M3 9v1" }],
      ["path", { d: "M5 21a2 2 0 0 1-2-2" }],
      ["path", { d: "M9 21h1" }],
    ],
    r0 = [
      ["path", { d: "M5 3a2 2 0 0 0-2 2" }],
      ["path", { d: "M19 3a2 2 0 0 1 2 2" }],
      ["path", { d: "M21 19a2 2 0 0 1-2 2" }],
      ["path", { d: "M5 21a2 2 0 0 1-2-2" }],
      ["path", { d: "M9 3h1" }],
      ["path", { d: "M9 21h1" }],
      ["path", { d: "M14 3h1" }],
      ["path", { d: "M14 21h1" }],
      ["path", { d: "M3 9v1" }],
      ["path", { d: "M21 9v1" }],
      ["path", { d: "M3 14v1" }],
      ["path", { d: "M21 14v1" }],
    ],
    o0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["line", { x1: "8", x2: "16", y1: "12", y2: "12" }],
      ["line", { x1: "12", x2: "12", y1: "16", y2: "16" }],
      ["line", { x1: "12", x2: "12", y1: "8", y2: "8" }],
    ],
    v0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["circle", { cx: "12", cy: "12", r: "1" }],
    ],
    $0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M7 10h10" }],
      ["path", { d: "M7 14h10" }],
    ],
    m0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3" }],
      ["path", { d: "M9 11.2h5.7" }],
    ],
    y0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M8 7v7" }],
      ["path", { d: "M12 7v4" }],
      ["path", { d: "M16 7v9" }],
    ],
    s0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M7 7v10" }],
      ["path", { d: "M11 7v10" }],
      ["path", { d: "m15 7 2 10" }],
    ],
    g0 = [
      [
        "path",
        {
          d: "M8 16V8.5a.5.5 0 0 1 .9-.3l2.7 3.599a.5.5 0 0 0 .8 0l2.7-3.6a.5.5 0 0 1 .9.3V16",
        },
      ],
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
    ],
    u0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M7 8h10" }],
      ["path", { d: "M7 12h10" }],
      ["path", { d: "M7 16h10" }],
    ],
    C0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M8 12h8" }],
    ],
    H0 = [
      [
        "path",
        {
          d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
        },
      ],
      [
        "path",
        { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" },
      ],
    ],
    A0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9" }],
    ],
    w0 = [
      [
        "path",
        { d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41" },
      ],
      ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2" }],
      ["path", { d: "M9 17v-2.3" }],
    ],
    Pm = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["line", { x1: "10", x2: "10", y1: "15", y2: "9" }],
      ["line", { x1: "14", x2: "14", y1: "15", y2: "9" }],
    ],
    p = [
      [
        "path",
        { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" },
      ],
      [
        "path",
        {
          d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
        },
      ],
    ],
    V0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "m15 9-6 6" }],
      ["path", { d: "M9 9h.01" }],
      ["path", { d: "M15 15h.01" }],
    ],
    S0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M7 7h10" }],
      ["path", { d: "M10 7v10" }],
      ["path", { d: "M16 17a2 2 0 0 1-2-2V7" }],
    ],
    L0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17" }],
      ["path", { d: "M12 7v10" }],
      ["path", { d: "M16 7v10" }],
    ],
    f0 = [
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
      [
        "path",
        {
          d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
        },
      ],
    ],
    k0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M8 12h8" }],
      ["path", { d: "M12 8v8" }],
    ],
    P0 = [
      ["path", { d: "M12 7v4" }],
      ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005" }],
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
    ],
    Bm = [
      ["path", { d: "M7 12h2l2 5 2-10h4" }],
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
    ],
    Dm = [
      ["path", { d: "M21 11a8 8 0 0 0-8-8" }],
      [
        "path",
        { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" },
      ],
    ],
    B0 = [
      ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "2" }],
      ["circle", { cx: "8", cy: "8", r: "2" }],
      ["path", { d: "M9.414 9.414 12 12" }],
      ["path", { d: "M14.8 14.8 18 18" }],
      ["circle", { cx: "8", cy: "16", r: "2" }],
      ["path", { d: "m18 6-8.586 8.586" }],
    ],
    D0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9" }],
    ],
    F0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["line", { x1: "9", x2: "15", y1: "15", y2: "9" }],
    ],
    z0 = [
      ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3" }],
      ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3" }],
      ["line", { x1: "12", x2: "12", y1: "4", y2: "20" }],
    ],
    b0 = [
      ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3" }],
      ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3" }],
      ["line", { x1: "4", x2: "20", y1: "12", y2: "12" }],
    ],
    Fm = [
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
      ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1" }],
    ],
    zm = [
      ["path", { d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2" }],
      [
        "path",
        { d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2" },
      ],
      ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2" }],
    ],
    bm = [
      [
        "path",
        {
          d: "M11.035 7.69a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.866l-1.156-1.153a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z",
        },
      ],
      ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
    ],
    Rm = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1" }],
    ],
    R0 = [
      ["path", { d: "m7 11 2-2-2-2" }],
      ["path", { d: "M11 13h4" }],
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
    ],
    T0 = [
      ["path", { d: "M18 21a6 6 0 0 0-12 0" }],
      ["circle", { cx: "12", cy: "11", r: "4" }],
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
    ],
    q0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["circle", { cx: "12", cy: "10", r: "3" }],
      ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2" }],
    ],
    U0 = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["path", { d: "m15 9-6 6" }],
      ["path", { d: "m9 9 6 6" }],
    ],
    Tm = [["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }]],
    qm = [
      [
        "path",
        {
          d: "M16 12v2a2 2 0 0 1-2 2H9a1 1 0 0 0-1 1v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h0",
        },
      ],
      [
        "path",
        {
          d: "M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3a1 1 0 0 1-1 1h-5a2 2 0 0 0-2 2v2",
        },
      ],
    ],
    Um = [
      ["path", { d: "M10 22a2 2 0 0 1-2-2" }],
      ["path", { d: "M14 2a2 2 0 0 1 2 2" }],
      ["path", { d: "M16 22h-2" }],
      ["path", { d: "M2 10V8" }],
      ["path", { d: "M2 4a2 2 0 0 1 2-2" }],
      ["path", { d: "M20 8a2 2 0 0 1 2 2" }],
      ["path", { d: "M22 14v2" }],
      ["path", { d: "M22 20a2 2 0 0 1-2 2" }],
      ["path", { d: "M4 16a2 2 0 0 1-2-2" }],
      [
        "path",
        {
          d: "M8 10a2 2 0 0 1 2-2h5a1 1 0 0 1 1 1v5a2 2 0 0 1-2 2H9a1 1 0 0 1-1-1z",
        },
      ],
      ["path", { d: "M8 2h2" }],
    ],
    Om = [
      ["path", { d: "M10 22a2 2 0 0 1-2-2" }],
      ["path", { d: "M16 22h-2" }],
      [
        "path",
        {
          d: "M16 4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-5a2 2 0 0 1 2-2h5a1 1 0 0 0 1-1z",
        },
      ],
      ["path", { d: "M20 8a2 2 0 0 1 2 2" }],
      ["path", { d: "M22 14v2" }],
      ["path", { d: "M22 20a2 2 0 0 1-2 2" }],
    ],
    Zm = [
      [
        "path",
        {
          d: "M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3a1 1 0 0 0 1 1h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-3a1 1 0 0 0-1-1z",
        },
      ],
    ],
    Gm = [
      ["path", { d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9" }],
    ],
    Im = [
      ["path", { d: "M13.77 3.043a34 34 0 0 0-3.54 0" }],
      ["path", { d: "M13.771 20.956a33 33 0 0 1-3.541.001" }],
      ["path", { d: "M20.18 17.74c-.51 1.15-1.29 1.93-2.439 2.44" }],
      ["path", { d: "M20.18 6.259c-.51-1.148-1.291-1.929-2.44-2.438" }],
      ["path", { d: "M20.957 10.23a33 33 0 0 1 0 3.54" }],
      ["path", { d: "M3.043 10.23a34 34 0 0 0 .001 3.541" }],
      ["path", { d: "M6.26 20.179c-1.15-.508-1.93-1.29-2.44-2.438" }],
      ["path", { d: "M6.26 3.82c-1.149.51-1.93 1.291-2.44 2.44" }],
    ],
    Wm = [
      ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5" }],
      [
        "path",
        { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4" },
      ],
      ["path", { d: "M18 13h.01" }],
      [
        "path",
        {
          d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
        },
      ],
    ],
    Em = [
      [
        "path",
        { d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-6 0c0 2 1 2 1 3.5V13" },
      ],
      [
        "path",
        {
          d: "M20 15.5a2.5 2.5 0 0 0-2.5-2.5h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1z",
        },
      ],
      ["path", { d: "M5 22h14" }],
    ],
    Xm = [
      [
        "path",
        {
          d: "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2",
        },
      ],
    ],
    jm = [
      [
        "path",
        { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43" },
      ],
      ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91" }],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    Nm = [
      [
        "path",
        {
          d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
        },
      ],
    ],
    Km = [
      [
        "path",
        {
          d: "M13.971 4.285A2 2 0 0 1 17 6v12a2 2 0 0 1-3.029 1.715l-9.997-5.998a2 2 0 0 1-.003-3.432z",
        },
      ],
      ["path", { d: "M21 20V4" }],
    ],
    Qm = [
      ["path", { d: "M11 2v2" }],
      ["path", { d: "M5 2v2" }],
      [
        "path",
        { d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1" },
      ],
      ["path", { d: "M8 15a6 6 0 0 0 12 0v-3" }],
      ["circle", { cx: "20", cy: "10", r: "2" }],
    ],
    Jm = [
      [
        "path",
        {
          d: "M10.029 4.285A2 2 0 0 0 7 6v12a2 2 0 0 0 3.029 1.715l9.997-5.998a2 2 0 0 0 .003-3.432z",
        },
      ],
      ["path", { d: "M3 4v16" }],
    ],
    Ym = [
      [
        "path",
        {
          d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z",
        },
      ],
      ["path", { d: "M14 3v4a2 2 0 0 0 2 2h4" }],
      ["path", { d: "M8 13h.01" }],
      ["path", { d: "M16 13h.01" }],
      ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1" }],
    ],
    _m = [
      [
        "path",
        { d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z" },
      ],
      ["path", { d: "M15 3v4a2 2 0 0 0 2 2h4" }],
    ],
    xm = [
      ["path", { d: "M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5" }],
      [
        "path",
        {
          d: "M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244",
        },
      ],
      ["path", { d: "M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05" }],
    ],
    ay = [
      ["rect", { width: "20", height: "6", x: "2", y: "4", rx: "2" }],
      ["rect", { width: "20", height: "6", x: "2", y: "14", rx: "2" }],
    ],
    ty = [
      ["rect", { width: "6", height: "20", x: "4", y: "2", rx: "2" }],
      ["rect", { width: "6", height: "20", x: "14", y: "2", rx: "2" }],
    ],
    hy = [
      ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4" }],
      ["path", { d: "M14 12a4 4 0 0 1 0 8H6" }],
      ["line", { x1: "4", x2: "20", y1: "12", y2: "12" }],
    ],
    dy = [
      ["path", { d: "m4 5 8 8" }],
      ["path", { d: "m12 5-8 8" }],
      [
        "path",
        {
          d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
        },
      ],
    ],
    cy = [
      ["circle", { cx: "12", cy: "12", r: "4" }],
      ["path", { d: "M12 4h.01" }],
      ["path", { d: "M20 12h.01" }],
      ["path", { d: "M12 20h.01" }],
      ["path", { d: "M4 12h.01" }],
      ["path", { d: "M17.657 6.343h.01" }],
      ["path", { d: "M17.657 17.657h.01" }],
      ["path", { d: "M6.343 17.657h.01" }],
      ["path", { d: "M6.343 6.343h.01" }],
    ],
    My = [
      ["circle", { cx: "12", cy: "12", r: "4" }],
      ["path", { d: "M12 3v1" }],
      ["path", { d: "M12 20v1" }],
      ["path", { d: "M3 12h1" }],
      ["path", { d: "M20 12h1" }],
      ["path", { d: "m18.364 5.636-.707.707" }],
      ["path", { d: "m6.343 17.657-.707.707" }],
      ["path", { d: "m5.636 5.636.707.707" }],
      ["path", { d: "m17.657 17.657.707.707" }],
    ],
    py = [
      ["path", { d: "M12 2v2" }],
      [
        "path",
        {
          d: "M14.837 16.385a6 6 0 1 1-7.223-7.222c.624-.147.97.66.715 1.248a4 4 0 0 0 5.26 5.259c.589-.255 1.396.09 1.248.715",
        },
      ],
      ["path", { d: "M16 12a4 4 0 0 0-4-4" }],
      ["path", { d: "m19 5-1.256 1.256" }],
      ["path", { d: "M20 12h2" }],
    ],
    iy = [
      ["path", { d: "M10 21v-1" }],
      ["path", { d: "M10 4V3" }],
      ["path", { d: "M10 9a3 3 0 0 0 0 6" }],
      ["path", { d: "m14 20 1.25-2.5L18 18" }],
      ["path", { d: "m14 4 1.25 2.5L18 6" }],
      ["path", { d: "m17 21-3-6 1.5-3H22" }],
      ["path", { d: "m17 3-3 6 1.5 3" }],
      ["path", { d: "M2 12h1" }],
      ["path", { d: "m20 10-1.5 2 1.5 2" }],
      ["path", { d: "m3.64 18.36.7-.7" }],
      ["path", { d: "m4.34 6.34-.7-.7" }],
    ],
    ny = [
      ["circle", { cx: "12", cy: "12", r: "4" }],
      ["path", { d: "M12 2v2" }],
      ["path", { d: "M12 20v2" }],
      ["path", { d: "m4.93 4.93 1.41 1.41" }],
      ["path", { d: "m17.66 17.66 1.41 1.41" }],
      ["path", { d: "M2 12h2" }],
      ["path", { d: "M20 12h2" }],
      ["path", { d: "m6.34 17.66-1.41 1.41" }],
      ["path", { d: "m19.07 4.93-1.41 1.41" }],
    ],
    ly = [
      ["path", { d: "M12 2v8" }],
      ["path", { d: "m4.93 10.93 1.41 1.41" }],
      ["path", { d: "M2 18h2" }],
      ["path", { d: "M20 18h2" }],
      ["path", { d: "m19.07 10.93-1.41 1.41" }],
      ["path", { d: "M22 22H2" }],
      ["path", { d: "m8 6 4-4 4 4" }],
      ["path", { d: "M16 18a4 4 0 0 0-8 0" }],
    ],
    ey = [
      ["path", { d: "M12 10V2" }],
      ["path", { d: "m4.93 10.93 1.41 1.41" }],
      ["path", { d: "M2 18h2" }],
      ["path", { d: "M20 18h2" }],
      ["path", { d: "m19.07 10.93-1.41 1.41" }],
      ["path", { d: "M22 22H2" }],
      ["path", { d: "m16 6-4 4-4-4" }],
      ["path", { d: "M16 18a4 4 0 0 0-8 0" }],
    ],
    ry = [
      ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z" }],
      ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7" }],
      ["path", { d: "M 7 17h.01" }],
      [
        "path",
        {
          d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
        },
      ],
    ],
    oy = [
      ["path", { d: "m4 19 8-8" }],
      ["path", { d: "m12 19-8-8" }],
      [
        "path",
        {
          d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
        },
      ],
    ],
    vy = [
      ["path", { d: "M10 21V3h8" }],
      ["path", { d: "M6 16h9" }],
      ["path", { d: "M10 9.5h7" }],
    ],
    $y = [
      ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5" }],
      ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5" }],
      ["circle", { cx: "12", cy: "12", r: "3" }],
      ["path", { d: "m18 22-3-3 3-3" }],
      ["path", { d: "m6 2 3 3-3 3" }],
    ],
    my = [
      ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5" }],
      ["line", { x1: "13", x2: "19", y1: "19", y2: "13" }],
      ["line", { x1: "16", x2: "20", y1: "16", y2: "20" }],
      ["line", { x1: "19", x2: "21", y1: "21", y2: "19" }],
    ],
    yy = [
      ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5" }],
      ["line", { x1: "13", x2: "19", y1: "19", y2: "13" }],
      ["line", { x1: "16", x2: "20", y1: "16", y2: "20" }],
      ["line", { x1: "19", x2: "21", y1: "21", y2: "19" }],
      ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5" }],
      ["line", { x1: "5", x2: "9", y1: "14", y2: "18" }],
      ["line", { x1: "7", x2: "4", y1: "17", y2: "20" }],
      ["line", { x1: "3", x2: "5", y1: "19", y2: "21" }],
    ],
    sy = [
      ["path", { d: "m18 2 4 4" }],
      ["path", { d: "m17 7 3-3" }],
      [
        "path",
        { d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5" },
      ],
      ["path", { d: "m9 11 4 4" }],
      ["path", { d: "m5 19-3 3" }],
      ["path", { d: "m14 4 6 6" }],
    ],
    gy = [
      [
        "path",
        {
          d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
        },
      ],
    ],
    uy = [
      ["path", { d: "M12 21v-6" }],
      ["path", { d: "M12 9V3" }],
      ["path", { d: "M3 15h18" }],
      ["path", { d: "M3 9h18" }],
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
    ],
    Cy = [
      ["path", { d: "M14 14v2" }],
      ["path", { d: "M14 20v2" }],
      ["path", { d: "M14 2v2" }],
      ["path", { d: "M14 8v2" }],
      ["path", { d: "M2 15h8" }],
      ["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2" }],
      ["path", { d: "M2 9h8" }],
      ["path", { d: "M22 15h-4" }],
      ["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2" }],
      ["path", { d: "M22 9h-4" }],
      ["path", { d: "M5 3v18" }],
    ],
    Hy = [
      ["path", { d: "M12 15V9" }],
      ["path", { d: "M3 15h18" }],
      ["path", { d: "M3 9h18" }],
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
    ],
    Ay = [
      ["path", { d: "M15 3v18" }],
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M21 9H3" }],
      ["path", { d: "M21 15H3" }],
    ],
    wy = [
      ["path", { d: "M16 5H3" }],
      ["path", { d: "M16 12H3" }],
      ["path", { d: "M16 19H3" }],
      ["path", { d: "M21 5h.01" }],
      ["path", { d: "M21 12h.01" }],
      ["path", { d: "M21 19h.01" }],
    ],
    Vy = [
      ["path", { d: "M14 10h2" }],
      ["path", { d: "M15 22v-8" }],
      ["path", { d: "M15 2v4" }],
      ["path", { d: "M2 10h2" }],
      ["path", { d: "M20 10h2" }],
      ["path", { d: "M3 19h18" }],
      ["path", { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6" }],
      ["path", { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2" }],
      ["path", { d: "M8 10h2" }],
      ["path", { d: "M9 22v-8" }],
      ["path", { d: "M9 2v4" }],
    ],
    Sy = [
      ["path", { d: "M12 3v18" }],
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 9h18" }],
      ["path", { d: "M3 15h18" }],
    ],
    Ly = [
      ["rect", { width: "10", height: "14", x: "3", y: "8", rx: "2" }],
      [
        "path",
        { d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4" },
      ],
      ["path", { d: "M8 18h.01" }],
    ],
    fy = [
      ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2" }],
      ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18" }],
    ],
    ky = [
      ["circle", { cx: "7", cy: "7", r: "5" }],
      ["circle", { cx: "17", cy: "17", r: "5" }],
      ["path", { d: "M12 17h10" }],
      ["path", { d: "m3.46 10.54 7.08-7.08" }],
    ],
    Py = [
      [
        "path",
        {
          d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
        },
      ],
      ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" }],
    ],
    By = [["path", { d: "M4 4v16" }]],
    Dy = [
      [
        "path",
        {
          d: "M13.172 2a2 2 0 0 1 1.414.586l6.71 6.71a2.4 2.4 0 0 1 0 3.408l-4.592 4.592a2.4 2.4 0 0 1-3.408 0l-6.71-6.71A2 2 0 0 1 6 9.172V3a1 1 0 0 1 1-1z",
        },
      ],
      [
        "path",
        {
          d: "M2 7v6.172a2 2 0 0 0 .586 1.414l6.71 6.71a2.4 2.4 0 0 0 3.191.193",
        },
      ],
      ["circle", { cx: "10.5", cy: "6.5", r: ".5", fill: "currentColor" }],
    ],
    Fy = [
      ["path", { d: "M4 4v16" }],
      ["path", { d: "M9 4v16" }],
    ],
    zy = [
      ["path", { d: "M4 4v16" }],
      ["path", { d: "M9 4v16" }],
      ["path", { d: "M14 4v16" }],
    ],
    by = [
      ["path", { d: "M4 4v16" }],
      ["path", { d: "M9 4v16" }],
      ["path", { d: "M14 4v16" }],
      ["path", { d: "M19 4v16" }],
    ],
    Ry = [
      ["path", { d: "M4 4v16" }],
      ["path", { d: "M9 4v16" }],
      ["path", { d: "M14 4v16" }],
      ["path", { d: "M19 4v16" }],
      ["path", { d: "M22 6 2 18" }],
    ],
    Ty = [
      ["circle", { cx: "17", cy: "4", r: "2" }],
      ["path", { d: "M15.59 5.41 5.41 15.59" }],
      ["circle", { cx: "4", cy: "17", r: "2" }],
      ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12" }],
    ],
    qy = [
      ["circle", { cx: "12", cy: "12", r: "10" }],
      ["circle", { cx: "12", cy: "12", r: "6" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
    ],
    Uy = [
      [
        "path",
        {
          d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
        },
      ],
      ["path", { d: "m13.56 11.747 4.332-.924" }],
      ["path", { d: "m16 21-3.105-6.21" }],
      [
        "path",
        {
          d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
        },
      ],
      ["path", { d: "m6.158 8.633 1.114 4.456" }],
      ["path", { d: "m8 21 3.105-6.21" }],
      ["circle", { cx: "12", cy: "13", r: "2" }],
    ],
    Oy = [
      ["circle", { cx: "4", cy: "4", r: "2" }],
      ["path", { d: "m14 5 3-3 3 3" }],
      ["path", { d: "m14 10 3-3 3 3" }],
      ["path", { d: "M17 14V2" }],
      ["path", { d: "M17 14H7l-5 8h20Z" }],
      ["path", { d: "M8 14v8" }],
      ["path", { d: "m9 14 5 8" }],
    ],
    Zy = [
      ["path", { d: "M3.5 21 14 3" }],
      ["path", { d: "M20.5 21 10 3" }],
      ["path", { d: "M15.5 21 12 15l-3.5 6" }],
      ["path", { d: "M2 21h20" }],
    ],
    Gy = [
      ["path", { d: "M12 19h8" }],
      ["path", { d: "m4 17 6-6-6-6" }],
    ],
    O0 = [
      [
        "path",
        {
          d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3",
        },
      ],
      ["path", { d: "m16 2 6 6" }],
      ["path", { d: "M12 16H4" }],
    ],
    Iy = [
      [
        "path",
        { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2" },
      ],
      ["path", { d: "M8.5 2h7" }],
      ["path", { d: "M14.5 16h-5" }],
    ],
    Wy = [
      ["path", { d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2" }],
      [
        "path",
        { d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2" },
      ],
      ["path", { d: "M3 2h7" }],
      ["path", { d: "M14 2h7" }],
      ["path", { d: "M9 16H4" }],
      ["path", { d: "M20 16h-5" }],
    ],
    Z0 = [
      ["path", { d: "M21 5H3" }],
      ["path", { d: "M17 12H7" }],
      ["path", { d: "M19 19H5" }],
    ],
    G0 = [
      ["path", { d: "M21 5H3" }],
      ["path", { d: "M21 12H9" }],
      ["path", { d: "M21 19H7" }],
    ],
    I0 = [
      ["path", { d: "M3 5h18" }],
      ["path", { d: "M3 12h18" }],
      ["path", { d: "M3 19h18" }],
    ],
    m = [
      ["path", { d: "M21 5H3" }],
      ["path", { d: "M15 12H3" }],
      ["path", { d: "M17 19H3" }],
    ],
    Ey = [
      ["path", { d: "M12 20h-1a2 2 0 0 1-2-2 2 2 0 0 1-2 2H6" }],
      ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7" }],
      ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1" }],
      ["path", { d: "M6 4h1a2 2 0 0 1 2 2 2 2 0 0 1 2-2h1" }],
      ["path", { d: "M9 6v12" }],
    ],
    Xy = [
      ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1" }],
      ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1" }],
      ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1" }],
    ],
    W0 = [
      ["path", { d: "M15 5h6" }],
      ["path", { d: "M15 12h6" }],
      ["path", { d: "M3 19h18" }],
      ["path", { d: "m3 12 3.553-7.724a.5.5 0 0 1 .894 0L11 12" }],
      ["path", { d: "M3.92 10h6.16" }],
    ],
    jy = [
      ["path", { d: "M17 5H3" }],
      ["path", { d: "M21 12H8" }],
      ["path", { d: "M21 19H8" }],
      ["path", { d: "M3 12v7" }],
    ],
    Ny = [
      ["path", { d: "M21 5H3" }],
      ["path", { d: "M10 12H3" }],
      ["path", { d: "M10 19H3" }],
      ["circle", { cx: "17", cy: "15", r: "3" }],
      ["path", { d: "m21 19-1.9-1.9" }],
    ],
    E0 = [
      ["path", { d: "M14 21h1" }],
      ["path", { d: "M14 3h1" }],
      ["path", { d: "M19 3a2 2 0 0 1 2 2" }],
      ["path", { d: "M21 14v1" }],
      ["path", { d: "M21 19a2 2 0 0 1-2 2" }],
      ["path", { d: "M21 9v1" }],
      ["path", { d: "M3 14v1" }],
      ["path", { d: "M3 9v1" }],
      ["path", { d: "M5 21a2 2 0 0 1-2-2" }],
      ["path", { d: "M5 3a2 2 0 0 0-2 2" }],
      ["path", { d: "M7 12h10" }],
      ["path", { d: "M7 16h6" }],
      ["path", { d: "M7 8h8" }],
      ["path", { d: "M9 21h1" }],
      ["path", { d: "M9 3h1" }],
    ],
    X0 = [
      ["path", { d: "m16 16-3 3 3 3" }],
      ["path", { d: "M3 12h14.5a1 1 0 0 1 0 7H13" }],
      ["path", { d: "M3 19h6" }],
      ["path", { d: "M3 5h18" }],
    ],
    Ky = [
      ["path", { d: "M2 10s3-3 3-8" }],
      ["path", { d: "M22 10s-3-3-3-8" }],
      ["path", { d: "M10 2c0 4.4-3.6 8-8 8" }],
      ["path", { d: "M14 2c0 4.4 3.6 8 8 8" }],
      ["path", { d: "M2 10s2 2 2 5" }],
      ["path", { d: "M22 10s-2 2-2 5" }],
      ["path", { d: "M8 15h8" }],
      ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1" }],
      ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1" }],
    ],
    Qy = [
      ["path", { d: "m10 20-1.25-2.5L6 18" }],
      ["path", { d: "M10 4 8.75 6.5 6 6" }],
      ["path", { d: "M10.585 15H10" }],
      ["path", { d: "M2 12h6.5L10 9" }],
      ["path", { d: "M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z" }],
      ["path", { d: "m4 10 1.5 2L4 14" }],
      ["path", { d: "m7 21 3-6-1.5-3" }],
      ["path", { d: "m7 3 3 6h2" }],
    ],
    Jy = [
      ["path", { d: "M12 9a4 4 0 0 0-2 7.5" }],
      ["path", { d: "M12 3v2" }],
      ["path", { d: "m6.6 18.4-1.4 1.4" }],
      ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z" }],
      ["path", { d: "M4 13H2" }],
      ["path", { d: "M6.34 7.34 4.93 5.93" }],
    ],
    Yy = [["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z" }]],
    _y = [
      ["path", { d: "M17 14V2" }],
      [
        "path",
        {
          d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
        },
      ],
    ],
    xy = [
      ["path", { d: "M7 10v12" }],
      [
        "path",
        {
          d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
        },
      ],
    ],
    as = [
      [
        "path",
        {
          d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        },
      ],
      ["path", { d: "m9 12 2 2 4-4" }],
    ],
    ts = [
      [
        "path",
        {
          d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        },
      ],
      ["path", { d: "M9 12h6" }],
    ],
    hs = [
      [
        "path",
        {
          d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        },
      ],
      ["path", { d: "M9 9h.01" }],
      ["path", { d: "m15 9-6 6" }],
      ["path", { d: "M15 15h.01" }],
    ],
    ds = [
      [
        "path",
        {
          d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        },
      ],
      ["path", { d: "M9 12h6" }],
      ["path", { d: "M12 9v6" }],
    ],
    cs = [
      [
        "path",
        {
          d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        },
      ],
      ["path", { d: "m9.5 14.5 5-5" }],
      ["path", { d: "m9.5 9.5 5 5" }],
    ],
    Ms = [
      [
        "path",
        {
          d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        },
      ],
      ["path", { d: "M13 5v2" }],
      ["path", { d: "M13 17v2" }],
      ["path", { d: "M13 11v2" }],
    ],
    ps = [
      [
        "path",
        {
          d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        },
      ],
      ["path", { d: "m9.5 14.5 5-5" }],
    ],
    is = [
      ["path", { d: "M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12" }],
      ["path", { d: "m12 13.5 3.75.5" }],
      ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8" }],
      ["path", { d: "M6 10V8" }],
      ["path", { d: "M6 14v1" }],
      ["path", { d: "M6 19v2" }],
      ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2" }],
    ],
    ns = [
      ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8" }],
      ["path", { d: "M6 10V8" }],
      ["path", { d: "M6 14v1" }],
      ["path", { d: "M6 19v2" }],
      ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2" }],
    ],
    ls = [
      ["path", { d: "M10 2h4" }],
      ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7" }],
      ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M12 12v-2" }],
    ],
    es = [
      ["path", { d: "M10 2h4" }],
      ["path", { d: "M12 14v-4" }],
      ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6" }],
      ["path", { d: "M9 17H4v5" }],
    ],
    rs = [
      ["line", { x1: "10", x2: "14", y1: "2", y2: "2" }],
      ["line", { x1: "12", x2: "15", y1: "14", y2: "11" }],
      ["circle", { cx: "12", cy: "14", r: "8" }],
    ],
    os = [
      ["circle", { cx: "9", cy: "12", r: "3" }],
      ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "7" }],
    ],
    vs = [
      ["circle", { cx: "15", cy: "12", r: "3" }],
      ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "7" }],
    ],
    $s = [
      [
        "path",
        {
          d: "M7 12h13a1 1 0 0 1 1 1 5 5 0 0 1-5 5h-.598a.5.5 0 0 0-.424.765l1.544 2.47a.5.5 0 0 1-.424.765H5.402a.5.5 0 0 1-.424-.765L7 18",
        },
      ],
      ["path", { d: "M8 18a5 5 0 0 1-5-5V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8" }],
    ],
    ms = [
      ["path", { d: "M21 4H3" }],
      ["path", { d: "M18 8H6" }],
      ["path", { d: "M19 12H9" }],
      ["path", { d: "M16 16h-6" }],
      ["path", { d: "M11 20H9" }],
    ],
    ys = [
      ["path", { d: "M10 15h4" }],
      [
        "path",
        {
          d: "m14.817 10.995-.971-1.45 1.034-1.232a2 2 0 0 0-2.025-3.238l-1.82.364L9.91 3.885a2 2 0 0 0-3.625.748L6.141 6.55l-1.725.426a2 2 0 0 0-.19 3.756l.657.27",
        },
      ],
      [
        "path",
        {
          d: "m18.822 10.995 2.26-5.38a1 1 0 0 0-.557-1.318L16.954 2.9a1 1 0 0 0-1.281.533l-.924 2.122",
        },
      ],
      [
        "path",
        {
          d: "M4 12.006A1 1 0 0 1 4.994 11H19a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z",
        },
      ],
    ],
    ss = [
      ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2" }],
      ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5" }],
    ],
    gs = [
      ["path", { d: "M12 20v-6" }],
      ["path", { d: "M19.656 14H22" }],
      ["path", { d: "M2 14h12" }],
      ["path", { d: "m2 2 20 20" }],
      ["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2" }],
      ["path", { d: "M9.656 4H20a2 2 0 0 1 2 2v10.344" }],
    ],
    us = [
      ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
      ["path", { d: "M2 14h20" }],
      ["path", { d: "M12 20v-6" }],
    ],
    Cs = [
      ["rect", { width: "18", height: "12", x: "3", y: "8", rx: "1" }],
      ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3" }],
      ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3" }],
    ],
    Hs = [
      [
        "path",
        {
          d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z",
        },
      ],
      ["path", { d: "M8 13v9" }],
      ["path", { d: "M16 22v-9" }],
      ["path", { d: "m9 6 1 7" }],
      ["path", { d: "m15 6-1 7" }],
      ["path", { d: "M12 6V2" }],
      ["path", { d: "M13 2h-2" }],
    ],
    As = [
      [
        "path",
        {
          d: "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20",
        },
      ],
      ["path", { d: "M16 18h-5" }],
      ["path", { d: "M18 5a1 1 0 0 0-1 1v5.573" }],
      ["path", { d: "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246" }],
      ["path", { d: "M4 11V4" }],
      ["path", { d: "M7 15h.01" }],
      ["path", { d: "M8 10.1V4" }],
      ["circle", { cx: "18", cy: "18", r: "2" }],
      ["circle", { cx: "7", cy: "15", r: "5" }],
    ],
    ws = [
      ["path", { d: "M16.05 10.966a5 2.5 0 0 1-8.1 0" }],
      [
        "path",
        {
          d: "m16.923 14.049 4.48 2.04a1 1 0 0 1 .001 1.831l-8.574 3.9a2 2 0 0 1-1.66 0l-8.574-3.91a1 1 0 0 1 0-1.83l4.484-2.04",
        },
      ],
      [
        "path",
        { d: "M16.949 14.14a5 2.5 0 1 1-9.9 0L10.063 3.5a2 2 0 0 1 3.874 0z" },
      ],
      ["path", { d: "M9.194 6.57a5 2.5 0 0 0 5.61 0" }],
    ],
    Vs = [
      ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10" }],
      ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8" }],
      ["path", { d: "M10 15h.01" }],
      ["path", { d: "M14 15h.01" }],
      [
        "path",
        { d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z" },
      ],
      ["path", { d: "m9 19-2 3" }],
      ["path", { d: "m15 19 2 3" }],
    ],
    Ss = [
      ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1" }],
      ["path", { d: "m9 15-1-1" }],
      ["path", { d: "m15 15 1-1" }],
      [
        "path",
        { d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z" },
      ],
      ["path", { d: "m8 19-2 3" }],
      ["path", { d: "m16 19 2 3" }],
    ],
    Ls = [
      ["path", { d: "M2 17 17 2" }],
      ["path", { d: "m2 14 8 8" }],
      ["path", { d: "m5 11 8 8" }],
      ["path", { d: "m8 8 8 8" }],
      ["path", { d: "m11 5 8 8" }],
      ["path", { d: "m14 2 8 8" }],
      ["path", { d: "M7 22 22 7" }],
    ],
    j0 = [
      ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2" }],
      ["path", { d: "M4 11h16" }],
      ["path", { d: "M12 3v8" }],
      ["path", { d: "m8 19-2 3" }],
      ["path", { d: "m18 22-2-3" }],
      ["path", { d: "M8 15h.01" }],
      ["path", { d: "M16 15h.01" }],
    ],
    fs = [
      ["path", { d: "M12 16v6" }],
      ["path", { d: "M14 20h-4" }],
      ["path", { d: "M18 2h4v4" }],
      ["path", { d: "m2 2 7.17 7.17" }],
      ["path", { d: "M2 5.355V2h3.357" }],
      ["path", { d: "m22 2-7.17 7.17" }],
      ["path", { d: "M8 5 5 8" }],
      ["circle", { cx: "12", cy: "12", r: "4" }],
    ],
    ks = [
      ["path", { d: "M10 11v6" }],
      ["path", { d: "M14 11v6" }],
      ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }],
      ["path", { d: "M3 6h18" }],
      ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }],
    ],
    Ps = [
      ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }],
      ["path", { d: "M3 6h18" }],
      ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }],
    ],
    Bs = [
      [
        "path",
        {
          d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
        },
      ],
      ["path", { d: "M12 19v3" }],
    ],
    N0 = [
      ["path", { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4" }],
      [
        "path",
        {
          d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3",
        },
      ],
      [
        "path",
        {
          d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35",
        },
      ],
      ["path", { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14" }],
    ],
    Ds = [
      [
        "path",
        {
          d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
        },
      ],
      ["path", { d: "M12 22v-3" }],
    ],
    Fs = [
      [
        "path",
        { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z" },
      ],
      ["path", { d: "M7 16v6" }],
      ["path", { d: "M13 19v3" }],
      [
        "path",
        {
          d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
        },
      ],
    ],
    zs = [
      ["path", { d: "M16 17h6v-6" }],
      ["path", { d: "m22 17-8.5-8.5-5 5L2 7" }],
    ],
    bs = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
      ["rect", { width: "3", height: "9", x: "7", y: "7" }],
      ["rect", { width: "3", height: "5", x: "14", y: "7" }],
    ],
    Rs = [
      ["path", { d: "M14.828 14.828 21 21" }],
      ["path", { d: "M21 16v5h-5" }],
      ["path", { d: "m21 3-9 9-4-4-6 6" }],
      ["path", { d: "M21 8V3h-5" }],
    ],
    Ts = [
      ["path", { d: "M16 7h6v6" }],
      ["path", { d: "m22 7-8.5 8.5-5-5L2 17" }],
    ],
    qs = [
      ["path", { d: "M10.17 4.193a2 2 0 0 1 3.666.013" }],
      ["path", { d: "M14 21h2" }],
      ["path", { d: "m15.874 7.743 1 1.732" }],
      ["path", { d: "m18.849 12.952 1 1.732" }],
      ["path", { d: "M21.824 18.18a2 2 0 0 1-1.835 2.824" }],
      ["path", { d: "M4.024 21a2 2 0 0 1-1.839-2.839" }],
      ["path", { d: "m5.136 12.952-1 1.732" }],
      ["path", { d: "M8 21h2" }],
      ["path", { d: "m8.102 7.743-1 1.732" }],
    ],
    K0 = [
      [
        "path",
        {
          d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
        },
      ],
      ["path", { d: "M12 9v4" }],
      ["path", { d: "M12 17h.01" }],
    ],
    Us = [
      [
        "path",
        {
          d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
        },
      ],
    ],
    Os = [
      [
        "path",
        {
          d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z",
        },
      ],
    ],
    Zs = [
      [
        "path",
        { d: "M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978" },
      ],
      [
        "path",
        { d: "M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978" },
      ],
      ["path", { d: "M18 9h1.5a1 1 0 0 0 0-5H18" }],
      ["path", { d: "M4 22h16" }],
      ["path", { d: "M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z" }],
      ["path", { d: "M6 9H4.5a1 1 0 0 1 0-5H6" }],
    ],
    Gs = [
      ["path", { d: "M14 19V7a2 2 0 0 0-2-2H9" }],
      ["path", { d: "M15 19H9" }],
      [
        "path",
        {
          d: "M19 19h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 9.38a1 1 0 0 0-.78-.38H14",
        },
      ],
      ["path", { d: "M2 13v5a1 1 0 0 0 1 1h2" }],
      [
        "path",
        {
          d: "M4 3 2.15 5.15a.495.495 0 0 0 .35.86h2.15a.47.47 0 0 1 .35.86L3 9.02",
        },
      ],
      ["circle", { cx: "17", cy: "19", r: "2" }],
      ["circle", { cx: "7", cy: "19", r: "2" }],
    ],
    Is = [
      [
        "path",
        { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" },
      ],
      ["path", { d: "M15 18H9" }],
      [
        "path",
        {
          d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
        },
      ],
      ["circle", { cx: "17", cy: "18", r: "2" }],
      ["circle", { cx: "7", cy: "18", r: "2" }],
    ],
    Ws = [
      ["path", { d: "M10 12.01h.01" }],
      ["path", { d: "M18 8v4a8 8 0 0 1-1.07 4" }],
      ["circle", { cx: "10", cy: "12", r: "4" }],
      ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }],
    ],
    Es = [
      ["path", { d: "M15 4 5 9" }],
      ["path", { d: "m15 8.5-10 5" }],
      ["path", { d: "M18 12a9 9 0 0 1-9 9V3" }],
    ],
    Xs = [
      [
        "path",
        {
          d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
        },
      ],
      ["path", { d: "M4.82 7.9 8 10" }],
      ["path", { d: "M15.18 7.9 12 10" }],
      ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2" }],
    ],
    js = [
      [
        "path",
        {
          d: "M15.033 9.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56V7.648a.645.645 0 0 1 .967-.56z",
        },
      ],
      ["path", { d: "M7 21h10" }],
      ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
    ],
    Q0 = [
      ["path", { d: "M7 21h10" }],
      ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
    ],
    Ns = [
      ["path", { d: "m17 2-5 5-5-5" }],
      ["rect", { width: "20", height: "15", x: "2", y: "7", rx: "2" }],
    ],
    Ks = [["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7" }]],
    Qs = [
      [
        "path",
        {
          d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
        },
      ],
    ],
    Js = [
      [
        "path",
        {
          d: "M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z",
        },
      ],
    ],
    Ys = [
      ["path", { d: "M12 4v16" }],
      ["path", { d: "M4 7V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2" }],
      ["path", { d: "M9 20h6" }],
    ],
    _s = [
      ["path", { d: "M12 13v7a2 2 0 0 0 4 0" }],
      ["path", { d: "M12 2v2" }],
      [
        "path",
        {
          d: "M18.656 13h2.336a1 1 0 0 0 .97-1.274 10.284 10.284 0 0 0-12.07-7.51",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        { d: "M5.961 5.957a10.28 10.28 0 0 0-3.922 5.769A1 1 0 0 0 3 13h10" },
      ],
    ],
    xs = [
      ["path", { d: "M12 13v7a2 2 0 0 0 4 0" }],
      ["path", { d: "M12 2v2" }],
      [
        "path",
        {
          d: "M20.992 13a1 1 0 0 0 .97-1.274 10.284 10.284 0 0 0-19.923 0A1 1 0 0 0 3 13z",
        },
      ],
    ],
    ag = [
      ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4" }],
      ["line", { x1: "4", x2: "20", y1: "20", y2: "20" }],
    ],
    tg = [
      ["path", { d: "M9 14 4 9l5-5" }],
      [
        "path",
        { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11" },
      ],
    ],
    hg = [
      ["path", { d: "M21 17a9 9 0 0 0-15-6.7L3 13" }],
      ["path", { d: "M3 7v6h6" }],
      ["circle", { cx: "12", cy: "17", r: "1" }],
    ],
    dg = [
      ["path", { d: "M3 7v6h6" }],
      ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13" }],
    ],
    cg = [
      ["path", { d: "M16 12h6" }],
      ["path", { d: "M8 12H2" }],
      ["path", { d: "M12 2v2" }],
      ["path", { d: "M12 8v2" }],
      ["path", { d: "M12 14v2" }],
      ["path", { d: "M12 20v2" }],
      ["path", { d: "m19 15 3-3-3-3" }],
      ["path", { d: "m5 9-3 3 3 3" }],
    ],
    Mg = [
      ["path", { d: "M12 22v-6" }],
      ["path", { d: "M12 8V2" }],
      ["path", { d: "M4 12H2" }],
      ["path", { d: "M10 12H8" }],
      ["path", { d: "M16 12h-2" }],
      ["path", { d: "M22 12h-2" }],
      ["path", { d: "m15 19-3 3-3-3" }],
      ["path", { d: "m15 5-3-3-3 3" }],
    ],
    pg = [
      ["rect", { width: "8", height: "6", x: "5", y: "4", rx: "1" }],
      ["rect", { width: "8", height: "6", x: "11", y: "14", rx: "1" }],
    ],
    J0 = [
      ["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
      ["path", { d: "M18 12h.01" }],
      ["path", { d: "M18 16h.01" }],
      [
        "path",
        {
          d: "M22 7a1 1 0 0 0-1-1h-2a2 2 0 0 1-1.143-.359L13.143 2.36a2 2 0 0 0-2.286-.001L6.143 5.64A2 2 0 0 1 5 6H3a1 1 0 0 0-1 1v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2z",
        },
      ],
      ["path", { d: "M6 12h.01" }],
      ["path", { d: "M6 16h.01" }],
      ["circle", { cx: "12", cy: "10", r: "2" }],
    ],
    ig = [["path", { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2" }]],
    ng = [
      ["path", { d: "m19 5 3-3" }],
      ["path", { d: "m2 22 3-3" }],
      [
        "path",
        {
          d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z",
        },
      ],
      ["path", { d: "M7.5 13.5 10 11" }],
      ["path", { d: "M10.5 16.5 13 14" }],
      [
        "path",
        {
          d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z",
        },
      ],
    ],
    lg = [
      [
        "path",
        {
          d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
        },
      ],
      [
        "path",
        {
          d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
        },
      ],
      ["line", { x1: "8", x2: "8", y1: "2", y2: "5" }],
      ["line", { x1: "2", x2: "5", y1: "8", y2: "8" }],
      ["line", { x1: "16", x2: "16", y1: "19", y2: "22" }],
      ["line", { x1: "19", x2: "22", y1: "16", y2: "16" }],
    ],
    eg = [
      ["path", { d: "M12 3v12" }],
      ["path", { d: "m17 8-5-5-5 5" }],
      ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }],
    ],
    rg = [
      ["circle", { cx: "10", cy: "7", r: "1" }],
      ["circle", { cx: "4", cy: "20", r: "1" }],
      ["path", { d: "M4.7 19.3 19 5" }],
      ["path", { d: "m21 3-3 1 2 2Z" }],
      ["path", { d: "M9.26 7.68 5 12l2 5" }],
      ["path", { d: "m10 14 5 2 3.5-3.5" }],
      ["path", { d: "m18 12 1-1 1 1-1 1Z" }],
    ],
    og = [
      ["path", { d: "m16 11 2 2 4-4" }],
      ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
      ["circle", { cx: "9", cy: "7", r: "4" }],
    ],
    vg = [
      ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2" }],
      ["path", { d: "m14.305 16.53.923-.382" }],
      ["path", { d: "m15.228 13.852-.923-.383" }],
      ["path", { d: "m16.852 12.228-.383-.923" }],
      ["path", { d: "m16.852 17.772-.383.924" }],
      ["path", { d: "m19.148 12.228.383-.923" }],
      ["path", { d: "m19.53 18.696-.382-.924" }],
      ["path", { d: "m20.772 13.852.924-.383" }],
      ["path", { d: "m20.772 16.148.924.383" }],
      ["circle", { cx: "18", cy: "15", r: "3" }],
      ["circle", { cx: "9", cy: "7", r: "4" }],
    ],
    $g = [
      ["circle", { cx: "10", cy: "7", r: "4" }],
      ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2" }],
      ["path", { d: "M15 15.5V14a2 2 0 0 1 4 0v1.5" }],
      ["rect", { width: "8", height: "5", x: "13", y: "16", rx: ".899" }],
    ],
    mg = [
      ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
      ["circle", { cx: "9", cy: "7", r: "4" }],
      ["line", { x1: "22", x2: "16", y1: "11", y2: "11" }],
    ],
    yg = [
      ["path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2" }],
      [
        "path",
        {
          d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
        },
      ],
      ["circle", { cx: "10", cy: "7", r: "4" }],
    ],
    sg = [
      ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
      ["circle", { cx: "9", cy: "7", r: "4" }],
      ["line", { x1: "19", x2: "19", y1: "8", y2: "14" }],
      ["line", { x1: "22", x2: "16", y1: "11", y2: "11" }],
    ],
    Y0 = [
      ["path", { d: "m14.305 19.53.923-.382" }],
      ["path", { d: "m15.228 16.852-.923-.383" }],
      ["path", { d: "m16.852 15.228-.383-.923" }],
      ["path", { d: "m16.852 20.772-.383.924" }],
      ["path", { d: "m19.148 15.228.383-.923" }],
      ["path", { d: "m19.53 21.696-.382-.924" }],
      ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62" }],
      ["path", { d: "m20.772 16.852.924-.383" }],
      ["path", { d: "m20.772 19.148.924.383" }],
      ["circle", { cx: "10", cy: "8", r: "5" }],
      ["circle", { cx: "18", cy: "18", r: "3" }],
    ],
    _0 = [
      ["path", { d: "M2 21a8 8 0 0 1 13.292-6" }],
      ["circle", { cx: "10", cy: "8", r: "5" }],
      ["path", { d: "m16 19 2 2 4-4" }],
    ],
    x0 = [
      ["path", { d: "M2 21a8 8 0 0 1 13.292-6" }],
      ["circle", { cx: "10", cy: "8", r: "5" }],
      ["path", { d: "M22 19h-6" }],
    ],
    gg = [
      ["path", { d: "M2 21a8 8 0 0 1 10.821-7.487" }],
      [
        "path",
        {
          d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
        },
      ],
      ["circle", { cx: "10", cy: "8", r: "5" }],
    ],
    aa = [
      ["path", { d: "M2 21a8 8 0 0 1 13.292-6" }],
      ["circle", { cx: "10", cy: "8", r: "5" }],
      ["path", { d: "M19 16v6" }],
      ["path", { d: "M22 19h-6" }],
    ],
    ug = [
      ["circle", { cx: "10", cy: "8", r: "5" }],
      ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62" }],
      ["circle", { cx: "18", cy: "18", r: "3" }],
      ["path", { d: "m22 22-1.9-1.9" }],
    ],
    ta = [
      ["path", { d: "M2 21a8 8 0 0 1 11.873-7" }],
      ["circle", { cx: "10", cy: "8", r: "5" }],
      ["path", { d: "m17 17 5 5" }],
      ["path", { d: "m22 17-5 5" }],
    ],
    ha = [
      ["circle", { cx: "12", cy: "8", r: "5" }],
      ["path", { d: "M20 21a8 8 0 0 0-16 0" }],
    ],
    Cg = [
      ["circle", { cx: "10", cy: "7", r: "4" }],
      ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2" }],
      ["circle", { cx: "17", cy: "17", r: "3" }],
      ["path", { d: "m21 21-1.9-1.9" }],
    ],
    Hg = [
      [
        "path",
        {
          d: "M16.051 12.616a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.866l-1.156-1.153a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z",
        },
      ],
      ["path", { d: "M8 15H7a4 4 0 0 0-4 4v2" }],
      ["circle", { cx: "10", cy: "7", r: "4" }],
    ],
    Ag = [
      ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
      ["circle", { cx: "9", cy: "7", r: "4" }],
      ["line", { x1: "17", x2: "22", y1: "8", y2: "13" }],
      ["line", { x1: "22", x2: "17", y1: "8", y2: "13" }],
    ],
    wg = [
      ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }],
      ["circle", { cx: "12", cy: "7", r: "4" }],
    ],
    da = [
      ["path", { d: "M18 21a8 8 0 0 0-16 0" }],
      ["circle", { cx: "10", cy: "8", r: "5" }],
      ["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" }],
    ],
    Vg = [
      ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
      ["path", { d: "M16 3.128a4 4 0 0 1 0 7.744" }],
      ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }],
      ["circle", { cx: "9", cy: "7", r: "4" }],
    ],
    ca = [
      [
        "path",
        { d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8" },
      ],
      [
        "path",
        {
          d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7",
        },
      ],
      ["path", { d: "m2.1 21.8 6.4-6.3" }],
      ["path", { d: "m19 5-7 7" }],
    ],
    Ma = [
      ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" }],
      ["path", { d: "M7 2v20" }],
      ["path", { d: "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" }],
    ],
    Sg = [
      ["path", { d: "M12 2v20" }],
      ["path", { d: "M2 5h20" }],
      ["path", { d: "M3 3v2" }],
      ["path", { d: "M7 3v2" }],
      ["path", { d: "M17 3v2" }],
      ["path", { d: "M21 3v2" }],
      ["path", { d: "m19 5-7 7-7-7" }],
    ],
    Lg = [
      ["path", { d: "M8 21s-4-3-4-9 4-9 4-9" }],
      ["path", { d: "M16 3s4 3 4 9-4 9-4 9" }],
      ["line", { x1: "15", x2: "9", y1: "9", y2: "15" }],
      ["line", { x1: "9", x2: "15", y1: "9", y2: "15" }],
    ],
    fg = [
      ["path", { d: "M19.5 7a24 24 0 0 1 0 10" }],
      ["path", { d: "M4.5 7a24 24 0 0 0 0 10" }],
      ["path", { d: "M7 19.5a24 24 0 0 0 10 0" }],
      ["path", { d: "M7 4.5a24 24 0 0 1 10 0" }],
      ["rect", { x: "17", y: "17", width: "5", height: "5", rx: "1" }],
      ["rect", { x: "17", y: "2", width: "5", height: "5", rx: "1" }],
      ["rect", { x: "2", y: "17", width: "5", height: "5", rx: "1" }],
      ["rect", { x: "2", y: "2", width: "5", height: "5", rx: "1" }],
    ],
    kg = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" }],
      ["path", { d: "m7.9 7.9 2.7 2.7" }],
      ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor" }],
      ["path", { d: "m13.4 10.6 2.7-2.7" }],
      ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor" }],
      ["path", { d: "m7.9 16.1 2.7-2.7" }],
      ["circle", { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor" }],
      ["path", { d: "m13.4 13.4 2.7 2.7" }],
      ["circle", { cx: "12", cy: "12", r: "2" }],
    ],
    Pg = [
      ["path", { d: "M16 8q6 0 6-6-6 0-6 6" }],
      ["path", { d: "M17.41 3.59a10 10 0 1 0 3 3" }],
      ["path", { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14" }],
    ],
    Bg = [
      ["path", { d: "M18 11c-1.5 0-2.5.5-3 2" }],
      [
        "path",
        {
          d: "M4 6a2 2 0 0 0-2 2v4a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3a8 8 0 0 0-5 2 8 8 0 0 0-5-2z",
        },
      ],
      ["path", { d: "M6 11c1.5 0 2.5.5 3 2" }],
    ],
    Dg = [
      ["path", { d: "M10 20h4" }],
      ["path", { d: "M12 16v6" }],
      ["path", { d: "M17 2h4v4" }],
      ["path", { d: "m21 2-5.46 5.46" }],
      ["circle", { cx: "12", cy: "11", r: "5" }],
    ],
    Fg = [
      ["path", { d: "M12 15v7" }],
      ["path", { d: "M9 19h6" }],
      ["circle", { cx: "12", cy: "9", r: "6" }],
    ],
    zg = [
      ["path", { d: "m2 8 2 2-2 2 2 2-2 2" }],
      ["path", { d: "m22 8-2 2 2 2-2 2 2 2" }],
      ["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2" }],
      ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34" }],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    bg = [
      ["path", { d: "m2 8 2 2-2 2 2 2-2 2" }],
      ["path", { d: "m22 8-2 2 2 2-2 2 2 2" }],
      ["rect", { width: "8", height: "14", x: "8", y: "5", rx: "1" }],
    ],
    Rg = [
      [
        "path",
        {
          d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196",
        },
      ],
      ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2" }],
      ["path", { d: "m2 2 20 20" }],
    ],
    Tg = [
      [
        "path",
        {
          d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
        },
      ],
      ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2" }],
    ],
    qg = [
      ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
      ["path", { d: "M2 8h20" }],
      ["circle", { cx: "8", cy: "14", r: "2" }],
      ["path", { d: "M8 12h8" }],
      ["circle", { cx: "16", cy: "14", r: "2" }],
    ],
    Ug = [
      ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2" }],
      ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2" }],
      ["circle", { cx: "12", cy: "12", r: "1" }],
      [
        "path",
        {
          d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
        },
      ],
    ],
    Og = [
      ["circle", { cx: "6", cy: "12", r: "4" }],
      ["circle", { cx: "18", cy: "12", r: "4" }],
      ["line", { x1: "6", x2: "18", y1: "16", y2: "16" }],
    ],
    Zg = [
      ["path", { d: "M11.1 7.1a16.55 16.55 0 0 1 10.9 4" }],
      ["path", { d: "M12 12a12.6 12.6 0 0 1-8.7 5" }],
      ["path", { d: "M16.8 13.6a16.55 16.55 0 0 1-9 7.5" }],
      ["path", { d: "M20.7 17a12.8 12.8 0 0 0-8.7-5 13.3 13.3 0 0 1 0-10" }],
      ["path", { d: "M6.3 3.8a16.55 16.55 0 0 0 1.9 11.5" }],
      ["circle", { cx: "12", cy: "12", r: "10" }],
    ],
    Gg = [
      [
        "path",
        {
          d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
        },
      ],
      ["path", { d: "M16 9a5 5 0 0 1 0 6" }],
    ],
    Ig = [
      [
        "path",
        {
          d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
        },
      ],
      ["path", { d: "M16 9a5 5 0 0 1 0 6" }],
      ["path", { d: "M19.364 18.364a9 9 0 0 0 0-12.728" }],
    ],
    Wg = [
      ["path", { d: "M16 9a5 5 0 0 1 .95 2.293" }],
      ["path", { d: "M19.364 5.636a9 9 0 0 1 1.889 9.96" }],
      ["path", { d: "m2 2 20 20" }],
      [
        "path",
        {
          d: "m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11",
        },
      ],
      ["path", { d: "M9.828 4.172A.686.686 0 0 1 11 4.657v.686" }],
    ],
    Eg = [
      [
        "path",
        {
          d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
        },
      ],
      ["line", { x1: "22", x2: "16", y1: "9", y2: "15" }],
      ["line", { x1: "16", x2: "22", y1: "9", y2: "15" }],
    ],
    Xg = [
      [
        "path",
        {
          d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
        },
      ],
    ],
    jg = [
      ["path", { d: "m9 12 2 2 4-4" }],
      ["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z" }],
      ["path", { d: "M22 19H2" }],
    ],
    Ng = [
      ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2" }],
      [
        "path",
        {
          d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
        },
      ],
    ],
    pa = [
      ["path", { d: "M17 14h.01" }],
      [
        "path",
        {
          d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
        },
      ],
    ],
    Kg = [
      [
        "path",
        {
          d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
        },
      ],
      ["path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" }],
    ],
    Qg = [
      ["path", { d: "M12 17v4" }],
      ["path", { d: "M8 21h8" }],
      ["path", { d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15" }],
      ["circle", { cx: "8", cy: "9", r: "2" }],
      ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2" }],
    ],
    ia = [
      [
        "path",
        {
          d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
        },
      ],
      ["path", { d: "m14 7 3 3" }],
      ["path", { d: "M5 6v4" }],
      ["path", { d: "M19 14v4" }],
      ["path", { d: "M10 2v2" }],
      ["path", { d: "M7 8H3" }],
      ["path", { d: "M21 16h-4" }],
      ["path", { d: "M11 3H9" }],
    ],
    Jg = [
      ["path", { d: "M15 4V2" }],
      ["path", { d: "M15 16v-2" }],
      ["path", { d: "M8 9h2" }],
      ["path", { d: "M20 9h2" }],
      ["path", { d: "M17.8 11.8 19 13" }],
      ["path", { d: "M15 9h.01" }],
      ["path", { d: "M17.8 6.2 19 5" }],
      ["path", { d: "m3 21 9-9" }],
      ["path", { d: "M12.2 6.2 11 5" }],
    ],
    Yg = [
      ["path", { d: "M18 21V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v11" }],
      [
        "path",
        {
          d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 1.132-1.803l7.95-3.974a2 2 0 0 1 1.837 0l7.948 3.974A2 2 0 0 1 22 8z",
        },
      ],
      ["path", { d: "M6 13h12" }],
      ["path", { d: "M6 17h12" }],
    ],
    _g = [
      ["path", { d: "M3 6h3" }],
      ["path", { d: "M17 6h.01" }],
      ["rect", { width: "18", height: "20", x: "3", y: "2", rx: "2" }],
      ["circle", { cx: "12", cy: "13", r: "5" }],
      ["path", { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5" }],
    ],
    xg = [
      ["path", { d: "M12 10v2.2l1.6 1" }],
      [
        "path",
        {
          d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05",
        },
      ],
      [
        "path",
        {
          d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05",
        },
      ],
      ["circle", { cx: "12", cy: "12", r: "6" }],
    ],
    au = [
      ["path", { d: "M19 5a2 2 0 0 0-2 2v11" }],
      [
        "path",
        {
          d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        },
      ],
      ["path", { d: "M7 13h10" }],
      ["path", { d: "M7 9h10" }],
      ["path", { d: "M9 5a2 2 0 0 0-2 2v11" }],
    ],
    tu = [
      [
        "path",
        {
          d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        },
      ],
      [
        "path",
        {
          d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        },
      ],
      [
        "path",
        {
          d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        },
      ],
    ],
    hu = [
      ["circle", { cx: "12", cy: "4.5", r: "2.5" }],
      ["path", { d: "m10.2 6.3-3.9 3.9" }],
      ["circle", { cx: "4.5", cy: "12", r: "2.5" }],
      ["path", { d: "M7 12h10" }],
      ["circle", { cx: "19.5", cy: "12", r: "2.5" }],
      ["path", { d: "m13.8 17.7 3.9-3.9" }],
      ["circle", { cx: "12", cy: "19.5", r: "2.5" }],
    ],
    du = [
      ["circle", { cx: "12", cy: "10", r: "8" }],
      ["circle", { cx: "12", cy: "10", r: "3" }],
      ["path", { d: "M7 22h10" }],
      ["path", { d: "M12 22v-4" }],
    ],
    cu = [
      ["circle", { cx: "12", cy: "5", r: "3" }],
      [
        "path",
        {
          d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
        },
      ],
    ],
    Mu = [
      ["path", { d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15" }],
      ["path", { d: "M9 3.4a4 4 0 0 1 6.52.66" }],
      ["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05" }],
      ["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7" }],
      ["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414" }],
      ["path", { d: "m12 6 .6 1" }],
      ["path", { d: "m2 2 20 20" }],
    ],
    pu = [
      [
        "path",
        {
          d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
        },
      ],
      [
        "path",
        { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06" },
      ],
      ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8" }],
    ],
    iu = [
      ["path", { d: "m2 22 10-10" }],
      ["path", { d: "m16 8-1.17 1.17" }],
      [
        "path",
        {
          d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
        },
      ],
      [
        "path",
        {
          d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97",
        },
      ],
      [
        "path",
        {
          d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62",
        },
      ],
      ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z" }],
      [
        "path",
        {
          d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
        },
      ],
      [
        "path",
        {
          d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
        },
      ],
      [
        "path",
        {
          d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
        },
      ],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    nu = [
      ["path", { d: "M2 22 16 8" }],
      [
        "path",
        {
          d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
        },
      ],
      [
        "path",
        {
          d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
        },
      ],
      [
        "path",
        {
          d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
        },
      ],
      ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z" }],
      [
        "path",
        {
          d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
        },
      ],
      [
        "path",
        {
          d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
        },
      ],
      [
        "path",
        {
          d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
        },
      ],
    ],
    lu = [
      ["circle", { cx: "7", cy: "12", r: "3" }],
      ["path", { d: "M10 9v6" }],
      ["circle", { cx: "17", cy: "12", r: "3" }],
      ["path", { d: "M14 7v8" }],
      ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1" }],
    ],
    eu = [
      ["path", { d: "m14.305 19.53.923-.382" }],
      ["path", { d: "m15.228 16.852-.923-.383" }],
      ["path", { d: "m16.852 15.228-.383-.923" }],
      ["path", { d: "m16.852 20.772-.383.924" }],
      ["path", { d: "m19.148 15.228.383-.923" }],
      ["path", { d: "m19.53 21.696-.382-.924" }],
      ["path", { d: "M2 7.82a15 15 0 0 1 20 0" }],
      ["path", { d: "m20.772 16.852.924-.383" }],
      ["path", { d: "m20.772 19.148.924.383" }],
      ["path", { d: "M5 11.858a10 10 0 0 1 11.5-1.785" }],
      ["path", { d: "M8.5 15.429a5 5 0 0 1 2.413-1.31" }],
      ["circle", { cx: "18", cy: "18", r: "3" }],
    ],
    ru = [
      ["path", { d: "M12 20h.01" }],
      ["path", { d: "M5 12.859a10 10 0 0 1 14 0" }],
      ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0" }],
    ],
    ou = [
      ["path", { d: "M12 20h.01" }],
      ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0" }],
    ],
    vu = [
      ["path", { d: "M2 8.82a15 15 0 0 1 20 0" }],
      [
        "path",
        {
          d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
        },
      ],
      ["path", { d: "M5 12.859a10 10 0 0 1 10.5-2.222" }],
      ["path", { d: "M8.5 16.429a5 5 0 0 1 3-1.406" }],
    ],
    $u = [
      ["path", { d: "M11.965 10.105v4L13.5 12.5a5 5 0 0 1 8 1.5" }],
      ["path", { d: "M11.965 14.105h4" }],
      ["path", { d: "M17.965 18.105h4L20.43 19.71a5 5 0 0 1-8-1.5" }],
      ["path", { d: "M2 8.82a15 15 0 0 1 20 0" }],
      ["path", { d: "M21.965 22.105v-4" }],
      ["path", { d: "M5 12.86a10 10 0 0 1 3-2.032" }],
      ["path", { d: "M8.5 16.429h.01" }],
    ],
    mu = [
      ["path", { d: "M12 20h.01" }],
      ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0" }],
      ["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69" }],
      ["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523" }],
      ["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643" }],
      ["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764" }],
      ["path", { d: "m2 2 20 20" }],
    ],
    yu = [["path", { d: "M12 20h.01" }]],
    su = [
      ["path", { d: "M12 20h.01" }],
      ["path", { d: "M2 8.82a15 15 0 0 1 20 0" }],
      ["path", { d: "M5 12.859a10 10 0 0 1 14 0" }],
      ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0" }],
    ],
    gu = [
      ["path", { d: "M10 2v8" }],
      ["path", { d: "M12.8 21.6A2 2 0 1 0 14 18H2" }],
      ["path", { d: "M17.5 10a2.5 2.5 0 1 1 2 4H2" }],
      ["path", { d: "m6 6 4 4 4-4" }],
    ],
    uu = [
      ["path", { d: "M12.8 19.6A2 2 0 1 0 14 16H2" }],
      ["path", { d: "M17.5 8a2.5 2.5 0 1 1 2 4H2" }],
      ["path", { d: "M9.8 4.4A2 2 0 1 1 11 8H2" }],
    ],
    Cu = [
      ["path", { d: "M8 22h8" }],
      ["path", { d: "M7 10h3m7 0h-1.343" }],
      ["path", { d: "M12 15v7" }],
      [
        "path",
        {
          d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
        },
      ],
      ["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
    ],
    Hu = [
      ["path", { d: "M8 22h8" }],
      ["path", { d: "M7 10h10" }],
      ["path", { d: "M12 15v7" }],
      [
        "path",
        {
          d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z",
        },
      ],
    ],
    Au = [
      ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2" }],
      ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4" }],
      ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2" }],
    ],
    wu = [
      ["path", { d: "m19 12-1.5 3" }],
      ["path", { d: "M19.63 18.81 22 20" }],
      [
        "path",
        {
          d: "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z",
        },
      ],
    ],
    Vu = [
      [
        "path",
        {
          d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
        },
      ],
    ],
    Su = [
      ["path", { d: "M18 6 6 18" }],
      ["path", { d: "m6 6 12 12" }],
    ],
    Lu = [
      [
        "path",
        {
          d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
        },
      ],
      ["path", { d: "m10 15 5-3-5-3z" }],
    ],
    fu = [
      [
        "path",
        { d: "M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317" },
      ],
      ["path", { d: "M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773" }],
      [
        "path",
        {
          d: "M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643",
        },
      ],
      ["path", { d: "m2 2 20 20" }],
    ],
    ku = [
      [
        "path",
        {
          d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
        },
      ],
    ],
    Pu = [
      ["circle", { cx: "11", cy: "11", r: "8" }],
      ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65" }],
      ["line", { x1: "11", x2: "11", y1: "8", y2: "14" }],
      ["line", { x1: "8", x2: "14", y1: "11", y2: "11" }],
    ],
    Bu = [
      ["circle", { cx: "11", cy: "11", r: "8" }],
      ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65" }],
      ["line", { x1: "8", x2: "14", y1: "11", y2: "11" }],
    ];
  var Du = Object.freeze({
    __proto__: null,
    AArrowDown: oa,
    AArrowUp: va,
    ALargeSmall: $a,
    Accessibility: ma,
    Activity: ya,
    ActivitySquare: G2,
    AirVent: sa,
    Airplay: ga,
    AlarmCheck: y,
    AlarmClock: Ca,
    AlarmClockCheck: y,
    AlarmClockMinus: s,
    AlarmClockOff: ua,
    AlarmClockPlus: g,
    AlarmMinus: s,
    AlarmPlus: g,
    AlarmSmoke: Ha,
    Album: Aa,
    AlertCircle: N,
    AlertOctagon: y2,
    AlertTriangle: K0,
    AlignCenter: Z0,
    AlignCenterHorizontal: wa,
    AlignCenterVertical: Va,
    AlignEndHorizontal: Sa,
    AlignEndVertical: La,
    AlignHorizontalDistributeCenter: fa,
    AlignHorizontalDistributeEnd: ka,
    AlignHorizontalDistributeStart: Pa,
    AlignHorizontalJustifyCenter: Ba,
    AlignHorizontalJustifyEnd: Da,
    AlignHorizontalJustifyStart: Fa,
    AlignHorizontalSpaceAround: za,
    AlignHorizontalSpaceBetween: ba,
    AlignJustify: I0,
    AlignLeft: m,
    AlignRight: G0,
    AlignStartHorizontal: Ra,
    AlignStartVertical: Ta,
    AlignVerticalDistributeCenter: qa,
    AlignVerticalDistributeEnd: Ua,
    AlignVerticalDistributeStart: Oa,
    AlignVerticalJustifyCenter: Za,
    AlignVerticalJustifyEnd: Ga,
    AlignVerticalJustifyStart: Ia,
    AlignVerticalSpaceAround: Wa,
    AlignVerticalSpaceBetween: Ea,
    Ambulance: ja,
    Ampersand: Xa,
    Ampersands: Na,
    Amphora: Ka,
    Anchor: Qa,
    Angry: Ja,
    Annoyed: Ya,
    Antenna: _a,
    Anvil: xa,
    Aperture: at,
    AppWindow: ht,
    AppWindowMac: tt,
    Apple: dt,
    Archive: pt,
    ArchiveRestore: ct,
    ArchiveX: Mt,
    AreaChart: z,
    Armchair: it,
    ArrowBigDown: lt,
    ArrowBigDownDash: nt,
    ArrowBigLeft: rt,
    ArrowBigLeftDash: et,
    ArrowBigRight: vt,
    ArrowBigRightDash: ot,
    ArrowBigUp: st,
    ArrowBigUpDash: $t,
    ArrowDown: St,
    ArrowDown01: mt,
    ArrowDown10: yt,
    ArrowDownAZ: u,
    ArrowDownAz: u,
    ArrowDownCircle: K,
    ArrowDownFromLine: gt,
    ArrowDownLeft: Ct,
    ArrowDownLeftFromCircle: J,
    ArrowDownLeftFromSquare: j2,
    ArrowDownLeftSquare: I2,
    ArrowDownNarrowWide: ut,
    ArrowDownRight: At,
    ArrowDownRightFromCircle: _,
    ArrowDownRightFromSquare: N2,
    ArrowDownRightSquare: W2,
    ArrowDownSquare: E2,
    ArrowDownToDot: Ht,
    ArrowDownToLine: wt,
    ArrowDownUp: Vt,
    ArrowDownWideNarrow: C,
    ArrowDownZA: H,
    ArrowDownZa: H,
    ArrowLeft: Pt,
    ArrowLeftCircle: Q,
    ArrowLeftFromLine: Lt,
    ArrowLeftRight: ft,
    ArrowLeftSquare: X2,
    ArrowLeftToLine: kt,
    ArrowRight: zt,
    ArrowRightCircle: a1,
    ArrowRightFromLine: Bt,
    ArrowRightLeft: Ft,
    ArrowRightSquare: J2,
    ArrowRightToLine: Dt,
    ArrowUp: Wt,
    ArrowUp01: bt,
    ArrowUp10: Rt,
    ArrowUpAZ: A,
    ArrowUpAz: A,
    ArrowUpCircle: t1,
    ArrowUpDown: Tt,
    ArrowUpFromDot: Ut,
    ArrowUpFromLine: qt,
    ArrowUpLeft: Ot,
    ArrowUpLeftFromCircle: Y,
    ArrowUpLeftFromSquare: K2,
    ArrowUpLeftSquare: Y2,
    ArrowUpNarrowWide: w,
    ArrowUpRight: Zt,
    ArrowUpRightFromCircle: x,
    ArrowUpRightFromSquare: Q2,
    ArrowUpRightSquare: _2,
    ArrowUpSquare: x2,
    ArrowUpToLine: It,
    ArrowUpWideNarrow: Gt,
    ArrowUpZA: V,
    ArrowUpZa: V,
    ArrowsUpFromLine: Et,
    Asterisk: Xt,
    AsteriskSquare: a0,
    AtSign: jt,
    Atom: Qt,
    AudioLines: Nt,
    AudioWaveform: Kt,
    Award: Jt,
    Axe: Yt,
    Axis3D: S,
    Axis3d: S,
    Baby: _t,
    Backpack: xt,
    Badge: mh,
    BadgeAlert: ah,
    BadgeCent: th,
    BadgeCheck: L,
    BadgeDollarSign: hh,
    BadgeEuro: dh,
    BadgeHelp: f,
    BadgeIndianRupee: ch,
    BadgeInfo: Mh,
    BadgeJapaneseYen: ph,
    BadgeMinus: ih,
    BadgePercent: nh,
    BadgePlus: lh,
    BadgePoundSterling: eh,
    BadgeQuestionMark: f,
    BadgeRussianRuble: rh,
    BadgeSwissFranc: oh,
    BadgeTurkishLira: vh,
    BadgeX: $h,
    BaggageClaim: yh,
    Ban: sh,
    Banana: gh,
    Bandage: uh,
    Banknote: wh,
    BanknoteArrowDown: Ch,
    BanknoteArrowUp: Hh,
    BanknoteX: Ah,
    BarChart: G,
    BarChart2: I,
    BarChart3: O,
    BarChart4: U,
    BarChartBig: q,
    BarChartHorizontal: T,
    BarChartHorizontalBig: b,
    Barcode: Vh,
    Barrel: Sh,
    Baseline: Lh,
    Bath: fh,
    Battery: bh,
    BatteryCharging: kh,
    BatteryFull: Ph,
    BatteryLow: Bh,
    BatteryMedium: Dh,
    BatteryPlus: Fh,
    BatteryWarning: zh,
    Beaker: Rh,
    Bean: qh,
    BeanOff: Th,
    Bed: Zh,
    BedDouble: Uh,
    BedSingle: Oh,
    Beef: Gh,
    Beer: Wh,
    BeerOff: Ih,
    Bell: Jh,
    BellDot: Eh,
    BellElectric: Xh,
    BellMinus: jh,
    BellOff: Nh,
    BellPlus: Kh,
    BellRing: Qh,
    BetweenHorizonalEnd: k,
    BetweenHorizonalStart: P,
    BetweenHorizontalEnd: k,
    BetweenHorizontalStart: P,
    BetweenVerticalEnd: Yh,
    BetweenVerticalStart: _h,
    BicepsFlexed: xh,
    Bike: a4,
    Binary: t4,
    Binoculars: h4,
    Biohazard: d4,
    Bird: c4,
    Bitcoin: p4,
    Blend: M4,
    Blinds: n4,
    Blocks: i4,
    Bluetooth: r4,
    BluetoothConnected: l4,
    BluetoothOff: o4,
    BluetoothSearching: e4,
    Bold: v4,
    Bolt: $4,
    Bomb: m4,
    Bone: y4,
    Book: Z4,
    BookA: s4,
    BookAlert: g4,
    BookAudio: u4,
    BookCheck: C4,
    BookCopy: H4,
    BookDashed: B,
    BookDown: A4,
    BookHeadphones: w4,
    BookHeart: V4,
    BookImage: S4,
    BookKey: L4,
    BookLock: f4,
    BookMarked: k4,
    BookMinus: P4,
    BookOpen: F4,
    BookOpenCheck: B4,
    BookOpenText: D4,
    BookPlus: z4,
    BookTemplate: B,
    BookText: b4,
    BookType: T4,
    BookUp: q4,
    BookUp2: R4,
    BookUser: U4,
    BookX: O4,
    Bookmark: X4,
    BookmarkCheck: G4,
    BookmarkMinus: I4,
    BookmarkPlus: W4,
    BookmarkX: E4,
    BoomBox: j4,
    Bot: Q4,
    BotMessageSquare: K4,
    BotOff: N4,
    BottleWine: J4,
    BowArrow: Y4,
    Box: _4,
    BoxSelect: r0,
    Boxes: x4,
    Braces: D,
    Brackets: a5,
    Brain: d5,
    BrainCircuit: t5,
    BrainCog: h5,
    BrickWall: p5,
    BrickWallFire: c5,
    BrickWallShield: M5,
    Briefcase: e5,
    BriefcaseBusiness: i5,
    BriefcaseConveyorBelt: n5,
    BriefcaseMedical: l5,
    BringToFront: r5,
    Brush: v5,
    BrushCleaning: o5,
    Bubbles: $5,
    Bug: s5,
    BugOff: m5,
    BugPlay: y5,
    Building: u5,
    Building2: g5,
    Bus: H5,
    BusFront: C5,
    Cable: w5,
    CableCar: A5,
    Cake: S5,
    CakeSlice: V5,
    Calculator: L5,
    Calendar: N5,
    Calendar1: f5,
    CalendarArrowDown: k5,
    CalendarArrowUp: P5,
    CalendarCheck: D5,
    CalendarCheck2: B5,
    CalendarClock: F5,
    CalendarCog: R5,
    CalendarDays: z5,
    CalendarFold: b5,
    CalendarHeart: T5,
    CalendarMinus: U5,
    CalendarMinus2: q5,
    CalendarOff: O5,
    CalendarPlus: Z5,
    CalendarPlus2: I5,
    CalendarRange: G5,
    CalendarSearch: E5,
    CalendarSync: W5,
    CalendarX: j5,
    CalendarX2: X5,
    Camera: Q5,
    CameraOff: K5,
    CandlestickChart: R,
    Candy: _5,
    CandyCane: J5,
    CandyOff: Y5,
    Cannabis: x5,
    Captions: F,
    CaptionsOff: a3,
    Car: d3,
    CarFront: t3,
    CarTaxiFront: h3,
    Caravan: c3,
    CardSim: M3,
    Carrot: p3,
    CaseLower: i3,
    CaseSensitive: n3,
    CaseUpper: l3,
    CassetteTape: e3,
    Cast: r3,
    Castle: o3,
    Cat: v3,
    Cctv: $3,
    ChartArea: z,
    ChartBar: T,
    ChartBarBig: b,
    ChartBarDecreasing: m3,
    ChartBarIncreasing: y3,
    ChartBarStacked: s3,
    ChartCandlestick: R,
    ChartColumn: O,
    ChartColumnBig: q,
    ChartColumnDecreasing: g3,
    ChartColumnIncreasing: U,
    ChartColumnStacked: u3,
    ChartGantt: C3,
    ChartLine: Z,
    ChartNetwork: H3,
    ChartNoAxesColumn: I,
    ChartNoAxesColumnDecreasing: A3,
    ChartNoAxesColumnIncreasing: G,
    ChartNoAxesCombined: w3,
    ChartNoAxesGantt: W,
    ChartPie: X,
    ChartScatter: E,
    ChartSpline: V3,
    Check: f3,
    CheckCheck: S3,
    CheckCircle: h1,
    CheckCircle2: d1,
    CheckLine: L3,
    CheckSquare: h0,
    CheckSquare2: d0,
    ChefHat: k3,
    Cherry: B3,
    ChevronDown: P3,
    ChevronDownCircle: c1,
    ChevronDownSquare: c0,
    ChevronFirst: D3,
    ChevronLast: F3,
    ChevronLeft: z3,
    ChevronLeftCircle: M1,
    ChevronLeftSquare: M0,
    ChevronRight: b3,
    ChevronRightCircle: p1,
    ChevronRightSquare: p0,
    ChevronUp: R3,
    ChevronUpCircle: i1,
    ChevronUpSquare: i0,
    ChevronsDown: q3,
    ChevronsDownUp: T3,
    ChevronsLeft: Z3,
    ChevronsLeftRight: O3,
    ChevronsLeftRightEllipsis: U3,
    ChevronsRight: I3,
    ChevronsRightLeft: G3,
    ChevronsUp: E3,
    ChevronsUpDown: W3,
    Chrome: j,
    Chromium: j,
    Church: X3,
    Cigarette: N3,
    CigaretteOff: j3,
    Circle: id,
    CircleAlert: N,
    CircleArrowDown: K,
    CircleArrowLeft: Q,
    CircleArrowOutDownLeft: J,
    CircleArrowOutDownRight: _,
    CircleArrowOutUpLeft: Y,
    CircleArrowOutUpRight: x,
    CircleArrowRight: a1,
    CircleArrowUp: t1,
    CircleCheck: d1,
    CircleCheckBig: h1,
    CircleChevronDown: c1,
    CircleChevronLeft: M1,
    CircleChevronRight: p1,
    CircleChevronUp: i1,
    CircleDashed: K3,
    CircleDivide: n1,
    CircleDollarSign: Q3,
    CircleDot: Y3,
    CircleDotDashed: J3,
    CircleEllipsis: _3,
    CircleEqual: x3,
    CircleFadingArrowUp: ad,
    CircleFadingPlus: td,
    CircleGauge: l1,
    CircleHelp: l,
    CircleMinus: e1,
    CircleOff: hd,
    CircleParking: o1,
    CircleParkingOff: r1,
    CirclePause: v1,
    CirclePercent: $1,
    CirclePlay: m1,
    CirclePlus: y1,
    CirclePoundSterling: dd,
    CirclePower: s1,
    CircleQuestionMark: l,
    CircleSlash: cd,
    CircleSlash2: g1,
    CircleSlashed: g1,
    CircleSmall: Md,
    CircleStar: pd,
    CircleStop: u1,
    CircleUser: H1,
    CircleUserRound: C1,
    CircleX: A1,
    CircuitBoard: nd,
    Citrus: ld,
    Clapperboard: ed,
    Clipboard: Cd,
    ClipboardCheck: rd,
    ClipboardClock: od,
    ClipboardCopy: vd,
    ClipboardEdit: V1,
    ClipboardList: $d,
    ClipboardMinus: md,
    ClipboardPaste: yd,
    ClipboardPen: V1,
    ClipboardPenLine: w1,
    ClipboardPlus: sd,
    ClipboardSignature: w1,
    ClipboardType: gd,
    ClipboardX: ud,
    Clock: Ud,
    Clock1: Hd,
    Clock10: Ad,
    Clock11: wd,
    Clock12: Vd,
    Clock2: Sd,
    Clock3: Ld,
    Clock4: fd,
    Clock5: kd,
    Clock6: Pd,
    Clock7: Bd,
    Clock8: Dd,
    Clock9: Fd,
    ClockAlert: zd,
    ClockArrowDown: bd,
    ClockArrowUp: Rd,
    ClockFading: Td,
    ClockPlus: qd,
    ClosedCaption: Od,
    Cloud: t6,
    CloudAlert: Zd,
    CloudCheck: Gd,
    CloudCog: Id,
    CloudDownload: S1,
    CloudDrizzle: Wd,
    CloudFog: Ed,
    CloudHail: Xd,
    CloudLightning: Nd,
    CloudMoon: Kd,
    CloudMoonRain: jd,
    CloudOff: Qd,
    CloudRain: Yd,
    CloudRainWind: Jd,
    CloudSnow: _d,
    CloudSun: a6,
    CloudSunRain: xd,
    CloudUpload: L1,
    Cloudy: h6,
    Clover: d6,
    Club: c6,
    Code: p6,
    Code2: f1,
    CodeSquare: n0,
    CodeXml: f1,
    Codepen: M6,
    Codesandbox: i6,
    Coffee: n6,
    Cog: l6,
    Coins: e6,
    Columns: k1,
    Columns2: k1,
    Columns3: P1,
    Columns3Cog: e,
    Columns4: r6,
    ColumnsSettings: e,
    Combine: o6,
    Command: v6,
    Compass: $6,
    Component: m6,
    Computer: y6,
    ConciergeBell: s6,
    Cone: g6,
    Construction: u6,
    Contact: C6,
    Contact2: B1,
    ContactRound: B1,
    Container: H6,
    Contrast: A6,
    Cookie: w6,
    CookingPot: V6,
    Copy: B6,
    CopyCheck: S6,
    CopyMinus: L6,
    CopyPlus: f6,
    CopySlash: k6,
    CopyX: P6,
    Copyleft: D6,
    Copyright: F6,
    CornerDownLeft: b6,
    CornerDownRight: z6,
    CornerLeftDown: R6,
    CornerLeftUp: T6,
    CornerRightDown: q6,
    CornerRightUp: U6,
    CornerUpLeft: G6,
    CornerUpRight: O6,
    Cpu: Z6,
    CreativeCommons: I6,
    CreditCard: W6,
    Croissant: E6,
    Crop: X6,
    Cross: j6,
    Crosshair: N6,
    Crown: K6,
    Cuboid: Q6,
    CupSoda: J6,
    CurlyBraces: D,
    Currency: Y6,
    Cylinder: _6,
    Dam: x6,
    Database: h8,
    DatabaseBackup: a8,
    DatabaseZap: t8,
    DecimalsArrowLeft: d8,
    DecimalsArrowRight: c8,
    Delete: M8,
    Dessert: p8,
    Diameter: i8,
    Diamond: e8,
    DiamondMinus: n8,
    DiamondPercent: D1,
    DiamondPlus: l8,
    Dice1: r8,
    Dice2: o8,
    Dice3: v8,
    Dice4: $8,
    Dice5: m8,
    Dice6: y8,
    Dices: s8,
    Diff: g8,
    Disc: A8,
    Disc2: u8,
    Disc3: C8,
    DiscAlbum: H8,
    Divide: w8,
    DivideCircle: n1,
    DivideSquare: o0,
    Dna: S8,
    DnaOff: V8,
    Dock: L8,
    Dog: f8,
    DollarSign: k8,
    Donut: P8,
    DoorClosed: D8,
    DoorClosedLocked: B8,
    DoorOpen: F8,
    Dot: z8,
    DotSquare: v0,
    Download: b8,
    DownloadCloud: S1,
    DraftingCompass: R8,
    Drama: T8,
    Dribbble: q8,
    Drill: U8,
    Drone: O8,
    Droplet: G8,
    DropletOff: Z8,
    Droplets: I8,
    Drum: W8,
    Drumstick: E8,
    Dumbbell: X8,
    Ear: j8,
    EarOff: N8,
    Earth: F1,
    EarthLock: K8,
    Eclipse: Q8,
    Edit: p,
    Edit2: P2,
    Edit3: k2,
    Egg: Y8,
    EggFried: J8,
    EggOff: _8,
    Ellipsis: b1,
    EllipsisVertical: z1,
    Equal: tc,
    EqualApproximately: x8,
    EqualNot: ac,
    EqualSquare: $0,
    Eraser: dc,
    EthernetPort: hc,
    Euro: cc,
    EvCharger: Mc,
    Expand: pc,
    ExternalLink: ic,
    Eye: ec,
    EyeClosed: nc,
    EyeOff: lc,
    Facebook: rc,
    Factory: oc,
    Fan: vc,
    FastForward: $c,
    Feather: mc,
    Fence: yc,
    FerrisWheel: sc,
    Figma: gc,
    File: o7,
    FileArchive: uc,
    FileAudio: Hc,
    FileAudio2: Cc,
    FileAxis3D: R1,
    FileAxis3d: R1,
    FileBadge: wc,
    FileBadge2: Ac,
    FileBarChart: T1,
    FileBarChart2: q1,
    FileBox: Vc,
    FileChartColumn: q1,
    FileChartColumnIncreasing: T1,
    FileChartLine: U1,
    FileChartPie: O1,
    FileCheck: Lc,
    FileCheck2: Sc,
    FileClock: fc,
    FileCode: Pc,
    FileCode2: kc,
    FileCog: Z1,
    FileCog2: Z1,
    FileDiff: Bc,
    FileDigit: Dc,
    FileDown: Fc,
    FileEdit: I1,
    FileHeart: zc,
    FileImage: bc,
    FileInput: Rc,
    FileJson: qc,
    FileJson2: Tc,
    FileKey: Oc,
    FileKey2: Uc,
    FileLineChart: U1,
    FileLock: Gc,
    FileLock2: Zc,
    FileMinus: Wc,
    FileMinus2: Ic,
    FileMusic: Ec,
    FileOutput: Xc,
    FilePen: I1,
    FilePenLine: G1,
    FilePieChart: O1,
    FilePlay: W1,
    FilePlus: Nc,
    FilePlus2: jc,
    FileQuestion: E1,
    FileQuestionMark: E1,
    FileScan: Kc,
    FileSearch: Jc,
    FileSearch2: Qc,
    FileSignature: G1,
    FileSliders: Yc,
    FileSpreadsheet: _c,
    FileStack: xc,
    FileSymlink: a7,
    FileTerminal: t7,
    FileText: h7,
    FileType: c7,
    FileType2: d7,
    FileUp: M7,
    FileUser: p7,
    FileVideo: W1,
    FileVideo2: X1,
    FileVideoCamera: X1,
    FileVolume: n7,
    FileVolume2: i7,
    FileWarning: l7,
    FileX: r7,
    FileX2: e7,
    Files: v7,
    Film: $7,
    Filter: K1,
    FilterX: Q1,
    Fingerprint: y7,
    FireExtinguisher: m7,
    Fish: u7,
    FishOff: s7,
    FishSymbol: g7,
    Flag: w7,
    FlagOff: C7,
    FlagTriangleLeft: H7,
    FlagTriangleRight: A7,
    Flame: S7,
    FlameKindling: V7,
    Flashlight: f7,
    FlashlightOff: L7,
    FlaskConical: P7,
    FlaskConicalOff: k7,
    FlaskRound: B7,
    FlipHorizontal: F7,
    FlipHorizontal2: D7,
    FlipVertical: b7,
    FlipVertical2: z7,
    Flower: T7,
    Flower2: R7,
    Focus: q7,
    FoldHorizontal: U7,
    FoldVertical: O7,
    Folder: vM,
    FolderArchive: G7,
    FolderCheck: Z7,
    FolderClock: I7,
    FolderClosed: E7,
    FolderCode: W7,
    FolderCog: j1,
    FolderCog2: j1,
    FolderDot: X7,
    FolderDown: j7,
    FolderEdit: N1,
    FolderGit: K7,
    FolderGit2: N7,
    FolderHeart: Q7,
    FolderInput: J7,
    FolderKanban: _7,
    FolderKey: Y7,
    FolderLock: aM,
    FolderMinus: x7,
    FolderOpen: hM,
    FolderOpenDot: tM,
    FolderOutput: dM,
    FolderPen: N1,
    FolderPlus: cM,
    FolderRoot: MM,
    FolderSearch: iM,
    FolderSearch2: pM,
    FolderSymlink: nM,
    FolderSync: lM,
    FolderTree: eM,
    FolderUp: rM,
    FolderX: oM,
    Folders: $M,
    Footprints: mM,
    ForkKnife: Ma,
    ForkKnifeCrossed: ca,
    Forklift: yM,
    FormInput: D2,
    Forward: sM,
    Frame: gM,
    Framer: uM,
    Frown: CM,
    Fuel: HM,
    Fullscreen: AM,
    FunctionSquare: m0,
    Funnel: K1,
    FunnelPlus: wM,
    FunnelX: Q1,
    GalleryHorizontal: SM,
    GalleryHorizontalEnd: VM,
    GalleryThumbnails: LM,
    GalleryVertical: kM,
    GalleryVerticalEnd: fM,
    Gamepad: BM,
    Gamepad2: PM,
    GanttChart: W,
    GanttChartSquare: $,
    Gauge: DM,
    GaugeCircle: l1,
    Gavel: FM,
    Gem: zM,
    GeorgianLari: bM,
    Ghost: qM,
    Gift: RM,
    GitBranch: UM,
    GitBranchPlus: TM,
    GitCommit: J1,
    GitCommitHorizontal: J1,
    GitCommitVertical: OM,
    GitCompare: GM,
    GitCompareArrows: ZM,
    GitFork: IM,
    GitGraph: WM,
    GitMerge: EM,
    GitPullRequest: JM,
    GitPullRequestArrow: XM,
    GitPullRequestClosed: jM,
    GitPullRequestCreate: KM,
    GitPullRequestCreateArrow: NM,
    GitPullRequestDraft: QM,
    Github: YM,
    Gitlab: _M,
    GlassWater: xM,
    Glasses: a9,
    Globe: t9,
    Globe2: F1,
    GlobeLock: h9,
    Goal: d9,
    Gpu: c9,
    Grab: t2,
    GraduationCap: M9,
    Grape: p9,
    Grid: r,
    Grid2X2: a2,
    Grid2X2Check: _1,
    Grid2X2Plus: Y1,
    Grid2X2X: x1,
    Grid2x2: a2,
    Grid2x2Check: _1,
    Grid2x2Plus: Y1,
    Grid2x2X: x1,
    Grid3X3: r,
    Grid3x2: i9,
    Grid3x3: r,
    Grip: e9,
    GripHorizontal: n9,
    GripVertical: l9,
    Group: r9,
    Guitar: v9,
    Ham: o9,
    Hamburger: $9,
    Hammer: m9,
    Hand: A9,
    HandCoins: y9,
    HandFist: s9,
    HandGrab: t2,
    HandHeart: g9,
    HandHelping: h2,
    HandMetal: u9,
    HandPlatter: C9,
    Handbag: H9,
    Handshake: w9,
    HardDrive: f9,
    HardDriveDownload: V9,
    HardDriveUpload: S9,
    HardHat: L9,
    Hash: k9,
    HatGlasses: P9,
    Haze: D9,
    HdmiPort: B9,
    Heading: U9,
    Heading1: F9,
    Heading2: z9,
    Heading3: R9,
    Heading4: b9,
    Heading5: T9,
    Heading6: q9,
    HeadphoneOff: O9,
    Headphones: Z9,
    Headset: G9,
    Heart: K9,
    HeartCrack: I9,
    HeartHandshake: W9,
    HeartMinus: E9,
    HeartOff: X9,
    HeartPlus: j9,
    HeartPulse: N9,
    Heater: Q9,
    HelpCircle: l,
    HelpingHand: h2,
    Hexagon: J9,
    Highlighter: Y9,
    History: _9,
    Home: d2,
    Hop: ap,
    HopOff: x9,
    Hospital: tp,
    Hotel: hp,
    Hourglass: dp,
    House: d2,
    HouseHeart: cp,
    HousePlug: Mp,
    HousePlus: pp,
    HouseWifi: ip,
    IceCream: c2,
    IceCream2: M2,
    IceCreamBowl: M2,
    IceCreamCone: c2,
    IdCard: lp,
    IdCardLanyard: np,
    Image: sp,
    ImageDown: ep,
    ImageMinus: rp,
    ImageOff: op,
    ImagePlay: vp,
    ImagePlus: $p,
    ImageUp: mp,
    ImageUpscale: yp,
    Images: gp,
    Import: up,
    Inbox: Hp,
    Indent: v,
    IndentDecrease: o,
    IndentIncrease: v,
    IndianRupee: Cp,
    Infinity: Ap,
    Info: wp,
    Inspect: H0,
    InspectionPanel: Vp,
    Instagram: Sp,
    Italic: Lp,
    IterationCcw: fp,
    IterationCw: kp,
    JapaneseYen: Pp,
    Joystick: Bp,
    Kanban: Dp,
    KanbanSquare: y0,
    KanbanSquareDashed: l0,
    Kayak: zp,
    Key: Rp,
    KeyRound: Fp,
    KeySquare: bp,
    Keyboard: Up,
    KeyboardMusic: Tp,
    KeyboardOff: qp,
    Lamp: Ep,
    LampCeiling: Op,
    LampDesk: Zp,
    LampFloor: Gp,
    LampWallDown: Ip,
    LampWallUp: Wp,
    LandPlot: Xp,
    Landmark: jp,
    Languages: Np,
    Laptop: Qp,
    Laptop2: p2,
    LaptopMinimal: p2,
    LaptopMinimalCheck: Kp,
    Lasso: Yp,
    LassoSelect: Jp,
    Laugh: _p,
    Layers: i2,
    Layers2: xp,
    Layers3: i2,
    Layout: f2,
    LayoutDashboard: ai,
    LayoutGrid: ti,
    LayoutList: hi,
    LayoutPanelLeft: di,
    LayoutPanelTop: Mi,
    LayoutTemplate: ci,
    Leaf: pi,
    LeafyGreen: ii,
    Lectern: ni,
    LetterText: W0,
    Library: ei,
    LibraryBig: li,
    LibrarySquare: s0,
    LifeBuoy: ri,
    Ligature: vi,
    Lightbulb: $i,
    LightbulbOff: oi,
    LineChart: Z,
    LineSquiggle: mi,
    Link: gi,
    Link2: si,
    Link2Off: yi,
    Linkedin: ui,
    List: qi,
    ListCheck: Ci,
    ListChecks: Hi,
    ListChevronsDownUp: Ai,
    ListChevronsUpDown: wi,
    ListCollapse: Vi,
    ListEnd: Si,
    ListFilter: fi,
    ListFilterPlus: Li,
    ListIndentDecrease: o,
    ListIndentIncrease: v,
    ListMinus: ki,
    ListMusic: Pi,
    ListOrdered: Bi,
    ListPlus: Di,
    ListRestart: Fi,
    ListStart: zi,
    ListTodo: bi,
    ListTree: Ti,
    ListVideo: Ri,
    ListX: Ui,
    Loader: Zi,
    Loader2: n2,
    LoaderCircle: n2,
    LoaderPinwheel: Oi,
    Locate: Wi,
    LocateFixed: Ii,
    LocateOff: Gi,
    LocationEdit: o2,
    Lock: Xi,
    LockKeyhole: Ei,
    LockKeyholeOpen: l2,
    LockOpen: e2,
    LogIn: Ni,
    LogOut: ji,
    Logs: Ki,
    Lollipop: Qi,
    Luggage: Ji,
    MSquare: g0,
    Magnet: Yi,
    Mail: Mn,
    MailCheck: _i,
    MailMinus: xi,
    MailOpen: an,
    MailPlus: tn,
    MailQuestion: r2,
    MailQuestionMark: r2,
    MailSearch: hn,
    MailWarning: dn,
    MailX: cn,
    Mailbox: pn,
    Mails: nn,
    Map: wn,
    MapMinus: ln,
    MapPin: Cn,
    MapPinCheck: rn,
    MapPinCheckInside: en,
    MapPinHouse: on,
    MapPinMinus: $n,
    MapPinMinusInside: vn,
    MapPinOff: mn,
    MapPinPen: o2,
    MapPinPlus: gn,
    MapPinPlusInside: yn,
    MapPinX: un,
    MapPinXInside: sn,
    MapPinned: Hn,
    MapPlus: An,
    Mars: Sn,
    MarsStroke: Vn,
    Martini: Ln,
    Maximize: kn,
    Maximize2: fn,
    Medal: Pn,
    Megaphone: Dn,
    MegaphoneOff: Bn,
    Meh: Fn,
    MemoryStick: zn,
    Menu: bn,
    MenuSquare: u0,
    Merge: Rn,
    MessageCircle: Xn,
    MessageCircleCode: Tn,
    MessageCircleDashed: qn,
    MessageCircleHeart: Un,
    MessageCircleMore: On,
    MessageCircleOff: Zn,
    MessageCirclePlus: Gn,
    MessageCircleQuestion: v2,
    MessageCircleQuestionMark: v2,
    MessageCircleReply: In,
    MessageCircleWarning: Wn,
    MessageCircleX: En,
    MessageSquare: il,
    MessageSquareCode: jn,
    MessageSquareDashed: Nn,
    MessageSquareDiff: Kn,
    MessageSquareDot: Qn,
    MessageSquareHeart: Jn,
    MessageSquareLock: _n,
    MessageSquareMore: Yn,
    MessageSquareOff: xn,
    MessageSquarePlus: al,
    MessageSquareQuote: tl,
    MessageSquareReply: hl,
    MessageSquareShare: dl,
    MessageSquareText: cl,
    MessageSquareWarning: Ml,
    MessageSquareX: pl,
    MessagesSquare: nl,
    Mic: el,
    Mic2: $2,
    MicOff: ll,
    MicVocal: $2,
    Microchip: rl,
    Microscope: ol,
    Microwave: vl,
    Milestone: $l,
    Milk: yl,
    MilkOff: ml,
    Minimize: gl,
    Minimize2: sl,
    Minus: ul,
    MinusCircle: e1,
    MinusSquare: C0,
    Monitor: zl,
    MonitorCheck: Cl,
    MonitorCog: Hl,
    MonitorDot: Al,
    MonitorDown: wl,
    MonitorOff: Vl,
    MonitorPause: Sl,
    MonitorPlay: Ll,
    MonitorSmartphone: fl,
    MonitorSpeaker: kl,
    MonitorStop: Pl,
    MonitorUp: Bl,
    MonitorX: Dl,
    Moon: bl,
    MoonStar: Fl,
    MoreHorizontal: b1,
    MoreVertical: z1,
    Motorbike: Rl,
    Mountain: ql,
    MountainSnow: Tl,
    Mouse: Wl,
    MouseOff: Ul,
    MousePointer: Il,
    MousePointer2: Ol,
    MousePointerBan: Zl,
    MousePointerClick: Gl,
    MousePointerSquareDashed: e0,
    Move: he,
    Move3D: m2,
    Move3d: m2,
    MoveDiagonal: Xl,
    MoveDiagonal2: El,
    MoveDown: Kl,
    MoveDownLeft: jl,
    MoveDownRight: Nl,
    MoveHorizontal: Ql,
    MoveLeft: Jl,
    MoveRight: Yl,
    MoveUp: ae,
    MoveUpLeft: xl,
    MoveUpRight: _l,
    MoveVertical: te,
    Music: pe,
    Music2: de,
    Music3: ce,
    Music4: Me,
    Navigation: ee,
    Navigation2: ne,
    Navigation2Off: ie,
    NavigationOff: le,
    Network: re,
    Newspaper: oe,
    Nfc: ve,
    NonBinary: $e,
    Notebook: ge,
    NotebookPen: me,
    NotebookTabs: ye,
    NotebookText: se,
    NotepadText: Ce,
    NotepadTextDashed: ue,
    Nut: Ae,
    NutOff: He,
    Octagon: Ve,
    OctagonAlert: y2,
    OctagonMinus: we,
    OctagonPause: s2,
    OctagonX: g2,
    Omega: Se,
    Option: fe,
    Orbit: Le,
    Origami: ke,
    Outdent: o,
    Package: Te,
    Package2: Pe,
    PackageCheck: Be,
    PackageMinus: De,
    PackageOpen: ze,
    PackagePlus: Fe,
    PackageSearch: be,
    PackageX: Re,
    PaintBucket: qe,
    PaintRoller: Ue,
    Paintbrush: Oe,
    Paintbrush2: u2,
    PaintbrushVertical: u2,
    Palette: Ze,
    Palmtree: N0,
    Panda: Ge,
    PanelBottom: Ee,
    PanelBottomClose: Ie,
    PanelBottomDashed: C2,
    PanelBottomInactive: C2,
    PanelBottomOpen: We,
    PanelLeft: V2,
    PanelLeftClose: H2,
    PanelLeftDashed: A2,
    PanelLeftInactive: A2,
    PanelLeftOpen: w2,
    PanelLeftRightDashed: Xe,
    PanelRight: Ke,
    PanelRightClose: je,
    PanelRightDashed: S2,
    PanelRightInactive: S2,
    PanelRightOpen: Ne,
    PanelTop: _e,
    PanelTopBottomDashed: Qe,
    PanelTopClose: Je,
    PanelTopDashed: L2,
    PanelTopInactive: L2,
    PanelTopOpen: Ye,
    PanelsLeftBottom: xe,
    PanelsLeftRight: P1,
    PanelsRightBottom: ar,
    PanelsTopBottom: b2,
    PanelsTopLeft: f2,
    Paperclip: hr,
    Parentheses: tr,
    ParkingCircle: o1,
    ParkingCircleOff: r1,
    ParkingMeter: dr,
    ParkingSquare: A0,
    ParkingSquareOff: w0,
    PartyPopper: cr,
    Pause: Mr,
    PauseCircle: v1,
    PauseOctagon: s2,
    PawPrint: pr,
    PcCase: nr,
    Pen: P2,
    PenBox: p,
    PenLine: k2,
    PenOff: ir,
    PenSquare: p,
    PenTool: lr,
    Pencil: vr,
    PencilLine: er,
    PencilOff: rr,
    PencilRuler: or,
    Pentagon: $r,
    Percent: mr,
    PercentCircle: $1,
    PercentDiamond: D1,
    PercentSquare: V0,
    PersonStanding: yr,
    PhilippinePeso: sr,
    Phone: Vr,
    PhoneCall: gr,
    PhoneForwarded: ur,
    PhoneIncoming: Cr,
    PhoneMissed: Hr,
    PhoneOff: Ar,
    PhoneOutgoing: wr,
    Pi: Sr,
    PiSquare: S0,
    Piano: Lr,
    Pickaxe: fr,
    PictureInPicture: Pr,
    PictureInPicture2: kr,
    PieChart: X,
    PiggyBank: Br,
    Pilcrow: zr,
    PilcrowLeft: Dr,
    PilcrowRight: Fr,
    PilcrowSquare: L0,
    Pill: Rr,
    PillBottle: br,
    Pin: qr,
    PinOff: Tr,
    Pipette: Ur,
    Pizza: Or,
    Plane: Ir,
    PlaneLanding: Zr,
    PlaneTakeoff: Gr,
    Play: Wr,
    PlayCircle: m1,
    PlaySquare: f0,
    Plug: Xr,
    Plug2: Er,
    PlugZap: B2,
    PlugZap2: B2,
    Plus: jr,
    PlusCircle: y1,
    PlusSquare: k0,
    Pocket: Kr,
    PocketKnife: Nr,
    Podcast: Yr,
    Pointer: Jr,
    PointerOff: Qr,
    Popcorn: _r,
    Popsicle: xr,
    PoundSterling: ao,
    Power: ho,
    PowerCircle: s1,
    PowerOff: to,
    PowerSquare: P0,
    Presentation: co,
    Printer: po,
    PrinterCheck: Mo,
    Projector: io,
    Proportions: no,
    Puzzle: lo,
    Pyramid: eo,
    QrCode: ro,
    Quote: oo,
    Rabbit: vo,
    Radar: $o,
    Radiation: mo,
    Radical: yo,
    Radio: uo,
    RadioReceiver: so,
    RadioTower: go,
    Radius: Ho,
    RailSymbol: Co,
    Rainbow: Ao,
    Rat: wo,
    Ratio: Vo,
    Receipt: zo,
    ReceiptCent: So,
    ReceiptEuro: Lo,
    ReceiptIndianRupee: fo,
    ReceiptJapaneseYen: ko,
    ReceiptPoundSterling: Po,
    ReceiptRussianRuble: Bo,
    ReceiptSwissFranc: Do,
    ReceiptText: Fo,
    ReceiptTurkishLira: bo,
    RectangleCircle: Ro,
    RectangleEllipsis: D2,
    RectangleGoggles: To,
    RectangleHorizontal: qo,
    RectangleVertical: Oo,
    Recycle: Uo,
    Redo: Io,
    Redo2: Zo,
    RedoDot: Go,
    RefreshCcw: Wo,
    RefreshCcwDot: Eo,
    RefreshCw: jo,
    RefreshCwOff: Xo,
    Refrigerator: No,
    Regex: Ko,
    RemoveFormatting: Qo,
    Repeat: _o,
    Repeat1: Yo,
    Repeat2: Jo,
    Replace: av,
    ReplaceAll: xo,
    Reply: hv,
    ReplyAll: tv,
    Rewind: dv,
    Ribbon: cv,
    Rocket: Mv,
    RockingChair: pv,
    RollerCoaster: iv,
    Rose: nv,
    Rotate3D: F2,
    Rotate3d: F2,
    RotateCcw: ev,
    RotateCcwKey: lv,
    RotateCcwSquare: ov,
    RotateCw: $v,
    RotateCwSquare: rv,
    Route: mv,
    RouteOff: vv,
    Router: yv,
    Rows: z2,
    Rows2: z2,
    Rows3: b2,
    Rows4: sv,
    Rss: gv,
    Ruler: Cv,
    RulerDimensionLine: uv,
    RussianRuble: Hv,
    Sailboat: Av,
    Salad: wv,
    Sandwich: Vv,
    Satellite: Lv,
    SatelliteDish: Sv,
    SaudiRiyal: fv,
    Save: Bv,
    SaveAll: kv,
    SaveOff: Pv,
    Scale: Dv,
    Scale3D: R2,
    Scale3d: R2,
    Scaling: Fv,
    Scan: Gv,
    ScanBarcode: zv,
    ScanEye: bv,
    ScanFace: Rv,
    ScanHeart: Tv,
    ScanLine: qv,
    ScanQrCode: Uv,
    ScanSearch: Ov,
    ScanText: Zv,
    ScatterChart: E,
    School: Iv,
    School2: J0,
    Scissors: Ev,
    ScissorsLineDashed: Wv,
    ScissorsSquare: B0,
    ScissorsSquareDashedBottom: t0,
    ScreenShare: jv,
    ScreenShareOff: Xv,
    Scroll: Kv,
    ScrollText: Nv,
    Search: xv,
    SearchCheck: Qv,
    SearchCode: Jv,
    SearchSlash: Yv,
    SearchX: _v,
    Section: a$,
    Send: h$,
    SendHorizonal: T2,
    SendHorizontal: T2,
    SendToBack: t$,
    SeparatorHorizontal: d$,
    SeparatorVertical: c$,
    Server: n$,
    ServerCog: M$,
    ServerCrash: p$,
    ServerOff: i$,
    Settings: e$,
    Settings2: l$,
    Shapes: o$,
    Share: v$,
    Share2: r$,
    Sheet: $$,
    Shell: m$,
    Shield: S$,
    ShieldAlert: y$,
    ShieldBan: s$,
    ShieldCheck: g$,
    ShieldClose: U2,
    ShieldEllipsis: u$,
    ShieldHalf: C$,
    ShieldMinus: H$,
    ShieldOff: A$,
    ShieldPlus: w$,
    ShieldQuestion: q2,
    ShieldQuestionMark: q2,
    ShieldUser: V$,
    ShieldX: U2,
    Ship: f$,
    ShipWheel: L$,
    Shirt: k$,
    ShoppingBag: P$,
    ShoppingBasket: B$,
    ShoppingCart: D$,
    Shovel: F$,
    ShowerHead: z$,
    Shredder: b$,
    Shrimp: R$,
    Shrink: T$,
    Shrub: q$,
    Shuffle: U$,
    Sidebar: V2,
    SidebarClose: H2,
    SidebarOpen: w2,
    Sigma: O$,
    SigmaSquare: D0,
    Signal: E$,
    SignalHigh: Z$,
    SignalLow: G$,
    SignalMedium: I$,
    SignalZero: W$,
    Signature: X$,
    Signpost: N$,
    SignpostBig: j$,
    Siren: K$,
    SkipBack: Q$,
    SkipForward: J$,
    Skull: Y$,
    Slack: _$,
    Slash: x$,
    SlashSquare: F0,
    Slice: am,
    Sliders: O2,
    SlidersHorizontal: tm,
    SlidersVertical: O2,
    Smartphone: cm,
    SmartphoneCharging: hm,
    SmartphoneNfc: dm,
    Smile: pm,
    SmilePlus: Mm,
    Snail: im,
    Snowflake: nm,
    SoapDispenserDroplet: em,
    Sofa: lm,
    SortAsc: w,
    SortDesc: C,
    Soup: rm,
    Space: om,
    Spade: vm,
    Sparkle: $m,
    Sparkles: Z2,
    Speaker: mm,
    Speech: ym,
    SpellCheck: gm,
    SpellCheck2: sm,
    Spline: Cm,
    SplinePointer: um,
    Split: Hm,
    SplitSquareHorizontal: z0,
    SplitSquareVertical: b0,
    Spool: Am,
    Spotlight: wm,
    SprayCan: Vm,
    Sprout: Sm,
    Square: Tm,
    SquareActivity: G2,
    SquareArrowDown: E2,
    SquareArrowDownLeft: I2,
    SquareArrowDownRight: W2,
    SquareArrowLeft: X2,
    SquareArrowOutDownLeft: j2,
    SquareArrowOutDownRight: N2,
    SquareArrowOutUpLeft: K2,
    SquareArrowOutUpRight: Q2,
    SquareArrowRight: J2,
    SquareArrowUp: x2,
    SquareArrowUpLeft: Y2,
    SquareArrowUpRight: _2,
    SquareAsterisk: a0,
    SquareBottomDashedScissors: t0,
    SquareChartGantt: $,
    SquareCheck: d0,
    SquareCheckBig: h0,
    SquareChevronDown: c0,
    SquareChevronLeft: M0,
    SquareChevronRight: p0,
    SquareChevronUp: i0,
    SquareCode: n0,
    SquareDashed: r0,
    SquareDashedBottom: fm,
    SquareDashedBottomCode: Lm,
    SquareDashedKanban: l0,
    SquareDashedMousePointer: e0,
    SquareDashedTopSolid: km,
    SquareDivide: o0,
    SquareDot: v0,
    SquareEqual: $0,
    SquareFunction: m0,
    SquareGanttChart: $,
    SquareKanban: y0,
    SquareLibrary: s0,
    SquareM: g0,
    SquareMenu: u0,
    SquareMinus: C0,
    SquareMousePointer: H0,
    SquareParking: A0,
    SquareParkingOff: w0,
    SquarePause: Pm,
    SquarePen: p,
    SquarePercent: V0,
    SquarePi: S0,
    SquarePilcrow: L0,
    SquarePlay: f0,
    SquarePlus: k0,
    SquarePower: P0,
    SquareRadical: Bm,
    SquareRoundCorner: Dm,
    SquareScissors: B0,
    SquareSigma: D0,
    SquareSlash: F0,
    SquareSplitHorizontal: z0,
    SquareSplitVertical: b0,
    SquareSquare: Fm,
    SquareStack: zm,
    SquareStar: bm,
    SquareStop: Rm,
    SquareTerminal: R0,
    SquareUser: q0,
    SquareUserRound: T0,
    SquareX: U0,
    SquaresExclude: qm,
    SquaresIntersect: Um,
    SquaresSubtract: Om,
    SquaresUnite: Zm,
    Squircle: Gm,
    SquircleDashed: Im,
    Squirrel: Wm,
    Stamp: Em,
    Star: Nm,
    StarHalf: Xm,
    StarOff: jm,
    Stars: Z2,
    StepBack: Km,
    StepForward: Jm,
    Stethoscope: Qm,
    Sticker: Ym,
    StickyNote: _m,
    StopCircle: u1,
    Store: xm,
    StretchHorizontal: ay,
    StretchVertical: ty,
    Strikethrough: hy,
    Subscript: dy,
    Subtitles: F,
    Sun: ny,
    SunDim: cy,
    SunMedium: My,
    SunMoon: py,
    SunSnow: iy,
    Sunrise: ly,
    Sunset: ey,
    Superscript: oy,
    SwatchBook: ry,
    SwissFranc: vy,
    SwitchCamera: $y,
    Sword: my,
    Swords: yy,
    Syringe: sy,
    Table: Sy,
    Table2: gy,
    TableCellsMerge: uy,
    TableCellsSplit: Hy,
    TableColumnsSplit: Cy,
    TableConfig: e,
    TableOfContents: wy,
    TableProperties: Ay,
    TableRowsSplit: Vy,
    Tablet: fy,
    TabletSmartphone: Ly,
    Tablets: ky,
    Tag: Py,
    Tags: Dy,
    Tally1: By,
    Tally2: Fy,
    Tally3: zy,
    Tally4: by,
    Tally5: Ry,
    Tangent: Ty,
    Target: qy,
    Telescope: Uy,
    Tent: Zy,
    TentTree: Oy,
    Terminal: Gy,
    TerminalSquare: R0,
    TestTube: Iy,
    TestTube2: O0,
    TestTubeDiagonal: O0,
    TestTubes: Wy,
    Text: m,
    TextAlignCenter: Z0,
    TextAlignEnd: G0,
    TextAlignJustify: I0,
    TextAlignStart: m,
    TextCursor: Xy,
    TextCursorInput: Ey,
    TextInitial: W0,
    TextQuote: jy,
    TextSearch: Ny,
    TextSelect: E0,
    TextSelection: E0,
    TextWrap: X0,
    Theater: Ky,
    Thermometer: Yy,
    ThermometerSnowflake: Qy,
    ThermometerSun: Jy,
    ThumbsDown: _y,
    ThumbsUp: xy,
    Ticket: Ms,
    TicketCheck: as,
    TicketMinus: ts,
    TicketPercent: hs,
    TicketPlus: ds,
    TicketSlash: ps,
    TicketX: cs,
    Tickets: ns,
    TicketsPlane: is,
    Timer: rs,
    TimerOff: ls,
    TimerReset: es,
    ToggleLeft: os,
    ToggleRight: vs,
    Toilet: $s,
    ToolCase: ys,
    Tornado: ms,
    Torus: ss,
    Touchpad: us,
    TouchpadOff: gs,
    TowerControl: Hs,
    ToyBrick: Cs,
    Tractor: As,
    TrafficCone: ws,
    Train: j0,
    TrainFront: Ss,
    TrainFrontTunnel: Vs,
    TrainTrack: Ls,
    TramFront: j0,
    Transgender: fs,
    Trash: Ps,
    Trash2: ks,
    TreeDeciduous: Bs,
    TreePalm: N0,
    TreePine: Ds,
    Trees: Fs,
    Trello: bs,
    TrendingDown: zs,
    TrendingUp: Ts,
    TrendingUpDown: Rs,
    Triangle: Os,
    TriangleAlert: K0,
    TriangleDashed: qs,
    TriangleRight: Us,
    Trophy: Zs,
    Truck: Is,
    TruckElectric: Gs,
    TurkishLira: Es,
    Turntable: Ws,
    Turtle: Xs,
    Tv: Ns,
    Tv2: Q0,
    TvMinimal: Q0,
    TvMinimalPlay: js,
    Twitch: Ks,
    Twitter: Qs,
    Type: Ys,
    TypeOutline: Js,
    Umbrella: xs,
    UmbrellaOff: _s,
    Underline: ag,
    Undo: dg,
    Undo2: tg,
    UndoDot: hg,
    UnfoldHorizontal: cg,
    UnfoldVertical: Mg,
    Ungroup: pg,
    University: J0,
    Unlink: lg,
    Unlink2: ig,
    Unlock: e2,
    UnlockKeyhole: l2,
    Unplug: ng,
    Upload: eg,
    UploadCloud: L1,
    Usb: rg,
    User: wg,
    User2: ha,
    UserCheck: og,
    UserCheck2: _0,
    UserCircle: H1,
    UserCircle2: C1,
    UserCog: vg,
    UserCog2: Y0,
    UserLock: $g,
    UserMinus: mg,
    UserMinus2: x0,
    UserPen: yg,
    UserPlus: sg,
    UserPlus2: aa,
    UserRound: ha,
    UserRoundCheck: _0,
    UserRoundCog: Y0,
    UserRoundMinus: x0,
    UserRoundPen: gg,
    UserRoundPlus: aa,
    UserRoundSearch: ug,
    UserRoundX: ta,
    UserSearch: Cg,
    UserSquare: q0,
    UserSquare2: T0,
    UserStar: Hg,
    UserX: Ag,
    UserX2: ta,
    Users: Vg,
    Users2: da,
    UsersRound: da,
    Utensils: Ma,
    UtensilsCrossed: ca,
    UtilityPole: Sg,
    Variable: Lg,
    Vault: kg,
    VectorSquare: fg,
    Vegan: Pg,
    VenetianMask: Bg,
    Venus: Fg,
    VenusAndMars: Dg,
    Verified: L,
    Vibrate: bg,
    VibrateOff: zg,
    Video: Tg,
    VideoOff: Rg,
    Videotape: qg,
    View: Ug,
    Voicemail: Og,
    Volleyball: Zg,
    Volume: Xg,
    Volume1: Gg,
    Volume2: Ig,
    VolumeOff: Wg,
    VolumeX: Eg,
    Vote: jg,
    Wallet: Kg,
    Wallet2: pa,
    WalletCards: Ng,
    WalletMinimal: pa,
    Wallpaper: Qg,
    Wand: Jg,
    Wand2: ia,
    WandSparkles: ia,
    Warehouse: Yg,
    WashingMachine: _g,
    Watch: xg,
    Waves: tu,
    WavesLadder: au,
    Waypoints: hu,
    Webcam: du,
    Webhook: pu,
    WebhookOff: Mu,
    Weight: cu,
    Wheat: nu,
    WheatOff: iu,
    WholeWord: lu,
    Wifi: su,
    WifiCog: eu,
    WifiHigh: ru,
    WifiLow: ou,
    WifiOff: mu,
    WifiPen: vu,
    WifiSync: $u,
    WifiZero: yu,
    Wind: uu,
    WindArrowDown: gu,
    Wine: Hu,
    WineOff: Cu,
    Workflow: Au,
    Worm: wu,
    WrapText: X0,
    Wrench: Vu,
    X: Su,
    XCircle: A1,
    XOctagon: g2,
    XSquare: U0,
    Youtube: Lu,
    Zap: ku,
    ZapOff: fu,
    ZoomIn: Pu,
    ZoomOut: Bu,
  });
  const Ou = ({
    icons: t = Du,
    nameAttr: h = "data-lucide",
    attrs: d = {},
    root: c = document,
  } = {}) => {
    if (!Object.values(t).length)
      throw new Error(`Please provide an icons object.
If you want to use all the icons you can import it like:
 \`import { createIcons, icons } from 'lucide';
lucide.createIcons({icons});\``);
    if (typeof c > "u")
      throw new Error("`createIcons()` only works in a browser environment.");
    const M = c.querySelectorAll(`[${h}]`);
    if (
      (Array.from(M).forEach((i) => ra(i, { nameAttr: h, icons: t, attrs: d })),
      h === "data-lucide")
    ) {
      const i = c.querySelectorAll("[icon-name]");
      i.length > 0 &&
        (console.warn(
          "[Lucide] Some icons were found with the now deprecated icon-name attribute. These will still be replaced for backwards compatibility, but will no longer be supported in v1.0 and you should switch to data-lucide"
        ),
        Array.from(i).forEach((na) =>
          ra(na, { nameAttr: "icon-name", icons: t, attrs: d })
        ));
    }
  };
  (a.AArrowDown = oa),
    (a.AArrowUp = va),
    (a.ALargeSmall = $a),
    (a.Accessibility = ma),
    (a.Activity = ya),
    (a.ActivitySquare = G2),
    (a.AirVent = sa),
    (a.Airplay = ga),
    (a.AlarmCheck = y),
    (a.AlarmClock = Ca),
    (a.AlarmClockCheck = y),
    (a.AlarmClockMinus = s),
    (a.AlarmClockOff = ua),
    (a.AlarmClockPlus = g),
    (a.AlarmMinus = s),
    (a.AlarmPlus = g),
    (a.AlarmSmoke = Ha),
    (a.Album = Aa),
    (a.AlertCircle = N),
    (a.AlertOctagon = y2),
    (a.AlertTriangle = K0),
    (a.AlignCenter = Z0),
    (a.AlignCenterHorizontal = wa),
    (a.AlignCenterVertical = Va),
    (a.AlignEndHorizontal = Sa),
    (a.AlignEndVertical = La),
    (a.AlignHorizontalDistributeCenter = fa),
    (a.AlignHorizontalDistributeEnd = ka),
    (a.AlignHorizontalDistributeStart = Pa),
    (a.AlignHorizontalJustifyCenter = Ba),
    (a.AlignHorizontalJustifyEnd = Da),
    (a.AlignHorizontalJustifyStart = Fa),
    (a.AlignHorizontalSpaceAround = za),
    (a.AlignHorizontalSpaceBetween = ba),
    (a.AlignJustify = I0),
    (a.AlignLeft = m),
    (a.AlignRight = G0),
    (a.AlignStartHorizontal = Ra),
    (a.AlignStartVertical = Ta),
    (a.AlignVerticalDistributeCenter = qa),
    (a.AlignVerticalDistributeEnd = Ua),
    (a.AlignVerticalDistributeStart = Oa),
    (a.AlignVerticalJustifyCenter = Za),
    (a.AlignVerticalJustifyEnd = Ga),
    (a.AlignVerticalJustifyStart = Ia),
    (a.AlignVerticalSpaceAround = Wa),
    (a.AlignVerticalSpaceBetween = Ea),
    (a.Ambulance = ja),
    (a.Ampersand = Xa),
    (a.Ampersands = Na),
    (a.Amphora = Ka),
    (a.Anchor = Qa),
    (a.Angry = Ja),
    (a.Annoyed = Ya),
    (a.Antenna = _a),
    (a.Anvil = xa),
    (a.Aperture = at),
    (a.AppWindow = ht),
    (a.AppWindowMac = tt),
    (a.Apple = dt),
    (a.Archive = pt),
    (a.ArchiveRestore = ct),
    (a.ArchiveX = Mt),
    (a.AreaChart = z),
    (a.Armchair = it),
    (a.ArrowBigDown = lt),
    (a.ArrowBigDownDash = nt),
    (a.ArrowBigLeft = rt),
    (a.ArrowBigLeftDash = et),
    (a.ArrowBigRight = vt),
    (a.ArrowBigRightDash = ot),
    (a.ArrowBigUp = st),
    (a.ArrowBigUpDash = $t),
    (a.ArrowDown = St),
    (a.ArrowDown01 = mt),
    (a.ArrowDown10 = yt),
    (a.ArrowDownAZ = u),
    (a.ArrowDownAz = u),
    (a.ArrowDownCircle = K),
    (a.ArrowDownFromLine = gt),
    (a.ArrowDownLeft = Ct),
    (a.ArrowDownLeftFromCircle = J),
    (a.ArrowDownLeftFromSquare = j2),
    (a.ArrowDownLeftSquare = I2),
    (a.ArrowDownNarrowWide = ut),
    (a.ArrowDownRight = At),
    (a.ArrowDownRightFromCircle = _),
    (a.ArrowDownRightFromSquare = N2),
    (a.ArrowDownRightSquare = W2),
    (a.ArrowDownSquare = E2),
    (a.ArrowDownToDot = Ht),
    (a.ArrowDownToLine = wt),
    (a.ArrowDownUp = Vt),
    (a.ArrowDownWideNarrow = C),
    (a.ArrowDownZA = H),
    (a.ArrowDownZa = H),
    (a.ArrowLeft = Pt),
    (a.ArrowLeftCircle = Q),
    (a.ArrowLeftFromLine = Lt),
    (a.ArrowLeftRight = ft),
    (a.ArrowLeftSquare = X2),
    (a.ArrowLeftToLine = kt),
    (a.ArrowRight = zt),
    (a.ArrowRightCircle = a1),
    (a.ArrowRightFromLine = Bt),
    (a.ArrowRightLeft = Ft),
    (a.ArrowRightSquare = J2),
    (a.ArrowRightToLine = Dt),
    (a.ArrowUp = Wt),
    (a.ArrowUp01 = bt),
    (a.ArrowUp10 = Rt),
    (a.ArrowUpAZ = A),
    (a.ArrowUpAz = A),
    (a.ArrowUpCircle = t1),
    (a.ArrowUpDown = Tt),
    (a.ArrowUpFromDot = Ut),
    (a.ArrowUpFromLine = qt),
    (a.ArrowUpLeft = Ot),
    (a.ArrowUpLeftFromCircle = Y),
    (a.ArrowUpLeftFromSquare = K2),
    (a.ArrowUpLeftSquare = Y2),
    (a.ArrowUpNarrowWide = w),
    (a.ArrowUpRight = Zt),
    (a.ArrowUpRightFromCircle = x),
    (a.ArrowUpRightFromSquare = Q2),
    (a.ArrowUpRightSquare = _2),
    (a.ArrowUpSquare = x2),
    (a.ArrowUpToLine = It),
    (a.ArrowUpWideNarrow = Gt),
    (a.ArrowUpZA = V),
    (a.ArrowUpZa = V),
    (a.ArrowsUpFromLine = Et),
    (a.Asterisk = Xt),
    (a.AsteriskSquare = a0),
    (a.AtSign = jt),
    (a.Atom = Qt),
    (a.AudioLines = Nt),
    (a.AudioWaveform = Kt),
    (a.Award = Jt),
    (a.Axe = Yt),
    (a.Axis3D = S),
    (a.Axis3d = S),
    (a.Baby = _t),
    (a.Backpack = xt),
    (a.Badge = mh),
    (a.BadgeAlert = ah),
    (a.BadgeCent = th),
    (a.BadgeCheck = L),
    (a.BadgeDollarSign = hh),
    (a.BadgeEuro = dh),
    (a.BadgeHelp = f),
    (a.BadgeIndianRupee = ch),
    (a.BadgeInfo = Mh),
    (a.BadgeJapaneseYen = ph),
    (a.BadgeMinus = ih),
    (a.BadgePercent = nh),
    (a.BadgePlus = lh),
    (a.BadgePoundSterling = eh),
    (a.BadgeQuestionMark = f),
    (a.BadgeRussianRuble = rh),
    (a.BadgeSwissFranc = oh),
    (a.BadgeTurkishLira = vh),
    (a.BadgeX = $h),
    (a.BaggageClaim = yh),
    (a.Ban = sh),
    (a.Banana = gh),
    (a.Bandage = uh),
    (a.Banknote = wh),
    (a.BanknoteArrowDown = Ch),
    (a.BanknoteArrowUp = Hh),
    (a.BanknoteX = Ah),
    (a.BarChart = G),
    (a.BarChart2 = I),
    (a.BarChart3 = O),
    (a.BarChart4 = U),
    (a.BarChartBig = q),
    (a.BarChartHorizontal = T),
    (a.BarChartHorizontalBig = b),
    (a.Barcode = Vh),
    (a.Barrel = Sh),
    (a.Baseline = Lh),
    (a.Bath = fh),
    (a.Battery = bh),
    (a.BatteryCharging = kh),
    (a.BatteryFull = Ph),
    (a.BatteryLow = Bh),
    (a.BatteryMedium = Dh),
    (a.BatteryPlus = Fh),
    (a.BatteryWarning = zh),
    (a.Beaker = Rh),
    (a.Bean = qh),
    (a.BeanOff = Th),
    (a.Bed = Zh),
    (a.BedDouble = Uh),
    (a.BedSingle = Oh),
    (a.Beef = Gh),
    (a.Beer = Wh),
    (a.BeerOff = Ih),
    (a.Bell = Jh),
    (a.BellDot = Eh),
    (a.BellElectric = Xh),
    (a.BellMinus = jh),
    (a.BellOff = Nh),
    (a.BellPlus = Kh),
    (a.BellRing = Qh),
    (a.BetweenHorizonalEnd = k),
    (a.BetweenHorizonalStart = P),
    (a.BetweenHorizontalEnd = k),
    (a.BetweenHorizontalStart = P),
    (a.BetweenVerticalEnd = Yh),
    (a.BetweenVerticalStart = _h),
    (a.BicepsFlexed = xh),
    (a.Bike = a4),
    (a.Binary = t4),
    (a.Binoculars = h4),
    (a.Biohazard = d4),
    (a.Bird = c4),
    (a.Bitcoin = p4),
    (a.Blend = M4),
    (a.Blinds = n4),
    (a.Blocks = i4),
    (a.Bluetooth = r4),
    (a.BluetoothConnected = l4),
    (a.BluetoothOff = o4),
    (a.BluetoothSearching = e4),
    (a.Bold = v4),
    (a.Bolt = $4),
    (a.Bomb = m4),
    (a.Bone = y4),
    (a.Book = Z4),
    (a.BookA = s4),
    (a.BookAlert = g4),
    (a.BookAudio = u4),
    (a.BookCheck = C4),
    (a.BookCopy = H4),
    (a.BookDashed = B),
    (a.BookDown = A4),
    (a.BookHeadphones = w4),
    (a.BookHeart = V4),
    (a.BookImage = S4),
    (a.BookKey = L4),
    (a.BookLock = f4),
    (a.BookMarked = k4),
    (a.BookMinus = P4),
    (a.BookOpen = F4),
    (a.BookOpenCheck = B4),
    (a.BookOpenText = D4),
    (a.BookPlus = z4),
    (a.BookTemplate = B),
    (a.BookText = b4),
    (a.BookType = T4),
    (a.BookUp = q4),
    (a.BookUp2 = R4),
    (a.BookUser = U4),
    (a.BookX = O4),
    (a.Bookmark = X4),
    (a.BookmarkCheck = G4),
    (a.BookmarkMinus = I4),
    (a.BookmarkPlus = W4),
    (a.BookmarkX = E4),
    (a.BoomBox = j4),
    (a.Bot = Q4),
    (a.BotMessageSquare = K4),
    (a.BotOff = N4),
    (a.BottleWine = J4),
    (a.BowArrow = Y4),
    (a.Box = _4),
    (a.BoxSelect = r0),
    (a.Boxes = x4),
    (a.Braces = D),
    (a.Brackets = a5),
    (a.Brain = d5),
    (a.BrainCircuit = t5),
    (a.BrainCog = h5),
    (a.BrickWall = p5),
    (a.BrickWallFire = c5),
    (a.BrickWallShield = M5),
    (a.Briefcase = e5),
    (a.BriefcaseBusiness = i5),
    (a.BriefcaseConveyorBelt = n5),
    (a.BriefcaseMedical = l5),
    (a.BringToFront = r5),
    (a.Brush = v5),
    (a.BrushCleaning = o5),
    (a.Bubbles = $5),
    (a.Bug = s5),
    (a.BugOff = m5),
    (a.BugPlay = y5),
    (a.Building = u5),
    (a.Building2 = g5),
    (a.Bus = H5),
    (a.BusFront = C5),
    (a.Cable = w5),
    (a.CableCar = A5),
    (a.Cake = S5),
    (a.CakeSlice = V5),
    (a.Calculator = L5),
    (a.Calendar = N5),
    (a.Calendar1 = f5),
    (a.CalendarArrowDown = k5),
    (a.CalendarArrowUp = P5),
    (a.CalendarCheck = D5),
    (a.CalendarCheck2 = B5),
    (a.CalendarClock = F5),
    (a.CalendarCog = R5),
    (a.CalendarDays = z5),
    (a.CalendarFold = b5),
    (a.CalendarHeart = T5),
    (a.CalendarMinus = U5),
    (a.CalendarMinus2 = q5),
    (a.CalendarOff = O5),
    (a.CalendarPlus = Z5),
    (a.CalendarPlus2 = I5),
    (a.CalendarRange = G5),
    (a.CalendarSearch = E5),
    (a.CalendarSync = W5),
    (a.CalendarX = j5),
    (a.CalendarX2 = X5),
    (a.Camera = Q5),
    (a.CameraOff = K5),
    (a.CandlestickChart = R),
    (a.Candy = _5),
    (a.CandyCane = J5),
    (a.CandyOff = Y5),
    (a.Cannabis = x5),
    (a.Captions = F),
    (a.CaptionsOff = a3),
    (a.Car = d3),
    (a.CarFront = t3),
    (a.CarTaxiFront = h3),
    (a.Caravan = c3),
    (a.CardSim = M3),
    (a.Carrot = p3),
    (a.CaseLower = i3),
    (a.CaseSensitive = n3),
    (a.CaseUpper = l3),
    (a.CassetteTape = e3),
    (a.Cast = r3),
    (a.Castle = o3),
    (a.Cat = v3),
    (a.Cctv = $3),
    (a.ChartArea = z),
    (a.ChartBar = T),
    (a.ChartBarBig = b),
    (a.ChartBarDecreasing = m3),
    (a.ChartBarIncreasing = y3),
    (a.ChartBarStacked = s3),
    (a.ChartCandlestick = R),
    (a.ChartColumn = O),
    (a.ChartColumnBig = q),
    (a.ChartColumnDecreasing = g3),
    (a.ChartColumnIncreasing = U),
    (a.ChartColumnStacked = u3),
    (a.ChartGantt = C3),
    (a.ChartLine = Z),
    (a.ChartNetwork = H3),
    (a.ChartNoAxesColumn = I),
    (a.ChartNoAxesColumnDecreasing = A3),
    (a.ChartNoAxesColumnIncreasing = G),
    (a.ChartNoAxesCombined = w3),
    (a.ChartNoAxesGantt = W),
    (a.ChartPie = X),
    (a.ChartScatter = E),
    (a.ChartSpline = V3),
    (a.Check = f3),
    (a.CheckCheck = S3),
    (a.CheckCircle = h1),
    (a.CheckCircle2 = d1),
    (a.CheckLine = L3),
    (a.CheckSquare = h0),
    (a.CheckSquare2 = d0),
    (a.ChefHat = k3),
    (a.Cherry = B3),
    (a.ChevronDown = P3),
    (a.ChevronDownCircle = c1),
    (a.ChevronDownSquare = c0),
    (a.ChevronFirst = D3),
    (a.ChevronLast = F3),
    (a.ChevronLeft = z3),
    (a.ChevronLeftCircle = M1),
    (a.ChevronLeftSquare = M0),
    (a.ChevronRight = b3),
    (a.ChevronRightCircle = p1),
    (a.ChevronRightSquare = p0),
    (a.ChevronUp = R3),
    (a.ChevronUpCircle = i1),
    (a.ChevronUpSquare = i0),
    (a.ChevronsDown = q3),
    (a.ChevronsDownUp = T3),
    (a.ChevronsLeft = Z3),
    (a.ChevronsLeftRight = O3),
    (a.ChevronsLeftRightEllipsis = U3),
    (a.ChevronsRight = I3),
    (a.ChevronsRightLeft = G3),
    (a.ChevronsUp = E3),
    (a.ChevronsUpDown = W3),
    (a.Chrome = j),
    (a.Chromium = j),
    (a.Church = X3),
    (a.Cigarette = N3),
    (a.CigaretteOff = j3),
    (a.Circle = id),
    (a.CircleAlert = N),
    (a.CircleArrowDown = K),
    (a.CircleArrowLeft = Q),
    (a.CircleArrowOutDownLeft = J),
    (a.CircleArrowOutDownRight = _),
    (a.CircleArrowOutUpLeft = Y),
    (a.CircleArrowOutUpRight = x),
    (a.CircleArrowRight = a1),
    (a.CircleArrowUp = t1),
    (a.CircleCheck = d1),
    (a.CircleCheckBig = h1),
    (a.CircleChevronDown = c1),
    (a.CircleChevronLeft = M1),
    (a.CircleChevronRight = p1),
    (a.CircleChevronUp = i1),
    (a.CircleDashed = K3),
    (a.CircleDivide = n1),
    (a.CircleDollarSign = Q3),
    (a.CircleDot = Y3),
    (a.CircleDotDashed = J3),
    (a.CircleEllipsis = _3),
    (a.CircleEqual = x3),
    (a.CircleFadingArrowUp = ad),
    (a.CircleFadingPlus = td),
    (a.CircleGauge = l1),
    (a.CircleHelp = l),
    (a.CircleMinus = e1),
    (a.CircleOff = hd),
    (a.CircleParking = o1),
    (a.CircleParkingOff = r1),
    (a.CirclePause = v1),
    (a.CirclePercent = $1),
    (a.CirclePlay = m1),
    (a.CirclePlus = y1),
    (a.CirclePoundSterling = dd),
    (a.CirclePower = s1),
    (a.CircleQuestionMark = l),
    (a.CircleSlash = cd),
    (a.CircleSlash2 = g1),
    (a.CircleSlashed = g1),
    (a.CircleSmall = Md),
    (a.CircleStar = pd),
    (a.CircleStop = u1),
    (a.CircleUser = H1),
    (a.CircleUserRound = C1),
    (a.CircleX = A1),
    (a.CircuitBoard = nd),
    (a.Citrus = ld),
    (a.Clapperboard = ed),
    (a.Clipboard = Cd),
    (a.ClipboardCheck = rd),
    (a.ClipboardClock = od),
    (a.ClipboardCopy = vd),
    (a.ClipboardEdit = V1),
    (a.ClipboardList = $d),
    (a.ClipboardMinus = md),
    (a.ClipboardPaste = yd),
    (a.ClipboardPen = V1),
    (a.ClipboardPenLine = w1),
    (a.ClipboardPlus = sd),
    (a.ClipboardSignature = w1),
    (a.ClipboardType = gd),
    (a.ClipboardX = ud),
    (a.Clock = Ud),
    (a.Clock1 = Hd),
    (a.Clock10 = Ad),
    (a.Clock11 = wd),
    (a.Clock12 = Vd),
    (a.Clock2 = Sd),
    (a.Clock3 = Ld),
    (a.Clock4 = fd),
    (a.Clock5 = kd),
    (a.Clock6 = Pd),
    (a.Clock7 = Bd),
    (a.Clock8 = Dd),
    (a.Clock9 = Fd),
    (a.ClockAlert = zd),
    (a.ClockArrowDown = bd),
    (a.ClockArrowUp = Rd),
    (a.ClockFading = Td),
    (a.ClockPlus = qd),
    (a.ClosedCaption = Od),
    (a.Cloud = t6),
    (a.CloudAlert = Zd),
    (a.CloudCheck = Gd),
    (a.CloudCog = Id),
    (a.CloudDownload = S1),
    (a.CloudDrizzle = Wd),
    (a.CloudFog = Ed),
    (a.CloudHail = Xd),
    (a.CloudLightning = Nd),
    (a.CloudMoon = Kd),
    (a.CloudMoonRain = jd),
    (a.CloudOff = Qd),
    (a.CloudRain = Yd),
    (a.CloudRainWind = Jd),
    (a.CloudSnow = _d),
    (a.CloudSun = a6),
    (a.CloudSunRain = xd),
    (a.CloudUpload = L1),
    (a.Cloudy = h6),
    (a.Clover = d6),
    (a.Club = c6),
    (a.Code = p6),
    (a.Code2 = f1),
    (a.CodeSquare = n0),
    (a.CodeXml = f1),
    (a.Codepen = M6),
    (a.Codesandbox = i6),
    (a.Coffee = n6),
    (a.Cog = l6),
    (a.Coins = e6),
    (a.Columns = k1),
    (a.Columns2 = k1),
    (a.Columns3 = P1),
    (a.Columns3Cog = e),
    (a.Columns4 = r6),
    (a.ColumnsSettings = e),
    (a.Combine = o6),
    (a.Command = v6),
    (a.Compass = $6),
    (a.Component = m6),
    (a.Computer = y6),
    (a.ConciergeBell = s6),
    (a.Cone = g6),
    (a.Construction = u6),
    (a.Contact = C6),
    (a.Contact2 = B1),
    (a.ContactRound = B1),
    (a.Container = H6),
    (a.Contrast = A6),
    (a.Cookie = w6),
    (a.CookingPot = V6),
    (a.Copy = B6),
    (a.CopyCheck = S6),
    (a.CopyMinus = L6),
    (a.CopyPlus = f6),
    (a.CopySlash = k6),
    (a.CopyX = P6),
    (a.Copyleft = D6),
    (a.Copyright = F6),
    (a.CornerDownLeft = b6),
    (a.CornerDownRight = z6),
    (a.CornerLeftDown = R6),
    (a.CornerLeftUp = T6),
    (a.CornerRightDown = q6),
    (a.CornerRightUp = U6),
    (a.CornerUpLeft = G6),
    (a.CornerUpRight = O6),
    (a.Cpu = Z6),
    (a.CreativeCommons = I6),
    (a.CreditCard = W6),
    (a.Croissant = E6),
    (a.Crop = X6),
    (a.Cross = j6),
    (a.Crosshair = N6),
    (a.Crown = K6),
    (a.Cuboid = Q6),
    (a.CupSoda = J6),
    (a.CurlyBraces = D),
    (a.Currency = Y6),
    (a.Cylinder = _6),
    (a.Dam = x6),
    (a.Database = h8),
    (a.DatabaseBackup = a8),
    (a.DatabaseZap = t8),
    (a.DecimalsArrowLeft = d8),
    (a.DecimalsArrowRight = c8),
    (a.Delete = M8),
    (a.Dessert = p8),
    (a.Diameter = i8),
    (a.Diamond = e8),
    (a.DiamondMinus = n8),
    (a.DiamondPercent = D1),
    (a.DiamondPlus = l8),
    (a.Dice1 = r8),
    (a.Dice2 = o8),
    (a.Dice3 = v8),
    (a.Dice4 = $8),
    (a.Dice5 = m8),
    (a.Dice6 = y8),
    (a.Dices = s8),
    (a.Diff = g8),
    (a.Disc = A8),
    (a.Disc2 = u8),
    (a.Disc3 = C8),
    (a.DiscAlbum = H8),
    (a.Divide = w8),
    (a.DivideCircle = n1),
    (a.DivideSquare = o0),
    (a.Dna = S8),
    (a.DnaOff = V8),
    (a.Dock = L8),
    (a.Dog = f8),
    (a.DollarSign = k8),
    (a.Donut = P8),
    (a.DoorClosed = D8),
    (a.DoorClosedLocked = B8),
    (a.DoorOpen = F8),
    (a.Dot = z8),
    (a.DotSquare = v0),
    (a.Download = b8),
    (a.DownloadCloud = S1),
    (a.DraftingCompass = R8),
    (a.Drama = T8),
    (a.Dribbble = q8),
    (a.Drill = U8),
    (a.Drone = O8),
    (a.Droplet = G8),
    (a.DropletOff = Z8),
    (a.Droplets = I8),
    (a.Drum = W8),
    (a.Drumstick = E8),
    (a.Dumbbell = X8),
    (a.Ear = j8),
    (a.EarOff = N8),
    (a.Earth = F1),
    (a.EarthLock = K8),
    (a.Eclipse = Q8),
    (a.Edit = p),
    (a.Edit2 = P2),
    (a.Edit3 = k2),
    (a.Egg = Y8),
    (a.EggFried = J8),
    (a.EggOff = _8),
    (a.Ellipsis = b1),
    (a.EllipsisVertical = z1),
    (a.Equal = tc),
    (a.EqualApproximately = x8),
    (a.EqualNot = ac),
    (a.EqualSquare = $0),
    (a.Eraser = dc),
    (a.EthernetPort = hc),
    (a.Euro = cc),
    (a.EvCharger = Mc),
    (a.Expand = pc),
    (a.ExternalLink = ic),
    (a.Eye = ec),
    (a.EyeClosed = nc),
    (a.EyeOff = lc),
    (a.Facebook = rc),
    (a.Factory = oc),
    (a.Fan = vc),
    (a.FastForward = $c),
    (a.Feather = mc),
    (a.Fence = yc),
    (a.FerrisWheel = sc),
    (a.Figma = gc),
    (a.File = o7),
    (a.FileArchive = uc),
    (a.FileAudio = Hc),
    (a.FileAudio2 = Cc),
    (a.FileAxis3D = R1),
    (a.FileAxis3d = R1),
    (a.FileBadge = wc),
    (a.FileBadge2 = Ac),
    (a.FileBarChart = T1),
    (a.FileBarChart2 = q1),
    (a.FileBox = Vc),
    (a.FileChartColumn = q1),
    (a.FileChartColumnIncreasing = T1),
    (a.FileChartLine = U1),
    (a.FileChartPie = O1),
    (a.FileCheck = Lc),
    (a.FileCheck2 = Sc),
    (a.FileClock = fc),
    (a.FileCode = Pc),
    (a.FileCode2 = kc),
    (a.FileCog = Z1),
    (a.FileCog2 = Z1),
    (a.FileDiff = Bc),
    (a.FileDigit = Dc),
    (a.FileDown = Fc),
    (a.FileEdit = I1),
    (a.FileHeart = zc),
    (a.FileImage = bc),
    (a.FileInput = Rc),
    (a.FileJson = qc),
    (a.FileJson2 = Tc),
    (a.FileKey = Oc),
    (a.FileKey2 = Uc),
    (a.FileLineChart = U1),
    (a.FileLock = Gc),
    (a.FileLock2 = Zc),
    (a.FileMinus = Wc),
    (a.FileMinus2 = Ic),
    (a.FileMusic = Ec),
    (a.FileOutput = Xc),
    (a.FilePen = I1),
    (a.FilePenLine = G1),
    (a.FilePieChart = O1),
    (a.FilePlay = W1),
    (a.FilePlus = Nc),
    (a.FilePlus2 = jc),
    (a.FileQuestion = E1),
    (a.FileQuestionMark = E1),
    (a.FileScan = Kc),
    (a.FileSearch = Jc),
    (a.FileSearch2 = Qc),
    (a.FileSignature = G1),
    (a.FileSliders = Yc),
    (a.FileSpreadsheet = _c),
    (a.FileStack = xc),
    (a.FileSymlink = a7),
    (a.FileTerminal = t7),
    (a.FileText = h7),
    (a.FileType = c7),
    (a.FileType2 = d7),
    (a.FileUp = M7),
    (a.FileUser = p7),
    (a.FileVideo = W1),
    (a.FileVideo2 = X1),
    (a.FileVideoCamera = X1),
    (a.FileVolume = n7),
    (a.FileVolume2 = i7),
    (a.FileWarning = l7),
    (a.FileX = r7),
    (a.FileX2 = e7),
    (a.Files = v7),
    (a.Film = $7),
    (a.Filter = K1),
    (a.FilterX = Q1),
    (a.Fingerprint = y7),
    (a.FireExtinguisher = m7),
    (a.Fish = u7),
    (a.FishOff = s7),
    (a.FishSymbol = g7),
    (a.Flag = w7),
    (a.FlagOff = C7),
    (a.FlagTriangleLeft = H7),
    (a.FlagTriangleRight = A7),
    (a.Flame = S7),
    (a.FlameKindling = V7),
    (a.Flashlight = f7),
    (a.FlashlightOff = L7),
    (a.FlaskConical = P7),
    (a.FlaskConicalOff = k7),
    (a.FlaskRound = B7),
    (a.FlipHorizontal = F7),
    (a.FlipHorizontal2 = D7),
    (a.FlipVertical = b7),
    (a.FlipVertical2 = z7),
    (a.Flower = T7),
    (a.Flower2 = R7),
    (a.Focus = q7),
    (a.FoldHorizontal = U7),
    (a.FoldVertical = O7),
    (a.Folder = vM),
    (a.FolderArchive = G7),
    (a.FolderCheck = Z7),
    (a.FolderClock = I7),
    (a.FolderClosed = E7),
    (a.FolderCode = W7),
    (a.FolderCog = j1),
    (a.FolderCog2 = j1),
    (a.FolderDot = X7),
    (a.FolderDown = j7),
    (a.FolderEdit = N1),
    (a.FolderGit = K7),
    (a.FolderGit2 = N7),
    (a.FolderHeart = Q7),
    (a.FolderInput = J7),
    (a.FolderKanban = _7),
    (a.FolderKey = Y7),
    (a.FolderLock = aM),
    (a.FolderMinus = x7),
    (a.FolderOpen = hM),
    (a.FolderOpenDot = tM),
    (a.FolderOutput = dM),
    (a.FolderPen = N1),
    (a.FolderPlus = cM),
    (a.FolderRoot = MM),
    (a.FolderSearch = iM),
    (a.FolderSearch2 = pM),
    (a.FolderSymlink = nM),
    (a.FolderSync = lM),
    (a.FolderTree = eM),
    (a.FolderUp = rM),
    (a.FolderX = oM),
    (a.Folders = $M),
    (a.Footprints = mM),
    (a.ForkKnife = Ma),
    (a.ForkKnifeCrossed = ca),
    (a.Forklift = yM),
    (a.FormInput = D2),
    (a.Forward = sM),
    (a.Frame = gM),
    (a.Framer = uM),
    (a.Frown = CM),
    (a.Fuel = HM),
    (a.Fullscreen = AM),
    (a.FunctionSquare = m0),
    (a.Funnel = K1),
    (a.FunnelPlus = wM),
    (a.FunnelX = Q1),
    (a.GalleryHorizontal = SM),
    (a.GalleryHorizontalEnd = VM),
    (a.GalleryThumbnails = LM),
    (a.GalleryVertical = kM),
    (a.GalleryVerticalEnd = fM),
    (a.Gamepad = BM),
    (a.Gamepad2 = PM),
    (a.GanttChart = W),
    (a.GanttChartSquare = $),
    (a.Gauge = DM),
    (a.GaugeCircle = l1),
    (a.Gavel = FM),
    (a.Gem = zM),
    (a.GeorgianLari = bM),
    (a.Ghost = qM),
    (a.Gift = RM),
    (a.GitBranch = UM),
    (a.GitBranchPlus = TM),
    (a.GitCommit = J1),
    (a.GitCommitHorizontal = J1),
    (a.GitCommitVertical = OM),
    (a.GitCompare = GM),
    (a.GitCompareArrows = ZM),
    (a.GitFork = IM),
    (a.GitGraph = WM),
    (a.GitMerge = EM),
    (a.GitPullRequest = JM),
    (a.GitPullRequestArrow = XM),
    (a.GitPullRequestClosed = jM),
    (a.GitPullRequestCreate = KM),
    (a.GitPullRequestCreateArrow = NM),
    (a.GitPullRequestDraft = QM),
    (a.Github = YM),
    (a.Gitlab = _M),
    (a.GlassWater = xM),
    (a.Glasses = a9),
    (a.Globe = t9),
    (a.Globe2 = F1),
    (a.GlobeLock = h9),
    (a.Goal = d9),
    (a.Gpu = c9),
    (a.Grab = t2),
    (a.GraduationCap = M9),
    (a.Grape = p9),
    (a.Grid = r),
    (a.Grid2X2 = a2),
    (a.Grid2X2Check = _1),
    (a.Grid2X2Plus = Y1),
    (a.Grid2X2X = x1),
    (a.Grid2x2 = a2),
    (a.Grid2x2Check = _1),
    (a.Grid2x2Plus = Y1),
    (a.Grid2x2X = x1),
    (a.Grid3X3 = r),
    (a.Grid3x2 = i9),
    (a.Grid3x3 = r),
    (a.Grip = e9),
    (a.GripHorizontal = n9),
    (a.GripVertical = l9),
    (a.Group = r9),
    (a.Guitar = v9),
    (a.Ham = o9),
    (a.Hamburger = $9),
    (a.Hammer = m9),
    (a.Hand = A9),
    (a.HandCoins = y9),
    (a.HandFist = s9),
    (a.HandGrab = t2),
    (a.HandHeart = g9),
    (a.HandHelping = h2),
    (a.HandMetal = u9),
    (a.HandPlatter = C9),
    (a.Handbag = H9),
    (a.Handshake = w9),
    (a.HardDrive = f9),
    (a.HardDriveDownload = V9),
    (a.HardDriveUpload = S9),
    (a.HardHat = L9),
    (a.Hash = k9),
    (a.HatGlasses = P9),
    (a.Haze = D9),
    (a.HdmiPort = B9),
    (a.Heading = U9),
    (a.Heading1 = F9),
    (a.Heading2 = z9),
    (a.Heading3 = R9),
    (a.Heading4 = b9),
    (a.Heading5 = T9),
    (a.Heading6 = q9),
    (a.HeadphoneOff = O9),
    (a.Headphones = Z9),
    (a.Headset = G9),
    (a.Heart = K9),
    (a.HeartCrack = I9),
    (a.HeartHandshake = W9),
    (a.HeartMinus = E9),
    (a.HeartOff = X9),
    (a.HeartPlus = j9),
    (a.HeartPulse = N9),
    (a.Heater = Q9),
    (a.HelpCircle = l),
    (a.HelpingHand = h2),
    (a.Hexagon = J9),
    (a.Highlighter = Y9),
    (a.History = _9),
    (a.Home = d2),
    (a.Hop = ap),
    (a.HopOff = x9),
    (a.Hospital = tp),
    (a.Hotel = hp),
    (a.Hourglass = dp),
    (a.House = d2),
    (a.HouseHeart = cp),
    (a.HousePlug = Mp),
    (a.HousePlus = pp),
    (a.HouseWifi = ip),
    (a.IceCream = c2),
    (a.IceCream2 = M2),
    (a.IceCreamBowl = M2),
    (a.IceCreamCone = c2),
    (a.IdCard = lp),
    (a.IdCardLanyard = np),
    (a.Image = sp),
    (a.ImageDown = ep),
    (a.ImageMinus = rp),
    (a.ImageOff = op),
    (a.ImagePlay = vp),
    (a.ImagePlus = $p),
    (a.ImageUp = mp),
    (a.ImageUpscale = yp),
    (a.Images = gp),
    (a.Import = up),
    (a.Inbox = Hp),
    (a.Indent = v),
    (a.IndentDecrease = o),
    (a.IndentIncrease = v),
    (a.IndianRupee = Cp),
    (a.Infinity = Ap),
    (a.Info = wp),
    (a.Inspect = H0),
    (a.InspectionPanel = Vp),
    (a.Instagram = Sp),
    (a.Italic = Lp),
    (a.IterationCcw = fp),
    (a.IterationCw = kp),
    (a.JapaneseYen = Pp),
    (a.Joystick = Bp),
    (a.Kanban = Dp),
    (a.KanbanSquare = y0),
    (a.KanbanSquareDashed = l0),
    (a.Kayak = zp),
    (a.Key = Rp),
    (a.KeyRound = Fp),
    (a.KeySquare = bp),
    (a.Keyboard = Up),
    (a.KeyboardMusic = Tp),
    (a.KeyboardOff = qp),
    (a.Lamp = Ep),
    (a.LampCeiling = Op),
    (a.LampDesk = Zp),
    (a.LampFloor = Gp),
    (a.LampWallDown = Ip),
    (a.LampWallUp = Wp),
    (a.LandPlot = Xp),
    (a.Landmark = jp),
    (a.Languages = Np),
    (a.Laptop = Qp),
    (a.Laptop2 = p2),
    (a.LaptopMinimal = p2),
    (a.LaptopMinimalCheck = Kp),
    (a.Lasso = Yp),
    (a.LassoSelect = Jp),
    (a.Laugh = _p),
    (a.Layers = i2),
    (a.Layers2 = xp),
    (a.Layers3 = i2),
    (a.Layout = f2),
    (a.LayoutDashboard = ai),
    (a.LayoutGrid = ti),
    (a.LayoutList = hi),
    (a.LayoutPanelLeft = di),
    (a.LayoutPanelTop = Mi),
    (a.LayoutTemplate = ci),
    (a.Leaf = pi),
    (a.LeafyGreen = ii),
    (a.Lectern = ni),
    (a.LetterText = W0),
    (a.Library = ei),
    (a.LibraryBig = li),
    (a.LibrarySquare = s0),
    (a.LifeBuoy = ri),
    (a.Ligature = vi),
    (a.Lightbulb = $i),
    (a.LightbulbOff = oi),
    (a.LineChart = Z),
    (a.LineSquiggle = mi),
    (a.Link = gi),
    (a.Link2 = si),
    (a.Link2Off = yi),
    (a.Linkedin = ui),
    (a.List = qi),
    (a.ListCheck = Ci),
    (a.ListChecks = Hi),
    (a.ListChevronsDownUp = Ai),
    (a.ListChevronsUpDown = wi),
    (a.ListCollapse = Vi),
    (a.ListEnd = Si),
    (a.ListFilter = fi),
    (a.ListFilterPlus = Li),
    (a.ListIndentDecrease = o),
    (a.ListIndentIncrease = v),
    (a.ListMinus = ki),
    (a.ListMusic = Pi),
    (a.ListOrdered = Bi),
    (a.ListPlus = Di),
    (a.ListRestart = Fi),
    (a.ListStart = zi),
    (a.ListTodo = bi),
    (a.ListTree = Ti),
    (a.ListVideo = Ri),
    (a.ListX = Ui),
    (a.Loader = Zi),
    (a.Loader2 = n2),
    (a.LoaderCircle = n2),
    (a.LoaderPinwheel = Oi),
    (a.Locate = Wi),
    (a.LocateFixed = Ii),
    (a.LocateOff = Gi),
    (a.LocationEdit = o2),
    (a.Lock = Xi),
    (a.LockKeyhole = Ei),
    (a.LockKeyholeOpen = l2),
    (a.LockOpen = e2),
    (a.LogIn = Ni),
    (a.LogOut = ji),
    (a.Logs = Ki),
    (a.Lollipop = Qi),
    (a.Luggage = Ji),
    (a.MSquare = g0),
    (a.Magnet = Yi),
    (a.Mail = Mn),
    (a.MailCheck = _i),
    (a.MailMinus = xi),
    (a.MailOpen = an),
    (a.MailPlus = tn),
    (a.MailQuestion = r2),
    (a.MailQuestionMark = r2),
    (a.MailSearch = hn),
    (a.MailWarning = dn),
    (a.MailX = cn),
    (a.Mailbox = pn),
    (a.Mails = nn),
    (a.Map = wn),
    (a.MapMinus = ln),
    (a.MapPin = Cn),
    (a.MapPinCheck = rn),
    (a.MapPinCheckInside = en),
    (a.MapPinHouse = on),
    (a.MapPinMinus = $n),
    (a.MapPinMinusInside = vn),
    (a.MapPinOff = mn),
    (a.MapPinPen = o2),
    (a.MapPinPlus = gn),
    (a.MapPinPlusInside = yn),
    (a.MapPinX = un),
    (a.MapPinXInside = sn),
    (a.MapPinned = Hn),
    (a.MapPlus = An),
    (a.Mars = Sn),
    (a.MarsStroke = Vn),
    (a.Martini = Ln),
    (a.Maximize = kn),
    (a.Maximize2 = fn),
    (a.Medal = Pn),
    (a.Megaphone = Dn),
    (a.MegaphoneOff = Bn),
    (a.Meh = Fn),
    (a.MemoryStick = zn),
    (a.Menu = bn),
    (a.MenuSquare = u0),
    (a.Merge = Rn),
    (a.MessageCircle = Xn),
    (a.MessageCircleCode = Tn),
    (a.MessageCircleDashed = qn),
    (a.MessageCircleHeart = Un),
    (a.MessageCircleMore = On),
    (a.MessageCircleOff = Zn),
    (a.MessageCirclePlus = Gn),
    (a.MessageCircleQuestion = v2),
    (a.MessageCircleQuestionMark = v2),
    (a.MessageCircleReply = In),
    (a.MessageCircleWarning = Wn),
    (a.MessageCircleX = En),
    (a.MessageSquare = il),
    (a.MessageSquareCode = jn),
    (a.MessageSquareDashed = Nn),
    (a.MessageSquareDiff = Kn),
    (a.MessageSquareDot = Qn),
    (a.MessageSquareHeart = Jn),
    (a.MessageSquareLock = _n),
    (a.MessageSquareMore = Yn),
    (a.MessageSquareOff = xn),
    (a.MessageSquarePlus = al),
    (a.MessageSquareQuote = tl),
    (a.MessageSquareReply = hl),
    (a.MessageSquareShare = dl),
    (a.MessageSquareText = cl),
    (a.MessageSquareWarning = Ml),
    (a.MessageSquareX = pl),
    (a.MessagesSquare = nl),
    (a.Mic = el),
    (a.Mic2 = $2),
    (a.MicOff = ll),
    (a.MicVocal = $2),
    (a.Microchip = rl),
    (a.Microscope = ol),
    (a.Microwave = vl),
    (a.Milestone = $l),
    (a.Milk = yl),
    (a.MilkOff = ml),
    (a.Minimize = gl),
    (a.Minimize2 = sl),
    (a.Minus = ul),
    (a.MinusCircle = e1),
    (a.MinusSquare = C0),
    (a.Monitor = zl),
    (a.MonitorCheck = Cl),
    (a.MonitorCog = Hl),
    (a.MonitorDot = Al),
    (a.MonitorDown = wl),
    (a.MonitorOff = Vl),
    (a.MonitorPause = Sl),
    (a.MonitorPlay = Ll),
    (a.MonitorSmartphone = fl),
    (a.MonitorSpeaker = kl),
    (a.MonitorStop = Pl),
    (a.MonitorUp = Bl),
    (a.MonitorX = Dl),
    (a.Moon = bl),
    (a.MoonStar = Fl),
    (a.MoreHorizontal = b1),
    (a.MoreVertical = z1),
    (a.Motorbike = Rl),
    (a.Mountain = ql),
    (a.MountainSnow = Tl),
    (a.Mouse = Wl),
    (a.MouseOff = Ul),
    (a.MousePointer = Il),
    (a.MousePointer2 = Ol),
    (a.MousePointerBan = Zl),
    (a.MousePointerClick = Gl),
    (a.MousePointerSquareDashed = e0),
    (a.Move = he),
    (a.Move3D = m2),
    (a.Move3d = m2),
    (a.MoveDiagonal = Xl),
    (a.MoveDiagonal2 = El),
    (a.MoveDown = Kl),
    (a.MoveDownLeft = jl),
    (a.MoveDownRight = Nl),
    (a.MoveHorizontal = Ql),
    (a.MoveLeft = Jl),
    (a.MoveRight = Yl),
    (a.MoveUp = ae),
    (a.MoveUpLeft = xl),
    (a.MoveUpRight = _l),
    (a.MoveVertical = te),
    (a.Music = pe),
    (a.Music2 = de),
    (a.Music3 = ce),
    (a.Music4 = Me),
    (a.Navigation = ee),
    (a.Navigation2 = ne),
    (a.Navigation2Off = ie),
    (a.NavigationOff = le),
    (a.Network = re),
    (a.Newspaper = oe),
    (a.Nfc = ve),
    (a.NonBinary = $e),
    (a.Notebook = ge),
    (a.NotebookPen = me),
    (a.NotebookTabs = ye),
    (a.NotebookText = se),
    (a.NotepadText = Ce),
    (a.NotepadTextDashed = ue),
    (a.Nut = Ae),
    (a.NutOff = He),
    (a.Octagon = Ve),
    (a.OctagonAlert = y2),
    (a.OctagonMinus = we),
    (a.OctagonPause = s2),
    (a.OctagonX = g2),
    (a.Omega = Se),
    (a.Option = fe),
    (a.Orbit = Le),
    (a.Origami = ke),
    (a.Outdent = o),
    (a.Package = Te),
    (a.Package2 = Pe),
    (a.PackageCheck = Be),
    (a.PackageMinus = De),
    (a.PackageOpen = ze),
    (a.PackagePlus = Fe),
    (a.PackageSearch = be),
    (a.PackageX = Re),
    (a.PaintBucket = qe),
    (a.PaintRoller = Ue),
    (a.Paintbrush = Oe),
    (a.Paintbrush2 = u2),
    (a.PaintbrushVertical = u2),
    (a.Palette = Ze),
    (a.Palmtree = N0),
    (a.Panda = Ge),
    (a.PanelBottom = Ee),
    (a.PanelBottomClose = Ie),
    (a.PanelBottomDashed = C2),
    (a.PanelBottomInactive = C2),
    (a.PanelBottomOpen = We),
    (a.PanelLeft = V2),
    (a.PanelLeftClose = H2),
    (a.PanelLeftDashed = A2),
    (a.PanelLeftInactive = A2),
    (a.PanelLeftOpen = w2),
    (a.PanelLeftRightDashed = Xe),
    (a.PanelRight = Ke),
    (a.PanelRightClose = je),
    (a.PanelRightDashed = S2),
    (a.PanelRightInactive = S2),
    (a.PanelRightOpen = Ne),
    (a.PanelTop = _e),
    (a.PanelTopBottomDashed = Qe),
    (a.PanelTopClose = Je),
    (a.PanelTopDashed = L2),
    (a.PanelTopInactive = L2),
    (a.PanelTopOpen = Ye),
    (a.PanelsLeftBottom = xe),
    (a.PanelsLeftRight = P1),
    (a.PanelsRightBottom = ar),
    (a.PanelsTopBottom = b2),
    (a.PanelsTopLeft = f2),
    (a.Paperclip = hr),
    (a.Parentheses = tr),
    (a.ParkingCircle = o1),
    (a.ParkingCircleOff = r1),
    (a.ParkingMeter = dr),
    (a.ParkingSquare = A0),
    (a.ParkingSquareOff = w0),
    (a.PartyPopper = cr),
    (a.Pause = Mr),
    (a.PauseCircle = v1),
    (a.PauseOctagon = s2),
    (a.PawPrint = pr),
    (a.PcCase = nr),
    (a.Pen = P2),
    (a.PenBox = p),
    (a.PenLine = k2),
    (a.PenOff = ir),
    (a.PenSquare = p),
    (a.PenTool = lr),
    (a.Pencil = vr),
    (a.PencilLine = er),
    (a.PencilOff = rr),
    (a.PencilRuler = or),
    (a.Pentagon = $r),
    (a.Percent = mr),
    (a.PercentCircle = $1),
    (a.PercentDiamond = D1),
    (a.PercentSquare = V0),
    (a.PersonStanding = yr),
    (a.PhilippinePeso = sr),
    (a.Phone = Vr),
    (a.PhoneCall = gr),
    (a.PhoneForwarded = ur),
    (a.PhoneIncoming = Cr),
    (a.PhoneMissed = Hr),
    (a.PhoneOff = Ar),
    (a.PhoneOutgoing = wr),
    (a.Pi = Sr),
    (a.PiSquare = S0),
    (a.Piano = Lr),
    (a.Pickaxe = fr),
    (a.PictureInPicture = Pr),
    (a.PictureInPicture2 = kr),
    (a.PieChart = X),
    (a.PiggyBank = Br),
    (a.Pilcrow = zr),
    (a.PilcrowLeft = Dr),
    (a.PilcrowRight = Fr),
    (a.PilcrowSquare = L0),
    (a.Pill = Rr),
    (a.PillBottle = br),
    (a.Pin = qr),
    (a.PinOff = Tr),
    (a.Pipette = Ur),
    (a.Pizza = Or),
    (a.Plane = Ir),
    (a.PlaneLanding = Zr),
    (a.PlaneTakeoff = Gr),
    (a.Play = Wr),
    (a.PlayCircle = m1),
    (a.PlaySquare = f0),
    (a.Plug = Xr),
    (a.Plug2 = Er),
    (a.PlugZap = B2),
    (a.PlugZap2 = B2),
    (a.Plus = jr),
    (a.PlusCircle = y1),
    (a.PlusSquare = k0),
    (a.Pocket = Kr),
    (a.PocketKnife = Nr),
    (a.Podcast = Yr),
    (a.Pointer = Jr),
    (a.PointerOff = Qr),
    (a.Popcorn = _r),
    (a.Popsicle = xr),
    (a.PoundSterling = ao),
    (a.Power = ho),
    (a.PowerCircle = s1),
    (a.PowerOff = to),
    (a.PowerSquare = P0),
    (a.Presentation = co),
    (a.Printer = po),
    (a.PrinterCheck = Mo),
    (a.Projector = io),
    (a.Proportions = no),
    (a.Puzzle = lo),
    (a.Pyramid = eo),
    (a.QrCode = ro),
    (a.Quote = oo),
    (a.Rabbit = vo),
    (a.Radar = $o),
    (a.Radiation = mo),
    (a.Radical = yo),
    (a.Radio = uo),
    (a.RadioReceiver = so),
    (a.RadioTower = go),
    (a.Radius = Ho),
    (a.RailSymbol = Co),
    (a.Rainbow = Ao),
    (a.Rat = wo),
    (a.Ratio = Vo),
    (a.Receipt = zo),
    (a.ReceiptCent = So),
    (a.ReceiptEuro = Lo),
    (a.ReceiptIndianRupee = fo),
    (a.ReceiptJapaneseYen = ko),
    (a.ReceiptPoundSterling = Po),
    (a.ReceiptRussianRuble = Bo),
    (a.ReceiptSwissFranc = Do),
    (a.ReceiptText = Fo),
    (a.ReceiptTurkishLira = bo),
    (a.RectangleCircle = Ro),
    (a.RectangleEllipsis = D2),
    (a.RectangleGoggles = To),
    (a.RectangleHorizontal = qo),
    (a.RectangleVertical = Oo),
    (a.Recycle = Uo),
    (a.Redo = Io),
    (a.Redo2 = Zo),
    (a.RedoDot = Go),
    (a.RefreshCcw = Wo),
    (a.RefreshCcwDot = Eo),
    (a.RefreshCw = jo),
    (a.RefreshCwOff = Xo),
    (a.Refrigerator = No),
    (a.Regex = Ko),
    (a.RemoveFormatting = Qo),
    (a.Repeat = _o),
    (a.Repeat1 = Yo),
    (a.Repeat2 = Jo),
    (a.Replace = av),
    (a.ReplaceAll = xo),
    (a.Reply = hv),
    (a.ReplyAll = tv),
    (a.Rewind = dv),
    (a.Ribbon = cv),
    (a.Rocket = Mv),
    (a.RockingChair = pv),
    (a.RollerCoaster = iv),
    (a.Rose = nv),
    (a.Rotate3D = F2),
    (a.Rotate3d = F2),
    (a.RotateCcw = ev),
    (a.RotateCcwKey = lv),
    (a.RotateCcwSquare = ov),
    (a.RotateCw = $v),
    (a.RotateCwSquare = rv),
    (a.Route = mv),
    (a.RouteOff = vv),
    (a.Router = yv),
    (a.Rows = z2),
    (a.Rows2 = z2),
    (a.Rows3 = b2),
    (a.Rows4 = sv),
    (a.Rss = gv),
    (a.Ruler = Cv),
    (a.RulerDimensionLine = uv),
    (a.RussianRuble = Hv),
    (a.Sailboat = Av),
    (a.Salad = wv),
    (a.Sandwich = Vv),
    (a.Satellite = Lv),
    (a.SatelliteDish = Sv),
    (a.SaudiRiyal = fv),
    (a.Save = Bv),
    (a.SaveAll = kv),
    (a.SaveOff = Pv),
    (a.Scale = Dv),
    (a.Scale3D = R2),
    (a.Scale3d = R2),
    (a.Scaling = Fv),
    (a.Scan = Gv),
    (a.ScanBarcode = zv),
    (a.ScanEye = bv),
    (a.ScanFace = Rv),
    (a.ScanHeart = Tv),
    (a.ScanLine = qv),
    (a.ScanQrCode = Uv),
    (a.ScanSearch = Ov),
    (a.ScanText = Zv),
    (a.ScatterChart = E),
    (a.School = Iv),
    (a.School2 = J0),
    (a.Scissors = Ev),
    (a.ScissorsLineDashed = Wv),
    (a.ScissorsSquare = B0),
    (a.ScissorsSquareDashedBottom = t0),
    (a.ScreenShare = jv),
    (a.ScreenShareOff = Xv),
    (a.Scroll = Kv),
    (a.ScrollText = Nv),
    (a.Search = xv),
    (a.SearchCheck = Qv),
    (a.SearchCode = Jv),
    (a.SearchSlash = Yv),
    (a.SearchX = _v),
    (a.Section = a$),
    (a.Send = h$),
    (a.SendHorizonal = T2),
    (a.SendHorizontal = T2),
    (a.SendToBack = t$),
    (a.SeparatorHorizontal = d$),
    (a.SeparatorVertical = c$),
    (a.Server = n$),
    (a.ServerCog = M$),
    (a.ServerCrash = p$),
    (a.ServerOff = i$),
    (a.Settings = e$),
    (a.Settings2 = l$),
    (a.Shapes = o$),
    (a.Share = v$),
    (a.Share2 = r$),
    (a.Sheet = $$),
    (a.Shell = m$),
    (a.Shield = S$),
    (a.ShieldAlert = y$),
    (a.ShieldBan = s$),
    (a.ShieldCheck = g$),
    (a.ShieldClose = U2),
    (a.ShieldEllipsis = u$),
    (a.ShieldHalf = C$),
    (a.ShieldMinus = H$),
    (a.ShieldOff = A$),
    (a.ShieldPlus = w$),
    (a.ShieldQuestion = q2),
    (a.ShieldQuestionMark = q2),
    (a.ShieldUser = V$),
    (a.ShieldX = U2),
    (a.Ship = f$),
    (a.ShipWheel = L$),
    (a.Shirt = k$),
    (a.ShoppingBag = P$),
    (a.ShoppingBasket = B$),
    (a.ShoppingCart = D$),
    (a.Shovel = F$),
    (a.ShowerHead = z$),
    (a.Shredder = b$),
    (a.Shrimp = R$),
    (a.Shrink = T$),
    (a.Shrub = q$),
    (a.Shuffle = U$),
    (a.Sidebar = V2),
    (a.SidebarClose = H2),
    (a.SidebarOpen = w2),
    (a.Sigma = O$),
    (a.SigmaSquare = D0),
    (a.Signal = E$),
    (a.SignalHigh = Z$),
    (a.SignalLow = G$),
    (a.SignalMedium = I$),
    (a.SignalZero = W$),
    (a.Signature = X$),
    (a.Signpost = N$),
    (a.SignpostBig = j$),
    (a.Siren = K$),
    (a.SkipBack = Q$),
    (a.SkipForward = J$),
    (a.Skull = Y$),
    (a.Slack = _$),
    (a.Slash = x$),
    (a.SlashSquare = F0),
    (a.Slice = am),
    (a.Sliders = O2),
    (a.SlidersHorizontal = tm),
    (a.SlidersVertical = O2),
    (a.Smartphone = cm),
    (a.SmartphoneCharging = hm),
    (a.SmartphoneNfc = dm),
    (a.Smile = pm),
    (a.SmilePlus = Mm),
    (a.Snail = im),
    (a.Snowflake = nm),
    (a.SoapDispenserDroplet = em),
    (a.Sofa = lm),
    (a.SortAsc = w),
    (a.SortDesc = C),
    (a.Soup = rm),
    (a.Space = om),
    (a.Spade = vm),
    (a.Sparkle = $m),
    (a.Sparkles = Z2),
    (a.Speaker = mm),
    (a.Speech = ym),
    (a.SpellCheck = gm),
    (a.SpellCheck2 = sm),
    (a.Spline = Cm),
    (a.SplinePointer = um),
    (a.Split = Hm),
    (a.SplitSquareHorizontal = z0),
    (a.SplitSquareVertical = b0),
    (a.Spool = Am),
    (a.Spotlight = wm),
    (a.SprayCan = Vm),
    (a.Sprout = Sm),
    (a.Square = Tm),
    (a.SquareActivity = G2),
    (a.SquareArrowDown = E2),
    (a.SquareArrowDownLeft = I2),
    (a.SquareArrowDownRight = W2),
    (a.SquareArrowLeft = X2),
    (a.SquareArrowOutDownLeft = j2),
    (a.SquareArrowOutDownRight = N2),
    (a.SquareArrowOutUpLeft = K2),
    (a.SquareArrowOutUpRight = Q2),
    (a.SquareArrowRight = J2),
    (a.SquareArrowUp = x2),
    (a.SquareArrowUpLeft = Y2),
    (a.SquareArrowUpRight = _2),
    (a.SquareAsterisk = a0),
    (a.SquareBottomDashedScissors = t0),
    (a.SquareChartGantt = $),
    (a.SquareCheck = d0),
    (a.SquareCheckBig = h0),
    (a.SquareChevronDown = c0),
    (a.SquareChevronLeft = M0),
    (a.SquareChevronRight = p0),
    (a.SquareChevronUp = i0),
    (a.SquareCode = n0),
    (a.SquareDashed = r0),
    (a.SquareDashedBottom = fm),
    (a.SquareDashedBottomCode = Lm),
    (a.SquareDashedKanban = l0),
    (a.SquareDashedMousePointer = e0),
    (a.SquareDashedTopSolid = km),
    (a.SquareDivide = o0),
    (a.SquareDot = v0),
    (a.SquareEqual = $0),
    (a.SquareFunction = m0),
    (a.SquareGanttChart = $),
    (a.SquareKanban = y0),
    (a.SquareLibrary = s0),
    (a.SquareM = g0),
    (a.SquareMenu = u0),
    (a.SquareMinus = C0),
    (a.SquareMousePointer = H0),
    (a.SquareParking = A0),
    (a.SquareParkingOff = w0),
    (a.SquarePause = Pm),
    (a.SquarePen = p),
    (a.SquarePercent = V0),
    (a.SquarePi = S0),
    (a.SquarePilcrow = L0),
    (a.SquarePlay = f0),
    (a.SquarePlus = k0),
    (a.SquarePower = P0),
    (a.SquareRadical = Bm),
    (a.SquareRoundCorner = Dm),
    (a.SquareScissors = B0),
    (a.SquareSigma = D0),
    (a.SquareSlash = F0),
    (a.SquareSplitHorizontal = z0),
    (a.SquareSplitVertical = b0),
    (a.SquareSquare = Fm),
    (a.SquareStack = zm),
    (a.SquareStar = bm),
    (a.SquareStop = Rm),
    (a.SquareTerminal = R0),
    (a.SquareUser = q0),
    (a.SquareUserRound = T0),
    (a.SquareX = U0),
    (a.SquaresExclude = qm),
    (a.SquaresIntersect = Um),
    (a.SquaresSubtract = Om),
    (a.SquaresUnite = Zm),
    (a.Squircle = Gm),
    (a.SquircleDashed = Im),
    (a.Squirrel = Wm),
    (a.Stamp = Em),
    (a.Star = Nm),
    (a.StarHalf = Xm),
    (a.StarOff = jm),
    (a.Stars = Z2),
    (a.StepBack = Km),
    (a.StepForward = Jm),
    (a.Stethoscope = Qm),
    (a.Sticker = Ym),
    (a.StickyNote = _m),
    (a.StopCircle = u1),
    (a.Store = xm),
    (a.StretchHorizontal = ay),
    (a.StretchVertical = ty),
    (a.Strikethrough = hy),
    (a.Subscript = dy),
    (a.Subtitles = F),
    (a.Sun = ny),
    (a.SunDim = cy),
    (a.SunMedium = My),
    (a.SunMoon = py),
    (a.SunSnow = iy),
    (a.Sunrise = ly),
    (a.Sunset = ey),
    (a.Superscript = oy),
    (a.SwatchBook = ry),
    (a.SwissFranc = vy),
    (a.SwitchCamera = $y),
    (a.Sword = my),
    (a.Swords = yy),
    (a.Syringe = sy),
    (a.Table = Sy),
    (a.Table2 = gy),
    (a.TableCellsMerge = uy),
    (a.TableCellsSplit = Hy),
    (a.TableColumnsSplit = Cy),
    (a.TableConfig = e),
    (a.TableOfContents = wy),
    (a.TableProperties = Ay),
    (a.TableRowsSplit = Vy),
    (a.Tablet = fy),
    (a.TabletSmartphone = Ly),
    (a.Tablets = ky),
    (a.Tag = Py),
    (a.Tags = Dy),
    (a.Tally1 = By),
    (a.Tally2 = Fy),
    (a.Tally3 = zy),
    (a.Tally4 = by),
    (a.Tally5 = Ry),
    (a.Tangent = Ty),
    (a.Target = qy),
    (a.Telescope = Uy),
    (a.Tent = Zy),
    (a.TentTree = Oy),
    (a.Terminal = Gy),
    (a.TerminalSquare = R0),
    (a.TestTube = Iy),
    (a.TestTube2 = O0),
    (a.TestTubeDiagonal = O0),
    (a.TestTubes = Wy),
    (a.Text = m),
    (a.TextAlignCenter = Z0),
    (a.TextAlignEnd = G0),
    (a.TextAlignJustify = I0),
    (a.TextAlignStart = m),
    (a.TextCursor = Xy),
    (a.TextCursorInput = Ey),
    (a.TextInitial = W0),
    (a.TextQuote = jy),
    (a.TextSearch = Ny),
    (a.TextSelect = E0),
    (a.TextSelection = E0),
    (a.TextWrap = X0),
    (a.Theater = Ky),
    (a.Thermometer = Yy),
    (a.ThermometerSnowflake = Qy),
    (a.ThermometerSun = Jy),
    (a.ThumbsDown = _y),
    (a.ThumbsUp = xy),
    (a.Ticket = Ms),
    (a.TicketCheck = as),
    (a.TicketMinus = ts),
    (a.TicketPercent = hs),
    (a.TicketPlus = ds),
    (a.TicketSlash = ps),
    (a.TicketX = cs),
    (a.Tickets = ns),
    (a.TicketsPlane = is),
    (a.Timer = rs),
    (a.TimerOff = ls),
    (a.TimerReset = es),
    (a.ToggleLeft = os),
    (a.ToggleRight = vs),
    (a.Toilet = $s),
    (a.ToolCase = ys),
    (a.Tornado = ms),
    (a.Torus = ss),
    (a.Touchpad = us),
    (a.TouchpadOff = gs),
    (a.TowerControl = Hs),
    (a.ToyBrick = Cs),
    (a.Tractor = As),
    (a.TrafficCone = ws),
    (a.Train = j0),
    (a.TrainFront = Ss),
    (a.TrainFrontTunnel = Vs),
    (a.TrainTrack = Ls),
    (a.TramFront = j0),
    (a.Transgender = fs),
    (a.Trash = Ps),
    (a.Trash2 = ks),
    (a.TreeDeciduous = Bs),
    (a.TreePalm = N0),
    (a.TreePine = Ds),
    (a.Trees = Fs),
    (a.Trello = bs),
    (a.TrendingDown = zs),
    (a.TrendingUp = Ts),
    (a.TrendingUpDown = Rs),
    (a.Triangle = Os),
    (a.TriangleAlert = K0),
    (a.TriangleDashed = qs),
    (a.TriangleRight = Us),
    (a.Trophy = Zs),
    (a.Truck = Is),
    (a.TruckElectric = Gs),
    (a.TurkishLira = Es),
    (a.Turntable = Ws),
    (a.Turtle = Xs),
    (a.Tv = Ns),
    (a.Tv2 = Q0),
    (a.TvMinimal = Q0),
    (a.TvMinimalPlay = js),
    (a.Twitch = Ks),
    (a.Twitter = Qs),
    (a.Type = Ys),
    (a.TypeOutline = Js),
    (a.Umbrella = xs),
    (a.UmbrellaOff = _s),
    (a.Underline = ag),
    (a.Undo = dg),
    (a.Undo2 = tg),
    (a.UndoDot = hg),
    (a.UnfoldHorizontal = cg),
    (a.UnfoldVertical = Mg),
    (a.Ungroup = pg),
    (a.University = J0),
    (a.Unlink = lg),
    (a.Unlink2 = ig),
    (a.Unlock = e2),
    (a.UnlockKeyhole = l2),
    (a.Unplug = ng),
    (a.Upload = eg),
    (a.UploadCloud = L1),
    (a.Usb = rg),
    (a.User = wg),
    (a.User2 = ha),
    (a.UserCheck = og),
    (a.UserCheck2 = _0),
    (a.UserCircle = H1),
    (a.UserCircle2 = C1),
    (a.UserCog = vg),
    (a.UserCog2 = Y0),
    (a.UserLock = $g),
    (a.UserMinus = mg),
    (a.UserMinus2 = x0),
    (a.UserPen = yg),
    (a.UserPlus = sg),
    (a.UserPlus2 = aa),
    (a.UserRound = ha),
    (a.UserRoundCheck = _0),
    (a.UserRoundCog = Y0),
    (a.UserRoundMinus = x0),
    (a.UserRoundPen = gg),
    (a.UserRoundPlus = aa),
    (a.UserRoundSearch = ug),
    (a.UserRoundX = ta),
    (a.UserSearch = Cg),
    (a.UserSquare = q0),
    (a.UserSquare2 = T0),
    (a.UserStar = Hg),
    (a.UserX = Ag),
    (a.UserX2 = ta),
    (a.Users = Vg),
    (a.Users2 = da),
    (a.UsersRound = da),
    (a.Utensils = Ma),
    (a.UtensilsCrossed = ca),
    (a.UtilityPole = Sg),
    (a.Variable = Lg),
    (a.Vault = kg),
    (a.VectorSquare = fg),
    (a.Vegan = Pg),
    (a.VenetianMask = Bg),
    (a.Venus = Fg),
    (a.VenusAndMars = Dg),
    (a.Verified = L),
    (a.Vibrate = bg),
    (a.VibrateOff = zg),
    (a.Video = Tg),
    (a.VideoOff = Rg),
    (a.Videotape = qg),
    (a.View = Ug),
    (a.Voicemail = Og),
    (a.Volleyball = Zg),
    (a.Volume = Xg),
    (a.Volume1 = Gg),
    (a.Volume2 = Ig),
    (a.VolumeOff = Wg),
    (a.VolumeX = Eg),
    (a.Vote = jg),
    (a.Wallet = Kg),
    (a.Wallet2 = pa),
    (a.WalletCards = Ng),
    (a.WalletMinimal = pa),
    (a.Wallpaper = Qg),
    (a.Wand = Jg),
    (a.Wand2 = ia),
    (a.WandSparkles = ia),
    (a.Warehouse = Yg),
    (a.WashingMachine = _g),
    (a.Watch = xg),
    (a.Waves = tu),
    (a.WavesLadder = au),
    (a.Waypoints = hu),
    (a.Webcam = du),
    (a.Webhook = pu),
    (a.WebhookOff = Mu),
    (a.Weight = cu),
    (a.Wheat = nu),
    (a.WheatOff = iu),
    (a.WholeWord = lu),
    (a.Wifi = su),
    (a.WifiCog = eu),
    (a.WifiHigh = ru),
    (a.WifiLow = ou),
    (a.WifiOff = mu),
    (a.WifiPen = vu),
    (a.WifiSync = $u),
    (a.WifiZero = yu),
    (a.Wind = uu),
    (a.WindArrowDown = gu),
    (a.Wine = Hu),
    (a.WineOff = Cu),
    (a.Workflow = Au),
    (a.Worm = wu),
    (a.WrapText = X0),
    (a.Wrench = Vu),
    (a.X = Su),
    (a.XCircle = A1),
    (a.XOctagon = g2),
    (a.XSquare = U0),
    (a.Youtube = Lu),
    (a.Zap = ku),
    (a.ZapOff = fu),
    (a.ZoomIn = Pu),
    (a.ZoomOut = Bu),
    (a.createElement = ea),
    (a.createIcons = Ou),
    (a.icons = Du);
});
//# sourceMappingURL=lucide.min.js.map
